/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "http://h.cdn.pengpengla.com/up/prelogin/1.0.5/assets/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 345);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(2);
var core = __webpack_require__(21);
var hide = __webpack_require__(12);
var redefine = __webpack_require__(13);
var ctx = __webpack_require__(18);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(4);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 2 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(50)('wks');
var uid = __webpack_require__(32);
var Symbol = __webpack_require__(2).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(3)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(1);
var IE8_DOM_DEFINE = __webpack_require__(92);
var toPrimitive = __webpack_require__(22);
var dP = Object.defineProperty;

exports.f = __webpack_require__(6) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(24);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(23);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 10 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 11 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(7);
var createDesc = __webpack_require__(31);
module.exports = __webpack_require__(6) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(2);
var hide = __webpack_require__(12);
var has = __webpack_require__(11);
var SRC = __webpack_require__(32)('src');
var TO_STRING = 'toString';
var $toString = Function[TO_STRING];
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__(21).inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var fails = __webpack_require__(3);
var defined = __webpack_require__(23);
var quot = /"/g;
// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
var createHTML = function (string, tag, attribute, value) {
  var S = String(defined(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};
module.exports = function (NAME, exec) {
  var O = {};
  O[NAME] = exec(createHTML);
  $export($export.P + $export.F * fails(function () {
    var test = ''[NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  }), 'String', O);
};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(46);
var defined = __webpack_require__(23);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(47);
var createDesc = __webpack_require__(31);
var toIObject = __webpack_require__(15);
var toPrimitive = __webpack_require__(22);
var has = __webpack_require__(11);
var IE8_DOM_DEFINE = __webpack_require__(92);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(6) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(11);
var toObject = __webpack_require__(9);
var IE_PROTO = __webpack_require__(67)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(10);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 19 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(3);

module.exports = function (method, arg) {
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call
    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
  });
};


/***/ }),
/* 21 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.1' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(4);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 23 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 24 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(0);
var core = __webpack_require__(21);
var fails = __webpack_require__(3);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(18);
var IObject = __webpack_require__(46);
var toObject = __webpack_require__(9);
var toLength = __webpack_require__(8);
var asc = __webpack_require__(84);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

if (__webpack_require__(6)) {
  var LIBRARY = __webpack_require__(33);
  var global = __webpack_require__(2);
  var fails = __webpack_require__(3);
  var $export = __webpack_require__(0);
  var $typed = __webpack_require__(60);
  var $buffer = __webpack_require__(90);
  var ctx = __webpack_require__(18);
  var anInstance = __webpack_require__(39);
  var propertyDesc = __webpack_require__(31);
  var hide = __webpack_require__(12);
  var redefineAll = __webpack_require__(41);
  var toInteger = __webpack_require__(24);
  var toLength = __webpack_require__(8);
  var toIndex = __webpack_require__(118);
  var toAbsoluteIndex = __webpack_require__(35);
  var toPrimitive = __webpack_require__(22);
  var has = __webpack_require__(11);
  var classof = __webpack_require__(48);
  var isObject = __webpack_require__(4);
  var toObject = __webpack_require__(9);
  var isArrayIter = __webpack_require__(81);
  var create = __webpack_require__(36);
  var getPrototypeOf = __webpack_require__(17);
  var gOPN = __webpack_require__(37).f;
  var getIterFn = __webpack_require__(83);
  var uid = __webpack_require__(32);
  var wks = __webpack_require__(5);
  var createArrayMethod = __webpack_require__(26);
  var createArrayIncludes = __webpack_require__(51);
  var speciesConstructor = __webpack_require__(58);
  var ArrayIterators = __webpack_require__(86);
  var Iterators = __webpack_require__(44);
  var $iterDetect = __webpack_require__(55);
  var setSpecies = __webpack_require__(38);
  var arrayFill = __webpack_require__(85);
  var arrayCopyWithin = __webpack_require__(108);
  var $DP = __webpack_require__(7);
  var $GOPD = __webpack_require__(16);
  var dP = $DP.f;
  var gOPD = $GOPD.f;
  var RangeError = global.RangeError;
  var TypeError = global.TypeError;
  var Uint8Array = global.Uint8Array;
  var ARRAY_BUFFER = 'ArrayBuffer';
  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
  var PROTOTYPE = 'prototype';
  var ArrayProto = Array[PROTOTYPE];
  var $ArrayBuffer = $buffer.ArrayBuffer;
  var $DataView = $buffer.DataView;
  var arrayForEach = createArrayMethod(0);
  var arrayFilter = createArrayMethod(2);
  var arraySome = createArrayMethod(3);
  var arrayEvery = createArrayMethod(4);
  var arrayFind = createArrayMethod(5);
  var arrayFindIndex = createArrayMethod(6);
  var arrayIncludes = createArrayIncludes(true);
  var arrayIndexOf = createArrayIncludes(false);
  var arrayValues = ArrayIterators.values;
  var arrayKeys = ArrayIterators.keys;
  var arrayEntries = ArrayIterators.entries;
  var arrayLastIndexOf = ArrayProto.lastIndexOf;
  var arrayReduce = ArrayProto.reduce;
  var arrayReduceRight = ArrayProto.reduceRight;
  var arrayJoin = ArrayProto.join;
  var arraySort = ArrayProto.sort;
  var arraySlice = ArrayProto.slice;
  var arrayToString = ArrayProto.toString;
  var arrayToLocaleString = ArrayProto.toLocaleString;
  var ITERATOR = wks('iterator');
  var TAG = wks('toStringTag');
  var TYPED_CONSTRUCTOR = uid('typed_constructor');
  var DEF_CONSTRUCTOR = uid('def_constructor');
  var ALL_CONSTRUCTORS = $typed.CONSTR;
  var TYPED_ARRAY = $typed.TYPED;
  var VIEW = $typed.VIEW;
  var WRONG_LENGTH = 'Wrong length!';

  var $map = createArrayMethod(1, function (O, length) {
    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
  });

  var LITTLE_ENDIAN = fails(function () {
    // eslint-disable-next-line no-undef
    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
  });

  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
    new Uint8Array(1).set({});
  });

  var toOffset = function (it, BYTES) {
    var offset = toInteger(it);
    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
    return offset;
  };

  var validate = function (it) {
    if (isObject(it) && TYPED_ARRAY in it) return it;
    throw TypeError(it + ' is not a typed array!');
  };

  var allocate = function (C, length) {
    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
      throw TypeError('It is not a typed array constructor!');
    } return new C(length);
  };

  var speciesFromList = function (O, list) {
    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
  };

  var fromList = function (C, list) {
    var index = 0;
    var length = list.length;
    var result = allocate(C, length);
    while (length > index) result[index] = list[index++];
    return result;
  };

  var addGetter = function (it, key, internal) {
    dP(it, key, { get: function () { return this._d[internal]; } });
  };

  var $from = function from(source /* , mapfn, thisArg */) {
    var O = toObject(source);
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var iterFn = getIterFn(O);
    var i, length, values, result, step, iterator;
    if (iterFn != undefined && !isArrayIter(iterFn)) {
      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
        values.push(step.value);
      } O = values;
    }
    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
      result[i] = mapping ? mapfn(O[i], i) : O[i];
    }
    return result;
  };

  var $of = function of(/* ...items */) {
    var index = 0;
    var length = arguments.length;
    var result = allocate(this, length);
    while (length > index) result[index] = arguments[index++];
    return result;
  };

  // iOS Safari 6.x fails here
  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });

  var $toLocaleString = function toLocaleString() {
    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
  };

  var proto = {
    copyWithin: function copyWithin(target, start /* , end */) {
      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
    },
    every: function every(callbackfn /* , thisArg */) {
      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
      return arrayFill.apply(validate(this), arguments);
    },
    filter: function filter(callbackfn /* , thisArg */) {
      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
        arguments.length > 1 ? arguments[1] : undefined));
    },
    find: function find(predicate /* , thisArg */) {
      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    findIndex: function findIndex(predicate /* , thisArg */) {
      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    forEach: function forEach(callbackfn /* , thisArg */) {
      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    indexOf: function indexOf(searchElement /* , fromIndex */) {
      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    includes: function includes(searchElement /* , fromIndex */) {
      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    join: function join(separator) { // eslint-disable-line no-unused-vars
      return arrayJoin.apply(validate(this), arguments);
    },
    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
      return arrayLastIndexOf.apply(validate(this), arguments);
    },
    map: function map(mapfn /* , thisArg */) {
      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduce.apply(validate(this), arguments);
    },
    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduceRight.apply(validate(this), arguments);
    },
    reverse: function reverse() {
      var that = this;
      var length = validate(that).length;
      var middle = Math.floor(length / 2);
      var index = 0;
      var value;
      while (index < middle) {
        value = that[index];
        that[index++] = that[--length];
        that[length] = value;
      } return that;
    },
    some: function some(callbackfn /* , thisArg */) {
      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    sort: function sort(comparefn) {
      return arraySort.call(validate(this), comparefn);
    },
    subarray: function subarray(begin, end) {
      var O = validate(this);
      var length = O.length;
      var $begin = toAbsoluteIndex(begin, length);
      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
        O.buffer,
        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
      );
    }
  };

  var $slice = function slice(start, end) {
    return speciesFromList(this, arraySlice.call(validate(this), start, end));
  };

  var $set = function set(arrayLike /* , offset */) {
    validate(this);
    var offset = toOffset(arguments[1], 1);
    var length = this.length;
    var src = toObject(arrayLike);
    var len = toLength(src.length);
    var index = 0;
    if (len + offset > length) throw RangeError(WRONG_LENGTH);
    while (index < len) this[offset + index] = src[index++];
  };

  var $iterators = {
    entries: function entries() {
      return arrayEntries.call(validate(this));
    },
    keys: function keys() {
      return arrayKeys.call(validate(this));
    },
    values: function values() {
      return arrayValues.call(validate(this));
    }
  };

  var isTAIndex = function (target, key) {
    return isObject(target)
      && target[TYPED_ARRAY]
      && typeof key != 'symbol'
      && key in target
      && String(+key) == String(key);
  };
  var $getDesc = function getOwnPropertyDescriptor(target, key) {
    return isTAIndex(target, key = toPrimitive(key, true))
      ? propertyDesc(2, target[key])
      : gOPD(target, key);
  };
  var $setDesc = function defineProperty(target, key, desc) {
    if (isTAIndex(target, key = toPrimitive(key, true))
      && isObject(desc)
      && has(desc, 'value')
      && !has(desc, 'get')
      && !has(desc, 'set')
      // TODO: add validation descriptor w/o calling accessors
      && !desc.configurable
      && (!has(desc, 'writable') || desc.writable)
      && (!has(desc, 'enumerable') || desc.enumerable)
    ) {
      target[key] = desc.value;
      return target;
    } return dP(target, key, desc);
  };

  if (!ALL_CONSTRUCTORS) {
    $GOPD.f = $getDesc;
    $DP.f = $setDesc;
  }

  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
    getOwnPropertyDescriptor: $getDesc,
    defineProperty: $setDesc
  });

  if (fails(function () { arrayToString.call({}); })) {
    arrayToString = arrayToLocaleString = function toString() {
      return arrayJoin.call(this);
    };
  }

  var $TypedArrayPrototype$ = redefineAll({}, proto);
  redefineAll($TypedArrayPrototype$, $iterators);
  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
  redefineAll($TypedArrayPrototype$, {
    slice: $slice,
    set: $set,
    constructor: function () { /* noop */ },
    toString: arrayToString,
    toLocaleString: $toLocaleString
  });
  addGetter($TypedArrayPrototype$, 'buffer', 'b');
  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
  addGetter($TypedArrayPrototype$, 'length', 'e');
  dP($TypedArrayPrototype$, TAG, {
    get: function () { return this[TYPED_ARRAY]; }
  });

  // eslint-disable-next-line max-statements
  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
    CLAMPED = !!CLAMPED;
    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
    var GETTER = 'get' + KEY;
    var SETTER = 'set' + KEY;
    var TypedArray = global[NAME];
    var Base = TypedArray || {};
    var TAC = TypedArray && getPrototypeOf(TypedArray);
    var FORCED = !TypedArray || !$typed.ABV;
    var O = {};
    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
    var getter = function (that, index) {
      var data = that._d;
      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
    };
    var setter = function (that, index, value) {
      var data = that._d;
      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
    };
    var addElement = function (that, index) {
      dP(that, index, {
        get: function () {
          return getter(this, index);
        },
        set: function (value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };
    if (FORCED) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME, '_d');
        var index = 0;
        var offset = 0;
        var buffer, byteLength, length, klass;
        if (!isObject(data)) {
          length = toIndex(data);
          byteLength = length * BYTES;
          buffer = new $ArrayBuffer(byteLength);
        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          buffer = data;
          offset = toOffset($offset, BYTES);
          var $len = data.byteLength;
          if ($length === undefined) {
            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
            byteLength = $len - offset;
            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (TYPED_ARRAY in data) {
          return fromList(TypedArray, data);
        } else {
          return $from.call(TypedArray, data);
        }
        hide(that, '_d', {
          b: buffer,
          o: offset,
          l: byteLength,
          e: length,
          v: new $DataView(buffer)
        });
        while (index < length) addElement(that, index++);
      });
      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
      hide(TypedArrayPrototype, 'constructor', TypedArray);
    } else if (!fails(function () {
      TypedArray(1);
    }) || !fails(function () {
      new TypedArray(-1); // eslint-disable-line no-new
    }) || !$iterDetect(function (iter) {
      new TypedArray(); // eslint-disable-line no-new
      new TypedArray(null); // eslint-disable-line no-new
      new TypedArray(1.5); // eslint-disable-line no-new
      new TypedArray(iter); // eslint-disable-line no-new
    }, true)) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME);
        var klass;
        // `ws` module bug, temporarily remove validation length for Uint8Array
        // https://github.com/websockets/ws/pull/645
        if (!isObject(data)) return new Base(toIndex(data));
        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          return $length !== undefined
            ? new Base(data, toOffset($offset, BYTES), $length)
            : $offset !== undefined
              ? new Base(data, toOffset($offset, BYTES))
              : new Base(data);
        }
        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
        return $from.call(TypedArray, data);
      });
      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
      });
      TypedArray[PROTOTYPE] = TypedArrayPrototype;
      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
    }
    var $nativeIterator = TypedArrayPrototype[ITERATOR];
    var CORRECT_ITER_NAME = !!$nativeIterator
      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
    var $iterator = $iterators.values;
    hide(TypedArray, TYPED_CONSTRUCTOR, true);
    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
    hide(TypedArrayPrototype, VIEW, true);
    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);

    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
      dP(TypedArrayPrototype, TAG, {
        get: function () { return NAME; }
      });
    }

    O[NAME] = TypedArray;

    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);

    $export($export.S, NAME, {
      BYTES_PER_ELEMENT: BYTES
    });

    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
      from: $from,
      of: $of
    });

    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);

    $export($export.P, NAME, proto);

    setSpecies(NAME);

    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });

    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);

    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;

    $export($export.P + $export.F * fails(function () {
      new TypedArray(1).slice();
    }), NAME, { slice: $slice });

    $export($export.P + $export.F * (fails(function () {
      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
    }) || !fails(function () {
      TypedArrayPrototype.toLocaleString.call([1, 2]);
    })), NAME, { toLocaleString: $toLocaleString });

    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
  };
} else module.exports = function () { /* empty */ };


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

var Map = __webpack_require__(113);
var $export = __webpack_require__(0);
var shared = __webpack_require__(50)('metadata');
var store = shared.store || (shared.store = new (__webpack_require__(116))());

var getOrCreateMetadataMap = function (target, targetKey, create) {
  var targetMetadata = store.get(target);
  if (!targetMetadata) {
    if (!create) return undefined;
    store.set(target, targetMetadata = new Map());
  }
  var keyMetadata = targetMetadata.get(targetKey);
  if (!keyMetadata) {
    if (!create) return undefined;
    targetMetadata.set(targetKey, keyMetadata = new Map());
  } return keyMetadata;
};
var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
};
var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
};
var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
};
var ordinaryOwnMetadataKeys = function (target, targetKey) {
  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
  var keys = [];
  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
  return keys;
};
var toMetaKey = function (it) {
  return it === undefined || typeof it == 'symbol' ? it : String(it);
};
var exp = function (O) {
  $export($export.S, 'Reflect', O);
};

module.exports = {
  store: store,
  map: getOrCreateMetadataMap,
  has: ordinaryHasOwnMetadata,
  get: ordinaryGetOwnMetadata,
  set: ordinaryDefineOwnMetadata,
  keys: ordinaryOwnMetadataKeys,
  key: toMetaKey,
  exp: exp
};


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(32)('meta');
var isObject = __webpack_require__(4);
var has = __webpack_require__(11);
var setDesc = __webpack_require__(7).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(3)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(5)('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(12)(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),
/* 31 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 32 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 33 */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(94);
var enumBugKeys = __webpack_require__(68);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(24);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(1);
var dPs = __webpack_require__(95);
var enumBugKeys = __webpack_require__(68);
var IE_PROTO = __webpack_require__(67)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(65)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(69).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(94);
var hiddenKeys = __webpack_require__(68).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(2);
var dP = __webpack_require__(7);
var DESCRIPTORS = __webpack_require__(6);
var SPECIES = __webpack_require__(5)('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 39 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(18);
var call = __webpack_require__(106);
var isArrayIter = __webpack_require__(81);
var anObject = __webpack_require__(1);
var toLength = __webpack_require__(8);
var getIterFn = __webpack_require__(83);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(13);
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(7).f;
var has = __webpack_require__(11);
var TAG = __webpack_require__(5)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var defined = __webpack_require__(23);
var fails = __webpack_require__(3);
var spaces = __webpack_require__(71);
var space = '[' + spaces + ']';
var non = '\u200b\u0085';
var ltrim = RegExp('^' + space + space + '*');
var rtrim = RegExp(space + space + '*$');

var exporter = function (KEY, exec, ALIAS) {
  var exp = {};
  var FORCE = fails(function () {
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if (ALIAS) exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function (string, TYPE) {
  string = String(defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;


/***/ }),
/* 44 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(4);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(19);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 47 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(19);
var TAG = __webpack_require__(5)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 49 */
/***/ (function(module, exports) {



var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var url = {
    scope: 'search',
    paramReg: /^(?:([A-Za-z]+):(\/{0,3}))?([0-9.\-A-Za-z]+\.[0-9A-Za-z]+)?(?::(\d+))?(?:\/([^?#]*))?(?:\?([^#]*))?(?:#(.*))?$/,

    names: ['url', 'scheme', 'slash', 'host', 'port', 'path', 'query', 'hash'],

    query: function query(name, scope) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i"),
            scope = scope || this.scope,
            r = location[scope].substr(1).match(reg);
        if (r != null) {
            return decodeURIComponent(r[2]);
        }
        return null;
    },

    addParam: function addParam(url, data) {
        if (typeof data === 'undefined') {
            return;
        }

        var hashReg = /#.*$/gi,
            hashMatch = url.match(hashReg),
            hash = '';

        if (hashMatch) {
            hash = hashMatch[0];
        }

        // 去除hash值的url
        var preUrl = url.replace(hash, '');

        var searchReg = /\?(.*?)$/gi;
        var result = searchReg.exec(preUrl);
        var query, newUrl;
        if (result) {
            query = result[1].split('#')[0];
        }

        var id = !query ? '' : '&';

        return preUrl + (query && query.length > 0 ? '' : '?') + (id + $.param(data)) + hash;
    },

    delQuery: function delQuery(url, key) {
        var path = '',
            param = '',
            hash = '';
        if (url.indexOf('?') == -1) {
            path = url;
        } else {
            path = url.substr(0, url.indexOf('?'));
            param = url.substr(url.indexOf('?') + 1);
            if (param.indexOf('#') != -1) {
                hash = param.substr(param.indexOf('#') + 1);
                param = param.substr(0, param.indexOf('#'));
            }
        }
        var params = param.split('&');
        for (var i = params.length - 1; i >= 0; i--) {
            if (params[i].indexOf(key + '=') > -1) {
                params.splice(i, 1);
                break;
            }
        }

        return path + (params.join('&') ? '?' + params.join('&') : '') + (hash ? '#' + hash : '');
    },
    /**
     * 将URL query的字符串解析成对象
     */
    parseQuery: function parseQuery(query) {
        var ret = {},
            qs,
            q,
            _qs;
        if ((typeof query === 'undefined' ? 'undefined' : _typeof(query)) == 'object') {
            for (var p in query) {
                if (query.hasOwnProperty(p) && query[p] !== null) {
                    ret[p] = query[p];
                }
            }
        } else {
            qs = query.split('&');
            for (var i = 0; i < qs.length; i++) {
                if ((q = qs[i]) && (_qs = q.split('=')) && _qs[0]) {
                    ret[_qs[0]] = _qs[1] ? decodeURIComponent(_qs[1]) : '';
                }
            }
        }

        return ret;
    },
    /**
     * 将URL解析为对象
     * @name parse
     * @return {
     *      url: '',
     *      hash: '',
     *      query: '',
     *      host: ''
     *      ...
     * }
     */
    parse: function parse(url) {
        var results = this.paramReg.exec(url),
            names = this.names,
            ret = {},
            key;

        for (var i = 0, len = names.length; i < len; i += 1) {
            key = names[i];
            ret[key] = (key == 'path' ? '/' : '') + (results[i] || '');
        }

        return ret;
    },
    /**
     * 将对象解析为URL字符串
     */
    stringify: function stringify(data) {
        var ret = '';
        var names = this.names;
        for (var i = 1; i < names.length; i++) {
            var key = names[i],
                value = data[key];
            if (typeof value != 'undefined') {
                ret += function (key, value) {
                    if (key == 'scheme') {
                        return value + ':';
                    }
                    if (key == 'port') {
                        return value ? ':' + value : '';
                    }
                    if (key == 'host') {
                        return value;
                    }

                    if (key == 'query') {
                        return value ? '?' + value : '';
                    }
                    if (key == 'hash') {
                        return value ? '#' + value : '';
                    }

                    return value;
                }(key, value);
            }
        }
        return ret;
    }
};

module.exports = url;

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(2);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});
module.exports = function (key) {
  return store[key] || (store[key] = {});
};


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(15);
var toLength = __webpack_require__(8);
var toAbsoluteIndex = __webpack_require__(35);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 52 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(19);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__(4);
var cof = __webpack_require__(19);
var MATCH = __webpack_require__(5)('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(5)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.2.5.3 get RegExp.prototype.flags
var anObject = __webpack_require__(1);
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var hide = __webpack_require__(12);
var redefine = __webpack_require__(13);
var fails = __webpack_require__(3);
var defined = __webpack_require__(23);
var wks = __webpack_require__(5);

module.exports = function (KEY, length, exec) {
  var SYMBOL = wks(KEY);
  var fns = exec(defined, SYMBOL, ''[KEY]);
  var strfn = fns[0];
  var rxfn = fns[1];
  if (fails(function () {
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  })) {
    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(1);
var aFunction = __webpack_require__(10);
var SPECIES = __webpack_require__(5)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(2);
var $export = __webpack_require__(0);
var redefine = __webpack_require__(13);
var redefineAll = __webpack_require__(41);
var meta = __webpack_require__(29);
var forOf = __webpack_require__(40);
var anInstance = __webpack_require__(39);
var isObject = __webpack_require__(4);
var fails = __webpack_require__(3);
var $iterDetect = __webpack_require__(55);
var setToStringTag = __webpack_require__(42);
var inheritIfRequired = __webpack_require__(72);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  var fixMethod = function (KEY) {
    var fn = proto[KEY];
    redefine(proto, KEY,
      KEY == 'delete' ? function (a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a) {
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance = new C();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new C();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base(), target, C);
        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
    // weak collections should not contains .clear method
    if (IS_WEAK && proto.clear) delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(2);
var hide = __webpack_require__(12);
var uid = __webpack_require__(32);
var TYPED = uid('typed_array');
var VIEW = uid('view');
var ABV = !!(global.ArrayBuffer && global.DataView);
var CONSTR = ABV;
var i = 0;
var l = 9;
var Typed;

var TypedArrayConstructors = (
  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
).split(',');

while (i < l) {
  if (Typed = global[TypedArrayConstructors[i++]]) {
    hide(Typed.prototype, TYPED, true);
    hide(Typed.prototype, VIEW, true);
  } else CONSTR = false;
}

module.exports = {
  ABV: ABV,
  CONSTR: CONSTR,
  TYPED: TYPED,
  VIEW: VIEW
};


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Forced replacement prototype accessors methods
module.exports = __webpack_require__(33) || !__webpack_require__(3)(function () {
  var K = Math.random();
  // In FF throws only define methods
  // eslint-disable-next-line no-undef, no-useless-call
  __defineSetter__.call(null, K, function () { /* empty */ });
  delete __webpack_require__(2)[K];
});


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(0);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(0);
var aFunction = __webpack_require__(10);
var ctx = __webpack_require__(18);
var forOf = __webpack_require__(40);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),
/* 64 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(4);
var document = __webpack_require__(2).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(2);
var core = __webpack_require__(21);
var LIBRARY = __webpack_require__(33);
var wksExt = __webpack_require__(93);
var defineProperty = __webpack_require__(7).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(50)('keys');
var uid = __webpack_require__(32);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 68 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(2).document;
module.exports = document && document.documentElement;


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(4);
var anObject = __webpack_require__(1);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(18)(Function.call, __webpack_require__(16).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 71 */
/***/ (function(module, exports) {

module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(4);
var setPrototypeOf = __webpack_require__(70).set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toInteger = __webpack_require__(24);
var defined = __webpack_require__(23);

module.exports = function repeat(count) {
  var str = String(defined(this));
  var res = '';
  var n = toInteger(count);
  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
  return res;
};


/***/ }),
/* 74 */
/***/ (function(module, exports) {

// 20.2.2.28 Math.sign(x)
module.exports = Math.sign || function sign(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};


/***/ }),
/* 75 */
/***/ (function(module, exports) {

// 20.2.2.14 Math.expm1(x)
var $expm1 = Math.expm1;
module.exports = (!$expm1
  // Old FF bug
  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
  // Tor Browser bug
  || $expm1(-2e-17) != -2e-17
) ? function expm1(x) {
  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
} : $expm1;


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(24);
var defined = __webpack_require__(23);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(33);
var $export = __webpack_require__(0);
var redefine = __webpack_require__(13);
var hide = __webpack_require__(12);
var has = __webpack_require__(11);
var Iterators = __webpack_require__(44);
var $iterCreate = __webpack_require__(78);
var setToStringTag = __webpack_require__(42);
var getPrototypeOf = __webpack_require__(17);
var ITERATOR = __webpack_require__(5)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(36);
var descriptor = __webpack_require__(31);
var setToStringTag = __webpack_require__(42);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(12)(IteratorPrototype, __webpack_require__(5)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__(54);
var defined = __webpack_require__(23);

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

var MATCH = __webpack_require__(5)('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(44);
var ITERATOR = __webpack_require__(5)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(7);
var createDesc = __webpack_require__(31);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(48);
var ITERATOR = __webpack_require__(5)('iterator');
var Iterators = __webpack_require__(44);
module.exports = __webpack_require__(21).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(221);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)

var toObject = __webpack_require__(9);
var toAbsoluteIndex = __webpack_require__(35);
var toLength = __webpack_require__(8);
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = toLength(O.length);
  var aLen = arguments.length;
  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
  var end = aLen > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(30);
var step = __webpack_require__(109);
var Iterators = __webpack_require__(44);
var toIObject = __webpack_require__(15);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(77)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(18);
var invoke = __webpack_require__(99);
var html = __webpack_require__(69);
var cel = __webpack_require__(65);
var global = __webpack_require__(2);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(19)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(2);
var macrotask = __webpack_require__(87).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(19)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver
  } else if (Observer) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    var promise = Promise.resolve();
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(10);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(2);
var DESCRIPTORS = __webpack_require__(6);
var LIBRARY = __webpack_require__(33);
var $typed = __webpack_require__(60);
var hide = __webpack_require__(12);
var redefineAll = __webpack_require__(41);
var fails = __webpack_require__(3);
var anInstance = __webpack_require__(39);
var toInteger = __webpack_require__(24);
var toLength = __webpack_require__(8);
var toIndex = __webpack_require__(118);
var gOPN = __webpack_require__(37).f;
var dP = __webpack_require__(7).f;
var arrayFill = __webpack_require__(85);
var setToStringTag = __webpack_require__(42);
var ARRAY_BUFFER = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE = 'prototype';
var WRONG_LENGTH = 'Wrong length!';
var WRONG_INDEX = 'Wrong index!';
var $ArrayBuffer = global[ARRAY_BUFFER];
var $DataView = global[DATA_VIEW];
var Math = global.Math;
var RangeError = global.RangeError;
// eslint-disable-next-line no-shadow-restricted-names
var Infinity = global.Infinity;
var BaseBuffer = $ArrayBuffer;
var abs = Math.abs;
var pow = Math.pow;
var floor = Math.floor;
var log = Math.log;
var LN2 = Math.LN2;
var BUFFER = 'buffer';
var BYTE_LENGTH = 'byteLength';
var BYTE_OFFSET = 'byteOffset';
var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;

// IEEE754 conversions based on https://github.com/feross/ieee754
function packIEEE754(value, mLen, nBytes) {
  var buffer = Array(nBytes);
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
  var i = 0;
  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
  var e, m, c;
  value = abs(value);
  // eslint-disable-next-line no-self-compare
  if (value != value || value === Infinity) {
    // eslint-disable-next-line no-self-compare
    m = value != value ? 1 : 0;
    e = eMax;
  } else {
    e = floor(log(value) / LN2);
    if (value * (c = pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }
    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * pow(2, eBias - 1) * pow(2, mLen);
      e = 0;
    }
  }
  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
  e = e << mLen | m;
  eLen += mLen;
  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
  buffer[--i] |= s * 128;
  return buffer;
}
function unpackIEEE754(buffer, mLen, nBytes) {
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = eLen - 7;
  var i = nBytes - 1;
  var s = buffer[i--];
  var e = s & 127;
  var m;
  s >>= 7;
  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : s ? -Infinity : Infinity;
  } else {
    m = m + pow(2, mLen);
    e = e - eBias;
  } return (s ? -1 : 1) * m * pow(2, e - mLen);
}

function unpackI32(bytes) {
  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
}
function packI8(it) {
  return [it & 0xff];
}
function packI16(it) {
  return [it & 0xff, it >> 8 & 0xff];
}
function packI32(it) {
  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
}
function packF64(it) {
  return packIEEE754(it, 52, 8);
}
function packF32(it) {
  return packIEEE754(it, 23, 4);
}

function addGetter(C, key, internal) {
  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
}

function get(view, bytes, index, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = store.slice(start, start + bytes);
  return isLittleEndian ? pack : pack.reverse();
}
function set(view, bytes, index, conversion, value, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = conversion(+value);
  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
}

if (!$typed.ABV) {
  $ArrayBuffer = function ArrayBuffer(length) {
    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
    var byteLength = toIndex(length);
    this._b = arrayFill.call(Array(byteLength), 0);
    this[$LENGTH] = byteLength;
  };

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    anInstance(this, $DataView, DATA_VIEW);
    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
    var bufferLength = buffer[$LENGTH];
    var offset = toInteger(byteOffset);
    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
    this[$BUFFER] = buffer;
    this[$OFFSET] = offset;
    this[$LENGTH] = byteLength;
  };

  if (DESCRIPTORS) {
    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
    addGetter($DataView, BUFFER, '_b');
    addGetter($DataView, BYTE_LENGTH, '_l');
    addGetter($DataView, BYTE_OFFSET, '_o');
  }

  redefineAll($DataView[PROTOTYPE], {
    getInt8: function getInt8(byteOffset) {
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1]));
    },
    getUint32: function getUint32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
    },
    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
    },
    setInt8: function setInt8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packF32, value, arguments[2]);
    },
    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
      set(this, 8, byteOffset, packF64, value, arguments[2]);
    }
  });
} else {
  if (!fails(function () {
    $ArrayBuffer(1);
  }) || !fails(function () {
    new $ArrayBuffer(-1); // eslint-disable-line no-new
  }) || fails(function () {
    new $ArrayBuffer(); // eslint-disable-line no-new
    new $ArrayBuffer(1.5); // eslint-disable-line no-new
    new $ArrayBuffer(NaN); // eslint-disable-line no-new
    return $ArrayBuffer.name != ARRAY_BUFFER;
  })) {
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance(this, $ArrayBuffer);
      return new BaseBuffer(toIndex(length));
    };
    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
    }
    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
  }
  // iOS Safari 7.x bug
  var view = new $DataView(new $ArrayBuffer(2));
  var $setInt8 = $DataView[PROTOTYPE].setInt8;
  view.setInt8(0, 2147483648);
  view.setInt8(1, 2147483649);
  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
    setInt8: function setInt8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    }
  }, true);
}
setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);
hide($DataView[PROTOTYPE], $typed.VIEW, true);
exports[ARRAY_BUFFER] = $ArrayBuffer;
exports[DATA_VIEW] = $DataView;


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;

/**
 * 本地缓存组件
 * 本地存储的技术方案：
   1、localStorage
        只考虑localStorage的存储方式，不考虑cookie方式。原因：
        （1）cookie 存储上限只有 4KB，且会加重网络负担，cookie 会被发送到作用域之内的所有http请求，包括js请求，css请求，图片请求，很多异步的请求
        （2）localStorage 存储上线是5MB   
   2、组件规范
        （1）数据存储格式
            旧的游戏：prefix/env/ppuid/gameType/key
            新的游戏：prefix/env/openId/gameType/key
        （2）prefix
            key前缀。默认是ppcache
            如果同一款游戏，后期做推广，gameType或者用户openId(即appid)与自家版相同，推荐prefix改为package name
        （3）key
            存储数据的字段名
            推荐使用驼峰格式（首字母小写其他词首大写），如myFieldName
        （4）expires：-1
            有效期配置
            单位：毫秒
            -1  ：永久保存
            > 0 ：有设置有效期

 * 使用说明
    @method
        检测localstorage是否可用
            isEnable() // ==> true/false
        如果使用规范存储的字段格式，使用方法
            setCache(key, value, expires)
            getCache(key)
            removeCache(key)
        原生的自定义，存储的字段名，不遵循（prefix/env/XXX/gameType/key）格式；try()catch(e){}
            setItem(key, value, expires) // 设置；当存储到达上限之后，该方法不可用
            getItem(key)       // 获取
            removeItem(key)    // 清除
            getAll()           // 获取所有
            clear()            // 清除所有

 * @author 陈立英
 * @example 
 *      var cache = new Cache({
            prefix: 'knowme',
            gameType: 'knowme',
            uid: '123456'
        });

 */
!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {

    var Base = __webpack_require__(332);
    var Url = __webpack_require__(49);
    var win = window;

    var Cache = Base.extend({
        defaults: {
            prefix: 'ppcache', // 数据存储 key 的前缀，默认是ppcache。
            gameType: '', // 游戏类型，例如knowme
            uid: '', // 用户信息，新游戏是openId, 旧游戏是ppuid
            data: {}, // 存储缓存数据 data: {data: value, expires: 0}
            expires: -1 // 有效期，默认则为永久，单位毫秒
        },
        // 浏览器是否支持localStorage
        enable: false,

        /**
         * 初始化入口
         */
        initialize: function initialize() {
            var self = this;
            self.Parent.apply(self, arguments);

            self.isEnable();
        },
        /**
         * 设置本地缓存
         * @name set
         * @param key {String} 存储key
         * @param value {string| JSON Object} 存储内容。value会序列化
         * @param expires {Number} 单位毫秒 内容有效期设置，不设置则为永久缓存
         * @example     
         *      cache.set(key, value, expires);
         */
        setCache: function setCache(key, value, expires) {
            var name = this.getLocalKey(key);
            this.setItem(name, value, expires);
        },
        /**
         * 获取本地缓存
         * @name get
         * @param {string| JSON Object} 数据字段名。
         * @example
         *      cache.get(key);
         */
        getCache: function getCache(key) {
            var name = this.getLocalKey(key);
            return this.getItem(name);
        },
        /**
         * 移除本地缓存的数据'key'
         * @name remove
         */
        removeCache: function removeCache(key) {
            var name = this.getLocalKey(key);
            this.removeItem(name);
        },
        /**
         * 获取本地缓存的key
         */
        getLocalKey: function getLocalKey(key) {
            var prefix = this.get('prefix'),
                ret = [];
            var gameType = this.get('gameType') || '';
            var uid = this.get('uid') || '';
            var env = Url.query('env');

            if (!env || env == 'null') {
                env = 'pro';
            }

            if (prefix !== '') {
                ret.push(prefix);
            }

            if (env !== '') {
                ret.push(env);
            }

            if (uid !== '') {
                ret.push(uid);
            }

            if (gameType !== '') {
                ret.push(gameType);
            }

            if (key !== '') {
                ret.push(key);
            }

            return ret.join('/');
        },
        /**
         * 序列化工具方法
         * @name serialize
         */
        serialize: function serialize(value) {
            return JSON.stringify(value);
        },
        /**
         * 反序列化工具方法
         * @name deserialize
         */
        deserialize: function deserialize(value) {
            if (typeof value != 'string') {
                return undefined;
            }
            try {
                return JSON.parse(value);
            } catch (e) {
                return value || undefined;
            }
        },
        /**
         * 判断key是否失效
         * @return {Boolean}  true 无效； false未失效
         */
        isExpire: function isExpire(time) {
            if (time > 0) {
                return new Date().getTime() > Number(time);
            } else {
                return false;
            }
        },
        /**
         * 设置混存数据
         */
        setItem: function setItem(key, value, expires) {
            var expires = expires || this.get('expires');
            var curStamp = +new Date();
            var newValue;
            try {
                // 存储设置的本地数据
                if (expires > 0) {
                    newValue = {
                        data: value,
                        expires: curStamp + expires
                    };
                } else {
                    newValue = value;
                }
                newValue = this.serialize(newValue);
                localStorage.setItem(key, newValue);
            } catch (e) {
                // this.clear();
            }
        },
        /**
         * 获取缓存数据
         */
        getItem: function getItem(key) {
            var ret = null;

            try {
                var ret = localStorage.getItem(key);
                var opt = this.deserialize(ret);
                var isExpire = this.isExpire(opt.expires);
                // 已经失效
                if (isExpire) {
                    ret = null;
                    this.removeItem(key);
                } else {
                    return opt.expires > 0 ? opt.data : opt;
                }
            } catch (e) {}
        },
        /**
         * 清除全部数据
         */
        clear: function clear() {
            try {
                localStorage.clear();
            } catch (e) {}
        },
        /**
         * 移除数据key
         */
        removeItem: function removeItem(key) {
            try {
                localStorage.removeItem(key);
            } catch (e) {}
        },
        /**
         * 获得所有的本地缓存信息
         */
        getAll: function getAll() {
            var ret = {};
            try {
                for (var i = 0; i < localStorage.length; ++i) {
                    var key = localStorage.key(i);
                    ret[key] = this.getItem(key);
                }
            } catch (e) {}
            return ret;
        },
        /**
         * 浏览器是否支持localStorage。当存储达到上限值后。lcoalStorage.setItem()方法不可用
         * @return { Boolean } 如果浏览器支持 则返回 true, 否则返回 false.
         *  @example
         *      cache.isEnable() => true
         */
        isEnable: function isEnable() {
            var name = '__localStorageTest__';
            try {
                if ('localStorage' in win && win['localStorage'] && localStorage.setItem && localStorage.getItem) {

                    localStorage.setItem(name, name);

                    if (localStorage.getItem(name) == name) {
                        this.enable = true;
                    }
                    localStorage.removeItem(name);
                }
            } catch (e) {}

            return this.enable;
        }
    });

    module.exports = Cache;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(6) && !__webpack_require__(3)(function () {
  return Object.defineProperty(__webpack_require__(65)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(5);


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(11);
var toIObject = __webpack_require__(15);
var arrayIndexOf = __webpack_require__(51)(false);
var IE_PROTO = __webpack_require__(67)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(7);
var anObject = __webpack_require__(1);
var getKeys = __webpack_require__(34);

module.exports = __webpack_require__(6) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(15);
var gOPN = __webpack_require__(37).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(34);
var gOPS = __webpack_require__(52);
var pIE = __webpack_require__(47);
var toObject = __webpack_require__(9);
var IObject = __webpack_require__(46);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(3)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aFunction = __webpack_require__(10);
var isObject = __webpack_require__(4);
var invoke = __webpack_require__(99);
var arraySlice = [].slice;
var factories = {};

var construct = function (F, len, args) {
  if (!(len in factories)) {
    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func
    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
  } return factories[len](F, args);
};

module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aFunction(this);
  var partArgs = arraySlice.call(arguments, 1);
  var bound = function (/* args... */) {
    var args = partArgs.concat(arraySlice.call(arguments));
    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
  };
  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
  return bound;
};


/***/ }),
/* 99 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

var $parseInt = __webpack_require__(2).parseInt;
var $trim = __webpack_require__(43).trim;
var ws = __webpack_require__(71);
var hex = /^[-+]?0[xX]/;

module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
  var string = $trim(String(str), 3);
  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
} : $parseInt;


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

var $parseFloat = __webpack_require__(2).parseFloat;
var $trim = __webpack_require__(43).trim;

module.exports = 1 / $parseFloat(__webpack_require__(71) + '-0') !== -Infinity ? function parseFloat(str) {
  var string = $trim(String(str), 3);
  var result = $parseFloat(string);
  return result === 0 && string.charAt(0) == '-' ? -0 : result;
} : $parseFloat;


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

var cof = __webpack_require__(19);
module.exports = function (it, msg) {
  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
  return +it;
};


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var isObject = __webpack_require__(4);
var floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),
/* 104 */
/***/ (function(module, exports) {

// 20.2.2.20 Math.log1p(x)
module.exports = Math.log1p || function log1p(x) {
  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
};


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var sign = __webpack_require__(74);
var pow = Math.pow;
var EPSILON = pow(2, -52);
var EPSILON32 = pow(2, -23);
var MAX32 = pow(2, 127) * (2 - EPSILON32);
var MIN32 = pow(2, -126);

var roundTiesToEven = function (n) {
  return n + 1 / EPSILON - 1 / EPSILON;
};

module.exports = Math.fround || function fround(x) {
  var $abs = Math.abs(x);
  var $sign = sign(x);
  var a, result;
  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
  a = (1 + EPSILON32 / EPSILON) * $abs;
  result = a - (a - $abs);
  // eslint-disable-next-line no-self-compare
  if (result > MAX32 || result != result) return $sign * Infinity;
  return $sign * result;
};


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(1);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__(10);
var toObject = __webpack_require__(9);
var IObject = __webpack_require__(46);
var toLength = __webpack_require__(8);

module.exports = function (that, callbackfn, aLen, memo, isRight) {
  aFunction(callbackfn);
  var O = toObject(that);
  var self = IObject(O);
  var length = toLength(O.length);
  var index = isRight ? length - 1 : 0;
  var i = isRight ? -1 : 1;
  if (aLen < 2) for (;;) {
    if (index in self) {
      memo = self[index];
      index += i;
      break;
    }
    index += i;
    if (isRight ? index < 0 : length <= index) {
      throw TypeError('Reduce of empty array with no initial value');
    }
  }
  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
    memo = callbackfn(memo, self[index], index, O);
  }
  return memo;
};


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)

var toObject = __webpack_require__(9);
var toAbsoluteIndex = __webpack_require__(35);
var toLength = __webpack_require__(8);

module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
  var O = toObject(this);
  var len = toLength(O.length);
  var to = toAbsoluteIndex(target, len);
  var from = toAbsoluteIndex(start, len);
  var end = arguments.length > 2 ? arguments[2] : undefined;
  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
  var inc = 1;
  if (from < to && to < from + count) {
    inc = -1;
    from += count - 1;
    to += count - 1;
  }
  while (count-- > 0) {
    if (from in O) O[to] = O[from];
    else delete O[to];
    to += inc;
    from += inc;
  } return O;
};


/***/ }),
/* 109 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

// 21.2.5.3 get RegExp.prototype.flags()
if (__webpack_require__(6) && /./g.flags != 'g') __webpack_require__(7).f(RegExp.prototype, 'flags', {
  configurable: true,
  get: __webpack_require__(56)
});


/***/ }),
/* 111 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(1);
var isObject = __webpack_require__(4);
var newPromiseCapability = __webpack_require__(89);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(114);
var validate = __webpack_require__(45);
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__(59)(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(7).f;
var create = __webpack_require__(36);
var redefineAll = __webpack_require__(41);
var ctx = __webpack_require__(18);
var anInstance = __webpack_require__(39);
var forOf = __webpack_require__(40);
var $iterDefine = __webpack_require__(77);
var step = __webpack_require__(109);
var setSpecies = __webpack_require__(38);
var DESCRIPTORS = __webpack_require__(6);
var fastKey = __webpack_require__(29).fastKey;
var validate = __webpack_require__(45);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(114);
var validate = __webpack_require__(45);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(59)(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var each = __webpack_require__(26)(0);
var redefine = __webpack_require__(13);
var meta = __webpack_require__(29);
var assign = __webpack_require__(97);
var weak = __webpack_require__(117);
var isObject = __webpack_require__(4);
var fails = __webpack_require__(3);
var validate = __webpack_require__(45);
var WEAK_MAP = 'WeakMap';
var getWeak = meta.getWeak;
var isExtensible = Object.isExtensible;
var uncaughtFrozenStore = weak.ufstore;
var tmp = {};
var InternalMap;

var wrapper = function (get) {
  return function WeakMap() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};

var methods = {
  // 23.3.3.3 WeakMap.prototype.get(key)
  get: function get(key) {
    if (isObject(key)) {
      var data = getWeak(key);
      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  // 23.3.3.5 WeakMap.prototype.set(key, value)
  set: function set(key, value) {
    return weak.def(validate(this, WEAK_MAP), key, value);
  }
};

// 23.3 WeakMap Objects
var $WeakMap = module.exports = __webpack_require__(59)(WEAK_MAP, wrapper, methods, weak, true, true);

// IE11 WeakMap frozen keys fix
if (fails(function () { return new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7; })) {
  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
  assign(InternalMap.prototype, methods);
  meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function (key) {
    var proto = $WeakMap.prototype;
    var method = proto[key];
    redefine(proto, key, function (a, b) {
      // store frozen objects on internal weakmap shim
      if (isObject(a) && !isExtensible(a)) {
        if (!this._f) this._f = new InternalMap();
        var result = this._f[key](a, b);
        return key == 'set' ? this : result;
      // store all the rest on native weakmap
      } return method.call(this, a, b);
    });
  });
}


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefineAll = __webpack_require__(41);
var getWeak = __webpack_require__(29).getWeak;
var anObject = __webpack_require__(1);
var isObject = __webpack_require__(4);
var anInstance = __webpack_require__(39);
var forOf = __webpack_require__(40);
var createArrayMethod = __webpack_require__(26);
var $has = __webpack_require__(11);
var validate = __webpack_require__(45);
var arrayFind = createArrayMethod(5);
var arrayFindIndex = createArrayMethod(6);
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (that) {
  return that._l || (that._l = new UncaughtFrozenStore());
};
var UncaughtFrozenStore = function () {
  this.a = [];
};
var findUncaughtFrozen = function (store, key) {
  return arrayFind(store.a, function (it) {
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.a.push([key, value]);
  },
  'delete': function (key) {
    var index = arrayFindIndex(this.a, function (it) {
      return it[0] === key;
    });
    if (~index) this.a.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;      // collection type
      that._i = id++;      // collection id
      that._l = undefined; // leak store for uncaught frozen objects
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function (key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
        return data && $has(data, this._i) && delete data[this._i];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
        return data && $has(data, this._i);
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var data = getWeak(anObject(key), true);
    if (data === true) uncaughtFrozenStore(that).set(key, value);
    else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/ecma262/#sec-toindex
var toInteger = __webpack_require__(24);
var toLength = __webpack_require__(8);
module.exports = function (it) {
  if (it === undefined) return 0;
  var number = toInteger(it);
  var length = toLength(number);
  if (number !== length) throw RangeError('Wrong length!');
  return length;
};


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

// all object keys, includes non-enumerable and symbols
var gOPN = __webpack_require__(37);
var gOPS = __webpack_require__(52);
var anObject = __webpack_require__(1);
var Reflect = __webpack_require__(2).Reflect;
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
  var keys = gOPN.f(anObject(it));
  var getSymbols = gOPS.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var isArray = __webpack_require__(53);
var isObject = __webpack_require__(4);
var toLength = __webpack_require__(8);
var ctx = __webpack_require__(18);
var IS_CONCAT_SPREADABLE = __webpack_require__(5)('isConcatSpreadable');

function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
  var element, spreadable;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      spreadable = false;
      if (isObject(element)) {
        spreadable = element[IS_CONCAT_SPREADABLE];
        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
      }

      if (spreadable && depth > 0) {
        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
      } else {
        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
}

module.exports = flattenIntoArray;


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-string-pad-start-end
var toLength = __webpack_require__(8);
var repeat = __webpack_require__(73);
var defined = __webpack_require__(23);

module.exports = function (that, maxLength, fillString, left) {
  var S = String(defined(that));
  var stringLength = S.length;
  var fillStr = fillString === undefined ? ' ' : String(fillString);
  var intMaxLength = toLength(maxLength);
  if (intMaxLength <= stringLength || fillStr == '') return S;
  var fillLen = intMaxLength - stringLength;
  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
  return left ? stringFiller + S : S + stringFiller;
};


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

var getKeys = __webpack_require__(34);
var toIObject = __webpack_require__(15);
var isEnum = __webpack_require__(47).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) if (isEnum.call(O, key = keys[i++])) {
      result.push(isEntries ? [key, O[key]] : O[key]);
    } return result;
  };
};


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(48);
var from = __webpack_require__(124);
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(40);

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),
/* 125 */
/***/ (function(module, exports) {

// https://rwaldron.github.io/proposal-math-extensions/
module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
  if (
    arguments.length === 0
      // eslint-disable-next-line no-self-compare
      || x != x
      // eslint-disable-next-line no-self-compare
      || inLow != inLow
      // eslint-disable-next-line no-self-compare
      || inHigh != inHigh
      // eslint-disable-next-line no-self-compare
      || outLow != outLow
      // eslint-disable-next-line no-self-compare
      || outHigh != outHigh
  ) return NaN;
  if (x === Infinity || x === -Infinity) return x;
  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
};


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {

    /**
     * @file 合并参数
     * @author 子虔
     * @date    2014-08-15 17:43:36
     * @param  {Object}  to - 源
     * @param  {Object}  from - 要处理的对象
     */

    module.exports = function parseParam(to, from) {
        var key,
            obj = {};

        from = from || {};

        for (key in to) {
            if (to.hasOwnProperty(key)) {
                obj[key] = to[key];
                if (from[key] != null) {
                    if (from.hasOwnProperty(key)) {
                        if ($.isPlainObject(obj[key]) && $.isPlainObject(from[key])) {
                            obj[key] = parseParam(obj[key], from[key]);
                        } else {
                            obj[key] = from[key];
                        }
                    }
                }
            }
        }

        return obj;
    };
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {

    /**
     * @file isEqual(来自underscore)
     * @author 子虔
     * @date    2015-02-15 15:37:47
     */
    module.exports = eq;

    // Internal recursive comparison function for `isEqual`.
    function eq(a, b, aStack, bStack) {
        // Identical objects are equal. `0 === -0`, but they aren't identical.
        // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
        if (a === b) return a !== 0 || 1 / a === 1 / b;
        // A strict comparison is necessary because `null == undefined`.
        if (a == null || b == null) return a === b;

        // Compare `[[Class]]` names.
        var className = Object.prototype.toString.call(a);
        if (className !== Object.prototype.toString.call(b)) return false;

        switch (className) {
            // Strings, numbers, regular expressions, dates, and booleans are compared by value.
            case '[object RegExp]':
            // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
            case '[object String]':
                // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
                // equivalent to `new String("5")`.
                return '' + a === '' + b;
            case '[object Number]':
                // `NaN`s are equivalent, but non-reflexive.
                // Object(NaN) is equivalent to NaN
                if (+a !== +a) return +b !== +b;
                // An `egal` comparison is performed for other numeric values.
                return +a === 0 ? 1 / +a === 1 / b : +a === +b;
            case '[object Date]':
            case '[object Boolean]':
                // Coerce dates and booleans to numeric primitive values. Dates are compared by their
                // millisecond representations. Note that invalid dates with millisecond representations
                // of `NaN` are not equivalent.
                return +a === +b;
        }

        var areArrays = className === '[object Array]';

        if (!areArrays) {
            if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) != 'object' || (typeof b === 'undefined' ? 'undefined' : _typeof(b)) != 'object') return false;

            // Objects with different constructors are not equivalent, but `Object`s or `Array`s
            // from different frames are.
            var aCtor = a.constructor,
                bCtor = b.constructor;
            if (aCtor !== bCtor && !(typeof aCtor == 'function' && aCtor instanceof aCtor && typeof bCtor == 'function' && bCtor instanceof bCtor) && 'constructor' in a && 'constructor' in b) {
                return false;
            }
        }
        // Assume equality for cyclic structures. The algorithm for detecting cyclic
        // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.

        // Initializing stack of traversed objects.
        // It's done here since we only need them for objects and arrays comparison.
        aStack = aStack || [];
        bStack = bStack || [];
        var length = aStack.length;
        while (length--) {
            // Linear search. Performance is inversely proportional to the number of
            // unique nested structures.
            if (aStack[length] === a) return bStack[length] === b;
        }

        // Add the first object to the stack of traversed objects.
        aStack.push(a);
        bStack.push(b);

        // Recursively compare objects and arrays.
        if (areArrays) {
            // Compare array lengths to determine if a deep comparison is necessary.
            length = a.length;
            if (length !== b.length) return false;
            // Deep compare the contents, ignoring non-numeric properties.

            while (length--) {
                if (!eq(a[length], b[length], aStack, bStack)) return false;
            }
        } else {
            // Deep compare objects.
            var keys = Object.keys(a),
                key;
            length = keys.length;
            // Ensure that both objects contain the same number of properties before comparing deep equality.
            if (Object.keys(b).length !== length) return false;

            while (length--) {
                // Deep compare each member
                key = keys[length];
                if (!(b.hasOwnProperty(key) && eq(a[key], b[key], aStack, bStack))) return false;
            }
        }
        // Remove the first object from the stack of traversed objects.
        aStack.pop();
        bStack.pop();
        return true;
    }
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

__webpack_require__(130);

__webpack_require__(327);

__webpack_require__(328);

if (global._babelPolyfill) {
  throw new Error("only one instance of babel-polyfill is allowed");
}
global._babelPolyfill = true;

var DEFINE_PROPERTY = "defineProperty";
function define(O, key, value) {
  O[key] || Object[DEFINE_PROPERTY](O, key, {
    writable: true,
    configurable: true,
    value: value
  });
}

define(String.prototype, "padLeft", "".padStart);
define(String.prototype, "padRight", "".padEnd);

"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
  [][key] && define(Array, key, Function.call.bind([][key]));
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(64)))

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * @fileoverview 授权配置
 * @author zhenn
 */

var Url = __webpack_require__(49);

module.exports = {

    // webapi域名配置
    originMap: {
        dev: 'http://up-service.xingyunzhi.cn',
        stage: 'https://sg-service.pengpengla.com',
        pro: 'https://service.upliveapps.com'
    },

    getPrefix: function getPrefix() {
        var prefix = this.originMap[this.env()];

        return prefix;
    },

    getTwitterRequestTokenPath: function getTwitterRequestTokenPath() {
        var prefix = this.getPrefix();
        return prefix + '/webauth/twitter/requesttoken';
    },

    // 通过code获取userToken的webapi路径
    getUsertokenPath: function getUsertokenPath() {
        var prefix = this.getPrefix();
        var target = prefix + '/webauth/auth';
        return target;
    },

    // 获取环境
    env: function env() {
        return Url.query('env') || 'pro';
    },

    // 碰碰在sns平台中信息
    // key值为sourceid
    upInfoInPlatform: {

        //微信平台
        'wechat': {
            appid: 'wx78a12cd5f3b2a993',
            appid_stage: 'wx78a12cd5f3b2a993'
        },

        'fb': {
            appid: '1698316857098420'
        },
        'weibo': {
            appid: '3739970591'
        }

    }

};

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(131);
__webpack_require__(133);
__webpack_require__(134);
__webpack_require__(135);
__webpack_require__(136);
__webpack_require__(137);
__webpack_require__(138);
__webpack_require__(139);
__webpack_require__(140);
__webpack_require__(141);
__webpack_require__(142);
__webpack_require__(143);
__webpack_require__(144);
__webpack_require__(145);
__webpack_require__(146);
__webpack_require__(147);
__webpack_require__(149);
__webpack_require__(150);
__webpack_require__(151);
__webpack_require__(152);
__webpack_require__(153);
__webpack_require__(154);
__webpack_require__(155);
__webpack_require__(156);
__webpack_require__(157);
__webpack_require__(158);
__webpack_require__(159);
__webpack_require__(160);
__webpack_require__(161);
__webpack_require__(162);
__webpack_require__(163);
__webpack_require__(164);
__webpack_require__(165);
__webpack_require__(166);
__webpack_require__(167);
__webpack_require__(168);
__webpack_require__(169);
__webpack_require__(170);
__webpack_require__(171);
__webpack_require__(172);
__webpack_require__(173);
__webpack_require__(174);
__webpack_require__(175);
__webpack_require__(176);
__webpack_require__(177);
__webpack_require__(178);
__webpack_require__(179);
__webpack_require__(180);
__webpack_require__(181);
__webpack_require__(182);
__webpack_require__(183);
__webpack_require__(184);
__webpack_require__(185);
__webpack_require__(186);
__webpack_require__(187);
__webpack_require__(188);
__webpack_require__(189);
__webpack_require__(190);
__webpack_require__(191);
__webpack_require__(192);
__webpack_require__(193);
__webpack_require__(194);
__webpack_require__(195);
__webpack_require__(196);
__webpack_require__(197);
__webpack_require__(198);
__webpack_require__(199);
__webpack_require__(200);
__webpack_require__(201);
__webpack_require__(202);
__webpack_require__(203);
__webpack_require__(204);
__webpack_require__(205);
__webpack_require__(206);
__webpack_require__(207);
__webpack_require__(208);
__webpack_require__(209);
__webpack_require__(211);
__webpack_require__(212);
__webpack_require__(214);
__webpack_require__(215);
__webpack_require__(216);
__webpack_require__(217);
__webpack_require__(218);
__webpack_require__(219);
__webpack_require__(220);
__webpack_require__(222);
__webpack_require__(223);
__webpack_require__(224);
__webpack_require__(225);
__webpack_require__(226);
__webpack_require__(227);
__webpack_require__(228);
__webpack_require__(229);
__webpack_require__(230);
__webpack_require__(231);
__webpack_require__(232);
__webpack_require__(233);
__webpack_require__(234);
__webpack_require__(86);
__webpack_require__(235);
__webpack_require__(236);
__webpack_require__(110);
__webpack_require__(237);
__webpack_require__(238);
__webpack_require__(239);
__webpack_require__(240);
__webpack_require__(241);
__webpack_require__(113);
__webpack_require__(115);
__webpack_require__(116);
__webpack_require__(242);
__webpack_require__(243);
__webpack_require__(244);
__webpack_require__(245);
__webpack_require__(246);
__webpack_require__(247);
__webpack_require__(248);
__webpack_require__(249);
__webpack_require__(250);
__webpack_require__(251);
__webpack_require__(252);
__webpack_require__(253);
__webpack_require__(254);
__webpack_require__(255);
__webpack_require__(256);
__webpack_require__(257);
__webpack_require__(258);
__webpack_require__(259);
__webpack_require__(260);
__webpack_require__(261);
__webpack_require__(262);
__webpack_require__(263);
__webpack_require__(264);
__webpack_require__(265);
__webpack_require__(266);
__webpack_require__(267);
__webpack_require__(268);
__webpack_require__(269);
__webpack_require__(270);
__webpack_require__(271);
__webpack_require__(272);
__webpack_require__(273);
__webpack_require__(274);
__webpack_require__(275);
__webpack_require__(276);
__webpack_require__(277);
__webpack_require__(278);
__webpack_require__(279);
__webpack_require__(280);
__webpack_require__(281);
__webpack_require__(282);
__webpack_require__(283);
__webpack_require__(284);
__webpack_require__(285);
__webpack_require__(286);
__webpack_require__(287);
__webpack_require__(288);
__webpack_require__(289);
__webpack_require__(290);
__webpack_require__(291);
__webpack_require__(292);
__webpack_require__(293);
__webpack_require__(294);
__webpack_require__(295);
__webpack_require__(296);
__webpack_require__(297);
__webpack_require__(298);
__webpack_require__(299);
__webpack_require__(300);
__webpack_require__(301);
__webpack_require__(302);
__webpack_require__(303);
__webpack_require__(304);
__webpack_require__(305);
__webpack_require__(306);
__webpack_require__(307);
__webpack_require__(308);
__webpack_require__(309);
__webpack_require__(310);
__webpack_require__(311);
__webpack_require__(312);
__webpack_require__(313);
__webpack_require__(314);
__webpack_require__(315);
__webpack_require__(316);
__webpack_require__(317);
__webpack_require__(318);
__webpack_require__(319);
__webpack_require__(320);
__webpack_require__(321);
__webpack_require__(322);
__webpack_require__(323);
__webpack_require__(324);
__webpack_require__(325);
__webpack_require__(326);
module.exports = __webpack_require__(21);


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(2);
var has = __webpack_require__(11);
var DESCRIPTORS = __webpack_require__(6);
var $export = __webpack_require__(0);
var redefine = __webpack_require__(13);
var META = __webpack_require__(29).KEY;
var $fails = __webpack_require__(3);
var shared = __webpack_require__(50);
var setToStringTag = __webpack_require__(42);
var uid = __webpack_require__(32);
var wks = __webpack_require__(5);
var wksExt = __webpack_require__(93);
var wksDefine = __webpack_require__(66);
var enumKeys = __webpack_require__(132);
var isArray = __webpack_require__(53);
var anObject = __webpack_require__(1);
var toIObject = __webpack_require__(15);
var toPrimitive = __webpack_require__(22);
var createDesc = __webpack_require__(31);
var _create = __webpack_require__(36);
var gOPNExt = __webpack_require__(96);
var $GOPD = __webpack_require__(16);
var $DP = __webpack_require__(7);
var $keys = __webpack_require__(34);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(37).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(47).f = $propertyIsEnumerable;
  __webpack_require__(52).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(33)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    if (it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    replacer = args[1];
    if (typeof replacer == 'function') $replacer = replacer;
    if ($replacer || !isArray(replacer)) replacer = function (key, value) {
      if ($replacer) value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(12)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(34);
var gOPS = __webpack_require__(52);
var pIE = __webpack_require__(47);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(36) });


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(6), 'Object', { defineProperty: __webpack_require__(7).f });


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$export($export.S + $export.F * !__webpack_require__(6), 'Object', { defineProperties: __webpack_require__(95) });


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(15);
var $getOwnPropertyDescriptor = __webpack_require__(16).f;

__webpack_require__(25)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(9);
var $getPrototypeOf = __webpack_require__(17);

__webpack_require__(25)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(9);
var $keys = __webpack_require__(34);

__webpack_require__(25)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 Object.getOwnPropertyNames(O)
__webpack_require__(25)('getOwnPropertyNames', function () {
  return __webpack_require__(96).f;
});


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.5 Object.freeze(O)
var isObject = __webpack_require__(4);
var meta = __webpack_require__(29).onFreeze;

__webpack_require__(25)('freeze', function ($freeze) {
  return function freeze(it) {
    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
  };
});


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.17 Object.seal(O)
var isObject = __webpack_require__(4);
var meta = __webpack_require__(29).onFreeze;

__webpack_require__(25)('seal', function ($seal) {
  return function seal(it) {
    return $seal && isObject(it) ? $seal(meta(it)) : it;
  };
});


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.15 Object.preventExtensions(O)
var isObject = __webpack_require__(4);
var meta = __webpack_require__(29).onFreeze;

__webpack_require__(25)('preventExtensions', function ($preventExtensions) {
  return function preventExtensions(it) {
    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
  };
});


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.12 Object.isFrozen(O)
var isObject = __webpack_require__(4);

__webpack_require__(25)('isFrozen', function ($isFrozen) {
  return function isFrozen(it) {
    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
  };
});


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.13 Object.isSealed(O)
var isObject = __webpack_require__(4);

__webpack_require__(25)('isSealed', function ($isSealed) {
  return function isSealed(it) {
    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
  };
});


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.11 Object.isExtensible(O)
var isObject = __webpack_require__(4);

__webpack_require__(25)('isExtensible', function ($isExtensible) {
  return function isExtensible(it) {
    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
  };
});


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(0);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(97) });


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.10 Object.is(value1, value2)
var $export = __webpack_require__(0);
$export($export.S, 'Object', { is: __webpack_require__(148) });


/***/ }),
/* 148 */
/***/ (function(module, exports) {

// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(0);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(70).set });


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.3.6 Object.prototype.toString()
var classof = __webpack_require__(48);
var test = {};
test[__webpack_require__(5)('toStringTag')] = 'z';
if (test + '' != '[object z]') {
  __webpack_require__(13)(Object.prototype, 'toString', function toString() {
    return '[object ' + classof(this) + ']';
  }, true);
}


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
var $export = __webpack_require__(0);

$export($export.P, 'Function', { bind: __webpack_require__(98) });


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(7).f;
var FProto = Function.prototype;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// 19.2.4.2 name
NAME in FProto || __webpack_require__(6) && dP(FProto, NAME, {
  configurable: true,
  get: function () {
    try {
      return ('' + this).match(nameRE)[1];
    } catch (e) {
      return '';
    }
  }
});


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__(4);
var getPrototypeOf = __webpack_require__(17);
var HAS_INSTANCE = __webpack_require__(5)('hasInstance');
var FunctionProto = Function.prototype;
// 19.2.3.6 Function.prototype[@@hasInstance](V)
if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(7).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
  if (typeof this != 'function' || !isObject(O)) return false;
  if (!isObject(this.prototype)) return O instanceof this;
  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
  return false;
} });


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $parseInt = __webpack_require__(100);
// 18.2.5 parseInt(string, radix)
$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $parseFloat = __webpack_require__(101);
// 18.2.4 parseFloat(string)
$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(2);
var has = __webpack_require__(11);
var cof = __webpack_require__(19);
var inheritIfRequired = __webpack_require__(72);
var toPrimitive = __webpack_require__(22);
var fails = __webpack_require__(3);
var gOPN = __webpack_require__(37).f;
var gOPD = __webpack_require__(16).f;
var dP = __webpack_require__(7).f;
var $trim = __webpack_require__(43).trim;
var NUMBER = 'Number';
var $Number = global[NUMBER];
var Base = $Number;
var proto = $Number.prototype;
// Opera ~12 has broken Object#toString
var BROKEN_COF = cof(__webpack_require__(36)(proto)) == NUMBER;
var TRIM = 'trim' in String.prototype;

// 7.1.3 ToNumber(argument)
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  if (typeof it == 'string' && it.length > 2) {
    it = TRIM ? it.trim() : $trim(it, 3);
    var first = it.charCodeAt(0);
    var third, radix, maxCode;
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
        default: return +it;
      }
      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
        code = digits.charCodeAt(i);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
  $Number = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var that = this;
    return that instanceof $Number
      // check on 1..constructor(foo) case
      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
  };
  for (var keys = __webpack_require__(6) ? gOPN(Base) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES6 (in case, if modules with ES6 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(Base, key = keys[j]) && !has($Number, key)) {
      dP($Number, key, gOPD(Base, key));
    }
  }
  $Number.prototype = proto;
  proto.constructor = $Number;
  __webpack_require__(13)(global, NUMBER, $Number);
}


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toInteger = __webpack_require__(24);
var aNumberValue = __webpack_require__(102);
var repeat = __webpack_require__(73);
var $toFixed = 1.0.toFixed;
var floor = Math.floor;
var data = [0, 0, 0, 0, 0, 0];
var ERROR = 'Number.toFixed: incorrect invocation!';
var ZERO = '0';

var multiply = function (n, c) {
  var i = -1;
  var c2 = c;
  while (++i < 6) {
    c2 += n * data[i];
    data[i] = c2 % 1e7;
    c2 = floor(c2 / 1e7);
  }
};
var divide = function (n) {
  var i = 6;
  var c = 0;
  while (--i >= 0) {
    c += data[i];
    data[i] = floor(c / n);
    c = (c % n) * 1e7;
  }
};
var numToString = function () {
  var i = 6;
  var s = '';
  while (--i >= 0) {
    if (s !== '' || i === 0 || data[i] !== 0) {
      var t = String(data[i]);
      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
    }
  } return s;
};
var pow = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};
var log = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  } return n;
};

$export($export.P + $export.F * (!!$toFixed && (
  0.00008.toFixed(3) !== '0.000' ||
  0.9.toFixed(0) !== '1' ||
  1.255.toFixed(2) !== '1.25' ||
  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
) || !__webpack_require__(3)(function () {
  // V8 ~ Android 4.3-
  $toFixed.call({});
})), 'Number', {
  toFixed: function toFixed(fractionDigits) {
    var x = aNumberValue(this, ERROR);
    var f = toInteger(fractionDigits);
    var s = '';
    var m = ZERO;
    var e, z, j, k;
    if (f < 0 || f > 20) throw RangeError(ERROR);
    // eslint-disable-next-line no-self-compare
    if (x != x) return 'NaN';
    if (x <= -1e21 || x >= 1e21) return String(x);
    if (x < 0) {
      s = '-';
      x = -x;
    }
    if (x > 1e-21) {
      e = log(x * pow(2, 69, 1)) - 69;
      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(0, z);
        j = f;
        while (j >= 7) {
          multiply(1e7, 0);
          j -= 7;
        }
        multiply(pow(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(1 << 23);
          j -= 23;
        }
        divide(1 << j);
        multiply(1, 1);
        divide(2);
        m = numToString();
      } else {
        multiply(0, z);
        multiply(1 << -e, 0);
        m = numToString() + repeat.call(ZERO, f);
      }
    }
    if (f > 0) {
      k = m.length;
      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
    } else {
      m = s + m;
    } return m;
  }
});


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $fails = __webpack_require__(3);
var aNumberValue = __webpack_require__(102);
var $toPrecision = 1.0.toPrecision;

$export($export.P + $export.F * ($fails(function () {
  // IE7-
  return $toPrecision.call(1, undefined) !== '1';
}) || !$fails(function () {
  // V8 ~ Android 4.3-
  $toPrecision.call({});
})), 'Number', {
  toPrecision: function toPrecision(precision) {
    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
  }
});


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.1 Number.EPSILON
var $export = __webpack_require__(0);

$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.2 Number.isFinite(number)
var $export = __webpack_require__(0);
var _isFinite = __webpack_require__(2).isFinite;

$export($export.S, 'Number', {
  isFinite: function isFinite(it) {
    return typeof it == 'number' && _isFinite(it);
  }
});


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var $export = __webpack_require__(0);

$export($export.S, 'Number', { isInteger: __webpack_require__(103) });


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.4 Number.isNaN(number)
var $export = __webpack_require__(0);

$export($export.S, 'Number', {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.5 Number.isSafeInteger(number)
var $export = __webpack_require__(0);
var isInteger = __webpack_require__(103);
var abs = Math.abs;

$export($export.S, 'Number', {
  isSafeInteger: function isSafeInteger(number) {
    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
  }
});


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.6 Number.MAX_SAFE_INTEGER
var $export = __webpack_require__(0);

$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.10 Number.MIN_SAFE_INTEGER
var $export = __webpack_require__(0);

$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $parseFloat = __webpack_require__(101);
// 20.1.2.12 Number.parseFloat(string)
$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $parseInt = __webpack_require__(100);
// 20.1.2.13 Number.parseInt(string, radix)
$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.3 Math.acosh(x)
var $export = __webpack_require__(0);
var log1p = __webpack_require__(104);
var sqrt = Math.sqrt;
var $acosh = Math.acosh;

$export($export.S + $export.F * !($acosh
  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
  && Math.floor($acosh(Number.MAX_VALUE)) == 710
  // Tor Browser bug: Math.acosh(Infinity) -> NaN
  && $acosh(Infinity) == Infinity
), 'Math', {
  acosh: function acosh(x) {
    return (x = +x) < 1 ? NaN : x > 94906265.62425156
      ? Math.log(x) + Math.LN2
      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
  }
});


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.5 Math.asinh(x)
var $export = __webpack_require__(0);
var $asinh = Math.asinh;

function asinh(x) {
  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
}

// Tor Browser bug: Math.asinh(0) -> -0
$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.7 Math.atanh(x)
var $export = __webpack_require__(0);
var $atanh = Math.atanh;

// Tor Browser bug: Math.atanh(-0) -> 0
$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
  atanh: function atanh(x) {
    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
  }
});


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.9 Math.cbrt(x)
var $export = __webpack_require__(0);
var sign = __webpack_require__(74);

$export($export.S, 'Math', {
  cbrt: function cbrt(x) {
    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
  }
});


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.11 Math.clz32(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  clz32: function clz32(x) {
    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
  }
});


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.12 Math.cosh(x)
var $export = __webpack_require__(0);
var exp = Math.exp;

$export($export.S, 'Math', {
  cosh: function cosh(x) {
    return (exp(x = +x) + exp(-x)) / 2;
  }
});


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.14 Math.expm1(x)
var $export = __webpack_require__(0);
var $expm1 = __webpack_require__(75);

$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', { fround: __webpack_require__(105) });


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
var $export = __webpack_require__(0);
var abs = Math.abs;

$export($export.S, 'Math', {
  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
    var sum = 0;
    var i = 0;
    var aLen = arguments.length;
    var larg = 0;
    var arg, div;
    while (i < aLen) {
      arg = abs(arguments[i++]);
      if (larg < arg) {
        div = larg / arg;
        sum = sum * div * div + 1;
        larg = arg;
      } else if (arg > 0) {
        div = arg / larg;
        sum += div * div;
      } else sum += arg;
    }
    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
  }
});


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.18 Math.imul(x, y)
var $export = __webpack_require__(0);
var $imul = Math.imul;

// some WebKit versions fails with big numbers, some has wrong arity
$export($export.S + $export.F * __webpack_require__(3)(function () {
  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
}), 'Math', {
  imul: function imul(x, y) {
    var UINT16 = 0xffff;
    var xn = +x;
    var yn = +y;
    var xl = UINT16 & xn;
    var yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
});


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.21 Math.log10(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  log10: function log10(x) {
    return Math.log(x) * Math.LOG10E;
  }
});


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.20 Math.log1p(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', { log1p: __webpack_require__(104) });


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.22 Math.log2(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  log2: function log2(x) {
    return Math.log(x) / Math.LN2;
  }
});


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.28 Math.sign(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', { sign: __webpack_require__(74) });


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.30 Math.sinh(x)
var $export = __webpack_require__(0);
var expm1 = __webpack_require__(75);
var exp = Math.exp;

// V8 near Chromium 38 has a problem with very small numbers
$export($export.S + $export.F * __webpack_require__(3)(function () {
  return !Math.sinh(-2e-17) != -2e-17;
}), 'Math', {
  sinh: function sinh(x) {
    return Math.abs(x = +x) < 1
      ? (expm1(x) - expm1(-x)) / 2
      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
  }
});


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.33 Math.tanh(x)
var $export = __webpack_require__(0);
var expm1 = __webpack_require__(75);
var exp = Math.exp;

$export($export.S, 'Math', {
  tanh: function tanh(x) {
    var a = expm1(x = +x);
    var b = expm1(-x);
    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
  }
});


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.34 Math.trunc(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  trunc: function trunc(it) {
    return (it > 0 ? Math.floor : Math.ceil)(it);
  }
});


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var toAbsoluteIndex = __webpack_require__(35);
var fromCharCode = String.fromCharCode;
var $fromCodePoint = String.fromCodePoint;

// length should be 1, old FF problem
$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
  // 21.1.2.2 String.fromCodePoint(...codePoints)
  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
    var res = [];
    var aLen = arguments.length;
    var i = 0;
    var code;
    while (aLen > i) {
      code = +arguments[i++];
      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
      res.push(code < 0x10000
        ? fromCharCode(code)
        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
      );
    } return res.join('');
  }
});


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var toIObject = __webpack_require__(15);
var toLength = __webpack_require__(8);

$export($export.S, 'String', {
  // 21.1.2.4 String.raw(callSite, ...substitutions)
  raw: function raw(callSite) {
    var tpl = toIObject(callSite.raw);
    var len = toLength(tpl.length);
    var aLen = arguments.length;
    var res = [];
    var i = 0;
    while (len > i) {
      res.push(String(tpl[i++]));
      if (i < aLen) res.push(String(arguments[i]));
    } return res.join('');
  }
});


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.1.3.25 String.prototype.trim()
__webpack_require__(43)('trim', function ($trim) {
  return function trim() {
    return $trim(this, 3);
  };
});


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(76)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(77)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $at = __webpack_require__(76)(false);
$export($export.P, 'String', {
  // 21.1.3.3 String.prototype.codePointAt(pos)
  codePointAt: function codePointAt(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])

var $export = __webpack_require__(0);
var toLength = __webpack_require__(8);
var context = __webpack_require__(79);
var ENDS_WITH = 'endsWith';
var $endsWith = ''[ENDS_WITH];

$export($export.P + $export.F * __webpack_require__(80)(ENDS_WITH), 'String', {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = context(this, searchString, ENDS_WITH);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = toLength(that.length);
    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
    var search = String(searchString);
    return $endsWith
      ? $endsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.7 String.prototype.includes(searchString, position = 0)

var $export = __webpack_require__(0);
var context = __webpack_require__(79);
var INCLUDES = 'includes';

$export($export.P + $export.F * __webpack_require__(80)(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);

$export($export.P, 'String', {
  // 21.1.3.13 String.prototype.repeat(count)
  repeat: __webpack_require__(73)
});


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])

var $export = __webpack_require__(0);
var toLength = __webpack_require__(8);
var context = __webpack_require__(79);
var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * __webpack_require__(80)(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = context(this, searchString, STARTS_WITH);
    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.2 String.prototype.anchor(name)
__webpack_require__(14)('anchor', function (createHTML) {
  return function anchor(name) {
    return createHTML(this, 'a', 'name', name);
  };
});


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.3 String.prototype.big()
__webpack_require__(14)('big', function (createHTML) {
  return function big() {
    return createHTML(this, 'big', '', '');
  };
});


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.4 String.prototype.blink()
__webpack_require__(14)('blink', function (createHTML) {
  return function blink() {
    return createHTML(this, 'blink', '', '');
  };
});


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.5 String.prototype.bold()
__webpack_require__(14)('bold', function (createHTML) {
  return function bold() {
    return createHTML(this, 'b', '', '');
  };
});


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.6 String.prototype.fixed()
__webpack_require__(14)('fixed', function (createHTML) {
  return function fixed() {
    return createHTML(this, 'tt', '', '');
  };
});


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.7 String.prototype.fontcolor(color)
__webpack_require__(14)('fontcolor', function (createHTML) {
  return function fontcolor(color) {
    return createHTML(this, 'font', 'color', color);
  };
});


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.8 String.prototype.fontsize(size)
__webpack_require__(14)('fontsize', function (createHTML) {
  return function fontsize(size) {
    return createHTML(this, 'font', 'size', size);
  };
});


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.9 String.prototype.italics()
__webpack_require__(14)('italics', function (createHTML) {
  return function italics() {
    return createHTML(this, 'i', '', '');
  };
});


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.10 String.prototype.link(url)
__webpack_require__(14)('link', function (createHTML) {
  return function link(url) {
    return createHTML(this, 'a', 'href', url);
  };
});


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.11 String.prototype.small()
__webpack_require__(14)('small', function (createHTML) {
  return function small() {
    return createHTML(this, 'small', '', '');
  };
});


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.12 String.prototype.strike()
__webpack_require__(14)('strike', function (createHTML) {
  return function strike() {
    return createHTML(this, 'strike', '', '');
  };
});


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.13 String.prototype.sub()
__webpack_require__(14)('sub', function (createHTML) {
  return function sub() {
    return createHTML(this, 'sub', '', '');
  };
});


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.14 String.prototype.sup()
__webpack_require__(14)('sup', function (createHTML) {
  return function sup() {
    return createHTML(this, 'sup', '', '');
  };
});


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.3.1 / 15.9.4.4 Date.now()
var $export = __webpack_require__(0);

$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(9);
var toPrimitive = __webpack_require__(22);

$export($export.P + $export.F * __webpack_require__(3)(function () {
  return new Date(NaN).toJSON() !== null
    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
}), 'Date', {
  // eslint-disable-next-line no-unused-vars
  toJSON: function toJSON(key) {
    var O = toObject(this);
    var pv = toPrimitive(O);
    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
  }
});


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var $export = __webpack_require__(0);
var toISOString = __webpack_require__(210);

// PhantomJS / old WebKit has a broken implementations
$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
  toISOString: toISOString
});


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var fails = __webpack_require__(3);
var getTime = Date.prototype.getTime;
var $toISOString = Date.prototype.toISOString;

var lz = function (num) {
  return num > 9 ? num : '0' + num;
};

// PhantomJS / old WebKit has a broken implementations
module.exports = (fails(function () {
  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
}) || !fails(function () {
  $toISOString.call(new Date(NaN));
})) ? function toISOString() {
  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
  var d = this;
  var y = d.getUTCFullYear();
  var m = d.getUTCMilliseconds();
  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
} : $toISOString;


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

var DateProto = Date.prototype;
var INVALID_DATE = 'Invalid Date';
var TO_STRING = 'toString';
var $toString = DateProto[TO_STRING];
var getTime = DateProto.getTime;
if (new Date(NaN) + '' != INVALID_DATE) {
  __webpack_require__(13)(DateProto, TO_STRING, function toString() {
    var value = getTime.call(this);
    // eslint-disable-next-line no-self-compare
    return value === value ? $toString.call(this) : INVALID_DATE;
  });
}


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

var TO_PRIMITIVE = __webpack_require__(5)('toPrimitive');
var proto = Date.prototype;

if (!(TO_PRIMITIVE in proto)) __webpack_require__(12)(proto, TO_PRIMITIVE, __webpack_require__(213));


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(1);
var toPrimitive = __webpack_require__(22);
var NUMBER = 'number';

module.exports = function (hint) {
  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
  return toPrimitive(anObject(this), hint != NUMBER);
};


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
var $export = __webpack_require__(0);

$export($export.S, 'Array', { isArray: __webpack_require__(53) });


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(18);
var $export = __webpack_require__(0);
var toObject = __webpack_require__(9);
var call = __webpack_require__(106);
var isArrayIter = __webpack_require__(81);
var toLength = __webpack_require__(8);
var createProperty = __webpack_require__(82);
var getIterFn = __webpack_require__(83);

$export($export.S + $export.F * !__webpack_require__(55)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var createProperty = __webpack_require__(82);

// WebKit Array.of isn't generic
$export($export.S + $export.F * __webpack_require__(3)(function () {
  function F() { /* empty */ }
  return !(Array.of.call(F) instanceof F);
}), 'Array', {
  // 22.1.2.3 Array.of( ...items)
  of: function of(/* ...args */) {
    var index = 0;
    var aLen = arguments.length;
    var result = new (typeof this == 'function' ? this : Array)(aLen);
    while (aLen > index) createProperty(result, index, arguments[index++]);
    result.length = aLen;
    return result;
  }
});


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.13 Array.prototype.join(separator)
var $export = __webpack_require__(0);
var toIObject = __webpack_require__(15);
var arrayJoin = [].join;

// fallback for not array-like strings
$export($export.P + $export.F * (__webpack_require__(46) != Object || !__webpack_require__(20)(arrayJoin)), 'Array', {
  join: function join(separator) {
    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
  }
});


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var html = __webpack_require__(69);
var cof = __webpack_require__(19);
var toAbsoluteIndex = __webpack_require__(35);
var toLength = __webpack_require__(8);
var arraySlice = [].slice;

// fallback for not array-like ES3 strings and DOM objects
$export($export.P + $export.F * __webpack_require__(3)(function () {
  if (html) arraySlice.call(html);
}), 'Array', {
  slice: function slice(begin, end) {
    var len = toLength(this.length);
    var klass = cof(this);
    end = end === undefined ? len : end;
    if (klass == 'Array') return arraySlice.call(this, begin, end);
    var start = toAbsoluteIndex(begin, len);
    var upTo = toAbsoluteIndex(end, len);
    var size = toLength(upTo - start);
    var cloned = Array(size);
    var i = 0;
    for (; i < size; i++) cloned[i] = klass == 'String'
      ? this.charAt(start + i)
      : this[start + i];
    return cloned;
  }
});


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var aFunction = __webpack_require__(10);
var toObject = __webpack_require__(9);
var fails = __webpack_require__(3);
var $sort = [].sort;
var test = [1, 2, 3];

$export($export.P + $export.F * (fails(function () {
  // IE8-
  test.sort(undefined);
}) || !fails(function () {
  // V8 bug
  test.sort(null);
  // Old WebKit
}) || !__webpack_require__(20)($sort)), 'Array', {
  // 22.1.3.25 Array.prototype.sort(comparefn)
  sort: function sort(comparefn) {
    return comparefn === undefined
      ? $sort.call(toObject(this))
      : $sort.call(toObject(this), aFunction(comparefn));
  }
});


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $forEach = __webpack_require__(26)(0);
var STRICT = __webpack_require__(20)([].forEach, true);

$export($export.P + $export.F * !STRICT, 'Array', {
  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
  forEach: function forEach(callbackfn /* , thisArg */) {
    return $forEach(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(4);
var isArray = __webpack_require__(53);
var SPECIES = __webpack_require__(5)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $map = __webpack_require__(26)(1);

$export($export.P + $export.F * !__webpack_require__(20)([].map, true), 'Array', {
  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $filter = __webpack_require__(26)(2);

$export($export.P + $export.F * !__webpack_require__(20)([].filter, true), 'Array', {
  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $some = __webpack_require__(26)(3);

$export($export.P + $export.F * !__webpack_require__(20)([].some, true), 'Array', {
  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
  some: function some(callbackfn /* , thisArg */) {
    return $some(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $every = __webpack_require__(26)(4);

$export($export.P + $export.F * !__webpack_require__(20)([].every, true), 'Array', {
  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
  every: function every(callbackfn /* , thisArg */) {
    return $every(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $reduce = __webpack_require__(107);

$export($export.P + $export.F * !__webpack_require__(20)([].reduce, true), 'Array', {
  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
  reduce: function reduce(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
  }
});


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $reduce = __webpack_require__(107);

$export($export.P + $export.F * !__webpack_require__(20)([].reduceRight, true), 'Array', {
  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
  }
});


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $indexOf = __webpack_require__(51)(false);
var $native = [].indexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(20)($native)), 'Array', {
  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? $native.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments[1]);
  }
});


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toIObject = __webpack_require__(15);
var toInteger = __webpack_require__(24);
var toLength = __webpack_require__(8);
var $native = [].lastIndexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(20)($native)), 'Array', {
  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
    // convert -0 to +0
    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
    var O = toIObject(this);
    var length = toLength(O.length);
    var index = length - 1;
    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
    if (index < 0) index = length + index;
    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
    return -1;
  }
});


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
var $export = __webpack_require__(0);

$export($export.P, 'Array', { copyWithin: __webpack_require__(108) });

__webpack_require__(30)('copyWithin');


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
var $export = __webpack_require__(0);

$export($export.P, 'Array', { fill: __webpack_require__(85) });

__webpack_require__(30)('fill');


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = __webpack_require__(0);
var $find = __webpack_require__(26)(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(30)(KEY);


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
var $export = __webpack_require__(0);
var $find = __webpack_require__(26)(6);
var KEY = 'findIndex';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(30)(KEY);


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(38)('Array');


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(2);
var inheritIfRequired = __webpack_require__(72);
var dP = __webpack_require__(7).f;
var gOPN = __webpack_require__(37).f;
var isRegExp = __webpack_require__(54);
var $flags = __webpack_require__(56);
var $RegExp = global.RegExp;
var Base = $RegExp;
var proto = $RegExp.prototype;
var re1 = /a/g;
var re2 = /a/g;
// "new" creates a new object, old webkit buggy here
var CORRECT_NEW = new $RegExp(re1) !== re1;

if (__webpack_require__(6) && (!CORRECT_NEW || __webpack_require__(3)(function () {
  re2[__webpack_require__(5)('match')] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
}))) {
  $RegExp = function RegExp(p, f) {
    var tiRE = this instanceof $RegExp;
    var piRE = isRegExp(p);
    var fiU = f === undefined;
    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
      : inheritIfRequired(CORRECT_NEW
        ? new Base(piRE && !fiU ? p.source : p, f)
        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
      , tiRE ? this : proto, $RegExp);
  };
  var proxy = function (key) {
    key in $RegExp || dP($RegExp, key, {
      configurable: true,
      get: function () { return Base[key]; },
      set: function (it) { Base[key] = it; }
    });
  };
  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
  proto.constructor = $RegExp;
  $RegExp.prototype = proto;
  __webpack_require__(13)(global, 'RegExp', $RegExp);
}

__webpack_require__(38)('RegExp');


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(110);
var anObject = __webpack_require__(1);
var $flags = __webpack_require__(56);
var DESCRIPTORS = __webpack_require__(6);
var TO_STRING = 'toString';
var $toString = /./[TO_STRING];

var define = function (fn) {
  __webpack_require__(13)(RegExp.prototype, TO_STRING, fn, true);
};

// 21.2.5.14 RegExp.prototype.toString()
if (__webpack_require__(3)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
  define(function toString() {
    var R = anObject(this);
    return '/'.concat(R.source, '/',
      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
  });
// FF44- RegExp#toString has a wrong name
} else if ($toString.name != TO_STRING) {
  define(function toString() {
    return $toString.call(this);
  });
}


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

// @@match logic
__webpack_require__(57)('match', 1, function (defined, MATCH, $match) {
  // 21.1.3.11 String.prototype.match(regexp)
  return [function match(regexp) {
    'use strict';
    var O = defined(this);
    var fn = regexp == undefined ? undefined : regexp[MATCH];
    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
  }, $match];
});


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

// @@replace logic
__webpack_require__(57)('replace', 2, function (defined, REPLACE, $replace) {
  // 21.1.3.14 String.prototype.replace(searchValue, replaceValue)
  return [function replace(searchValue, replaceValue) {
    'use strict';
    var O = defined(this);
    var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
    return fn !== undefined
      ? fn.call(searchValue, O, replaceValue)
      : $replace.call(String(O), searchValue, replaceValue);
  }, $replace];
});


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

// @@search logic
__webpack_require__(57)('search', 1, function (defined, SEARCH, $search) {
  // 21.1.3.15 String.prototype.search(regexp)
  return [function search(regexp) {
    'use strict';
    var O = defined(this);
    var fn = regexp == undefined ? undefined : regexp[SEARCH];
    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
  }, $search];
});


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

// @@split logic
__webpack_require__(57)('split', 2, function (defined, SPLIT, $split) {
  'use strict';
  var isRegExp = __webpack_require__(54);
  var _split = $split;
  var $push = [].push;
  var $SPLIT = 'split';
  var LENGTH = 'length';
  var LAST_INDEX = 'lastIndex';
  if (
    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
    ''[$SPLIT](/.?/)[LENGTH]
  ) {
    var NPCG = /()??/.exec('')[1] === undefined; // nonparticipating capturing group
    // based on es5-shim implementation, need to rework it
    $split = function (separator, limit) {
      var string = String(this);
      if (separator === undefined && limit === 0) return [];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) return _split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? 4294967295 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var separator2, match, lastIndex, lastLength, i;
      // Doesn't need flags gy, but they don't hurt
      if (!NPCG) separator2 = new RegExp('^' + separatorCopy.source + '$(?!\\s)', flags);
      while (match = separatorCopy.exec(string)) {
        // `separatorCopy.lastIndex` is not reliable cross-browser
        lastIndex = match.index + match[0][LENGTH];
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          // Fix browsers whose `exec` methods don't consistently return `undefined` for NPCG
          // eslint-disable-next-line no-loop-func
          if (!NPCG && match[LENGTH] > 1) match[0].replace(separator2, function () {
            for (i = 1; i < arguments[LENGTH] - 2; i++) if (arguments[i] === undefined) match[i] = undefined;
          });
          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if (output[LENGTH] >= splitLimit) break;
        }
        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
      }
      if (lastLastIndex === string[LENGTH]) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
  // Chakra, V8
  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
    $split = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : _split.call(this, separator, limit);
    };
  }
  // 21.1.3.17 String.prototype.split(separator, limit)
  return [function split(separator, limit) {
    var O = defined(this);
    var fn = separator == undefined ? undefined : separator[SPLIT];
    return fn !== undefined ? fn.call(separator, O, limit) : $split.call(String(O), separator, limit);
  }, $split];
});


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(33);
var global = __webpack_require__(2);
var ctx = __webpack_require__(18);
var classof = __webpack_require__(48);
var $export = __webpack_require__(0);
var isObject = __webpack_require__(4);
var aFunction = __webpack_require__(10);
var anInstance = __webpack_require__(39);
var forOf = __webpack_require__(40);
var speciesConstructor = __webpack_require__(58);
var task = __webpack_require__(87).set;
var microtask = __webpack_require__(88)();
var newPromiseCapabilityModule = __webpack_require__(89);
var perform = __webpack_require__(111);
var promiseResolve = __webpack_require__(112);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(5)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value);
            if (domain) domain.exit();
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  if (promise._h == 1) return false;
  var chain = promise._a || promise._c;
  var i = 0;
  var reaction;
  while (chain.length > i) {
    reaction = chain[i++];
    if (reaction.fail || !isUnhandled(reaction.promise)) return false;
  } return true;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(41)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(42)($Promise, PROMISE);
__webpack_require__(38)(PROMISE);
Wrapper = __webpack_require__(21)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(55)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var weak = __webpack_require__(117);
var validate = __webpack_require__(45);
var WEAK_SET = 'WeakSet';

// 23.4 WeakSet Objects
__webpack_require__(59)(WEAK_SET, function (get) {
  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.4.3.1 WeakSet.prototype.add(value)
  add: function add(value) {
    return weak.def(validate(this, WEAK_SET), value, true);
  }
}, weak, false, true);


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $typed = __webpack_require__(60);
var buffer = __webpack_require__(90);
var anObject = __webpack_require__(1);
var toAbsoluteIndex = __webpack_require__(35);
var toLength = __webpack_require__(8);
var isObject = __webpack_require__(4);
var ArrayBuffer = __webpack_require__(2).ArrayBuffer;
var speciesConstructor = __webpack_require__(58);
var $ArrayBuffer = buffer.ArrayBuffer;
var $DataView = buffer.DataView;
var $isView = $typed.ABV && ArrayBuffer.isView;
var $slice = $ArrayBuffer.prototype.slice;
var VIEW = $typed.VIEW;
var ARRAY_BUFFER = 'ArrayBuffer';

$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });

$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
  // 24.1.3.1 ArrayBuffer.isView(arg)
  isView: function isView(it) {
    return $isView && $isView(it) || isObject(it) && VIEW in it;
  }
});

$export($export.P + $export.U + $export.F * __webpack_require__(3)(function () {
  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
}), ARRAY_BUFFER, {
  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
  slice: function slice(start, end) {
    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
    var len = anObject(this).byteLength;
    var first = toAbsoluteIndex(start, len);
    var final = toAbsoluteIndex(end === undefined ? len : end, len);
    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(final - first));
    var viewS = new $DataView(this);
    var viewT = new $DataView(result);
    var index = 0;
    while (first < final) {
      viewT.setUint8(index++, viewS.getUint8(first++));
    } return result;
  }
});

__webpack_require__(38)(ARRAY_BUFFER);


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
$export($export.G + $export.W + $export.F * !__webpack_require__(60).ABV, {
  DataView: __webpack_require__(90).DataView
});


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(27)('Int8', 1, function (init) {
  return function Int8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(27)('Uint8', 1, function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(27)('Uint8', 1, function (init) {
  return function Uint8ClampedArray(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
}, true);


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(27)('Int16', 2, function (init) {
  return function Int16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(27)('Uint16', 2, function (init) {
  return function Uint16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(27)('Int32', 4, function (init) {
  return function Int32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(27)('Uint32', 4, function (init) {
  return function Uint32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(27)('Float32', 4, function (init) {
  return function Float32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(27)('Float64', 8, function (init) {
  return function Float64Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
var $export = __webpack_require__(0);
var aFunction = __webpack_require__(10);
var anObject = __webpack_require__(1);
var rApply = (__webpack_require__(2).Reflect || {}).apply;
var fApply = Function.apply;
// MS Edge argumentsList argument is optional
$export($export.S + $export.F * !__webpack_require__(3)(function () {
  rApply(function () { /* empty */ });
}), 'Reflect', {
  apply: function apply(target, thisArgument, argumentsList) {
    var T = aFunction(target);
    var L = anObject(argumentsList);
    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
  }
});


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
var $export = __webpack_require__(0);
var create = __webpack_require__(36);
var aFunction = __webpack_require__(10);
var anObject = __webpack_require__(1);
var isObject = __webpack_require__(4);
var fails = __webpack_require__(3);
var bind = __webpack_require__(98);
var rConstruct = (__webpack_require__(2).Reflect || {}).construct;

// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
});
var ARGS_BUG = !fails(function () {
  rConstruct(function () { /* empty */ });
});

$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
  construct: function construct(Target, args /* , newTarget */) {
    aFunction(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : Object.prototype);
    var result = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
var dP = __webpack_require__(7);
var $export = __webpack_require__(0);
var anObject = __webpack_require__(1);
var toPrimitive = __webpack_require__(22);

// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
$export($export.S + $export.F * __webpack_require__(3)(function () {
  // eslint-disable-next-line no-undef
  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
}), 'Reflect', {
  defineProperty: function defineProperty(target, propertyKey, attributes) {
    anObject(target);
    propertyKey = toPrimitive(propertyKey, true);
    anObject(attributes);
    try {
      dP.f(target, propertyKey, attributes);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.4 Reflect.deleteProperty(target, propertyKey)
var $export = __webpack_require__(0);
var gOPD = __webpack_require__(16).f;
var anObject = __webpack_require__(1);

$export($export.S, 'Reflect', {
  deleteProperty: function deleteProperty(target, propertyKey) {
    var desc = gOPD(anObject(target), propertyKey);
    return desc && !desc.configurable ? false : delete target[propertyKey];
  }
});


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 26.1.5 Reflect.enumerate(target)
var $export = __webpack_require__(0);
var anObject = __webpack_require__(1);
var Enumerate = function (iterated) {
  this._t = anObject(iterated); // target
  this._i = 0;                  // next index
  var keys = this._k = [];      // keys
  var key;
  for (key in iterated) keys.push(key);
};
__webpack_require__(78)(Enumerate, 'Object', function () {
  var that = this;
  var keys = that._k;
  var key;
  do {
    if (that._i >= keys.length) return { value: undefined, done: true };
  } while (!((key = keys[that._i++]) in that._t));
  return { value: key, done: false };
});

$export($export.S, 'Reflect', {
  enumerate: function enumerate(target) {
    return new Enumerate(target);
  }
});


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.6 Reflect.get(target, propertyKey [, receiver])
var gOPD = __webpack_require__(16);
var getPrototypeOf = __webpack_require__(17);
var has = __webpack_require__(11);
var $export = __webpack_require__(0);
var isObject = __webpack_require__(4);
var anObject = __webpack_require__(1);

function get(target, propertyKey /* , receiver */) {
  var receiver = arguments.length < 3 ? target : arguments[2];
  var desc, proto;
  if (anObject(target) === receiver) return target[propertyKey];
  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
    ? desc.value
    : desc.get !== undefined
      ? desc.get.call(receiver)
      : undefined;
  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
}

$export($export.S, 'Reflect', { get: get });


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
var gOPD = __webpack_require__(16);
var $export = __webpack_require__(0);
var anObject = __webpack_require__(1);

$export($export.S, 'Reflect', {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
    return gOPD.f(anObject(target), propertyKey);
  }
});


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.8 Reflect.getPrototypeOf(target)
var $export = __webpack_require__(0);
var getProto = __webpack_require__(17);
var anObject = __webpack_require__(1);

$export($export.S, 'Reflect', {
  getPrototypeOf: function getPrototypeOf(target) {
    return getProto(anObject(target));
  }
});


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.9 Reflect.has(target, propertyKey)
var $export = __webpack_require__(0);

$export($export.S, 'Reflect', {
  has: function has(target, propertyKey) {
    return propertyKey in target;
  }
});


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.10 Reflect.isExtensible(target)
var $export = __webpack_require__(0);
var anObject = __webpack_require__(1);
var $isExtensible = Object.isExtensible;

$export($export.S, 'Reflect', {
  isExtensible: function isExtensible(target) {
    anObject(target);
    return $isExtensible ? $isExtensible(target) : true;
  }
});


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.11 Reflect.ownKeys(target)
var $export = __webpack_require__(0);

$export($export.S, 'Reflect', { ownKeys: __webpack_require__(119) });


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.12 Reflect.preventExtensions(target)
var $export = __webpack_require__(0);
var anObject = __webpack_require__(1);
var $preventExtensions = Object.preventExtensions;

$export($export.S, 'Reflect', {
  preventExtensions: function preventExtensions(target) {
    anObject(target);
    try {
      if ($preventExtensions) $preventExtensions(target);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
var dP = __webpack_require__(7);
var gOPD = __webpack_require__(16);
var getPrototypeOf = __webpack_require__(17);
var has = __webpack_require__(11);
var $export = __webpack_require__(0);
var createDesc = __webpack_require__(31);
var anObject = __webpack_require__(1);
var isObject = __webpack_require__(4);

function set(target, propertyKey, V /* , receiver */) {
  var receiver = arguments.length < 4 ? target : arguments[3];
  var ownDesc = gOPD.f(anObject(target), propertyKey);
  var existingDescriptor, proto;
  if (!ownDesc) {
    if (isObject(proto = getPrototypeOf(target))) {
      return set(proto, propertyKey, V, receiver);
    }
    ownDesc = createDesc(0);
  }
  if (has(ownDesc, 'value')) {
    if (ownDesc.writable === false || !isObject(receiver)) return false;
    existingDescriptor = gOPD.f(receiver, propertyKey) || createDesc(0);
    existingDescriptor.value = V;
    dP.f(receiver, propertyKey, existingDescriptor);
    return true;
  }
  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
}

$export($export.S, 'Reflect', { set: set });


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.14 Reflect.setPrototypeOf(target, proto)
var $export = __webpack_require__(0);
var setProto = __webpack_require__(70);

if (setProto) $export($export.S, 'Reflect', {
  setPrototypeOf: function setPrototypeOf(target, proto) {
    setProto.check(target, proto);
    try {
      setProto.set(target, proto);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/Array.prototype.includes
var $export = __webpack_require__(0);
var $includes = __webpack_require__(51)(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__(30)('includes');


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
var $export = __webpack_require__(0);
var flattenIntoArray = __webpack_require__(120);
var toObject = __webpack_require__(9);
var toLength = __webpack_require__(8);
var aFunction = __webpack_require__(10);
var arraySpeciesCreate = __webpack_require__(84);

$export($export.P, 'Array', {
  flatMap: function flatMap(callbackfn /* , thisArg */) {
    var O = toObject(this);
    var sourceLen, A;
    aFunction(callbackfn);
    sourceLen = toLength(O.length);
    A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
    return A;
  }
});

__webpack_require__(30)('flatMap');


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
var $export = __webpack_require__(0);
var flattenIntoArray = __webpack_require__(120);
var toObject = __webpack_require__(9);
var toLength = __webpack_require__(8);
var toInteger = __webpack_require__(24);
var arraySpeciesCreate = __webpack_require__(84);

$export($export.P, 'Array', {
  flatten: function flatten(/* depthArg = 1 */) {
    var depthArg = arguments[0];
    var O = toObject(this);
    var sourceLen = toLength(O.length);
    var A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
    return A;
  }
});

__webpack_require__(30)('flatten');


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/mathiasbynens/String.prototype.at
var $export = __webpack_require__(0);
var $at = __webpack_require__(76)(true);

$export($export.P, 'String', {
  at: function at(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(0);
var $pad = __webpack_require__(121);

$export($export.P, 'String', {
  padStart: function padStart(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
  }
});


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(0);
var $pad = __webpack_require__(121);

$export($export.P, 'String', {
  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
  }
});


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(43)('trimLeft', function ($trim) {
  return function trimLeft() {
    return $trim(this, 1);
  };
}, 'trimStart');


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(43)('trimRight', function ($trim) {
  return function trimRight() {
    return $trim(this, 2);
  };
}, 'trimEnd');


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/String.prototype.matchAll/
var $export = __webpack_require__(0);
var defined = __webpack_require__(23);
var toLength = __webpack_require__(8);
var isRegExp = __webpack_require__(54);
var getFlags = __webpack_require__(56);
var RegExpProto = RegExp.prototype;

var $RegExpStringIterator = function (regexp, string) {
  this._r = regexp;
  this._s = string;
};

__webpack_require__(78)($RegExpStringIterator, 'RegExp String', function next() {
  var match = this._r.exec(this._s);
  return { value: match, done: match === null };
});

$export($export.P, 'String', {
  matchAll: function matchAll(regexp) {
    defined(this);
    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
    var S = String(this);
    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
    rx.lastIndex = toLength(regexp.lastIndex);
    return new $RegExpStringIterator(rx, S);
  }
});


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(66)('asyncIterator');


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(66)('observable');


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-getownpropertydescriptors
var $export = __webpack_require__(0);
var ownKeys = __webpack_require__(119);
var toIObject = __webpack_require__(15);
var gOPD = __webpack_require__(16);
var createProperty = __webpack_require__(82);

$export($export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIObject(object);
    var getDesc = gOPD.f;
    var keys = ownKeys(O);
    var result = {};
    var i = 0;
    var key, desc;
    while (keys.length > i) {
      desc = getDesc(O, key = keys[i++]);
      if (desc !== undefined) createProperty(result, key, desc);
    }
    return result;
  }
});


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(0);
var $values = __webpack_require__(122)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(0);
var $entries = __webpack_require__(122)(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(9);
var aFunction = __webpack_require__(10);
var $defineProperty = __webpack_require__(7);

// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
__webpack_require__(6) && $export($export.P + __webpack_require__(61), 'Object', {
  __defineGetter__: function __defineGetter__(P, getter) {
    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(9);
var aFunction = __webpack_require__(10);
var $defineProperty = __webpack_require__(7);

// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
__webpack_require__(6) && $export($export.P + __webpack_require__(61), 'Object', {
  __defineSetter__: function __defineSetter__(P, setter) {
    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(9);
var toPrimitive = __webpack_require__(22);
var getPrototypeOf = __webpack_require__(17);
var getOwnPropertyDescriptor = __webpack_require__(16).f;

// B.2.2.4 Object.prototype.__lookupGetter__(P)
__webpack_require__(6) && $export($export.P + __webpack_require__(61), 'Object', {
  __lookupGetter__: function __lookupGetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(9);
var toPrimitive = __webpack_require__(22);
var getPrototypeOf = __webpack_require__(17);
var getOwnPropertyDescriptor = __webpack_require__(16).f;

// B.2.2.5 Object.prototype.__lookupSetter__(P)
__webpack_require__(6) && $export($export.P + __webpack_require__(61), 'Object', {
  __lookupSetter__: function __lookupSetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(0);

$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(123)('Map') });


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(0);

$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(123)('Set') });


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
__webpack_require__(62)('Map');


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
__webpack_require__(62)('Set');


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
__webpack_require__(62)('WeakMap');


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
__webpack_require__(62)('WeakSet');


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
__webpack_require__(63)('Map');


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
__webpack_require__(63)('Set');


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
__webpack_require__(63)('WeakMap');


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
__webpack_require__(63)('WeakSet');


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(0);

$export($export.G, { global: __webpack_require__(2) });


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(0);

$export($export.S, 'System', { global: __webpack_require__(2) });


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/ljharb/proposal-is-error
var $export = __webpack_require__(0);
var cof = __webpack_require__(19);

$export($export.S, 'Error', {
  isError: function isError(it) {
    return cof(it) === 'Error';
  }
});


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  clamp: function clamp(x, lower, upper) {
    return Math.min(upper, Math.max(lower, x));
  }
});


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);

$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);
var RAD_PER_DEG = 180 / Math.PI;

$export($export.S, 'Math', {
  degrees: function degrees(radians) {
    return radians * RAD_PER_DEG;
  }
});


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);
var scale = __webpack_require__(125);
var fround = __webpack_require__(105);

$export($export.S, 'Math', {
  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
    return fround(scale(x, inLow, inHigh, outLow, outHigh));
  }
});


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  iaddh: function iaddh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
  }
});


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  isubh: function isubh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
  }
});


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  imulh: function imulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >> 16;
    var v1 = $v >> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
  }
});


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);

$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);
var DEG_PER_RAD = Math.PI / 180;

$export($export.S, 'Math', {
  radians: function radians(degrees) {
    return degrees * DEG_PER_RAD;
  }
});


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);

$export($export.S, 'Math', { scale: __webpack_require__(125) });


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  umulh: function umulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >>> 16;
    var v1 = $v >>> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
  }
});


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

// http://jfbastien.github.io/papers/Math.signbit.html
var $export = __webpack_require__(0);

$export($export.S, 'Math', { signbit: function signbit(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
} });


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(0);
var core = __webpack_require__(21);
var global = __webpack_require__(2);
var speciesConstructor = __webpack_require__(58);
var promiseResolve = __webpack_require__(112);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(0);
var newPromiseCapability = __webpack_require__(89);
var perform = __webpack_require__(111);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(28);
var anObject = __webpack_require__(1);
var toMetaKey = metadata.key;
var ordinaryDefineOwnMetadata = metadata.set;

metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
} });


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(28);
var anObject = __webpack_require__(1);
var toMetaKey = metadata.key;
var getOrCreateMetadataMap = metadata.map;
var store = metadata.store;

metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
  if (metadataMap.size) return true;
  var targetMetadata = store.get(target);
  targetMetadata['delete'](targetKey);
  return !!targetMetadata.size || store['delete'](target);
} });


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(28);
var anObject = __webpack_require__(1);
var getPrototypeOf = __webpack_require__(17);
var ordinaryHasOwnMetadata = metadata.has;
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

var ordinaryGetMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
};

metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(115);
var from = __webpack_require__(124);
var metadata = __webpack_require__(28);
var anObject = __webpack_require__(1);
var getPrototypeOf = __webpack_require__(17);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

var ordinaryMetadataKeys = function (O, P) {
  var oKeys = ordinaryOwnMetadataKeys(O, P);
  var parent = getPrototypeOf(O);
  if (parent === null) return oKeys;
  var pKeys = ordinaryMetadataKeys(parent, P);
  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
};

metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(28);
var anObject = __webpack_require__(1);
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(28);
var anObject = __webpack_require__(1);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(28);
var anObject = __webpack_require__(1);
var getPrototypeOf = __webpack_require__(17);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

var ordinaryHasMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return true;
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
};

metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(28);
var anObject = __webpack_require__(1);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

var $metadata = __webpack_require__(28);
var anObject = __webpack_require__(1);
var aFunction = __webpack_require__(10);
var toMetaKey = $metadata.key;
var ordinaryDefineOwnMetadata = $metadata.set;

$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
  return function decorator(target, targetKey) {
    ordinaryDefineOwnMetadata(
      metadataKey, metadataValue,
      (targetKey !== undefined ? anObject : aFunction)(target),
      toMetaKey(targetKey)
    );
  };
} });


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
var $export = __webpack_require__(0);
var microtask = __webpack_require__(88)();
var process = __webpack_require__(2).process;
var isNode = __webpack_require__(19)(process) == 'process';

$export($export.G, {
  asap: function asap(fn) {
    var domain = isNode && process.domain;
    microtask(domain ? domain.bind(fn) : fn);
  }
});


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/zenparsing/es-observable
var $export = __webpack_require__(0);
var global = __webpack_require__(2);
var core = __webpack_require__(21);
var microtask = __webpack_require__(88)();
var OBSERVABLE = __webpack_require__(5)('observable');
var aFunction = __webpack_require__(10);
var anObject = __webpack_require__(1);
var anInstance = __webpack_require__(39);
var redefineAll = __webpack_require__(41);
var hide = __webpack_require__(12);
var forOf = __webpack_require__(40);
var RETURN = forOf.RETURN;

var getMethod = function (fn) {
  return fn == null ? undefined : aFunction(fn);
};

var cleanupSubscription = function (subscription) {
  var cleanup = subscription._c;
  if (cleanup) {
    subscription._c = undefined;
    cleanup();
  }
};

var subscriptionClosed = function (subscription) {
  return subscription._o === undefined;
};

var closeSubscription = function (subscription) {
  if (!subscriptionClosed(subscription)) {
    subscription._o = undefined;
    cleanupSubscription(subscription);
  }
};

var Subscription = function (observer, subscriber) {
  anObject(observer);
  this._c = undefined;
  this._o = observer;
  observer = new SubscriptionObserver(this);
  try {
    var cleanup = subscriber(observer);
    var subscription = cleanup;
    if (cleanup != null) {
      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
      else aFunction(cleanup);
      this._c = cleanup;
    }
  } catch (e) {
    observer.error(e);
    return;
  } if (subscriptionClosed(this)) cleanupSubscription(this);
};

Subscription.prototype = redefineAll({}, {
  unsubscribe: function unsubscribe() { closeSubscription(this); }
});

var SubscriptionObserver = function (subscription) {
  this._s = subscription;
};

SubscriptionObserver.prototype = redefineAll({}, {
  next: function next(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      try {
        var m = getMethod(observer.next);
        if (m) return m.call(observer, value);
      } catch (e) {
        try {
          closeSubscription(subscription);
        } finally {
          throw e;
        }
      }
    }
  },
  error: function error(value) {
    var subscription = this._s;
    if (subscriptionClosed(subscription)) throw value;
    var observer = subscription._o;
    subscription._o = undefined;
    try {
      var m = getMethod(observer.error);
      if (!m) throw value;
      value = m.call(observer, value);
    } catch (e) {
      try {
        cleanupSubscription(subscription);
      } finally {
        throw e;
      }
    } cleanupSubscription(subscription);
    return value;
  },
  complete: function complete(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      subscription._o = undefined;
      try {
        var m = getMethod(observer.complete);
        value = m ? m.call(observer, value) : undefined;
      } catch (e) {
        try {
          cleanupSubscription(subscription);
        } finally {
          throw e;
        }
      } cleanupSubscription(subscription);
      return value;
    }
  }
});

var $Observable = function Observable(subscriber) {
  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
};

redefineAll($Observable.prototype, {
  subscribe: function subscribe(observer) {
    return new Subscription(observer, this._f);
  },
  forEach: function forEach(fn) {
    var that = this;
    return new (core.Promise || global.Promise)(function (resolve, reject) {
      aFunction(fn);
      var subscription = that.subscribe({
        next: function (value) {
          try {
            return fn(value);
          } catch (e) {
            reject(e);
            subscription.unsubscribe();
          }
        },
        error: reject,
        complete: resolve
      });
    });
  }
});

redefineAll($Observable, {
  from: function from(x) {
    var C = typeof this === 'function' ? this : $Observable;
    var method = getMethod(anObject(x)[OBSERVABLE]);
    if (method) {
      var observable = anObject(method.call(x));
      return observable.constructor === C ? observable : new C(function (observer) {
        return observable.subscribe(observer);
      });
    }
    return new C(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          try {
            if (forOf(x, false, function (it) {
              observer.next(it);
              if (done) return RETURN;
            }) === RETURN) return;
          } catch (e) {
            if (done) throw e;
            observer.error(e);
            return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  },
  of: function of() {
    for (var i = 0, l = arguments.length, items = Array(l); i < l;) items[i] = arguments[i++];
    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          for (var j = 0; j < items.length; ++j) {
            observer.next(items[j]);
            if (done) return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  }
});

hide($Observable.prototype, OBSERVABLE, function () { return this; });

$export($export.G, { Observable: $Observable });

__webpack_require__(38)('Observable');


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

// ie9- setTimeout & setInterval additional parameters fix
var global = __webpack_require__(2);
var $export = __webpack_require__(0);
var navigator = global.navigator;
var slice = [].slice;
var MSIE = !!navigator && /MSIE .\./.test(navigator.userAgent); // <- dirty ie9- check
var wrap = function (set) {
  return function (fn, time /* , ...args */) {
    var boundArgs = arguments.length > 2;
    var args = boundArgs ? slice.call(arguments, 2) : false;
    return set(boundArgs ? function () {
      // eslint-disable-next-line no-new-func
      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
    } : fn, time);
  };
};
$export($export.G + $export.B + $export.F * MSIE, {
  setTimeout: wrap(global.setTimeout),
  setInterval: wrap(global.setInterval)
});


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $task = __webpack_require__(87);
$export($export.G + $export.B, {
  setImmediate: $task.set,
  clearImmediate: $task.clear
});


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__(86);
var getKeys = __webpack_require__(34);
var redefine = __webpack_require__(13);
var global = __webpack_require__(2);
var hide = __webpack_require__(12);
var Iterators = __webpack_require__(44);
var wks = __webpack_require__(5);
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2014, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
 * additional grant of patent rights can be found in the PATENTS file in
 * the same directory.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    if (typeof global.process === "object" && global.process.domain) {
      invoke = global.process.domain.bind(invoke);
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // Among the various tricks for obtaining a reference to the global
  // object, this seems to be the most reliable technique that does not
  // use indirect eval (which violates Content Security Policy).
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this
);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(64)))

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(329);
module.exports = __webpack_require__(21).RegExp.escape;


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/benjamingr/RexExp.escape
var $export = __webpack_require__(0);
var $re = __webpack_require__(330)(/[\\^$*+?.()|[\]{}]/g, '\\$&');

$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });


/***/ }),
/* 330 */
/***/ (function(module, exports) {

module.exports = function (regExp, replace) {
  var replacer = replace === Object(replace) ? function (part) {
    return replace[part];
  } : replace;
  return function (it) {
    return String(it).replace(regExp, replacer);
  };
};


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {

    module.exports = function (win) {
        var doc = win.document,
            body = doc.body,
            E_float,
            E_floatMsg,
            E_floatContent,
            E_floatOk,
            E_floatCancel,
            initDom = false,
            flashTimeoutId,
            showTimeoutId,
            hideTimeoutId,
            E_mask;

        E_mask = doc.createElement('div');
        E_mask.className = 'c-float-mask hide';

        E_float = doc.createElement('div');
        E_float.className = 'c-float-popWrap msgMode hide';
        E_float.innerHTML = ['<style type="text/css">', '.c-float-modePop{text-align:center}.c-float-modePop .warnMsg{color:#fff}.c-float-modePop button{padding:0.1875rem 0.28125rem 0.1875rem 0.28125rem;color:#157afb;background:-webkit-gradient(linear,left top,left bottom,color-stop(0,#404040),color-stop(100%,#2e2e2e));border:none}.c-float-shade{width:100%;display:block;position:absolute;z-index:99;background-color:#000;opacity:.5;top:0;left:0}.c-float-mask{position:fixed;top:0;left:0;bottom:0;right:0;height:100%;width:100%;z-index:9998;background:rgba(0,0,0,.7);opacity:0;-webkit-transition:opacity .3s linear 0s}.c-float-shade.hide{display:none}.c-float-mask.hide{display:none}.c-float-popWrap{width:90%; border-radius:0.25rem;-webkit-border-radius:0.25rem;z-index:9999;position:fixed;overflow:hidden;left:50%;top:50%; margin-left: -45%; -webkit-transition:opacity .3s linear 0s}.c-float-popWrap .c-float-modePop{background-color:rgba(0,0,0,.7);-webkit-border-radius:0.25rem;border-radius:0.25rem;overflow:hidden;padding:0.3125rem;}.c-float-popWrap .c-float-modePop .warnMsg{padding:0;font-size:0.46875rem;line-height:0.5625rem;color:#fff;font-weight:400}.c-float-popWrap .c-float-modePop .content{line-height:1.5}.c-float-popWrap.hide{display:none;-webkit-box-shadow:none}.c-float-popWrap.show{display:block}.c-float-popWrap.msgMode .c-float-modePop .content,.c-float-popWrap.msgMode .c-float-modePop .doBtn{display:none}.c-float-popWrap.alertMode .c-float-modePop .content{display:none}.c-float-popWrap.alertMode .c-float-modePop .doBtn .cancel{display:none}.c-float-popWrap.alertMode,.c-float-popWrap.confirmMode{width:90%;}.c-float-popWrap.alertMode .c-float-modePop,.c-float-popWrap.confirmMode .c-float-modePop{background:#fff;padding:0;color:#202325}.c-float-popWrap.alertMode .c-float-modePop .content,.c-float-popWrap.confirmMode .c-float-modePop .content{padding:0.3125rem;border-bottom:0.03125rem solid #d6d9dc}.c-float-popWrap.alertMode .c-float-modePop .warnMsg,.c-float-popWrap.confirmMode .c-float-modePop .warnMsg{padding:0.3125rem;display:-webkit-box;-webkit-box-align:center;-webkit-box-pack:center;text-align:center;font-weight:700}.c-float-popWrap.alertMode .c-float-modePop .doBtn,.c-float-popWrap.alertMode .c-float-modePop .warnMsg,.c-float-popWrap.confirmMode .c-float-modePop .doBtn,.c-float-popWrap.confirmMode .c-float-modePop .warnMsg{border-bottom:0.03125rem solid #d6d9dc;color:#202325}.c-float-popWrap.alertMode .c-float-modePop .doBtn,.c-float-popWrap.confirmMode .c-float-modePop .doBtn{border-bottom:none;display:-webkit-box;-webkit-box-align:center}.c-float-popWrap.alertMode .c-float-modePop .content,.c-float-popWrap.confirmMode .c-float-modePop .content{display:block;color:#202325;padding:0.3125rem;line-height:0.75rem;font-size:0.46875rem;text-align:left;font-weight:700}.c-float-modePop button{-webkit-box-flex:1;color:#157afb;background:#fff;height:1.25rem;font-size:0.5625rem;display:block}.c-float-modePop button.cancel{border-right:0.03125rem solid #b2b2b2}.c-float-modePop button.ok{font-weight:700}', '</style>', '<div class="c-float-modePop">', '<div class="warnMsg"></div>', '<div class="content"></div>', '<div class="doBtn">', '<button class="cancel">取消</button>', '<button class="ok">确定</button>', '</div>', '</div>'].join('');

        E_floatMsg = E_float.querySelector('.warnMsg');
        E_floatContent = E_float.querySelector('.content');
        E_floatOk = E_float.querySelector('.doBtn .ok');
        E_floatCancel = E_float.querySelector('.doBtn .cancel');

        E_floatMsg.addEventListener('click', function () {
            // alert(E_float.className);
        }, false);

        function _extend(a, b) {
            for (var k in b) {
                a[k] = b[k];
            }
            return a;
        }

        function successHandler(e) {
            this.callback && this.callback(e, true);
        }

        function failureHandler(e) {
            this.callback && this.callback(e, false);
        }

        function ModePop(options) {
            this._options = _extend({
                mode: 'msg',
                text: '网页提示',
                useTap: false
            }, options || {});

            this._init();
        }

        _extend(ModePop.prototype, {
            _init: function _init() {
                var that = this,
                    opt = that._options,
                    mode = opt.mode,
                    text = opt.text,
                    okText = opt.okText,
                    cancelText = opt.cancelText,
                    content = opt.content,
                    callback = opt.callback,
                    background = opt.background,
                    clickEvent = opt.useTap ? 'touchend' : 'click';

                // set mode
                var classTxt = E_float.className;
                classTxt = classTxt.replace(/(msg|alert|confirm)Mode/i, mode + 'Mode');
                E_float.className = classTxt;

                // set background
                background && (E_float.style.background = background);

                // set text & content
                if (text) {
                    E_floatMsg.innerHTML = text;
                    E_floatMsg.style.display = 'block';
                } else {
                    E_floatMsg.style.display = 'none';
                }

                if (content) {
                    E_floatContent.innerHTML = content;
                    E_floatContent.style.display = 'block';
                } else {
                    E_floatContent.style.display = 'none';
                }

                E_floatOk.innerHTML = okText || '确定';
                E_floatCancel.innerHTML = cancelText || '取消';

                if (mode == 'alert' || mode == 'confirm') {
                    this.hasMask = true;
                } else {
                    this.hasMask = false;
                }

                // click event
                E_floatOk.removeEventListener('touchend', successHandler);
                E_floatOk.removeEventListener('click', successHandler);
                E_floatCancel.removeEventListener('touchend', successHandler);
                E_floatCancel.removeEventListener('click', successHandler);
                E_floatOk.addEventListener(clickEvent, successHandler, false);
                E_floatCancel.addEventListener(clickEvent, failureHandler, false);
                E_floatOk.callback = E_floatCancel.callback = function () {
                    callback.apply(that, arguments);
                };

                if (!initDom) {
                    initDom = true;
                    doc.body.appendChild(E_mask);
                    doc.body.appendChild(E_float);
                    win.addEventListener('resize', function () {
                        setTimeout(function () {
                            that._pos();
                        }, 500);
                    }, false);
                }
            },

            _pos: function _pos() {
                var rect = E_float.getBoundingClientRect(),
                    eW = rect.width,
                    eH = rect.height;

                E_float.style.marginLeft = -eW / 2 + 'px';
                E_float.style.marginTop = -eH / 2 + 'px';
            },

            isShow: function isShow() {
                return E_float.className.indexOf('show') > -1;
            },

            isHide: function isHide() {
                return E_float.className.indexOf('hide') > -1;
            },

            _cbShow: function _cbShow(pos) {
                var that = this,
                    opt = that._options,
                    onShow = opt.onShow;

                E_float.style.opacity = '1';
                that.hasMask && (E_mask.style.opacity = '1');
                that.hasMask && (E_mask.className = E_mask.className.replace(/hide/g, '').trim());

                if (!that.isShow()) {
                    E_float.className += ' show';
                    that.hasMask && (E_mask.className += ' show');
                }

                pos && that._pos();

                onShow && onShow.call(that);
            },

            show: function show() {
                var that = this;

                if (flashTimeoutId) {
                    clearTimeout(flashTimeoutId);
                    flashTimeoutId = null;
                    this._cbHide();
                }

                if (showTimeoutId) {
                    clearTimeout(showTimeoutId);
                    showTimeoutId = null;
                }

                if (hideTimeoutId) {
                    clearTimeout(hideTimeoutId);
                    hideTimeoutId = null;
                }

                if (!that.isShow()) {
                    E_float.className = E_float.className.replace(/hide/g, '').trim();
                    that.hasMask && (E_mask.className = E_mask.className.replace(/hide/g, '').trim());

                    that._pos();

                    setTimeout(function () {
                        E_float.style.opacity = '1';
                        that.hasMask && (E_mask.style.opacity = '1');
                    }, 1);

                    showTimeoutId = setTimeout(function () {
                        that._cbShow();
                    }, 300);
                } else {
                    that._cbShow(true);
                }
            },

            _cbHide: function _cbHide() {
                var that = this,
                    opt = that._options,
                    onHide = opt.onHide;

                E_float.style.opacity = '0';
                E_mask.style.opacity = '0';

                if (!that.isHide()) {
                    E_float.className = E_float.className.replace(/hide|show/g, '').trim();
                    E_float.className += ' hide';
                    E_mask.className = E_mask.className.replace(/hide|show/g, '').trim();
                    E_mask.className += ' hide';
                }
                onHide && onHide.call(that);
            },
            // ruoli 添加timeout参数，防止点击弹出框，立即再弹出一个框，出现闪动
            hide: function hide(timeout) {
                var that = this;

                if (showTimeoutId) {
                    clearTimeout(showTimeoutId);
                    showTimeoutId = null;
                }

                if (hideTimeoutId) {
                    clearTimeout(hideTimeoutId);
                    hideTimeoutId = null;
                }

                if (!that.isHide()) {
                    E_float.className = E_float.className.replace(/show/g, '').trim();
                    E_mask.className = E_mask.className.replace(/show/g, '').trim();

                    setTimeout(function () {
                        E_float.style.opacity = '0';
                        E_mask.style.opacity = '0';
                    }, 1);

                    hideTimeoutId = setTimeout(function () {
                        that._cbHide();
                    }, timeout || 300);
                } else {
                    that._cbHide();
                }
            },

            flash: function flash(timeout) {
                var that = this,
                    opt = that._options;

                that.show();

                //opt.onShow = function() {
                flashTimeoutId = setTimeout(function () {
                    if (flashTimeoutId) {
                        that.hide();
                    }
                }, timeout);
                //};
            }
        });

        var notification = new function () {

            this.simple = function (text, bg, timeout) {
                if (arguments.length == 2) {
                    if (typeof arguments[1] == 'number') {
                        timeout = arguments[1];
                        bg = undefined;
                    }
                }

                var pop = new ModePop({
                    mode: 'msg',
                    text: text,
                    background: bg
                });

                pop.flash(timeout || 2000);
                return pop;
            };

            this.msg = function (text, options) {
                return new ModePop(_extend({
                    mode: 'msg',
                    text: text
                }, options || {}));
            };

            this.alert = function (text, content, callback, options) {

                if (typeof content === 'function') {
                    options = callback;
                    callback = content;
                    content = null;
                }

                return new ModePop(_extend({
                    mode: 'alert',
                    text: text,
                    content: content,
                    callback: callback
                }, options || {}));
            };

            this.confirm = function (text, content, callback, options) {
                return new ModePop(_extend({
                    mode: 'confirm',
                    text: text,
                    content: content,
                    callback: callback
                }, options || {}));
            };

            this.pop = function (options) {
                return new ModePop(options);
            };
        }();

        return notification;
    }(window);
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {

    /**
     * @file 组件基类
     * @authors 子虔
     * @date    2014-05-12 17:39:36
     * @example <caption>扩展一个子类</caption>
     *      Base.extend({
     *          defaults: {}, // 设置类的默认参数
     *          constructor: function Widget(){
     *              // 子类的构造函数
     *          },
     *      });
     *
     */
    var Events = __webpack_require__(333),
        extend = __webpack_require__(335),
        attributes = __webpack_require__(337),
        isEqual = __webpack_require__(127),
        parseParam = __webpack_require__(126);

    /**
     * 组件Base类
     * @param {object} [Opts={}] - 入参
     */
    function Base(Opts) {
        // 默认配置
        this.defaults = this.defaults || {};

        // 用户配置
        this.config = Opts || {};

        // 最终配置
        this.attributes = $.extend({}, this.attributes || {}, this.defaults) || {};

        if (_typeof(this.config) == 'object') {
            this.attributes = $.extend(this.attributes, this.config) || {};
        }

        this.initialize.apply(this, arguments);
    }

    // 扩展
    $.extend(Base.prototype, Events, {
        /**
         * @constructs
         */
        constructor: Base,

        initialize: function initialize() {},

        /**
         * 频道
         * @deprecated - 当要被废弃
         */
        channel: Events.channel,

        /**
         * 获取配置
         * @param  {string} name - 名称
         * @return {*}
         */
        get: function get(name) {
            return this.attributes[name];
        },

        /**
         * 设置配置
         * @param {*} name  -属性名
         * @param {*} [value] [属性值]
         * @param {boolean} [silent=false] [变化时是否派发事件，默认派发]
         */
        set: function set(name, value, silent) {
            var lastValue;
            if ((typeof name === 'undefined' ? 'undefined' : _typeof(name)) == 'object') {
                silent = value;
                for (var key in name) {
                    if (name.hasOwnProperty(key)) {
                        this.set(key, name[key], silent);
                    }
                }
            } else {
                lastValue = this.attributes[name];
                this.attributes[name] = value;
                if (!silent && !isEqual(lastValue, value)) {
                    this.emit('change:' + name, value, lastValue);
                    this.emit('change');
                }
            }
        },

        /**
         * 重置配置
         * @param  {string[]} [whiteList=[]] - white list,不需要重置的list
         * @param  {boolean} [silent=false] - 是否不不派发事件
         */
        reset: function reset(whiteList, silent) {
            whiteList = whiteList || [];

            if (arguments.length > 1) {
                silent = !!whiteList;
            }

            this.defaults = this.defaults || {};

            for (var key in this.attributes) {
                if (this.attributes.hasOwnProperty(key) && whiteList.indexOf(key) == -1) {
                    this.set(key, this.defaults[key], silent);
                }
            }
        },
        /**
         * 销毁，默认移除事件
         */
        destroy: function destroy() {
            this.off();
        }
    });

    // 生成子类
    Base.extend = extend;

    // 修改原型
    Base.use = function (protoProps) {
        var that = this,
            protoProps = [].concat(protoProps);

        protoProps.forEach(function (proto) {
            for (var name in proto) {
                if (proto.hasOwnProperty(name)) {
                    that.prototype[name] = proto[name];
                }
            }
        });
        return this;
    };

    // 组件过滤参数
    Base.parseParam = function (protoProps) {
        var newBase;

        newBase = this.extend({
            /**
             * 过滤实例时的参数
             * @description 剔除非defaults定义的属性
             */
            initialize: function initialize() {
                this.attributes = parseParam(this.defaults || {}, this.attributes);
                this.Parent(initialize, arguments);
            }
        });

        return protoProps ? newBase.extend(protoProps) : newBase;
    };

    module.exports = Base.extend(attributes);
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
    /**
     * @file 基础Event
     * @author 子虔
     * @date    2014-08-04 16:11:13
     * @example
     *        * 支持多个事件的添加、移除、派发
     *            this.on('name1,name2,name3',function(){});
     *        * 支持使用层次的方式调用子对象的事件
     *            this.on('parent/child/child/name',function(){}); === this.parent.child.child.on(name,function(){})
     */
    var Callbacks = __webpack_require__(334),
        channelObj = {};

    // 统一事件机制
    var Events = {
        Event: Callbacks,
        /**
         * 添加事件监听
         * @param  {string}   name - 事件名称
         * @param  {function} callback - 事件回调
         */
        on: function on(name, callback) {
            var obj,
                that = this;

            this.events = this.events || {};

            // 逗号隔开，支持多事件
            if (name && name.indexOf(',') != -1) {
                return (name.split(',') || []).forEach(function (item) {
                    if (item) {
                        that.on(item, callback);
                    }
                });
            }

            if (!this.global && name.indexOf('/') != -1) {
                // 频道监听
                if (name.split('/')[0] == 'channel') {
                    return that.channel.on(name.replace(/^channel\//gi, ''), callback);
                }

                obj = getObjectByNames(name, this);
                this.events[name] = this.events[name] || [];
                this.events[name].push(callback);
                return obj ? obj.on(getEventName(name), callback) : this;
            } else {
                obj = this.events[name] || (this.events[name] = this.Event());
            }

            // 如果设置为一起派发，则再次监听时，直接执行
            if (this._alwayEmitSource && this._alwayEmitSource[name]) {
                return callback.apply(name, this._alwayEmitSource[name]);
            }
            obj.add(callback);

            return this;
        },
        /**
         * 移除事件监听
         * @param  {string}   name     事件名称
         * @param  {function} [callback] - 事件回调，为空时，移除所有回调
         */
        off: function off(name, callback) {
            var obj,
                funs,
                that = this;

            this.events = this.events || {};

            // 逗号隔开，支持多事件
            if (name && name.indexOf(',') != -1) {
                return (name.split(',') || []).forEach(function (item) {
                    if (item) {
                        that.off(item, callback);
                    }
                });
            }

            if (!this.global && name && name.indexOf('/') != -1) {
                if (name.split('/')[0] == 'channel') {
                    return that.channel.off(name.replace(/^channel\//gi, ''), callback);
                }

                if (this.events[name]) {
                    obj = getObjectByNames(name, this);
                    if (callback) {
                        return obj ? obj.off(getEventName(name), callback) : this;
                    } else {
                        funs = this.events[name];
                        for (var i = 0; obj && funs && i < funs.length; i++) {
                            obj.off(getEventName(name), funs[i]);
                        }
                        this.events[name] = null;
                    }
                }

                return this;
            }

            if (name && callback && (obj = this.events[name])) {
                obj.remove(callback);
            } else if (name && (obj = this.events[name])) {
                obj.empty();
            } else {

                for (name in this.events) {
                    if (this.events.hasOwnProperty(name) && this.events[name]) {
                        if (!this.global && name.indexOf('/') != -1) {
                            if (name.split('/')[0] == 'channel') {
                                return this.channel.off(name.replace(/^channel\//gi, ''));
                            }
                            this.off(name);
                        } else {
                            this.events[name].empty();
                        }
                    }
                }
            }

            return this;
        },
        ///**
        // * 只监听一次事件
        // * @param name
        // * @param callback
        // */
        //once: function (name, callback) {
        //    var _callback;
        //
        //    this.on(name, _callback = function () {
        //        callback.apply(this, arguments);
        //        this.off(name, _callback);
        //    });
        //},
        /**
         * 默认派发事件
         * @return {object}
         */
        trigger: function trigger() {
            var name = arguments[0],
                obj,
                param,
                that = this;

            this.events = this.events || {};
            param = Array.prototype.slice.call(arguments, 1);

            // 逗号隔开，支持多事件
            if (name && name.indexOf(',') != -1) {
                return (name.split(',') || []).forEach(function (item) {
                    if (item) {
                        that.trigger.apply(this, [item].concat(param));
                    }
                });
            }

            if (!this.global && name && name.indexOf('/') != -1) {
                if (name.split('/')[0] == 'channel') {
                    return that.channel.trigger.apply(that.channel, [name.replace(/^channel\//gi, '')].concat(param));
                }
                obj = getObjectByNames(name, this);
                name = getEventName(name);
                return obj ? obj.trigger.apply(obj, [name].concat(param)) : this;
            }

            if (name && (obj = this.events[name])) {
                obj.fire.apply(this, [].concat(param));
            }

            return {
                event: obj,
                always: function always() {
                    that._alwayEmitSource = that._alwayEmitSource || {};
                    that._alwayEmitSource[name] = [].concat(param);
                }
            };
        },
        /**
         * 派发事件
         * @example
         *        this.emit('ready',args0,args1...);
         */
        emit: function emit() {
            return this.trigger.apply(this, arguments);
        }
    };

    /**
     * 获取context下的name属性
     * @private
     */
    function getObjectByNames(name, context) {
        var that, names, len;

        context = context || {};
        that = context;
        names = name.split('/');
        len = names.length;

        for (var i = 0; len > 1 && i < len - 1; i++) {
            if (that && that[names[i]]) {
                that = that[names[i]];
            } else {
                that = null;
            }
        }

        return that;
    }

    /**
     * 获取事件名称
     * @param  {String} name [description]
     * @return {String}
     */
    function getEventName(name) {
        var names = name.split('/');
        return names[names.length - 1];
    }

    // global single Event
    Events.channel = $.channel || ($.channel = $.extend(channelObj, Events));
    Events.channel.global = Events.channel;

    module.exports = Events;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {

    /**
     * @fileoverview callbacks
     * @author 子虔
     * @date    2014-08-31 12:09:10
     */
    module.exports = function (options) {
        options = $.extend({}, options);

        var memory,
            // Last fire value (for non-forgettable lists)
        _fired,
            // Flag to know if list was already fired
        firing,
            // Flag to know if list is currently firing
        firingStart,
            // First callback to fire (used internally by add and fireWith)
        firingLength,
            // End of the loop when firing
        firingIndex,
            // Index of currently firing callback (modified by remove if needed)
        list = [],
            // Actual callback list
        stack = !options.once && [],
            // Stack of fire calls for repeatable lists
        fire = function fire(data) {
            memory = options.memory && data;
            _fired = true;
            firingIndex = firingStart || 0;
            firingStart = 0;
            firingLength = list.length;
            firing = true;
            for (; list && firingIndex < firingLength; ++firingIndex) {
                if (list[firingIndex].apply(data[0], data[1]) === false && options.stopOnFalse) {
                    memory = false;
                    break;
                }
            }
            firing = false;
            if (list) {
                if (stack) stack.length && fire(stack.shift());else if (memory) list.length = 0;else Callbacks.disable();
            }
        },
            Callbacks = {
            list: list,
            add: function add() {
                if (list) {
                    var start = list.length,
                        add = function add(args) {
                        args = Array.prototype.slice.call(args);
                        args.forEach(function (arg, _) {
                            if (typeof arg === "function") {
                                if (!options.unique || !Callbacks.has(arg)) list.push(arg);
                            } else if (arg && arg.length && typeof arg !== 'string') add(arg);
                        });
                    };
                    add(arguments);
                    if (firing) firingLength = list.length;else if (memory) {
                        firingStart = start;
                        fire(memory);
                    }
                }
                return this;
            },
            remove: function remove() {
                var args = Array.prototype.slice.call(arguments);
                if (list) {
                    args.forEach(function (arg, _) {
                        var index;
                        while ((index = list.indexOf(arg, index)) > -1) {
                            list.splice(index, 1);
                            // Handle firing indexes
                            if (firing) {
                                if (index <= firingLength) --firingLength;
                                if (index <= firingIndex) --firingIndex;
                            }
                        }
                    });
                }
                return this;
            },
            has: function has(fn) {
                return !!(list && (fn ? list.indexOf(fn) > -1 : list.length));
            },
            empty: function empty() {
                firingLength = list.length = 0;
                return this;
            },
            disable: function disable() {
                list = stack = memory = undefined;
                return this;
            },
            disabled: function disabled() {
                return !list;
            },
            lock: function lock() {
                stack = undefined;
                if (!memory) Callbacks.disable();
                return this;
            },
            locked: function locked() {
                return !stack;
            },
            fireWith: function fireWith(context, args) {
                if (list && (!_fired || stack)) {
                    args = args || [];
                    args = [context, args.slice ? args.slice() : args];
                    if (firing) stack.push(args);else fire(args);
                }
                return this;
            },
            fire: function fire() {
                return Callbacks.fireWith(this, arguments);
            },
            fired: function fired() {
                return !!_fired;
            }
        };

        return Callbacks;
    };
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {

    /**
     * @file 继承和扩展
     * @author 子虔
     * @date    2014-08-15 11:24:20
     * @param  {Object} protoProps  子类的prototype
     * @param  {[type]} staticProps 子类的静态方法或属性
     * @return {Class}
     */
    var inherits = __webpack_require__(336);

    module.exports = function (protoProps, staticProps) {
        var parent = this,
            child,
            destroy;

        // The constructor function for the new subclass is either defined by you
        // (the "constructor" property in your `extend` definition), or defaulted
        // by us to simply call the parent's constructor.
        if (protoProps && protoProps.hasOwnProperty('constructor')) {
            child = protoProps.constructor;
        } else {
            child = function child() {
                return parent.apply(this, arguments);
            };
        }

        // inherits
        inherits(child, parent, protoProps, staticProps);

        // 销毁自动继承
        if (protoProps.hasOwnProperty('destroy') && (destroy = protoProps.destroy)) {
            protoProps.destroy = function () {
                try {
                    destroy.apply(this, arguments);
                } catch (e) {}

                try {
                    parent.prototype.destroy.apply(this, arguments);
                } catch (e) {}
            };
        }

        return child;
    };
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
    /**
     * @file 继承并在原型链中提供`Parent`方法，用于调用父类prototype中的方法
     * @author 子虔
     * @date    2015-02-15 15:11:23
     */
    module.exports = function (child, parent, protoProps, staticProps) {
        // 绑定静态属性
        $.extend(child, parent, staticProps);

        function Prototype() {
            this.constructor = child;
        }

        Prototype.prototype = parent.prototype;

        child.prototype = new Prototype();

        // 绑定新的属性
        if (protoProps) {
            $.extend(child.prototype, protoProps);
        }

        // merge the Class's default's prototype
        child.prototype.defaults = $.extend(true, {}, parent.prototype.defaults, child.prototype.defaults);

        // Set a convenience property in case the parent's prototype is needed
        // later.
        child.__super__ = parent.prototype;
        child.__class__ = [];

        if (!parent.__class__) {
            child.__class__.push(parent, child);
        } else {
            parent.__class__.forEach(function (item) {
                child.__class__.push(item);
            });
            child.__class__.push(child);
        }

        child.prototype.Parent = function Parent() {
            var caller,
                name,
                parent,
                allClass = this.constructor.__class__,
                allClassLength = allClass.length,
                i = allClassLength - 1,
                args = arguments,
                argsLen = args.length;

            if (argsLen == 2 && typeof args[0] == 'function' && isArgsObject(args[1])) {
                caller = args[0];
                args = args[1] || [];
            } else {
                caller = Parent.caller;
                args = arguments;
            }

            if (!caller) return;

            while (i > 0 && !name) {
                var fun = allClass[i],
                    fn = fun.prototype;
                for (var p in fn) {
                    if (fn.hasOwnProperty(p) && fn[p] === caller) {
                        name = p;
                        parent = allClass[i - 1];
                    }
                }
                i--;
            }

            if (name && parent) {
                if (parent.prototype[name]) {
                    return parent.prototype[name].apply(this, args);
                }
            }
        };
    };

    // 判断一个对象是否为arguments对象
    function isArgsObject(obj) {
        var type = Object.prototype.toString.call(obj);
        return type === '[object Arguments]';
    }
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {

    /**
     * @file 类属性相关的扩展
     * @author 子虔
     * @date    2014-08-18 17:41:24
     */

    var parseParam = __webpack_require__(126),
        isEqual = __webpack_require__(127);

    module.exports = {
        /**
         * 设置参数，可通过`a/b/c/d`的方式设置
         * @param {*} name - 名称或对象
         * @param {*} [value] - 属性值
         * @param {boolean} [silent=false] - 设置的值变化时，是否派发事件
         */
        set: function set(name, value, silent) {
            var data,
                names,
                lastValue,
                len,
                that = this;

            if (typeof name == 'string') {
                names = name.split('/');
                len = names.length;
                if (len > 1) {
                    names.forEach(function (item, index) {
                        if (index == len - 1) {
                            lastValue = data[item];
                            data[item] = value;
                            if (!silent && !isEqual(lastValue, value)) {
                                bubbling.call(that, names, value, lastValue);
                            }
                        } else {
                            data = data || that.attributes;
                            data[item] = data[item] || {};
                            data = data[item];
                        }
                    });
                    return;
                }
            }

            function bubbling(names, value, lastValue) {
                var name = names.length == 1 ? names[0] : names.join('/');

                if (names.length > 0) {
                    this.emit('change:' + name, value, lastValue);
                    names.pop();
                    bubbling.call(this, names, value, lastValue);
                }
            }

            return this.Parent(set, arguments);
        },
        /**
         * 获取参数,可通过`a/b/c/d`获取如上`set`例子中的`d`值
         * @param {string} name - 名称
         * @return {*}
         */
        get: function get(name) {
            var that = this,
                names,
                value = '',
                data,
                len;

            if (typeof name == 'string') {
                names = name.split('/');
                len = names.length;

                if (len > 1) {
                    names.forEach(function (item, index) {
                        if (index == len - 1 && data && (typeof data === 'undefined' ? 'undefined' : _typeof(data)) == 'object') {
                            value = data[item];
                        } else {
                            data = data || that.attributes;
                            data[item] = data[item];
                            data = data[item];
                        }
                    });

                    return value;
                }
            }

            return this.Parent(get, arguments);
        }
    };
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;

/**
 * @return env: {
        device: { // 设备
            val: 1,
            name: 'android',
            isAndroid: true/false
            isIOS: true/false,
            isOther: true/false
        }, 
        platform: { // SNS平台
            val: 1,
            name: 'pengpeng',
            isPengpeng: true/false
            isIOS: true/false,
            ...
        },
        env: '' // 当前开发环境：pro/stage
    }
 */
!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {

    var Url = __webpack_require__(49);

    var ua = window.navigator.userAgent;
    var Env = {
        platform: {},
        device: {},
        env: 'pro'
    };

    // $('#wrap').html(ua)
    //  当前设备
    if (ua.match(/pengpeng/i)) {
        // 碰碰
        Env.platform = {
            val: 2001,
            name: 'pengpeng',
            isPengpeng: true
        };
    } else if (ua.match(/uplive/i) || Url.query('pl', 'hash') == 'uplive' || localStorage.getItem('__inuplive__') || Url.query('pl') == 'uplive') {
        Env.platform = {
            val: 2002,
            name: 'uplive',
            isUplive: true
        };
    } else if (ua.match(/duobao/i)) {
        Env.platform = {
            val: 2003,
            name: 'duobao',
            isDuobao: true
        };
    } else if (ua.match(/micromessenger/i)) {
        // 微信
        Env.platform = {
            val: 1,
            name: 'wechat',
            isWeixin: true
        };
    } else if (ua.match(/qq/i) || ua.match(/and_sq_/i)) {
        // QQ
        Env.platform = {
            val: 4001,
            name: 'qq',
            isQQ: true
        };
    } else if (ua.match(/weibo/i)) {
        // 微博
        Env.platform = {
            val: 8001,
            name: 'weibo',
            isWeibo: true
        };
    } else if (ua.match(/[Tt]witter/i)) {
        // twitter
        Env.platform = {
            val: 2,
            name: 'twitter',
            isTwitter: true
        };
    } else if (ua.match(/FB_IAB/i)) {
        // facebook
        Env.platform = {
            val: 3,
            name: 'facebook',
            isFacebook: true
        };
    } else if (ua.match(/Line/i)) {
        Env.platform = {
            val: 4,
            name: 'line',
            isLine: true
        };
    } else {
        Env.platform = {
            val: 0,
            name: 'unknown',
            isOther: true
        };
    }
    // 当前社交环境
    if (Env.platform.isPengpeng) {
        if (ua.match(/android/i)) {
            Env.device = {
                val: 1,
                name: 'android',
                isAndroid: true
            };
        } else {
            Env.device = {
                val: 2,
                name: 'ios',
                isIOS: true
            };
        }
    } else {
        if (ua.match(/android/i)) {
            Env.device = {
                val: 1,
                name: 'android',
                isAndroid: true
            };
        } else if (ua.match(/iphone|ipad|itouch/i)) {
            Env.device = {
                val: 2,
                name: 'ios',
                isIOS: true
            };
        } else {
            Env.device = {
                val: 3,
                name: 'unknown',
                isOther: true
            };
        }
    }

    // 当前开发环境
    var _env = Url.query('env');

    if (!_env || _env == 'null') {
        Env.env = 'pro';
    } else {
        Env.env = _env;
    }

    module.exports = Env;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.twitter = exports.fb = undefined;

var _config = __webpack_require__(129);

var _config2 = _interopRequireDefault(_config);

var _cUrl = __webpack_require__(49);

var _cUrl2 = _interopRequireDefault(_cUrl);

var _cNenv = __webpack_require__(338);

var _cNenv2 = _interopRequireDefault(_cNenv);

var _fb = __webpack_require__(350);

var _fb2 = _interopRequireDefault(_fb);

var _twitter = __webpack_require__(351);

var _twitter2 = _interopRequireDefault(_twitter);

var _index = __webpack_require__(340);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var sns = {

    /**
     * 前往sns平台进行授权获取code(统一接口提供给外部调用)
     */
    jumpToSNS: function jumpToSNS(platfrom, scope) {
        this[platfrom + 'JumpForCode'](scope);
    },

    /**
     * 前往微信授权中心
     */
    wechatJumpForCode: function wechatJumpForCode(scope) {
        var self = this;
        var urlForCode = 'https://open.weixin.qq.com/connect/oauth2/authorize?';
        var wechat = _config2.default.upInfoInPlatform.wechat;
        var appid = void 0;

        if (_cUrl2.default.query('env') == 'stage') {
            appid = wechat['appid_stage'];
        } else {
            appid = wechat.appid;
        }

        var result = {
            appid: appid,
            redirect_uri: self.getRedirectUri(),
            response_type: 'code',
            scope: 'snsapi_base',
            state: '1'
        };

        if (scope == 'snsapi_userinfo') {
            $.extend(result, {
                scope: scope,
                state: '2'
            });
        }

        self.jump(urlForCode + $.param(result) + '#wechat_redirect');
    },

    qqJumpForCode: function qqJumpForCode() {

        var urlForCode = 'https://graph.qq.com/oauth2.0/authorize?display=mobile&response_type=code&scope=get_user_info';
        if (_cUrl2.default.query('display') == 'pcweb') {
            urlForCode = 'https://graph.qq.com/oauth2.0/authorize?response_type=code&scope=get_user_info';
        }
        var result = {
            client_id: '101402313',
            state: _cUrl2.default.query('stage'),
            redirect_uri: this.getRedirectUri()
        };

        this.jump(urlForCode + '&' + $.param(result));
    },

    twitterJumpForCode: function twitterJumpForCode(requestToken) {
        var urlForCode = 'https://api.twitter.com/oauth/authenticate?oauth_token=' + requestToken;
        this.jump(urlForCode);
    },

    weiboJumpForCode: function weiboJumpForCode() {
        var urlForCode = 'https://api.weibo.com/oauth2/authorize';
        var result = {
            client_id: _config2.default.upInfoInPlatform.weibo.appid,
            response_type: 'code',
            redirect_uri: this.getRedirectUri()
        };

        this.jump(urlForCode + '?' + $.param(result));
    },

    /**
     * 获得重定向URL
     */
    getRedirectUri: function getRedirectUri() {
        var uri = 'http://' + location.hostname + location.pathname;
        var target_uri = _cUrl2.default.query('target_uri') || '';

        var result = {
            target_uri: target_uri.indexOf('//') >= 0 ? encodeURIComponent(target_uri) : target_uri
        };

        if (_config2.default.env()) {
            result.env = _config2.default.env();
        }

        Object.assign(result, {
            oauthtype: _cUrl2.default.query('oauthtype'),
            lang: _index2.default.type,
            channel: _cUrl2.default.query('channel'),
            ignoreCountryCode: _cUrl2.default.query('ignoreCountryCode'),
            multiLoginChannel: _cUrl2.default.query('multiLoginChannel')
        });

        return uri + '?' + $.param(result);
    },

    /**
     * 链接跳转
     */
    jump: function jump(url) {
        location.replace(url);
    }

};

exports.default = sns;
exports.fb = _fb2.default;
exports.twitter = _twitter2.default;

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

var _underscore = __webpack_require__(341);

var _underscore2 = _interopRequireDefault(_underscore);

var _cUrl = __webpack_require__(49);

var _cUrl2 = _interopRequireDefault(_cUrl);

var _pack = __webpack_require__(353);

var _pack2 = _interopRequireDefault(_pack);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var lang = _cUrl2.default.query('lang'); /**
                                          * 前端多语言解决方案
                                          */

var tws = ['zh-SG', 'zh-MO', 'zh-TW', 'zh-HK'];
var ars = ['ar-AE', 'ar-BH', 'ar-DZ', 'ar-EG', 'ar-IQ', 'ar-JO', 'ar-KW', 'ar-LB', 'ar-LY', 'ar-MA', 'ar-OM', 'ar-QA', 'ar-SA', 'ar-SY', 'ar-TN', 'ar-YE'];
// if (!lang) {
//     let systemLanguage = navigator.language || navigator.browserLanguage;
//     if (systemLanguage.toLowerCase() == 'ar') {
//         systemLanguage = 'ar-EG';
//     } else {
//         let arr = systemLanguage.split('-');
//         systemLanguage = arr[0] + '-' + arr[1].toUpperCase();
//     }


//     if (systemLanguage == 'zh-CN' || systemLanguage == 'ja-JP') {
//         lang = systemLanguage;
//     } else if (tws.indexOf(systemLanguage) >= 0) {
//         lang = 'zh-TW';
//     } else if (ars.indexOf(systemLanguage) >= 0) {
//         lang = 'ar-EG';
//     } else {
//         lang = 'en-US';
//     }
// }
if (!lang) {
    var systemLanguage = navigator.language || navigator.browserLanguage;
    var _systemLanguage = systemLanguage.toLowerCase();

    switch (_systemLanguage) {
        case 'ar':
            systemLanguage = 'ar-EG';
            break;
        case 'vi':
            systemLanguage = 'vi-VN';
            break;
        case 'en':
            systemLanguage = 'en-US';
            break;
        case 'ja':
            systemLanguage = 'ja-JP';
            break;
        case 'zh':
            systemLanguage = 'zh-CN';
            break;
        default:
            break;
    }

    var arr = systemLanguage.split('-');

    if (arr.length > 1) {
        systemLanguage = arr[0] + '-' + arr[1].toUpperCase();
    } else {
        systemLanguage = 'en-US';
    }

    if (systemLanguage == 'zh-CN' || systemLanguage == 'ja-JP' || systemLanguage == 'vi-VN') {
        lang = systemLanguage;
    } else if (tws.indexOf(systemLanguage) >= 0) {
        lang = 'zh-TW';
    } else if (ars.indexOf(systemLanguage) >= 0) {
        lang = 'ar-EG';
    } else {
        lang = 'en-US';
    }
}

var langType = lang.replace('-', '').toLowerCase();
var langPack = _pack2.default[langType] || _pack2.default['enus'];

var _lang = {

    type: lang,
    init: function init() {
        $('html').attr('lang', lang);
        $('body').addClass(langType);
    },

    template: function template(tplStr, data, insertEM) {
        var tpl = langPack[tplStr] || tplStr;

        if (tpl) {
            if (typeof tpl != 'string') return;
            if (tpl.indexOf('@@@@') > 0) {
                var strArr = [];

                strArr.push('<ul>');
                tpl.split('@@@@').forEach(function (item, index) {
                    item && strArr.push('<li>' + item + '</li>');
                });
                strArr.push('</ul>');
                tpl = strArr.join('');
            }
            if (insertEM) {
                tpl = tpl.replace(/<%=([\s\S]+?)%>/g, function ($0, $1) {
                    return '<em class="' + $1 + '">' + $0 + '</em>';
                });
            }

            var compiled = _underscore2.default.template(tpl);
            return compiled(data);
        } else {
            return _underscore2.default.template(tplStr)(data);
        }
    }
};

_lang.init();

module.exports = _lang;

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//     Underscore.js 1.9.0
//     http://underscorejs.org
//     (c) 2009-2018 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
//     Underscore may be freely distributed under the MIT license.

(function() {

  // Baseline setup
  // --------------

  // Establish the root object, `window` (`self`) in the browser, `global`
  // on the server, or `this` in some virtual machines. We use `self`
  // instead of `window` for `WebWorker` support.
  var root = typeof self == 'object' && self.self === self && self ||
            typeof global == 'object' && global.global === global && global ||
            this ||
            {};

  // Save the previous value of the `_` variable.
  var previousUnderscore = root._;

  // Save bytes in the minified (but not gzipped) version:
  var ArrayProto = Array.prototype, ObjProto = Object.prototype;
  var SymbolProto = typeof Symbol !== 'undefined' ? Symbol.prototype : null;

  // Create quick reference variables for speed access to core prototypes.
  var push = ArrayProto.push,
      slice = ArrayProto.slice,
      toString = ObjProto.toString,
      hasOwnProperty = ObjProto.hasOwnProperty;

  // All **ECMAScript 5** native function implementations that we hope to use
  // are declared here.
  var nativeIsArray = Array.isArray,
      nativeKeys = Object.keys,
      nativeCreate = Object.create;

  // Naked function reference for surrogate-prototype-swapping.
  var Ctor = function(){};

  // Create a safe reference to the Underscore object for use below.
  var _ = function(obj) {
    if (obj instanceof _) return obj;
    if (!(this instanceof _)) return new _(obj);
    this._wrapped = obj;
  };

  // Export the Underscore object for **Node.js**, with
  // backwards-compatibility for their old module API. If we're in
  // the browser, add `_` as a global object.
  // (`nodeType` is checked to ensure that `module`
  // and `exports` are not HTML elements.)
  if (typeof exports != 'undefined' && !exports.nodeType) {
    if (typeof module != 'undefined' && !module.nodeType && module.exports) {
      exports = module.exports = _;
    }
    exports._ = _;
  } else {
    root._ = _;
  }

  // Current version.
  _.VERSION = '1.9.0';

  // Internal function that returns an efficient (for current engines) version
  // of the passed-in callback, to be repeatedly applied in other Underscore
  // functions.
  var optimizeCb = function(func, context, argCount) {
    if (context === void 0) return func;
    switch (argCount == null ? 3 : argCount) {
      case 1: return function(value) {
        return func.call(context, value);
      };
      // The 2-argument case is omitted because we’re not using it.
      case 3: return function(value, index, collection) {
        return func.call(context, value, index, collection);
      };
      case 4: return function(accumulator, value, index, collection) {
        return func.call(context, accumulator, value, index, collection);
      };
    }
    return function() {
      return func.apply(context, arguments);
    };
  };

  var builtinIteratee;

  // An internal function to generate callbacks that can be applied to each
  // element in a collection, returning the desired result — either `identity`,
  // an arbitrary callback, a property matcher, or a property accessor.
  var cb = function(value, context, argCount) {
    if (_.iteratee !== builtinIteratee) return _.iteratee(value, context);
    if (value == null) return _.identity;
    if (_.isFunction(value)) return optimizeCb(value, context, argCount);
    if (_.isObject(value) && !_.isArray(value)) return _.matcher(value);
    return _.property(value);
  };

  // External wrapper for our callback generator. Users may customize
  // `_.iteratee` if they want additional predicate/iteratee shorthand styles.
  // This abstraction hides the internal-only argCount argument.
  _.iteratee = builtinIteratee = function(value, context) {
    return cb(value, context, Infinity);
  };

  // Some functions take a variable number of arguments, or a few expected
  // arguments at the beginning and then a variable number of values to operate
  // on. This helper accumulates all remaining arguments past the function’s
  // argument length (or an explicit `startIndex`), into an array that becomes
  // the last argument. Similar to ES6’s "rest parameter".
  var restArguments = function(func, startIndex) {
    startIndex = startIndex == null ? func.length - 1 : +startIndex;
    return function() {
      var length = Math.max(arguments.length - startIndex, 0),
          rest = Array(length),
          index = 0;
      for (; index < length; index++) {
        rest[index] = arguments[index + startIndex];
      }
      switch (startIndex) {
        case 0: return func.call(this, rest);
        case 1: return func.call(this, arguments[0], rest);
        case 2: return func.call(this, arguments[0], arguments[1], rest);
      }
      var args = Array(startIndex + 1);
      for (index = 0; index < startIndex; index++) {
        args[index] = arguments[index];
      }
      args[startIndex] = rest;
      return func.apply(this, args);
    };
  };

  // An internal function for creating a new object that inherits from another.
  var baseCreate = function(prototype) {
    if (!_.isObject(prototype)) return {};
    if (nativeCreate) return nativeCreate(prototype);
    Ctor.prototype = prototype;
    var result = new Ctor;
    Ctor.prototype = null;
    return result;
  };

  var shallowProperty = function(key) {
    return function(obj) {
      return obj == null ? void 0 : obj[key];
    };
  };

  var deepGet = function(obj, path) {
    var length = path.length;
    for (var i = 0; i < length; i++) {
      if (obj == null) return void 0;
      obj = obj[path[i]];
    }
    return length ? obj : void 0;
  };

  // Helper for collection methods to determine whether a collection
  // should be iterated as an array or as an object.
  // Related: http://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
  // Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
  var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;
  var getLength = shallowProperty('length');
  var isArrayLike = function(collection) {
    var length = getLength(collection);
    return typeof length == 'number' && length >= 0 && length <= MAX_ARRAY_INDEX;
  };

  // Collection Functions
  // --------------------

  // The cornerstone, an `each` implementation, aka `forEach`.
  // Handles raw objects in addition to array-likes. Treats all
  // sparse array-likes as if they were dense.
  _.each = _.forEach = function(obj, iteratee, context) {
    iteratee = optimizeCb(iteratee, context);
    var i, length;
    if (isArrayLike(obj)) {
      for (i = 0, length = obj.length; i < length; i++) {
        iteratee(obj[i], i, obj);
      }
    } else {
      var keys = _.keys(obj);
      for (i = 0, length = keys.length; i < length; i++) {
        iteratee(obj[keys[i]], keys[i], obj);
      }
    }
    return obj;
  };

  // Return the results of applying the iteratee to each element.
  _.map = _.collect = function(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length,
        results = Array(length);
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      results[index] = iteratee(obj[currentKey], currentKey, obj);
    }
    return results;
  };

  // Create a reducing function iterating left or right.
  var createReduce = function(dir) {
    // Wrap code that reassigns argument variables in a separate function than
    // the one that accesses `arguments.length` to avoid a perf hit. (#1991)
    var reducer = function(obj, iteratee, memo, initial) {
      var keys = !isArrayLike(obj) && _.keys(obj),
          length = (keys || obj).length,
          index = dir > 0 ? 0 : length - 1;
      if (!initial) {
        memo = obj[keys ? keys[index] : index];
        index += dir;
      }
      for (; index >= 0 && index < length; index += dir) {
        var currentKey = keys ? keys[index] : index;
        memo = iteratee(memo, obj[currentKey], currentKey, obj);
      }
      return memo;
    };

    return function(obj, iteratee, memo, context) {
      var initial = arguments.length >= 3;
      return reducer(obj, optimizeCb(iteratee, context, 4), memo, initial);
    };
  };

  // **Reduce** builds up a single result from a list of values, aka `inject`,
  // or `foldl`.
  _.reduce = _.foldl = _.inject = createReduce(1);

  // The right-associative version of reduce, also known as `foldr`.
  _.reduceRight = _.foldr = createReduce(-1);

  // Return the first value which passes a truth test. Aliased as `detect`.
  _.find = _.detect = function(obj, predicate, context) {
    var keyFinder = isArrayLike(obj) ? _.findIndex : _.findKey;
    var key = keyFinder(obj, predicate, context);
    if (key !== void 0 && key !== -1) return obj[key];
  };

  // Return all the elements that pass a truth test.
  // Aliased as `select`.
  _.filter = _.select = function(obj, predicate, context) {
    var results = [];
    predicate = cb(predicate, context);
    _.each(obj, function(value, index, list) {
      if (predicate(value, index, list)) results.push(value);
    });
    return results;
  };

  // Return all the elements for which a truth test fails.
  _.reject = function(obj, predicate, context) {
    return _.filter(obj, _.negate(cb(predicate)), context);
  };

  // Determine whether all of the elements match a truth test.
  // Aliased as `all`.
  _.every = _.all = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length;
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      if (!predicate(obj[currentKey], currentKey, obj)) return false;
    }
    return true;
  };

  // Determine if at least one element in the object matches a truth test.
  // Aliased as `any`.
  _.some = _.any = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length;
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      if (predicate(obj[currentKey], currentKey, obj)) return true;
    }
    return false;
  };

  // Determine if the array or object contains a given item (using `===`).
  // Aliased as `includes` and `include`.
  _.contains = _.includes = _.include = function(obj, item, fromIndex, guard) {
    if (!isArrayLike(obj)) obj = _.values(obj);
    if (typeof fromIndex != 'number' || guard) fromIndex = 0;
    return _.indexOf(obj, item, fromIndex) >= 0;
  };

  // Invoke a method (with arguments) on every item in a collection.
  _.invoke = restArguments(function(obj, path, args) {
    var contextPath, func;
    if (_.isFunction(path)) {
      func = path;
    } else if (_.isArray(path)) {
      contextPath = path.slice(0, -1);
      path = path[path.length - 1];
    }
    return _.map(obj, function(context) {
      var method = func;
      if (!method) {
        if (contextPath && contextPath.length) {
          context = deepGet(context, contextPath);
        }
        if (context == null) return void 0;
        method = context[path];
      }
      return method == null ? method : method.apply(context, args);
    });
  });

  // Convenience version of a common use case of `map`: fetching a property.
  _.pluck = function(obj, key) {
    return _.map(obj, _.property(key));
  };

  // Convenience version of a common use case of `filter`: selecting only objects
  // containing specific `key:value` pairs.
  _.where = function(obj, attrs) {
    return _.filter(obj, _.matcher(attrs));
  };

  // Convenience version of a common use case of `find`: getting the first object
  // containing specific `key:value` pairs.
  _.findWhere = function(obj, attrs) {
    return _.find(obj, _.matcher(attrs));
  };

  // Return the maximum element (or element-based computation).
  _.max = function(obj, iteratee, context) {
    var result = -Infinity, lastComputed = -Infinity,
        value, computed;
    if (iteratee == null || typeof iteratee == 'number' && typeof obj[0] != 'object' && obj != null) {
      obj = isArrayLike(obj) ? obj : _.values(obj);
      for (var i = 0, length = obj.length; i < length; i++) {
        value = obj[i];
        if (value != null && value > result) {
          result = value;
        }
      }
    } else {
      iteratee = cb(iteratee, context);
      _.each(obj, function(v, index, list) {
        computed = iteratee(v, index, list);
        if (computed > lastComputed || computed === -Infinity && result === -Infinity) {
          result = v;
          lastComputed = computed;
        }
      });
    }
    return result;
  };

  // Return the minimum element (or element-based computation).
  _.min = function(obj, iteratee, context) {
    var result = Infinity, lastComputed = Infinity,
        value, computed;
    if (iteratee == null || typeof iteratee == 'number' && typeof obj[0] != 'object' && obj != null) {
      obj = isArrayLike(obj) ? obj : _.values(obj);
      for (var i = 0, length = obj.length; i < length; i++) {
        value = obj[i];
        if (value != null && value < result) {
          result = value;
        }
      }
    } else {
      iteratee = cb(iteratee, context);
      _.each(obj, function(v, index, list) {
        computed = iteratee(v, index, list);
        if (computed < lastComputed || computed === Infinity && result === Infinity) {
          result = v;
          lastComputed = computed;
        }
      });
    }
    return result;
  };

  // Shuffle a collection.
  _.shuffle = function(obj) {
    return _.sample(obj, Infinity);
  };

  // Sample **n** random values from a collection using the modern version of the
  // [Fisher-Yates shuffle](http://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
  // If **n** is not specified, returns a single random element.
  // The internal `guard` argument allows it to work with `map`.
  _.sample = function(obj, n, guard) {
    if (n == null || guard) {
      if (!isArrayLike(obj)) obj = _.values(obj);
      return obj[_.random(obj.length - 1)];
    }
    var sample = isArrayLike(obj) ? _.clone(obj) : _.values(obj);
    var length = getLength(sample);
    n = Math.max(Math.min(n, length), 0);
    var last = length - 1;
    for (var index = 0; index < n; index++) {
      var rand = _.random(index, last);
      var temp = sample[index];
      sample[index] = sample[rand];
      sample[rand] = temp;
    }
    return sample.slice(0, n);
  };

  // Sort the object's values by a criterion produced by an iteratee.
  _.sortBy = function(obj, iteratee, context) {
    var index = 0;
    iteratee = cb(iteratee, context);
    return _.pluck(_.map(obj, function(value, key, list) {
      return {
        value: value,
        index: index++,
        criteria: iteratee(value, key, list)
      };
    }).sort(function(left, right) {
      var a = left.criteria;
      var b = right.criteria;
      if (a !== b) {
        if (a > b || a === void 0) return 1;
        if (a < b || b === void 0) return -1;
      }
      return left.index - right.index;
    }), 'value');
  };

  // An internal function used for aggregate "group by" operations.
  var group = function(behavior, partition) {
    return function(obj, iteratee, context) {
      var result = partition ? [[], []] : {};
      iteratee = cb(iteratee, context);
      _.each(obj, function(value, index) {
        var key = iteratee(value, index, obj);
        behavior(result, value, key);
      });
      return result;
    };
  };

  // Groups the object's values by a criterion. Pass either a string attribute
  // to group by, or a function that returns the criterion.
  _.groupBy = group(function(result, value, key) {
    if (_.has(result, key)) result[key].push(value); else result[key] = [value];
  });

  // Indexes the object's values by a criterion, similar to `groupBy`, but for
  // when you know that your index values will be unique.
  _.indexBy = group(function(result, value, key) {
    result[key] = value;
  });

  // Counts instances of an object that group by a certain criterion. Pass
  // either a string attribute to count by, or a function that returns the
  // criterion.
  _.countBy = group(function(result, value, key) {
    if (_.has(result, key)) result[key]++; else result[key] = 1;
  });

  var reStrSymbol = /[^\ud800-\udfff]|[\ud800-\udbff][\udc00-\udfff]|[\ud800-\udfff]/g;
  // Safely create a real, live array from anything iterable.
  _.toArray = function(obj) {
    if (!obj) return [];
    if (_.isArray(obj)) return slice.call(obj);
    if (_.isString(obj)) {
      // Keep surrogate pair characters together
      return obj.match(reStrSymbol);
    }
    if (isArrayLike(obj)) return _.map(obj, _.identity);
    return _.values(obj);
  };

  // Return the number of elements in an object.
  _.size = function(obj) {
    if (obj == null) return 0;
    return isArrayLike(obj) ? obj.length : _.keys(obj).length;
  };

  // Split a collection into two arrays: one whose elements all satisfy the given
  // predicate, and one whose elements all do not satisfy the predicate.
  _.partition = group(function(result, value, pass) {
    result[pass ? 0 : 1].push(value);
  }, true);

  // Array Functions
  // ---------------

  // Get the first element of an array. Passing **n** will return the first N
  // values in the array. Aliased as `head` and `take`. The **guard** check
  // allows it to work with `_.map`.
  _.first = _.head = _.take = function(array, n, guard) {
    if (array == null || array.length < 1) return void 0;
    if (n == null || guard) return array[0];
    return _.initial(array, array.length - n);
  };

  // Returns everything but the last entry of the array. Especially useful on
  // the arguments object. Passing **n** will return all the values in
  // the array, excluding the last N.
  _.initial = function(array, n, guard) {
    return slice.call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
  };

  // Get the last element of an array. Passing **n** will return the last N
  // values in the array.
  _.last = function(array, n, guard) {
    if (array == null || array.length < 1) return void 0;
    if (n == null || guard) return array[array.length - 1];
    return _.rest(array, Math.max(0, array.length - n));
  };

  // Returns everything but the first entry of the array. Aliased as `tail` and `drop`.
  // Especially useful on the arguments object. Passing an **n** will return
  // the rest N values in the array.
  _.rest = _.tail = _.drop = function(array, n, guard) {
    return slice.call(array, n == null || guard ? 1 : n);
  };

  // Trim out all falsy values from an array.
  _.compact = function(array) {
    return _.filter(array, Boolean);
  };

  // Internal implementation of a recursive `flatten` function.
  var flatten = function(input, shallow, strict, output) {
    output = output || [];
    var idx = output.length;
    for (var i = 0, length = getLength(input); i < length; i++) {
      var value = input[i];
      if (isArrayLike(value) && (_.isArray(value) || _.isArguments(value))) {
        // Flatten current level of array or arguments object.
        if (shallow) {
          var j = 0, len = value.length;
          while (j < len) output[idx++] = value[j++];
        } else {
          flatten(value, shallow, strict, output);
          idx = output.length;
        }
      } else if (!strict) {
        output[idx++] = value;
      }
    }
    return output;
  };

  // Flatten out an array, either recursively (by default), or just one level.
  _.flatten = function(array, shallow) {
    return flatten(array, shallow, false);
  };

  // Return a version of the array that does not contain the specified value(s).
  _.without = restArguments(function(array, otherArrays) {
    return _.difference(array, otherArrays);
  });

  // Produce a duplicate-free version of the array. If the array has already
  // been sorted, you have the option of using a faster algorithm.
  // The faster algorithm will not work with an iteratee if the iteratee
  // is not a one-to-one function, so providing an iteratee will disable
  // the faster algorithm.
  // Aliased as `unique`.
  _.uniq = _.unique = function(array, isSorted, iteratee, context) {
    if (!_.isBoolean(isSorted)) {
      context = iteratee;
      iteratee = isSorted;
      isSorted = false;
    }
    if (iteratee != null) iteratee = cb(iteratee, context);
    var result = [];
    var seen = [];
    for (var i = 0, length = getLength(array); i < length; i++) {
      var value = array[i],
          computed = iteratee ? iteratee(value, i, array) : value;
      if (isSorted && !iteratee) {
        if (!i || seen !== computed) result.push(value);
        seen = computed;
      } else if (iteratee) {
        if (!_.contains(seen, computed)) {
          seen.push(computed);
          result.push(value);
        }
      } else if (!_.contains(result, value)) {
        result.push(value);
      }
    }
    return result;
  };

  // Produce an array that contains the union: each distinct element from all of
  // the passed-in arrays.
  _.union = restArguments(function(arrays) {
    return _.uniq(flatten(arrays, true, true));
  });

  // Produce an array that contains every item shared between all the
  // passed-in arrays.
  _.intersection = function(array) {
    var result = [];
    var argsLength = arguments.length;
    for (var i = 0, length = getLength(array); i < length; i++) {
      var item = array[i];
      if (_.contains(result, item)) continue;
      var j;
      for (j = 1; j < argsLength; j++) {
        if (!_.contains(arguments[j], item)) break;
      }
      if (j === argsLength) result.push(item);
    }
    return result;
  };

  // Take the difference between one array and a number of other arrays.
  // Only the elements present in just the first array will remain.
  _.difference = restArguments(function(array, rest) {
    rest = flatten(rest, true, true);
    return _.filter(array, function(value){
      return !_.contains(rest, value);
    });
  });

  // Complement of _.zip. Unzip accepts an array of arrays and groups
  // each array's elements on shared indices.
  _.unzip = function(array) {
    var length = array && _.max(array, getLength).length || 0;
    var result = Array(length);

    for (var index = 0; index < length; index++) {
      result[index] = _.pluck(array, index);
    }
    return result;
  };

  // Zip together multiple lists into a single array -- elements that share
  // an index go together.
  _.zip = restArguments(_.unzip);

  // Converts lists into objects. Pass either a single array of `[key, value]`
  // pairs, or two parallel arrays of the same length -- one of keys, and one of
  // the corresponding values. Passing by pairs is the reverse of _.pairs.
  _.object = function(list, values) {
    var result = {};
    for (var i = 0, length = getLength(list); i < length; i++) {
      if (values) {
        result[list[i]] = values[i];
      } else {
        result[list[i][0]] = list[i][1];
      }
    }
    return result;
  };

  // Generator function to create the findIndex and findLastIndex functions.
  var createPredicateIndexFinder = function(dir) {
    return function(array, predicate, context) {
      predicate = cb(predicate, context);
      var length = getLength(array);
      var index = dir > 0 ? 0 : length - 1;
      for (; index >= 0 && index < length; index += dir) {
        if (predicate(array[index], index, array)) return index;
      }
      return -1;
    };
  };

  // Returns the first index on an array-like that passes a predicate test.
  _.findIndex = createPredicateIndexFinder(1);
  _.findLastIndex = createPredicateIndexFinder(-1);

  // Use a comparator function to figure out the smallest index at which
  // an object should be inserted so as to maintain order. Uses binary search.
  _.sortedIndex = function(array, obj, iteratee, context) {
    iteratee = cb(iteratee, context, 1);
    var value = iteratee(obj);
    var low = 0, high = getLength(array);
    while (low < high) {
      var mid = Math.floor((low + high) / 2);
      if (iteratee(array[mid]) < value) low = mid + 1; else high = mid;
    }
    return low;
  };

  // Generator function to create the indexOf and lastIndexOf functions.
  var createIndexFinder = function(dir, predicateFind, sortedIndex) {
    return function(array, item, idx) {
      var i = 0, length = getLength(array);
      if (typeof idx == 'number') {
        if (dir > 0) {
          i = idx >= 0 ? idx : Math.max(idx + length, i);
        } else {
          length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
        }
      } else if (sortedIndex && idx && length) {
        idx = sortedIndex(array, item);
        return array[idx] === item ? idx : -1;
      }
      if (item !== item) {
        idx = predicateFind(slice.call(array, i, length), _.isNaN);
        return idx >= 0 ? idx + i : -1;
      }
      for (idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir) {
        if (array[idx] === item) return idx;
      }
      return -1;
    };
  };

  // Return the position of the first occurrence of an item in an array,
  // or -1 if the item is not included in the array.
  // If the array is large and already in sort order, pass `true`
  // for **isSorted** to use binary search.
  _.indexOf = createIndexFinder(1, _.findIndex, _.sortedIndex);
  _.lastIndexOf = createIndexFinder(-1, _.findLastIndex);

  // Generate an integer Array containing an arithmetic progression. A port of
  // the native Python `range()` function. See
  // [the Python documentation](http://docs.python.org/library/functions.html#range).
  _.range = function(start, stop, step) {
    if (stop == null) {
      stop = start || 0;
      start = 0;
    }
    if (!step) {
      step = stop < start ? -1 : 1;
    }

    var length = Math.max(Math.ceil((stop - start) / step), 0);
    var range = Array(length);

    for (var idx = 0; idx < length; idx++, start += step) {
      range[idx] = start;
    }

    return range;
  };

  // Chunk a single array into multiple arrays, each containing `count` or fewer
  // items.
  _.chunk = function(array, count) {
    if (count == null || count < 1) return [];
    var result = [];
    var i = 0, length = array.length;
    while (i < length) {
      result.push(slice.call(array, i, i += count));
    }
    return result;
  };

  // Function (ahem) Functions
  // ------------------

  // Determines whether to execute a function as a constructor
  // or a normal function with the provided arguments.
  var executeBound = function(sourceFunc, boundFunc, context, callingContext, args) {
    if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
    var self = baseCreate(sourceFunc.prototype);
    var result = sourceFunc.apply(self, args);
    if (_.isObject(result)) return result;
    return self;
  };

  // Create a function bound to a given object (assigning `this`, and arguments,
  // optionally). Delegates to **ECMAScript 5**'s native `Function.bind` if
  // available.
  _.bind = restArguments(function(func, context, args) {
    if (!_.isFunction(func)) throw new TypeError('Bind must be called on a function');
    var bound = restArguments(function(callArgs) {
      return executeBound(func, bound, context, this, args.concat(callArgs));
    });
    return bound;
  });

  // Partially apply a function by creating a version that has had some of its
  // arguments pre-filled, without changing its dynamic `this` context. _ acts
  // as a placeholder by default, allowing any combination of arguments to be
  // pre-filled. Set `_.partial.placeholder` for a custom placeholder argument.
  _.partial = restArguments(function(func, boundArgs) {
    var placeholder = _.partial.placeholder;
    var bound = function() {
      var position = 0, length = boundArgs.length;
      var args = Array(length);
      for (var i = 0; i < length; i++) {
        args[i] = boundArgs[i] === placeholder ? arguments[position++] : boundArgs[i];
      }
      while (position < arguments.length) args.push(arguments[position++]);
      return executeBound(func, bound, this, this, args);
    };
    return bound;
  });

  _.partial.placeholder = _;

  // Bind a number of an object's methods to that object. Remaining arguments
  // are the method names to be bound. Useful for ensuring that all callbacks
  // defined on an object belong to it.
  _.bindAll = restArguments(function(obj, keys) {
    keys = flatten(keys, false, false);
    var index = keys.length;
    if (index < 1) throw new Error('bindAll must be passed function names');
    while (index--) {
      var key = keys[index];
      obj[key] = _.bind(obj[key], obj);
    }
  });

  // Memoize an expensive function by storing its results.
  _.memoize = function(func, hasher) {
    var memoize = function(key) {
      var cache = memoize.cache;
      var address = '' + (hasher ? hasher.apply(this, arguments) : key);
      if (!_.has(cache, address)) cache[address] = func.apply(this, arguments);
      return cache[address];
    };
    memoize.cache = {};
    return memoize;
  };

  // Delays a function for the given number of milliseconds, and then calls
  // it with the arguments supplied.
  _.delay = restArguments(function(func, wait, args) {
    return setTimeout(function() {
      return func.apply(null, args);
    }, wait);
  });

  // Defers a function, scheduling it to run after the current call stack has
  // cleared.
  _.defer = _.partial(_.delay, _, 1);

  // Returns a function, that, when invoked, will only be triggered at most once
  // during a given window of time. Normally, the throttled function will run
  // as much as it can, without ever going more than once per `wait` duration;
  // but if you'd like to disable the execution on the leading edge, pass
  // `{leading: false}`. To disable execution on the trailing edge, ditto.
  _.throttle = function(func, wait, options) {
    var timeout, context, args, result;
    var previous = 0;
    if (!options) options = {};

    var later = function() {
      previous = options.leading === false ? 0 : _.now();
      timeout = null;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    };

    var throttled = function() {
      var now = _.now();
      if (!previous && options.leading === false) previous = now;
      var remaining = wait - (now - previous);
      context = this;
      args = arguments;
      if (remaining <= 0 || remaining > wait) {
        if (timeout) {
          clearTimeout(timeout);
          timeout = null;
        }
        previous = now;
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      } else if (!timeout && options.trailing !== false) {
        timeout = setTimeout(later, remaining);
      }
      return result;
    };

    throttled.cancel = function() {
      clearTimeout(timeout);
      previous = 0;
      timeout = context = args = null;
    };

    return throttled;
  };

  // Returns a function, that, as long as it continues to be invoked, will not
  // be triggered. The function will be called after it stops being called for
  // N milliseconds. If `immediate` is passed, trigger the function on the
  // leading edge, instead of the trailing.
  _.debounce = function(func, wait, immediate) {
    var timeout, result;

    var later = function(context, args) {
      timeout = null;
      if (args) result = func.apply(context, args);
    };

    var debounced = restArguments(function(args) {
      if (timeout) clearTimeout(timeout);
      if (immediate) {
        var callNow = !timeout;
        timeout = setTimeout(later, wait);
        if (callNow) result = func.apply(this, args);
      } else {
        timeout = _.delay(later, wait, this, args);
      }

      return result;
    });

    debounced.cancel = function() {
      clearTimeout(timeout);
      timeout = null;
    };

    return debounced;
  };

  // Returns the first function passed as an argument to the second,
  // allowing you to adjust arguments, run code before and after, and
  // conditionally execute the original function.
  _.wrap = function(func, wrapper) {
    return _.partial(wrapper, func);
  };

  // Returns a negated version of the passed-in predicate.
  _.negate = function(predicate) {
    return function() {
      return !predicate.apply(this, arguments);
    };
  };

  // Returns a function that is the composition of a list of functions, each
  // consuming the return value of the function that follows.
  _.compose = function() {
    var args = arguments;
    var start = args.length - 1;
    return function() {
      var i = start;
      var result = args[start].apply(this, arguments);
      while (i--) result = args[i].call(this, result);
      return result;
    };
  };

  // Returns a function that will only be executed on and after the Nth call.
  _.after = function(times, func) {
    return function() {
      if (--times < 1) {
        return func.apply(this, arguments);
      }
    };
  };

  // Returns a function that will only be executed up to (but not including) the Nth call.
  _.before = function(times, func) {
    var memo;
    return function() {
      if (--times > 0) {
        memo = func.apply(this, arguments);
      }
      if (times <= 1) func = null;
      return memo;
    };
  };

  // Returns a function that will be executed at most one time, no matter how
  // often you call it. Useful for lazy initialization.
  _.once = _.partial(_.before, 2);

  _.restArguments = restArguments;

  // Object Functions
  // ----------------

  // Keys in IE < 9 that won't be iterated by `for key in ...` and thus missed.
  var hasEnumBug = !{toString: null}.propertyIsEnumerable('toString');
  var nonEnumerableProps = ['valueOf', 'isPrototypeOf', 'toString',
    'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];

  var collectNonEnumProps = function(obj, keys) {
    var nonEnumIdx = nonEnumerableProps.length;
    var constructor = obj.constructor;
    var proto = _.isFunction(constructor) && constructor.prototype || ObjProto;

    // Constructor is a special case.
    var prop = 'constructor';
    if (_.has(obj, prop) && !_.contains(keys, prop)) keys.push(prop);

    while (nonEnumIdx--) {
      prop = nonEnumerableProps[nonEnumIdx];
      if (prop in obj && obj[prop] !== proto[prop] && !_.contains(keys, prop)) {
        keys.push(prop);
      }
    }
  };

  // Retrieve the names of an object's own properties.
  // Delegates to **ECMAScript 5**'s native `Object.keys`.
  _.keys = function(obj) {
    if (!_.isObject(obj)) return [];
    if (nativeKeys) return nativeKeys(obj);
    var keys = [];
    for (var key in obj) if (_.has(obj, key)) keys.push(key);
    // Ahem, IE < 9.
    if (hasEnumBug) collectNonEnumProps(obj, keys);
    return keys;
  };

  // Retrieve all the property names of an object.
  _.allKeys = function(obj) {
    if (!_.isObject(obj)) return [];
    var keys = [];
    for (var key in obj) keys.push(key);
    // Ahem, IE < 9.
    if (hasEnumBug) collectNonEnumProps(obj, keys);
    return keys;
  };

  // Retrieve the values of an object's properties.
  _.values = function(obj) {
    var keys = _.keys(obj);
    var length = keys.length;
    var values = Array(length);
    for (var i = 0; i < length; i++) {
      values[i] = obj[keys[i]];
    }
    return values;
  };

  // Returns the results of applying the iteratee to each element of the object.
  // In contrast to _.map it returns an object.
  _.mapObject = function(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    var keys = _.keys(obj),
        length = keys.length,
        results = {};
    for (var index = 0; index < length; index++) {
      var currentKey = keys[index];
      results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
    }
    return results;
  };

  // Convert an object into a list of `[key, value]` pairs.
  // The opposite of _.object.
  _.pairs = function(obj) {
    var keys = _.keys(obj);
    var length = keys.length;
    var pairs = Array(length);
    for (var i = 0; i < length; i++) {
      pairs[i] = [keys[i], obj[keys[i]]];
    }
    return pairs;
  };

  // Invert the keys and values of an object. The values must be serializable.
  _.invert = function(obj) {
    var result = {};
    var keys = _.keys(obj);
    for (var i = 0, length = keys.length; i < length; i++) {
      result[obj[keys[i]]] = keys[i];
    }
    return result;
  };

  // Return a sorted list of the function names available on the object.
  // Aliased as `methods`.
  _.functions = _.methods = function(obj) {
    var names = [];
    for (var key in obj) {
      if (_.isFunction(obj[key])) names.push(key);
    }
    return names.sort();
  };

  // An internal function for creating assigner functions.
  var createAssigner = function(keysFunc, defaults) {
    return function(obj) {
      var length = arguments.length;
      if (defaults) obj = Object(obj);
      if (length < 2 || obj == null) return obj;
      for (var index = 1; index < length; index++) {
        var source = arguments[index],
            keys = keysFunc(source),
            l = keys.length;
        for (var i = 0; i < l; i++) {
          var key = keys[i];
          if (!defaults || obj[key] === void 0) obj[key] = source[key];
        }
      }
      return obj;
    };
  };

  // Extend a given object with all the properties in passed-in object(s).
  _.extend = createAssigner(_.allKeys);

  // Assigns a given object with all the own properties in the passed-in object(s).
  // (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
  _.extendOwn = _.assign = createAssigner(_.keys);

  // Returns the first key on an object that passes a predicate test.
  _.findKey = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = _.keys(obj), key;
    for (var i = 0, length = keys.length; i < length; i++) {
      key = keys[i];
      if (predicate(obj[key], key, obj)) return key;
    }
  };

  // Internal pick helper function to determine if `obj` has key `key`.
  var keyInObj = function(value, key, obj) {
    return key in obj;
  };

  // Return a copy of the object only containing the whitelisted properties.
  _.pick = restArguments(function(obj, keys) {
    var result = {}, iteratee = keys[0];
    if (obj == null) return result;
    if (_.isFunction(iteratee)) {
      if (keys.length > 1) iteratee = optimizeCb(iteratee, keys[1]);
      keys = _.allKeys(obj);
    } else {
      iteratee = keyInObj;
      keys = flatten(keys, false, false);
      obj = Object(obj);
    }
    for (var i = 0, length = keys.length; i < length; i++) {
      var key = keys[i];
      var value = obj[key];
      if (iteratee(value, key, obj)) result[key] = value;
    }
    return result;
  });

  // Return a copy of the object without the blacklisted properties.
  _.omit = restArguments(function(obj, keys) {
    var iteratee = keys[0], context;
    if (_.isFunction(iteratee)) {
      iteratee = _.negate(iteratee);
      if (keys.length > 1) context = keys[1];
    } else {
      keys = _.map(flatten(keys, false, false), String);
      iteratee = function(value, key) {
        return !_.contains(keys, key);
      };
    }
    return _.pick(obj, iteratee, context);
  });

  // Fill in a given object with default properties.
  _.defaults = createAssigner(_.allKeys, true);

  // Creates an object that inherits from the given prototype object.
  // If additional properties are provided then they will be added to the
  // created object.
  _.create = function(prototype, props) {
    var result = baseCreate(prototype);
    if (props) _.extendOwn(result, props);
    return result;
  };

  // Create a (shallow-cloned) duplicate of an object.
  _.clone = function(obj) {
    if (!_.isObject(obj)) return obj;
    return _.isArray(obj) ? obj.slice() : _.extend({}, obj);
  };

  // Invokes interceptor with the obj, and then returns obj.
  // The primary purpose of this method is to "tap into" a method chain, in
  // order to perform operations on intermediate results within the chain.
  _.tap = function(obj, interceptor) {
    interceptor(obj);
    return obj;
  };

  // Returns whether an object has a given set of `key:value` pairs.
  _.isMatch = function(object, attrs) {
    var keys = _.keys(attrs), length = keys.length;
    if (object == null) return !length;
    var obj = Object(object);
    for (var i = 0; i < length; i++) {
      var key = keys[i];
      if (attrs[key] !== obj[key] || !(key in obj)) return false;
    }
    return true;
  };


  // Internal recursive comparison function for `isEqual`.
  var eq, deepEq;
  eq = function(a, b, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b) return a !== 0 || 1 / a === 1 / b;
    // `null` or `undefined` only equal to itself (strict comparison).
    if (a == null || b == null) return false;
    // `NaN`s are equivalent, but non-reflexive.
    if (a !== a) return b !== b;
    // Exhaust primitive checks
    var type = typeof a;
    if (type !== 'function' && type !== 'object' && typeof b != 'object') return false;
    return deepEq(a, b, aStack, bStack);
  };

  // Internal recursive comparison function for `isEqual`.
  deepEq = function(a, b, aStack, bStack) {
    // Unwrap any wrapped objects.
    if (a instanceof _) a = a._wrapped;
    if (b instanceof _) b = b._wrapped;
    // Compare `[[Class]]` names.
    var className = toString.call(a);
    if (className !== toString.call(b)) return false;
    switch (className) {
      // Strings, numbers, regular expressions, dates, and booleans are compared by value.
      case '[object RegExp]':
      // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
      case '[object String]':
        // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
        // equivalent to `new String("5")`.
        return '' + a === '' + b;
      case '[object Number]':
        // `NaN`s are equivalent, but non-reflexive.
        // Object(NaN) is equivalent to NaN.
        if (+a !== +a) return +b !== +b;
        // An `egal` comparison is performed for other numeric values.
        return +a === 0 ? 1 / +a === 1 / b : +a === +b;
      case '[object Date]':
      case '[object Boolean]':
        // Coerce dates and booleans to numeric primitive values. Dates are compared by their
        // millisecond representations. Note that invalid dates with millisecond representations
        // of `NaN` are not equivalent.
        return +a === +b;
      case '[object Symbol]':
        return SymbolProto.valueOf.call(a) === SymbolProto.valueOf.call(b);
    }

    var areArrays = className === '[object Array]';
    if (!areArrays) {
      if (typeof a != 'object' || typeof b != 'object') return false;

      // Objects with different constructors are not equivalent, but `Object`s or `Array`s
      // from different frames are.
      var aCtor = a.constructor, bCtor = b.constructor;
      if (aCtor !== bCtor && !(_.isFunction(aCtor) && aCtor instanceof aCtor &&
                               _.isFunction(bCtor) && bCtor instanceof bCtor)
                          && ('constructor' in a && 'constructor' in b)) {
        return false;
      }
    }
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.

    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    var length = aStack.length;
    while (length--) {
      // Linear search. Performance is inversely proportional to the number of
      // unique nested structures.
      if (aStack[length] === a) return bStack[length] === b;
    }

    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);

    // Recursively compare objects and arrays.
    if (areArrays) {
      // Compare array lengths to determine if a deep comparison is necessary.
      length = a.length;
      if (length !== b.length) return false;
      // Deep compare the contents, ignoring non-numeric properties.
      while (length--) {
        if (!eq(a[length], b[length], aStack, bStack)) return false;
      }
    } else {
      // Deep compare objects.
      var keys = _.keys(a), key;
      length = keys.length;
      // Ensure that both objects contain the same number of properties before comparing deep equality.
      if (_.keys(b).length !== length) return false;
      while (length--) {
        // Deep compare each member
        key = keys[length];
        if (!(_.has(b, key) && eq(a[key], b[key], aStack, bStack))) return false;
      }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
  };

  // Perform a deep comparison to check if two objects are equal.
  _.isEqual = function(a, b) {
    return eq(a, b);
  };

  // Is a given array, string, or object empty?
  // An "empty" object has no enumerable own-properties.
  _.isEmpty = function(obj) {
    if (obj == null) return true;
    if (isArrayLike(obj) && (_.isArray(obj) || _.isString(obj) || _.isArguments(obj))) return obj.length === 0;
    return _.keys(obj).length === 0;
  };

  // Is a given value a DOM element?
  _.isElement = function(obj) {
    return !!(obj && obj.nodeType === 1);
  };

  // Is a given value an array?
  // Delegates to ECMA5's native Array.isArray
  _.isArray = nativeIsArray || function(obj) {
    return toString.call(obj) === '[object Array]';
  };

  // Is a given variable an object?
  _.isObject = function(obj) {
    var type = typeof obj;
    return type === 'function' || type === 'object' && !!obj;
  };

  // Add some isType methods: isArguments, isFunction, isString, isNumber, isDate, isRegExp, isError, isMap, isWeakMap, isSet, isWeakSet.
  _.each(['Arguments', 'Function', 'String', 'Number', 'Date', 'RegExp', 'Error', 'Symbol', 'Map', 'WeakMap', 'Set', 'WeakSet'], function(name) {
    _['is' + name] = function(obj) {
      return toString.call(obj) === '[object ' + name + ']';
    };
  });

  // Define a fallback version of the method in browsers (ahem, IE < 9), where
  // there isn't any inspectable "Arguments" type.
  if (!_.isArguments(arguments)) {
    _.isArguments = function(obj) {
      return _.has(obj, 'callee');
    };
  }

  // Optimize `isFunction` if appropriate. Work around some typeof bugs in old v8,
  // IE 11 (#1621), Safari 8 (#1929), and PhantomJS (#2236).
  var nodelist = root.document && root.document.childNodes;
  if (typeof /./ != 'function' && typeof Int8Array != 'object' && typeof nodelist != 'function') {
    _.isFunction = function(obj) {
      return typeof obj == 'function' || false;
    };
  }

  // Is a given object a finite number?
  _.isFinite = function(obj) {
    return !_.isSymbol(obj) && isFinite(obj) && !isNaN(parseFloat(obj));
  };

  // Is the given value `NaN`?
  _.isNaN = function(obj) {
    return _.isNumber(obj) && isNaN(obj);
  };

  // Is a given value a boolean?
  _.isBoolean = function(obj) {
    return obj === true || obj === false || toString.call(obj) === '[object Boolean]';
  };

  // Is a given value equal to null?
  _.isNull = function(obj) {
    return obj === null;
  };

  // Is a given variable undefined?
  _.isUndefined = function(obj) {
    return obj === void 0;
  };

  // Shortcut function for checking if an object has a given property directly
  // on itself (in other words, not on a prototype).
  _.has = function(obj, path) {
    if (!_.isArray(path)) {
      return obj != null && hasOwnProperty.call(obj, path);
    }
    var length = path.length;
    for (var i = 0; i < length; i++) {
      var key = path[i];
      if (obj == null || !hasOwnProperty.call(obj, key)) {
        return false;
      }
      obj = obj[key];
    }
    return !!length;
  };

  // Utility Functions
  // -----------------

  // Run Underscore.js in *noConflict* mode, returning the `_` variable to its
  // previous owner. Returns a reference to the Underscore object.
  _.noConflict = function() {
    root._ = previousUnderscore;
    return this;
  };

  // Keep the identity function around for default iteratees.
  _.identity = function(value) {
    return value;
  };

  // Predicate-generating functions. Often useful outside of Underscore.
  _.constant = function(value) {
    return function() {
      return value;
    };
  };

  _.noop = function(){};

  // Creates a function that, when passed an object, will traverse that object’s
  // properties down the given `path`, specified as an array of keys or indexes.
  _.property = function(path) {
    if (!_.isArray(path)) {
      return shallowProperty(path);
    }
    return function(obj) {
      return deepGet(obj, path);
    };
  };

  // Generates a function for a given object that returns a given property.
  _.propertyOf = function(obj) {
    if (obj == null) {
      return function(){};
    }
    return function(path) {
      return !_.isArray(path) ? obj[path] : deepGet(obj, path);
    };
  };

  // Returns a predicate for checking whether an object has a given set of
  // `key:value` pairs.
  _.matcher = _.matches = function(attrs) {
    attrs = _.extendOwn({}, attrs);
    return function(obj) {
      return _.isMatch(obj, attrs);
    };
  };

  // Run a function **n** times.
  _.times = function(n, iteratee, context) {
    var accum = Array(Math.max(0, n));
    iteratee = optimizeCb(iteratee, context, 1);
    for (var i = 0; i < n; i++) accum[i] = iteratee(i);
    return accum;
  };

  // Return a random integer between min and max (inclusive).
  _.random = function(min, max) {
    if (max == null) {
      max = min;
      min = 0;
    }
    return min + Math.floor(Math.random() * (max - min + 1));
  };

  // A (possibly faster) way to get the current timestamp as an integer.
  _.now = Date.now || function() {
    return new Date().getTime();
  };

  // List of HTML entities for escaping.
  var escapeMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#x27;',
    '`': '&#x60;'
  };
  var unescapeMap = _.invert(escapeMap);

  // Functions for escaping and unescaping strings to/from HTML interpolation.
  var createEscaper = function(map) {
    var escaper = function(match) {
      return map[match];
    };
    // Regexes for identifying a key that needs to be escaped.
    var source = '(?:' + _.keys(map).join('|') + ')';
    var testRegexp = RegExp(source);
    var replaceRegexp = RegExp(source, 'g');
    return function(string) {
      string = string == null ? '' : '' + string;
      return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
    };
  };
  _.escape = createEscaper(escapeMap);
  _.unescape = createEscaper(unescapeMap);

  // Traverses the children of `obj` along `path`. If a child is a function, it
  // is invoked with its parent as context. Returns the value of the final
  // child, or `fallback` if any child is undefined.
  _.result = function(obj, path, fallback) {
    if (!_.isArray(path)) path = [path];
    var length = path.length;
    if (!length) {
      return _.isFunction(fallback) ? fallback.call(obj) : fallback;
    }
    for (var i = 0; i < length; i++) {
      var prop = obj == null ? void 0 : obj[path[i]];
      if (prop === void 0) {
        prop = fallback;
        i = length; // Ensure we don't continue iterating.
      }
      obj = _.isFunction(prop) ? prop.call(obj) : prop;
    }
    return obj;
  };

  // Generate a unique integer id (unique within the entire client session).
  // Useful for temporary DOM ids.
  var idCounter = 0;
  _.uniqueId = function(prefix) {
    var id = ++idCounter + '';
    return prefix ? prefix + id : id;
  };

  // By default, Underscore uses ERB-style template delimiters, change the
  // following template settings to use alternative delimiters.
  _.templateSettings = {
    evaluate: /<%([\s\S]+?)%>/g,
    interpolate: /<%=([\s\S]+?)%>/g,
    escape: /<%-([\s\S]+?)%>/g
  };

  // When customizing `templateSettings`, if you don't want to define an
  // interpolation, evaluation or escaping regex, we need one that is
  // guaranteed not to match.
  var noMatch = /(.)^/;

  // Certain characters need to be escaped so that they can be put into a
  // string literal.
  var escapes = {
    "'": "'",
    '\\': '\\',
    '\r': 'r',
    '\n': 'n',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  var escapeRegExp = /\\|'|\r|\n|\u2028|\u2029/g;

  var escapeChar = function(match) {
    return '\\' + escapes[match];
  };

  // JavaScript micro-templating, similar to John Resig's implementation.
  // Underscore templating handles arbitrary delimiters, preserves whitespace,
  // and correctly escapes quotes within interpolated code.
  // NB: `oldSettings` only exists for backwards compatibility.
  _.template = function(text, settings, oldSettings) {
    if (!settings && oldSettings) settings = oldSettings;
    settings = _.defaults({}, settings, _.templateSettings);

    // Combine delimiters into one regular expression via alternation.
    var matcher = RegExp([
      (settings.escape || noMatch).source,
      (settings.interpolate || noMatch).source,
      (settings.evaluate || noMatch).source
    ].join('|') + '|$', 'g');

    // Compile the template source, escaping string literals appropriately.
    var index = 0;
    var source = "__p+='";
    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
      source += text.slice(index, offset).replace(escapeRegExp, escapeChar);
      index = offset + match.length;

      if (escape) {
        source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
      } else if (interpolate) {
        source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
      } else if (evaluate) {
        source += "';\n" + evaluate + "\n__p+='";
      }

      // Adobe VMs need the match returned to produce the correct offset.
      return match;
    });
    source += "';\n";

    // If a variable is not specified, place data values in local scope.
    if (!settings.variable) source = 'with(obj||{}){\n' + source + '}\n';

    source = "var __t,__p='',__j=Array.prototype.join," +
      "print=function(){__p+=__j.call(arguments,'');};\n" +
      source + 'return __p;\n';

    var render;
    try {
      render = new Function(settings.variable || 'obj', '_', source);
    } catch (e) {
      e.source = source;
      throw e;
    }

    var template = function(data) {
      return render.call(this, data, _);
    };

    // Provide the compiled source as a convenience for precompilation.
    var argument = settings.variable || 'obj';
    template.source = 'function(' + argument + '){\n' + source + '}';

    return template;
  };

  // Add a "chain" function. Start chaining a wrapped Underscore object.
  _.chain = function(obj) {
    var instance = _(obj);
    instance._chain = true;
    return instance;
  };

  // OOP
  // ---------------
  // If Underscore is called as a function, it returns a wrapped object that
  // can be used OO-style. This wrapper holds altered versions of all the
  // underscore functions. Wrapped objects may be chained.

  // Helper function to continue chaining intermediate results.
  var chainResult = function(instance, obj) {
    return instance._chain ? _(obj).chain() : obj;
  };

  // Add your own custom functions to the Underscore object.
  _.mixin = function(obj) {
    _.each(_.functions(obj), function(name) {
      var func = _[name] = obj[name];
      _.prototype[name] = function() {
        var args = [this._wrapped];
        push.apply(args, arguments);
        return chainResult(this, func.apply(_, args));
      };
    });
    return _;
  };

  // Add all of the Underscore functions to the wrapper object.
  _.mixin(_);

  // Add all mutator Array functions to the wrapper.
  _.each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {
    var method = ArrayProto[name];
    _.prototype[name] = function() {
      var obj = this._wrapped;
      method.apply(obj, arguments);
      if ((name === 'shift' || name === 'splice') && obj.length === 0) delete obj[0];
      return chainResult(this, obj);
    };
  });

  // Add all accessor Array functions to the wrapper.
  _.each(['concat', 'join', 'slice'], function(name) {
    var method = ArrayProto[name];
    _.prototype[name] = function() {
      return chainResult(this, method.apply(this._wrapped, arguments));
    };
  });

  // Extracts the result from a wrapped and chained object.
  _.prototype.value = function() {
    return this._wrapped;
  };

  // Provide unwrapping proxy for some methods used in engine operations
  // such as arithmetic and JSON stringification.
  _.prototype.valueOf = _.prototype.toJSON = _.prototype.value;

  _.prototype.toString = function() {
    return String(this._wrapped);
  };

  // AMD registration happens at the end for compatibility with AMD loaders
  // that may not enforce next-turn semantics on modules. Even though general
  // practice for AMD registration is to be anonymous, underscore registers
  // as a named module because, like jQuery, it is a base library that is
  // popular enough to be bundled in a third party lib, but not be part of
  // an AMD load request. Those cases could generate an error when an
  // anonymous define() is called outside of a loader request.
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
      return _;
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
}());

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(64), __webpack_require__(352)(module)))

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); // import React, {Component} from 'react';


var _cUpPbajax = __webpack_require__(343);

var _cUpPbajax2 = _interopRequireDefault(_cUpPbajax);

var _cUrl = __webpack_require__(49);

var _cUrl2 = _interopRequireDefault(_cUrl);

var _public = __webpack_require__(344);

var _public2 = _interopRequireDefault(_public);

var _get = __webpack_require__(354);

var _get2 = _interopRequireDefault(_get);

var _cCache = __webpack_require__(91);

var _cCache2 = _interopRequireDefault(_cCache);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var cache = new _cCache2.default({
    prefix: 'uplive'
});
var pbajax = new _cUpPbajax2.default();

var Profile = function () {
    function Profile(vuid) {
        _classCallCheck(this, Profile);

        // debugger;
        this.promise = this.getData({
            vuid: vuid
        });
    }

    _createClass(Profile, [{
        key: 'getData',
        value: function getData(data) {

            var self = this;
            var businessData = new _get2.default.Profile.Get.Request(data);
            var defer = $.Deferred();
            // debugger;
            pbajax.do({
                service: 'service',
                api: '/profile/get',
                header: {
                    userToken: cache.getCache('user').userToken
                }
            }, businessData, function (res) {

                var dataWrap = _public2.default.Result.decode(res);
                var data = void 0;

                if (dataWrap.code == 1) {
                    data = _get2.default.Profile.Get.Response.decode(dataWrap.data.value);
                    defer.resolve(data.profile);
                } else {

                    if (dataWrap.code == 8192) {
                        global.login('http://' + location.hostname + location.pathname);
                    }
                }
            }, function () {
                defer.reject();
            }, function () {
                defer.reject();
            });

            return defer.promise();
        }
    }]);

    return Profile;
}();

exports.default = Profile;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(64)))

/***/ }),
/* 343 */
/***/ (function(module, exports) {



Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * pbajax模块(用于pb接口交互)
 * @author zhenn
 * @time 2016-11-16
 */
var proxyUrl = {
    pro: 'https://proxy.upliveapps.com/index/index',
    dev: 'http://awsbj-proxy.xingyunzhi.cn/index/index',
    stage: 'http://sg-proxy.xingyunzhi.cn/index/index'
};

// let pbajax = {

//     canceled: 0, // 是否被取消

//     do(cfg, data, success = () => {}, timeout = () => {}, fail = () => {}) {
//         let prefix = proxyUrl[pbajax.env()];
//         let _url = prefix + '?' + $.param(cfg);
//         let timer, xhr;
//         this.canceled = 0;
//         timer = setTimeout(function() {
//             timeout();
//         }, 5000);

//         try {
//             xhr = window.XMLHttpRequest ? new XMLHttpRequest() : new ActiveXObject('Microsoft.XMLHTTP');
//             xhr.open("POST", _url, true);
//             xhr.responseType = "arraybuffer";

//             try {
//                 xhr.send(data.toArrayBuffer());
//             } catch (e) {
//                 xhr.send();
//             }
//         } catch (e) {
//             alert('please upgrade your brower, such as chrome!');
//         }

//         xhr.onreadystatechange = (data)=>{

//             if (xhr.readyState == 4) {
//                 if (xhr.status == 200) {
//                     clearTimeout(timer);
//                     if (!this.canceled) {
//                         success(xhr.response);
//                     }

//                 } else {
//                     if (typeof fail == 'function') {
//                         fail();
//                     }
//                 }
//             }
//         }


//     },
//     query(name, scope) {
//         var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i"),
//             scope = scope || 'search',
//             r = location[scope].substr(1).match(reg);
//         if (r != null) {
//             return unescape(r[2]);
//         }
//         return null;
//     },

//     env() {
//         return this.query('env') || 'pro';
//     },

//     serializeURI(obj) {
//         var result = [];
//         if (typeof obj != 'object') {
//             obj = {};
//         }
//         for (var i in obj) {
//             result.push(i + '=' + encodeURIComponent(obj[i]));
//         }

//         return result.join('&')
//     },

//     cancel() {
//         this.canceled = 1;
//     }
// };

// export default pbajax;


var PbAajx = function () {
    function PbAajx() {
        _classCallCheck(this, PbAajx);

        this.canceled = 0;
    }

    // canceled: 0, // 是否被取消

    _createClass(PbAajx, [{
        key: 'do',
        value: function _do(cfg, data) {
            var success = arguments.length <= 2 || arguments[2] === undefined ? function () {} : arguments[2];

            var _this = this;

            var timeout = arguments.length <= 3 || arguments[3] === undefined ? function () {} : arguments[3];
            var fail = arguments.length <= 4 || arguments[4] === undefined ? function () {} : arguments[4];

            var prefix = proxyUrl[this.env()];
            var _url = prefix + '?' + $.param(cfg);
            var timer = void 0,
                xhr = void 0;
            timer = setTimeout(function () {
                timeout();
            }, 5000);

            try {
                xhr = window.XMLHttpRequest ? new XMLHttpRequest() : new ActiveXObject('Microsoft.XMLHTTP');
                xhr.open("POST", _url, true);
                xhr.responseType = "arraybuffer";

                try {
                    xhr.send(data.toArrayBuffer());
                } catch (e) {
                    xhr.send();
                }
            } catch (e) {
                alert('please upgrade your brower, such as chrome!');
            }

            xhr.onreadystatechange = function (data) {

                if (xhr.readyState == 4) {
                    if (xhr.status == 200) {
                        clearTimeout(timer);
                        if (!_this.canceled) {
                            success(xhr.response);
                        }
                    } else {
                        if (typeof fail == 'function') {
                            fail();
                        }
                    }
                }
            };
        }
    }, {
        key: 'query',
        value: function query(name, scope) {
            var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i"),
                scope = scope || 'search',
                r = location[scope].substr(1).match(reg);
            if (r != null) {
                return unescape(r[2]);
            }
            return null;
        }
    }, {
        key: 'env',
        value: function env() {
            return this.query('env') || 'pro';
        }
    }, {
        key: 'serializeURI',
        value: function serializeURI(obj) {
            var result = [];
            if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) != 'object') {
                obj = {};
            }
            for (var i in obj) {
                result.push(i + '=' + encodeURIComponent(obj[i]));
            }

            return result.join('&');
        }
    }, {
        key: 'cancel',
        value: function cancel() {
            this.canceled = 1;
        }
    }]);

    return PbAajx;
}();

exports.default = PbAajx;

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;
!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
    /**
     * The builder is transfered from SystemPreload.proto which sets the basic format such as 
     * code, msg, data and so on. When you receive buffer from server, you can decode it to json
     * by the special method called 'publicPB.Result.decode'. 
     * All works well until you face to new buffer in data structrue. It will be as follows.
     *      {
     *          code: 1,
     *          data: {
     *              type_url: 'xxx',
     *              value: {
     *                  buffer: [ArrayBuffer],
     *                  limit: 253,
     *                  ...
     *              },
     *              ...
     *          }
     *      }
     * In fact, all the real business data are included in data.value.buffer. So, we have to 
     * decode it into a string by special protobuf api.
     * It's right, the special api is 'preloadPB.System.Preload.Response.decodeDelimited'.
     */
    var publicPB = dcodeIO.ProtoBuf.newBuilder({})['import']({
        "package": null,
        "options": {
            "java_package": "com.asiainno.uplive.proto"
        },
        "messages": [{
            "name": "Result",
            "fields": [{
                "rule": "optional",
                "type": "Code",
                "name": "code",
                "id": 1
            }, {
                "rule": "optional",
                "type": "string",
                "name": "msg",
                "id": 2
            }, {
                "rule": "optional",
                "type": "google.protobuf.Any",
                "name": "data",
                "id": 3
            }]
        }, {
            "name": "google",
            "fields": [],
            "messages": [{
                "name": "protobuf",
                "fields": [],
                "options": {
                    "csharp_namespace": "Google.Protobuf.WellKnownTypes",
                    "go_package": "github.com/golang/protobuf/ptypes/any",
                    "java_package": "com.google.protobuf",
                    "java_outer_classname": "AnyProto",
                    "java_multiple_files": true,
                    "java_generate_equals_and_hash": true,
                    "objc_class_prefix": "GPB"
                },
                "messages": [{
                    "name": "Any",
                    "fields": [{
                        "rule": "optional",
                        "type": "string",
                        "name": "type_url",
                        "id": 1
                    }, {
                        "rule": "optional",
                        "type": "bytes",
                        "name": "value",
                        "id": 2
                    }]
                }]
            }]
        }],
        "enums": [{
            "name": "Code",
            "values": [{
                "name": "DEFAULT",
                "id": 0
            }, {
                "name": "SC_SUCCESS",
                "id": 1
            }, {
                "name": "SC_THIRD_PARTY_ALREADY_BIND",
                "id": 256
            }, {
                "name": "SC_THIRD_CHECK_USER_NOT_REGISTER",
                "id": 257
            }, {
                "name": "SC_PARAMETER_INVALID",
                "id": 4096
            }, {
                "name": "SC_ACCOUTN_USER_TOKEN_NOTMATCH",
                "id": 8192
            }, {
                "name": "SC_LOGINED_IN_OTHER_DEVICE",
                "id": 8193
            }, {
                "name": "SC_SMS_VERIFY_CODE_NOMOBILE",
                "id": 4097
            }, {
                "name": "SC_SMS_VERIFY_CODE_FAIL",
                "id": 4098
            }, {
                "name": "SC_SMS_VERIFY_CODE_NOTMATCH",
                "id": 4099
            }, {
                "name": "SC_ACCOUNT_MOBILE_PHONE_REPETITION",
                "id": 4100
            }, {
                "name": "SC_ACCOUNT_MOBILE_PHONE_ALLREADY_BIND",
                "id": 4101
            }, {
                "name": "SC_ACCOUTN_USER_NAME_FORBIDDEN",
                "id": 4102
            }, {
                "name": "SC_ACCOUTN_THIRD_CHECK_FAIL",
                "id": 4103
            }, {
                "name": "SC_ACCOUNT_USER_NAME_OVER_LONG",
                "id": 4104
            }, {
                "name": "SC_ACCOUNT_LIVE_CODE_OVER_LONG",
                "id": 4105
            }, {
                "name": "SC_ACCOUNT_LIVE_CODE_NOT_STANDARD",
                "id": 4112
            }, {
                "name": "SC_ACCOUNT_LIVE_CODE_EXIST",
                "id": 4113
            }, {
                "name": "SC_ACCOUNT_LIVE_UPDATE_FAIL",
                "id": 4114
            }, {
                "name": "SC_ACCOUNT_PASSWORD_ERROR",
                "id": 4115
            }, {
                "name": "SC_ACCOUNT_USER_NOT_EXIST",
                "id": 4116
            }, {
                "name": "SC_ACCOUNT_LIVE_CODE_TOO_SHORT",
                "id": 4117
            }, {
                "name": "SC_ACCOUNT_SIGNATURE_OVER_LONG",
                "id": 4118
            }, {
                "name": "SC_ACCOUTN_USER_FORBIDDEN",
                "id": 4119
            }, {
                "name": "SC_SENSITIVE_CONTENT",
                "id": 4609
            }, {
                "name": "SC_MALL_GIFT_NOT_EXIST",
                "id": 12289
            }, {
                "name": "SC_MALL_TRANSACTION_REPEATED",
                "id": 12290
            }, {
                "name": "SC_MALL_MONEY_NOT_ENOUGH",
                "id": 12291
            }, {
                "name": "SC_MALL_TRANSACTION_NOT_EXIST",
                "id": 12292
            }, {
                "name": "SC_MALL_PRODUCT_NOT_AVAILABLE",
                "id": 12293
            }, {
                "name": "SC_MALL_ORDER_NOT_EXIST",
                "id": 12294
            }, {
                "name": "SC_MALL_UNIFIED_ORDER_FAIL",
                "id": 12295
            }, {
                "name": "SC_MALL_PAY_FAIL",
                "id": 12296
            }, {
                "name": "SC_MALL_PAY_QUERY_FAIL",
                "id": 12297
            }, {
                "name": "SC_MALL_IAP_VALIDATE_FAIL",
                "id": 12298
            }, {
                "name": "SC_MALL_ORDER_EXIST_NOT_FINISHED",
                "id": 12299
            }, {
                "name": "SC_MALL_NOT_BIND_WECHAT",
                "id": 12300
            }, {
                "name": "SC_MALL_EXCEED_WITHDRAW_TIMES",
                "id": 12301
            }, {
                "name": "SC_MALL_EXCEED_WITHDRAW_QUOTA",
                "id": 12302
            }, {
                "name": "SC_MALL_WITHDRAW_FAIL",
                "id": 12303
            }, {
                "name": "SC_MALL_WITHDRAW_LESS_THAN_MIN",
                "id": 12304
            }, {
                "name": "SC_MALL_WITHDRAW_GREATER_THAN_MAX",
                "id": 12305
            }, {
                "name": "SC_MALL_WITHDRAW_FREQ_LIMIT",
                "id": 12306
            }, {
                "name": "SC_MALL_WITHDRAW_SENDNUM_LIMIT",
                "id": 12307
            }, {
                "name": "SC_CONTACT_ALREADY_FRIEND",
                "id": 16385
            }, {
                "name": "SC_LIVE_ROOM_NOT_EXIST",
                "id": 20481
            }, {
                "name": "SC_LIVE_ROOM_DISABLED",
                "id": 20482
            }, {
                "name": "SC_LIVE_ROOM_NO_PERMISSION",
                "id": 20483
            }, {
                "name": "SC_LIVE_ROOM_USER_GRADE_NOT_ENOUGH",
                "id": 20484
            }, {
                "name": "SC_SYSTEM_ERROR",
                "id": 16777215
            }]
        }]
    }).build();

    module.exports = publicPB;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(128);
module.exports = __webpack_require__(346);


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); // css文件中不要使用import
/**
 * 参数
 * oauthtype 授权类型，默认qq
 * target_uri 授权完成后的回调地址
 * channel 注册用户的渠道号，如果不传，默认为h5_default
 */


__webpack_require__(347);

__webpack_require__(348);

__webpack_require__(128);

var _cNenv = __webpack_require__(338);

var _cNenv2 = _interopRequireDefault(_cNenv);

var _cUrl = __webpack_require__(49);

var _cUrl2 = _interopRequireDefault(_cUrl);

var _token = __webpack_require__(349);

var _token2 = _interopRequireDefault(_token);

var _cCache = __webpack_require__(91);

var _cCache2 = _interopRequireDefault(_cCache);

var _cNotification = __webpack_require__(331);

var _cNotification2 = _interopRequireDefault(_cNotification);

var _index = __webpack_require__(339);

var _index2 = _interopRequireDefault(_index);

var _cFastclick = __webpack_require__(360);

var _cFastclick2 = _interopRequireDefault(_cFastclick);

__webpack_require__(361);

var _underscore = __webpack_require__(341);

var _underscore2 = _interopRequireDefault(_underscore);

var _get = __webpack_require__(342);

var _get2 = _interopRequireDefault(_get);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _lang = _cUrl2.default.query('lang') || 'zh-TW';

var cache = new _cCache2.default({
    prefix: 'uplive'
});

var textMap = {
    'zh-TW': {
        tip: '在使用Gifto錢包前需要先登錄',
        btn: '立刻登錄'
    },
    'en-US': {
        tip: 'Please login first before use the Gifto Wallet.',
        btn: 'Login now!'
    }
};

var getTextFromJSON = function getTextFromJSON(key) {
    var langObj = textMap[_lang];
    if (!langObj) {
        langObj = textMap['zh-TW'];
    }

    return langObj[key];
};

_cFastclick2.default.attach(document.body);

var Login = function () {
    function Login() {
        _classCallCheck(this, Login);

        this.code = _cUrl2.default.query('code');
        this.platform = _cNenv2.default.platform.name;
        this.oauthtype = _cUrl2.default.query('oauthtype');
        if (!this.oauthtype) {
            this.oauthtype = document.domain == 'h5.upliveapp.com' ? 'qq' : 'fb';
        }
    }

    _createClass(Login, [{
        key: 'init',
        value: function init() {
            var domain = document.domain;
            var multiLoginChannel = _cUrl2.default.query('multiLoginChannel');

            if (multiLoginChannel) {
                switch (this.oauthtype) {
                    case 'twitter':
                        this.twitter();
                        break;
                    case 'weibo':
                        this.weibo();
                        break;
                    case 'fb':
                        this.facebook();
                        break;
                    case 'wechat':
                        this.wechat();
                        break;
                    case 'qq':
                        this.qq();
                        break;
                    default:
                        if (domain == 'h5.upliveapp.com') {
                            this.qq();
                        } else {
                            this.facebook();
                        }
                        break;
                }
            } else {
                switch (this.platform) {
                    case 'wechat':
                        this.wechat();
                        break;
                    case 'twitter':
                        this.twitter();
                        break;
                    case 'weibo':
                        this.weibo();
                        break;
                    case 'facebook':
                        this.facebook();
                        break;
                    case 'qq':
                        this.qq();
                        break;
                    default:
                        switch (this.oauthtype) {
                            case 'twitter':
                                this.twitter();
                                break;
                            case 'weibo':
                                this.weibo();
                                break;
                            case 'fb':
                            default:
                                if (domain == 'h5.upliveapp.com') {
                                    this.qq();
                                } else {
                                    this.facebook();
                                }

                                break;
                        }
                        break;

                }
            }
        }
    }, {
        key: 'wechat',
        value: function wechat() {
            if (!this.code) {
                _index2.default.jumpToSNS('wechat');
            } else {
                _token2.default.get('wechat', this.code);
            }
        }
    }, {
        key: 'twitter',
        value: function twitter() {

            var oauth_token = _cUrl2.default.query('oauth_token');
            // 当获取request_token成功后, 则继续跳转到twitter的oauth验证页面获取verifier
            $.channel.on('getTwitterOauthTokenSuccess', function (resp) {
                if (!resp || !resp.oauth_token) {
                    _cNotification2.default.simple('get oauth_token fail');
                    return;
                }
                _index2.default.twitterJumpForCode(resp.oauth_token);
                cache.setCache('twitter', resp);
            });

            // 当url中不包含oauth_token时
            // 用户首次进入此授权登录页面, 先从java端获取request_token
            if (!oauth_token) {
                _index.twitter.getRequestToken();
            } else {
                // 反之, 已从twitter oauth页面返回并携带oauth_token
                // 此时可获取up usertoken
                _token2.default.get('twitter', oauth_token, cache.getCache('twitter').oauth_token_secret, _cUrl2.default.query('oauth_verifier'));
            }
        }
    }, {
        key: 'weibo',
        value: function weibo() {
            if (!this.code) {
                _index2.default.weiboJumpForCode();
            } else {
                _token2.default.get('weibo', this.code);
            }
        }
    }, {
        key: 'qq',
        value: function qq() {
            if (!this.code) {
                _index2.default.qqJumpForCode();
            } else {
                _token2.default.get('qq', this.code);
            }
        }
    }, {
        key: 'facebook',
        value: function facebook() {

            if (window.FBOauthResponse) {

                _token2.default.get('facebook', window.FBOauthResponse.accessToken);
            } else {
                if (typeof FB !== 'undefined') {
                    FB.login(function () {
                        _index.fb.checkLoginState();
                        if (window.FBOauthResponse) {
                            _token2.default.get('facebook', window.FBOauthResponse.accessToken);
                        }
                    });
                }
            }
        }
    }]);

    return Login;
}();

function getSMDeviceId() {
    var defer = $.Deferred();
    // 无论是否使用游客，都产生一个smd（数美的deviceId）
    // 并且存储到本地
    var cacheDeviceId = cache.getCache('smDeviceId');

    if (!cacheDeviceId) {

        // 数美JS已经加载完成
        if (typeof SMSdk !== 'undefined') {
            window.smDeviceId = SMSdk.getDeviceId();
            cache.setCache('smDeviceId', window.smDeviceId);
            defer.resolve();
        } else {

            // 否则监听事件，等待sdk加载完成
            $.channel.on('smsdkLoaded', function () {
                window.smDeviceId = SMSdk.getDeviceId();
                cache.setCache('smDeviceId', smDeviceId);
                defer.resolve();
            });

            $.channel.on('smsdkLoadedError', function () {
                defer.resolve();
            });
        }
    } else {
        window.smDeviceId = cacheDeviceId;
        defer.resolve();
    }

    return defer;
}

var login = new Login();

if (login.oauthtype == 'fb') {
    _index.fb.init();
}

// 若本地中已存在user信息
// 先验证user是否已过期
var localUser = cache.getCache('user');

if (localUser) {
    var _getProfile = function _getProfile(uid) {
        var profile = new _get2.default(uid);

        profile.promise.done(function (data) {
            // debugger;
            _token2.default.back();
        }).fail(function (data) {
            getSMDeviceId().done(function () {
                if (login.oauthtype != 'fb') {
                    login.init();
                } else {

                    setTimeout(function () {
                        if (typeof FB !== 'undefined') {
                            renderDom();
                        } else {
                            $.channel.on('fbsdkLoaded', function () {
                                renderDom();
                            });
                        }
                    }, 1500);
                }
            });
        });
    };

    _getProfile(localUser.uid);
} else {
    getSMDeviceId().done(function () {
        if (login.oauthtype != 'fb') {
            login.init();
        } else {

            setTimeout(function () {
                if (typeof FB !== 'undefined') {
                    renderDom();
                } else {
                    $.channel.on('fbsdkLoaded', function () {
                        renderDom();
                    });
                }
            }, 1500);
        }
    });
}

var renderDom = function renderDom() {
    var temp = $('#actbtn').html();
    $('#wrap').html(_underscore2.default.template(temp)({
        tip: getTextFromJSON('tip'),
        btn: getTextFromJSON('btn')
    }));

    $('.tip-content button').on('click', function () {
        login.init();
    });
};

/***/ }),
/* 347 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 348 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); // 授权两种方式
// 1，同域授权，获取usertoken成功后，存储到localstorage，跳转到业务页面读取即可
// 2，跨域授权（awsbj-game2u.xingyunzhi.cn  h5act.upliveapp.com m.upliveapps.com）
//      获取usertoken后，将其作为参数跳转到业务页面 

var _config = __webpack_require__(129);

var _config2 = _interopRequireDefault(_config);

var _index = __webpack_require__(339);

var _index2 = _interopRequireDefault(_index);

var _cNotification = __webpack_require__(331);

var _cNotification2 = _interopRequireDefault(_cNotification);

var _cCache = __webpack_require__(91);

var _cCache2 = _interopRequireDefault(_cCache);

var _cUrl = __webpack_require__(49);

var _cUrl2 = _interopRequireDefault(_cUrl);

var _get = __webpack_require__(342);

var _get2 = _interopRequireDefault(_get);

var _set = __webpack_require__(355);

var _set2 = _interopRequireDefault(_set);

var _index3 = __webpack_require__(340);

var _index4 = _interopRequireDefault(_index3);

var _cLoading = __webpack_require__(357);

var _cLoading2 = _interopRequireDefault(_cLoading);

var _cUpNative = __webpack_require__(358);

var _cUpNative2 = _interopRequireDefault(_cUpNative);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _system = _cUpNative2.default.getSystem();
var cache = new _cCache2.default({
    prefix: 'uplive'
});
var feature = _system == 'pc' ? 9999 : 8888;
var deviceType = _system == 'pc' ? 'PC' : 'H5';
var version = _system == 'pc' ? '8.8.8' : '9.9.9';

var token = {
    // 获取up用户的usertoken
    get: function get(platform, code, tokenSecret, verifier) {
        var _this = this;

        var opt = {
            authcode: code,
            feature: feature,
            channel: _cUrl2.default.query('channel') || 'h5_default',
            language: _index4.default.type, // 添加语言
            deviceType: deviceType,
            version: version
        };

        opt.channel = opt.channel.substr(0, 20);

        switch (platform) {
            case 'wechat':
                opt.type = 3;
                break;
            case 'facebook':
                opt.type = 4;
                break;
            case 'twitter':
                opt.type = 16;
                opt = Object.assign(opt, {
                    tokenSecret: tokenSecret,
                    verifier: verifier
                });
                break;
            case 'weibo':
                opt.type = 5;
                opt.callback = location.href;
                break;
            case 'qq':
                opt.type = 2;
                opt.callback = encodeURIComponent(location.href);
                opt.state = 'test';
                break;
            default:
                break;
        }

        if (window.smDeviceId) {
            opt.deviceId = window.smDeviceId;
        }

        $.ajax({
            url: _config2.default.getUsertokenPath(),
            data: opt,
            type: 'GET',
            dataType: 'json'
        }).done(function (res) {
            $('#wrap').empty();

            // 报错
            if (res.code == 'E000002' || res.code == 'E000003') {
                if (platform == 'wechat') {
                    _index2.default.jumpToSNS(platform, 'snsapi_userinfo');
                } else if (platform == 'weibo') {
                    _index2.default.jumpToSNS(platform);
                } else if (platform == 'facebook') {
                    location.reload();
                } else {
                    _cNotification2.default.simple('system error');
                }
            } else if (res.code == 'E000001' || res.code == 'E000004') {
                // 设备被封禁的code = E000005

                _cNotification2.default.simple('system error', 100 * 1000);
            } else if (res.code == 'E000005') {

                $(document.body).empty();
                _cNotification2.default.simple('device forbidden', 100 * 1000);
            } else {

                localStorage.setItem('uplive/usertoken', res.userToken);
                cache.setCache('user', res, 8 * 3600 * 1000);

                _this.user = encodeURIComponent(JSON.stringify(res));

                var getProfileCount = 0;
                var _getProfile = function _getProfile(uid) {
                    var profile = new _get2.default(uid);

                    profile.promise.done(function (data) {
                        var countryCode = data.countryCode;

                        if (_cUrl2.default.query('ignoreCountryCode')) {
                            _this.back();
                        } else {
                            if (!countryCode) {
                                _this.setProfile();
                            } else {
                                debugger;
                                _this.back();
                            }
                        }
                    }).fail(function (data) {
                        ++getProfileCount;

                        if (getProfileCount > 3) {
                            _cLoading2.default.hide();
                            _cNotification2.default.simple(_index4.default.template('获取个人信息失败'), 100 * 1000);
                        } else {
                            _getProfile(uid);
                        }
                    });
                };
                _cLoading2.default.show({
                    text: 'loading'
                });
                _getProfile(res.uid);
            }
        });
    },
    setProfile: function setProfile() {
        var _this2 = this;

        // let _lang = lang.type;
        // let countryCode = _lang.split('-')[1].toUpperCase();

        var systemLanguage = navigator.language || navigator.browserLanguage;
        var _systemLanguage = systemLanguage.toLowerCase();

        switch (_systemLanguage) {
            case 'ar':
                systemLanguage = 'ar-EG';
                break;
            case 'vi':
                systemLanguage = 'vi-VN';
                break;
            case 'en':
                systemLanguage = 'en-US';
                break;
            case 'ja':
                systemLanguage = 'ja-JP';
                break;
            case 'zh':
                systemLanguage = 'zh-CN';
                break;
            default:
                break;
        }

        var arr = systemLanguage.split('-');

        if (arr.length > 1) {
            systemLanguage = arr[0] + '-' + arr[1].toUpperCase();
        } else {
            systemLanguage = 'en-GB';
        }

        var countryCode = systemLanguage.split('-')[1].toUpperCase();

        var setProfileCount = 0;

        var _setProfile = function _setProfile() {
            var profileset = new _set2.default({
                countryCode: countryCode
            });

            profileset.promise.then(function (data) {
                _this2.back();
            }, function () {
                ++setProfileCount;

                if (setProfileCount > 3) {
                    _cLoading2.default.hide();
                    _cNotification2.default.simple(_index4.default.template('设置国家或地区失败'), 100 * 1000);
                } else {
                    _setProfile(countryCode);
                }
            });
        };

        _setProfile();
    },
    back: function back() {
        var target_uri = decodeURIComponent(_cUrl2.default.query('target_uri'));
        var crossDomains = ['awsbj-game2u.xingyunzhi.cn', 'h5act.upliveapp.com', 'mact.upliveapps.com', 'dev.upliveapps.com', 'cn.dev.uplivepapps.com', 'mena.dev.upliveapps.com', 'web.upliveapps.com', 'cn.up.live', 'live.uplive.club', 'localhost:8000', 'uplive.appanda.cn', // 微信抗封禁备用域名
        'up.live', 'www.upliveapp.com', 'www.uplive.club', 'www.upliveapps.com', 'www.uplivekr.com', 'uplivekr.com', 'lotteryweb.pengpengla.com'];
        var isCrossDomain = 0;
        crossDomains.forEach(function (item, inx) {
            if (target_uri.indexOf(item) > -1) {
                isCrossDomain = 1;
            }
        });

        if (isCrossDomain) {
            var _target_uri$split = target_uri.split('#'),
                _target_uri$split2 = _slicedToArray(_target_uri$split, 2),
                before = _target_uri$split2[0],
                hashs = _target_uri$split2[1];

            var pis = before.indexOf('?') > -1 ? '&' : '?';
            before += pis + '__user=' + this.user;
            target_uri = before + (hashs ? '#' + hashs : '');
        }
        _index2.default.jump(target_uri);
    }
};

exports.default = token;

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

var _config = __webpack_require__(129);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function statusChangeCallback(response) {

    if (response.status === 'connected') {
        // window.FBOauthResponse = response.authResponse;
        // Logged into your app and Facebook.
        // $.channel.emit('fbOauthSuccess' , response.authResponse);
        window.FBOauthResponse = response.authResponse;
        // localStorage.setItem('fbtoken', response.authResponse);
    } else if (response.status === 'not_authorized') {
        // The person is logged into Facebook, but not your app.
        // document.getElementById('status').innerHTML = 'Please log ' +
        //   'into this app.';
        // FB.login(checkLoginState);
    } else {
            // The person is not logged into Facebook, so we're not sure if
            // they are logged into this app or not.
            // FB.login(checkLoginState);
        }
}

// This function is called when someone finishes with the Login
// Button.  See the onlogin handler attached to it in the sample
// code below.
function checkLoginState() {
    FB.getLoginStatus(function (response) {
        statusChangeCallback(response);
    });
}

window.fbAsyncInit = function () {
    $.channel.emit('fbsdkLoaded');
    FB.init({
        appId: _config2.default.upInfoInPlatform.fb.appid,
        cookie: true, // enable cookies to allow the server to access 
        // the session
        xfbml: true, // parse social plugins on this page
        version: 'v2.5' // use graph api version 2.5
    });

    // Now that we've initialized the JavaScript SDK, we call 
    // FB.getLoginStatus().  This function gets the state of the
    // person visiting this page and can return one of three states to
    // the callback you provide.  They can be:
    //
    // 1. Logged into your app ('connected')
    // 2. Logged into Facebook, but not your app ('not_authorized')
    // 3. Not logged into Facebook and can't tell if they are logged into
    //    your app or not.
    //
    // These three cases are handled in the callback function.

    FB.getLoginStatus(function (response) {
        statusChangeCallback(response);
    });
};

function testAPI() {
    FB.api('/me', function (response) {
        console.log(response);
    });
}

module.exports = {
    init: function init() {
        // Load the SDK asynchronously
        (function (d, s, id) {
            var js,
                fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) return;
            js = d.createElement(s);js.id = id;
            js.src = "//connect.facebook.net/en_US/sdk.js";
            fjs.parentNode.insertBefore(js, fjs);
        })(document, 'script', 'facebook-jssdk');
    },
    checkLoginState: checkLoginState
};

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _config = __webpack_require__(129);

var _config2 = _interopRequireDefault(_config);

var _cNotification = __webpack_require__(331);

var _cNotification2 = _interopRequireDefault(_cNotification);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getRequestToken = function getRequestToken() {
    $.ajax({
        url: _config2.default.getTwitterRequestTokenPath(),
        data: {
            callback: encodeURIComponent(location.href)
        },
        type: 'GET',
        dataType: 'json'
    }).then(function (resp) {
        $('#wrap').empty();
        return resp;
    }).done(function (resp) {
        $.channel.emit('getTwitterOauthTokenSuccess', resp);
    }).fail(function () {
        _cNotification2.default.simple('request fail');
    });
};

exports.default = {
    getRequestToken: getRequestToken
};

/***/ }),
/* 352 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 353 */
/***/ (function(module, exports) {

module.exports = {
    "areg": {
        "<%=userName%>坐着<%=carName%>进入了直播间": "<%=userName%> يقود <%=carName%> لدخول غرفة البث المباشر",
        "AD": "أندورا",
        "AE": "الإمارات العربية المتحدة",
        "AF": "أفغانستان",
        "AG": "أنتيغوا وبربودا",
        "AI": "أنغيلا",
        "AL": "ألبانيا",
        "AM": "أرمينيا",
        "AN": "جزر الأنتيل الهولندية",
        "AO": "أنغولا",
        "AQ": "القطب الجنوبي",
        "AR": "الأرجنتين",
        "AS": "ساموا الأمريكية",
        "AT": "النمسا",
        "AU": "أستراليا",
        "AW": "أروبا",
        "AZ": "أذربيجان",
        "BA": "البوسنة والهرسك",
        "BB": "بربادوس",
        "BD": "بنغلاديش",
        "BE": "بلجيكا",
        "BF": "بوركينا فاسو",
        "BG": "بلغاريا",
        "BH": "البحرين",
        "BI": "بوروندي",
        "BJ": "بنين",
        "BL": "سانت بارتيليمي",
        "BM": "برمودا",
        "BN": "بروناي",
        "BO": "بوليفيا",
        "BR": "البرازيل",
        "BS": "الباهاما",
        "BT": "بوتان",
        "BW": "بوتسوانا",
        "BY": "روسيا البيضاء",
        "BZ": "بليز",
        "CA": "كندا",
        "CC": "جزر كوكوس",
        "CD": "جمهورية الكونغو الديموقراطية",
        "CF": "جمهورية افريقيا الوسطى",
        "CG": "جمهورية الكونغو",
        "CH": "سويسرا",
        "CI": "ساحل العاج",
        "CK": "جزر كوك",
        "CL": "تشيلي",
        "CM": "الكاميرون",
        "CN": "الصين",
        "CO": "كولومبيا",
        "CR": "كوستا ريكا",
        "CU": "كوبا",
        "CV": "الرأس الأخضر",
        "CW": "كوراكاو",
        "CX": "جزيرة عيد الميلاد",
        "CY": "قبرص",
        "CZ": "جمهورية التشيك",
        "DE": "ألمانيا",
        "DJ": "جيبوتي",
        "DK": "الدنمارك",
        "DM": "دومينيكا",
        "DO": "جمهورية الدومنيكان",
        "DZ": "الجزائر",
        "EC": "الإكوادور",
        "EE": "استونيا",
        "EG": "مصر",
        "EH": "الصحراء الغربية",
        "ER": "إريتريا",
        "ES": "إسبانيا",
        "ET": "أثيوبيا",
        "FI": "فنلندا",
        "FJ": "فيجي",
        "FK": "جزر فوكلاند",
        "FM": "ميكرونيزيا",
        "FO": "جزر صناعية",
        "FR": "فرنسا",
        "GA": "الغابون",
        "GB": "المملكة المتحدة",
        "GD": "غرينادا",
        "GE": "جورجيا",
        "GG": "غيرنسي",
        "GH": "غانا",
        "GI": "جبل طارق",
        "GL": "الأرض الخضراء",
        "GM": "غامبيا",
        "GN": "غينيا",
        "GQ": "غينيا الإستوائية",
        "GR": "اليونان",
        "GT": "غواتيمالا",
        "GU": "غوام",
        "GW": "غينيا بيساو",
        "GY": "غيانا",
        "HK": "هونغ كونغ",
        "HN": "هندوراس",
        "HR": "كرواتيا",
        "HT": "هايتي",
        "HU": "هنغاريا",
        "ID": "أندونيسيا",
        "IE": "أيرلندا",
        "IL": "إسرائيل",
        "IM": "جزيرة آيل أوف مان",
        "IN": "الهند",
        "IO": "إقليم المحيط البريطاني الهندي",
        "IQ": "العراق",
        "IR": "إيران",
        "IS": "أيسلندا",
        "IT": "إيطاليا",
        "JE": "جيرسي",
        "JM": "جامايكا",
        "JO": "الأردن",
        "JP": "اليابان",
        "KE": "كينيا",
        "KG": "قرغيزستان",
        "KH": "كمبوديا",
        "KI": "كيريباس",
        "KM": "جزر القمر",
        "KN": "سانت كيتس ونيفيس",
        "KP": "كوريا الشمالية",
        "KR": "كوريا الجنوبية",
        "KW": "الكويت",
        "KY": "جزر كايمان",
        "KZ": "كازاخستان",
        "LA": "لاوس",
        "LB": "لبنان",
        "LC": "سانت لوسيا",
        "LI": "ليختنشتاين",
        "LK": "سيريلانكا",
        "LR": "ليبيريا",
        "LS": "ليسوتو",
        "LT": "ليتوانيا",
        "LU": "لوكسمبورغ",
        "LV": "لاتفيا",
        "LY": "ليبيا",
        "MA": "المغرب",
        "MC": "موناكو",
        "MD": "مولدوفا",
        "ME": "الجبل الأسود",
        "MF": "سانت مارتن",
        "MG": "مدغشقر",
        "MH": "جزر مارشال",
        "MK": "مقدونيا",
        "ML": "مالي",
        "MM": "ميانمار",
        "MN": "منغوليا",
        "MO": "ماكاو",
        "MP": "جزر مريانا الشمالية",
        "MR": "موريتانيا",
        "MS": "مونتسيرات",
        "MT": "مالطا",
        "MU": "موريشيوس",
        "MV": "جزر المالديف",
        "MW": "ملاوي",
        "MX": "المكسيك",
        "MY": "ماليزيا",
        "MZ": "موزمبيق",
        "NA": "ناميبيا",
        "NC": "كاليدونيا الجديدة",
        "NE": "النيجر",
        "NG": "نيجيريا",
        "NI": "نيكاراغوا",
        "NL": "هولندا",
        "NO": "النرويج",
        "NP": "نيبال",
        "NR": "ناورو",
        "NU": "نيوي",
        "NZ": "نيوزيلاندا",
        "OM": "سلطنة عمان",
        "PA": "بناما",
        "PE": "بيرو",
        "PF": "بولينيزيا الفرنسية",
        "PG": "بابوا غينيا الجديدة",
        "PH": "الفلبين",
        "PK": "باكستان",
        "PL": "بولندا",
        "PM": "سان بيار وميكلون",
        "PN": "بيتكيرن",
        "PR": "بورتوريكو",
        "PS": "فلسطين",
        "PT": "البرتغال",
        "PW": "بالاو",
        "PY": "باراغواي",
        "QA": "قطر",
        "RE": "جمع شمل",
        "RO": "رومانيا",
        "RS": "صربيا",
        "RU": "روسيا",
        "RW": "رواندا",
        "SA": "المملكة العربية السعودية",
        "SB": "جزر سليمان",
        "SC": "سيشيل",
        "SD": "سودان",
        "SE": "السويد",
        "SG": "سنغافورة",
        "SH": "سانت هيلانة",
        "SI": "سلوفينيا",
        "SJ": "سفالبارد وجان مايان",
        "SK": "سلوفاكيا",
        "SL": "سيرا ليون",
        "SM": "سان مارينو",
        "SN": "السنغال",
        "SO": "الصومال",
        "SR": "سورينام",
        "SS": "جنوب السودان",
        "ST": "ساو تومي وبرينسيبي",
        "SV": "السلفادور",
        "SX": "سانت مارتن",
        "SY": "سوريا",
        "SZ": "سوازيلاند",
        "TC": "جزر تركس وكايكوس",
        "TD": "تشاد",
        "TG": "توغو",
        "TH": "تايلاند",
        "TJ": "طاجيكستان",
        "TK": "توكيلاو",
        "TL": "تيمور الشرقية",
        "TM": "تركمانستان",
        "TN": "تونس",
        "TO": "تونغا",
        "TR": "تركيا",
        "TT": "ترينداد وتوباغو",
        "TV": "توفالو",
        "TW": "تايوان",
        "TZ": "تنزانيا",
        "UA": "أوكرانيا",
        "UG": "أوغندا",
        "US": "الولايات المتحدة",
        "UY": "أوروغواي",
        "UZ": "أوزبكستان",
        "Up号:<%=code%>": "رقم حساب: <%=code%>",
        "Up直播": "uplive ",
        "U币贡献榜": "قائمة الأكثر دعما لمُضيف",
        "VA": "الفاتيكان",
        "VC": "سانت فنسنت وجزر غرينادين",
        "VE": "فنزويلا",
        "VG": "جزر فيرجن البريطانية",
        "VI": "جزر العذراء الأمريكية",
        "VN": "فيتنام",
        "VU": "فانواتو",
        "WF": "واليس وفوتونا",
        "WS": "ساموا",
        "XK": "كوسوفو",
        "YE": "اليمن",
        "YT": "مايوت",
        "ZA": "جنوب أفريقيا",
        "ZM": "زامبيا",
        "ZW": "زيمبابوي",
        "个人信息设定失败": "فشل في تحديد البيانات الشخصية",
        "个人信息设定成功": "تم تحديد البيانات الشخصية بنجاح",
        "主播可能在休息，稍后再来试试吧": "الآن هو وقت استراحه المُضيف، الرجاء الانتظار قليلا ثم العوده إليه",
        "主播已停播，即将返回首页!": "لقد أنهى المضيف البث المباشر، الرجوع إلى الصفحة الرئيسية",
        "优秀主播指南": "دليل المُضيفين المميزين",
        "余额不足情况下，充值提醒的描述": "الرصيد الماس غير كافى، أشحن الآن",
        "你关注的人还没有直播": "مُضيفك المفضل غير موجود الآن",
        "保存": "حفظ",
        "充值 >": "الشحن",
        "关注": "متابعة",
        "关注了主播，从此不再错过。": "قُم بمتابعة المُضيف الآن، ولا تفوت أي لحظة معه",
        "写个签名吧，让大家了解你。": "اكتب نبذة عنك، لكى يتمكن الجميع من معرفتك أكثر",
        "分享失败": "فشل المشاركة",
        "分享成功": "تمت المشاركة بنجاح",
        "去看看当前热门直播": "الرجوع الى صفحة قائمة الشائع",
        "参数无效": "كود غير صالح",
        "参数错误": "خطأ في الكود",
        "发现": "اكتشف",
        "发现新主播": "اكتشف المُضيفين الجدد",
        "发送": "أرسل",
        "取消": "إلغاء",
        "如何升级": "كيف يتم الترقي",
        "如何升级详情": " عند إهداء المُضيفين هدايا أكثر، يتم ترقيتهم أسرع.@@@@  ما رأيك أن تصبح مُضيف؟ المُضيفون المُتميزون يتم ترقيتهم أسرع",
        "守护身价:<%=code%>": "سعر منصب الحارس: <%=code%>",
        "已停播": "لقد توقف البث المباشر",
        "已关注": "تمت المتابعة ",
        "已取消分享": "تم إلغاء المشاركة",
        "我的U钻": "الماس ",
        "我的守护": "الحارس ",
        "我的收益（U币）": "إيراداتى من (الكوينز)",
        "我的直播": "البث المباشر الخاص بى",
        "我的等级": "المستوى",
        "拉黑": "حظر",
        "按语言推荐主播": "إقتراح مُضيفين بناءًا على اللغة",
        "搜索": "بحث",
        "收到的U币": "الكوينز التى تم الحصول عليها",
        "昵称不能出现敏感词": "لا يُمكن استخدام أي كلمات خارجة في الاسم",
        "暂无数据": "لا توجد بيانات متوفرة مؤقتًا",
        "暂无被拉黑用户": "لا يوجد معلومات متوفرة في القائمة السوداء مؤقتًا",
        "未知星球": "غير معروف",
        "正在加载": "جارٍ التحميل",
        "正在加载更多的数据...": "جارٍ تحميل المزيد من البيانات",
        "没发现此人，请重新输入试试": "لم تقم باكتشاف أي أحد، يُرجى المحاولة مرة أُخرى",
        "没有更多数据了哦": "لا يوجد مزيد من البيانات",
        "点亮了": "أحب هذه البث ",
        "热门": "الشائع",
        "用户登录失效": "فشل تسجيل دخول المُستخدم",
        "登出": "تسجيل الخروج",
        "直播中": "مباشر الآن",
        "确认": "تأكيد",
        "等级福利": "إمتيازات هذا المستوى ",
        "等级福利详情": " المستخدمون ذو المستوى المرتفع لديهم شعار مميز لنبذتهم الشخصية.@@@@  عند ترقيتك في المستوى، لديك فرص أكثر في الحصول على هدايا قيمة.",
        "签名不能出现敏感词": "لا يُمكن استخدام أي كلمات خارجة في الاسم",
        "粉丝": "معجبون",
        "系统消息": "رسالة النظام",
        "系统消息: 主播回来了，视频即将恢复！": "رسالة النظام: لقد عاد المُضيف، سيعود البث المباشر الآن",
        "系统消息: 主播暂时离开了，小伙伴们请稍候。": "رسالة النظام: لقد غادر المُضيف مؤقتا، من فضلك انتظر قليلا ",
        "系统消息: 我们提倡绿色直播，只有通过审核并被标记为优质的主播才可能出现在热门，如封面和直播内容含有涉黄、低俗、吸烟、暴露等情况，将会被封禁账号。网警将保持24小时在线审核与审查，请您遵守。": "رسالة النظام: نحن ندعم دائما البث المباشر المميز، والمُضيف المميز يظهر على قائمة الشائع مع الأشارة التى تميزه.\nإذا كان الصورة الشخصية الخاصة بالمُضيف أو المحتوى الخاص بالبث يحتوى على أى إيحاءات جنسية أو صور إباحية أو تدخين و مخدرات أو عنف و غيرها من الحالات الأخرى، سيتم وقف البث المباشر فى الحال.\nيتم مراقبة البث المباشر على مدار الـ24 ساعة ،  ونرجو منكم الإلتزام",
        "系统错误": "خطأ فى النظام",
        "累计经验：<%=code%>": "مجموع نقاط الخبرة：<%=code%>",
        "经验值<%=num%>": "نقاط الخبرة <%=num%>",
        "花费:": "تم إنفاق: ",
        "获取个人信息失败": "فشل في الحصول على المعلومات الشخصية",
        "获取成功": "تم الحصول عليه بنجاح",
        "获取热门主播失败": "فشل فى الحصول على قائمة الشائع",
        "虚位以待": "المركز لم يشغله أحد",
        "解除拉黑": "إزالة الحظر",
        "设置国家或地区失败": "فشل في تحديد الدولة أو المنطقة",
        "设置国家或地区成功": "تم تحديد الدولة أو المنطقة بنجاح",
        "说点什么吧": "دردش الآن",
        "请竖屏获得更佳体验": "يُرجى أن تكون الشاشة في وضع عمودي، للحصول على تجربة أفضل",
        "请输入用户昵称或Up号": "من فضلك قُم بإدخال الاسم أو رقم الحساب",
        "贡献U币:<%=code%>": " الكوينز التي تم الدعم بها: <%=code%>",
        "赠送": "أرسل هدية",
        "赠送了<%=count%>个<%=giftName%>": " أرسل <%=count%> من <%=giftName%>",
        "赠送了<%=giftName%>": "أرسل <%=giftName%>",
        "距离下一级：<%=code%>": "باقى على المستوى التالى：<%=code%>",
        "进入房间失败": "فشل فى دخول غرفة البث المباشر",
        "进入房间超时": "انتهاء مهلة دخول غرفة البث المباشر",
        "连": "+1",
        "连接失败，请退出直播间重新进入": "فشل فى الإتصال، من فضلك اخرج من غرفة البث المباشر وأعد الدخول مرة أخرى",
        "选择国家或地区": "قُم باختيار الدولة أو المنطقة",
        "重新选择": "إعادة الاختيار",
        "黑名单": "القائمة السوداء"
    },
    "enus": {
        "<%=userName%>坐着<%=carName%>进入了直播间": "Welcome <%=userName%> enter the chatting room on <%=carName%> ",
        "AD": "Andorra",
        "AE": "United Arab Emirates",
        "AF": "Afghanistan",
        "AG": "Antigua and Barbuda",
        "AI": "Anguilla",
        "AL": "Albania",
        "AM": "Armenia",
        "AN": "Netherlands Antilles",
        "AO": "Angola",
        "AQ": "Antarctica",
        "AR": "Argentina",
        "AS": "American Samoa",
        "AT": "Austria",
        "AU": "Australia",
        "AW": "Aruba",
        "AZ": "Azerbaijan",
        "BA": "Bosnia and Herzegovina",
        "BB": "Barbados",
        "BD": "Bangladesh",
        "BE": "Belgium",
        "BF": "Burkina Faso",
        "BG": "Bulgaria",
        "BH": "Bahrain",
        "BI": "Burundi",
        "BJ": "Benin",
        "BL": "Saint Barthelemy",
        "BM": "Bermuda",
        "BN": "Brunei",
        "BO": "Bolivia",
        "BR": "Brazil",
        "BS": "Bahamas",
        "BT": "Bhutan",
        "BW": "Botswana",
        "BY": "Belarus",
        "BZ": "Belize",
        "CA": "Canada",
        "CC": "Cocos Islands",
        "CD": "Democratic Republic of the Congo",
        "CF": "Central African Republic",
        "CG": "Republic of the Congo",
        "CH": "Switzerland",
        "CI": "Ivory Coast",
        "CK": "Cook Islands",
        "CL": "Chile",
        "CM": "Cameroon",
        "CN": "China",
        "CO": "Colombia",
        "CR": "Costa Rica",
        "CU": "Cuba",
        "CV": "Cape Verde",
        "CW": "Curacao",
        "CX": "Christmas Islands",
        "CY": "Cyprus",
        "CZ": "Czech Republic",
        "DE": "Germany",
        "DJ": "Djibouti",
        "DK": "Denmark",
        "DM": "Dominica",
        "DO": "Dominican Republic",
        "DZ": "Algeria",
        "EC": "Ecuador",
        "EE": "Estonia",
        "EG": "Egypt",
        "EH": "Western Sahara",
        "ER": "Eritrea",
        "ES": "Spain",
        "ET": "Ethiopia",
        "FI": "Finland",
        "FJ": "Fiji",
        "FK": "Falkland Islands",
        "FM": "Micronesia",
        "FO": "Faroe Islands",
        "FR": "France",
        "GA": "Gabon",
        "GB": "United Kingdom",
        "GD": "Grenada",
        "GE": "Georgia",
        "GG": "Guernsey",
        "GH": "Ghana",
        "GI": "Gibraltar",
        "GL": "Greenland",
        "GM": "Gambia",
        "GN": "Guinea",
        "GQ": "Equatorial Guinea",
        "GR": "Greece",
        "GT": "Guatemala",
        "GU": "Guam",
        "GW": "Guinea-Bissau",
        "GY": "Guyana",
        "HK": "Hong Kong",
        "HN": "Honduras",
        "HR": "Croatia",
        "HT": "Haiti",
        "HU": "Hungary",
        "ID": "Indonesia",
        "IE": "Ireland",
        "IL": "Israel",
        "IM": "Isle of Man",
        "IN": "India",
        "IO": "British Indian Ocean Territory",
        "IQ": "Iraq",
        "IR": "Iran",
        "IS": "Iceland",
        "IT": "Italy",
        "JE": "Jersey",
        "JM": "Jamaica",
        "JO": "Jordan",
        "JP": "Japan",
        "KE": "Kenya",
        "KG": "Kyrgyzstan",
        "KH": "Cambodia",
        "KI": "Kiribati",
        "KM": "Comoros",
        "KN": "Saint Kitts and Nevis",
        "KP": "North Korea",
        "KR": "South Korea",
        "KW": "Kuwait",
        "KY": "Cayman Islands",
        "KZ": "Kazakhstan",
        "LA": "Laos",
        "LB": "Lebanon",
        "LC": "Saint Lucia",
        "LI": "Liechtenstein",
        "LK": "Sri Lanka",
        "LR": "Liberia",
        "LS": "Lesotho",
        "LT": "Lithuania",
        "LU": "Luxembourg",
        "LV": "Latvia",
        "LY": "Libya",
        "MA": "Morocco",
        "MC": "Monaco",
        "MD": "Moldova",
        "ME": "Montenegro",
        "MF": "Saint Martin",
        "MG": "Madagascar",
        "MH": "Marshall Islands",
        "MK": "Macedonia",
        "ML": "Mali",
        "MM": "Myanmar",
        "MN": "Mongolia",
        "MO": "Macau",
        "MP": "Northern Mariana Islands",
        "MR": "Mauritania",
        "MS": "Montserrat",
        "MT": "Malta",
        "MU": "Mauritius",
        "MV": "Maldives",
        "MW": "Malawi",
        "MX": "Mexico",
        "MY": "Malaysia",
        "MZ": "Mozambique",
        "NA": "Namibia",
        "NC": "New Caledonia",
        "NE": "Niger",
        "NG": "Nigeria",
        "NI": "Nicaragua",
        "NL": "Netherlands",
        "NO": "Norway",
        "NP": "Nepal",
        "NR": "Nauru",
        "NU": "Niue",
        "NZ": "New Zealand",
        "OM": "Oman",
        "PA": "Panama",
        "PE": "Peru",
        "PF": "French Polynesia",
        "PG": "Papua New Guinea",
        "PH": "Philippines",
        "PK": "Pakistan",
        "PL": "Poland",
        "PM": "Saint Pierre and Miquelon",
        "PN": "Pitcairn",
        "PR": "Puerto Rico",
        "PS": "Palestine",
        "PT": "Portugal",
        "PW": "Palau",
        "PY": "Paraguay",
        "QA": "Qatar",
        "RE": "Reunion",
        "RO": "Romania",
        "RS": "Serbia",
        "RU": "Russia",
        "RW": "Rwanda",
        "SA": "Saudi Arabia",
        "SB": "Solomon Islands",
        "SC": "Seychelles",
        "SD": "Sudan",
        "SE": "Sweden",
        "SG": "Singapore",
        "SH": "Saint Helena",
        "SI": "Slovenia",
        "SJ": "Svalbard and Jan Mayen",
        "SK": "Slovakia",
        "SL": "Sierra Leone",
        "SM": "San Marino",
        "SN": "Senegal",
        "SO": "Somalia",
        "SR": "Suriname",
        "SS": "South Sudan",
        "ST": "Sao Tome and Principe",
        "SV": "El Salvador",
        "SX": "Sint Maarten",
        "SY": "Syria",
        "SZ": "Swaziland",
        "TC": "Turks and Caicos Islands",
        "TD": "Chad",
        "TG": "Togo",
        "TH": "Thailand",
        "TJ": "Tajikistan",
        "TK": "Tokelau",
        "TL": "East Timor",
        "TM": "Turkmenistan",
        "TN": "Tunisia",
        "TO": "Tonga",
        "TR": "Turkey",
        "TT": "Trinidad and Tobago",
        "TV": "Tuvalu",
        "TW": "Taiwan",
        "TZ": "Tanzania",
        "UA": "Ukraine",
        "UG": "Uganda",
        "US": "United States",
        "UY": "Uruguay",
        "UZ": "Uzbekistan",
        "Up号:<%=code%>": "Up ID:<%=code%>",
        "Up直播": "UpLive",
        "U币贡献榜": "Top fans",
        "VA": "Vatican",
        "VC": "Saint Vincent and the Grenadines",
        "VE": "Venezuela",
        "VG": "British Virgin Islands",
        "VI": "U.S. Virgin Islands",
        "VN": "Vietnam",
        "VU": "Vanuatu",
        "WF": "Wallis and Futuna",
        "WS": "Samoa",
        "XK": "Kosovo",
        "YE": "Yemen",
        "YT": "Mayotte",
        "ZA": "South Africa",
        "ZM": "Zambia",
        "ZW": "Zimbabwe",
        "个人信息设定失败": "Fail to save",
        "个人信息设定成功": "Saved success",
        "主播可能在休息，稍后再来试试吧": "The host is having a rest, please check later",
        "主播已停播，即将返回首页!": "Live stream ended, go back to homepage instantly",
        "优秀主播指南": "Broadcaster Guidelines",
        "余额不足情况下，充值提醒的描述": "Insufficient balance, want to go recharge?",
        "你关注的人还没有直播": "None of your followings is boardcasting.",
        "保存": "Save",
        "充值 >": "Recharge >",
        "关注": "Following",
        "关注了主播，从此不再错过。": "followed this host",
        "写个签名吧，让大家了解你。": "Say something about yourself",
        "分享失败": "Share failed",
        "分享成功": "Share successful",
        "去看看当前热门直播": "Go to check the hot list",
        "参数无效": "Invalid parameters",
        "参数错误": "error",
        "发现": "Discover",
        "发现新主播": "Discover interesting host",
        "发送": "Send",
        "取消": "Cancel",
        "如何升级": "How do I level up?",
        "如何升级详情": "Send more points and gain even more points.@@@@ Try to start your own boardcasts! ",
        "守护身价:<%=code%>": "Guardian Price",
        "已停播": "Live stream ended",
        "已关注": "Followed",
        "已取消分享": "Cancel",
        "我的U钻": "My U diamonds",
        "我的守护": "My Guardian",
        "我的收益（U币）": "My U coins (earnings)",
        "我的直播": "My shows",
        "我的等级": "My level",
        "拉黑": "Add to block list",
        "按语言推荐主播": "Recommended by language",
        "搜索": "Search",
        "收到的U币": "U coins earned",
        "昵称不能出现敏感词": "This nick name includs prohibit word",
        "暂无数据": "No data",
        "暂无被拉黑用户": "Noboby on the blacklist",
        "未知星球": "Unknown location",
        "正在加载": "Loading",
        "正在加载更多的数据...": "Loading more data...",
        "没发现此人，请重新输入试试": "No result found",
        "没有更多数据了哦": "That's all",
        "点亮了": "liked this",
        "热门": "Hot",
        "用户登录失效": "Sign-in failed",
        "登出": "Logout",
        "直播中": "On air",
        "确认": "Confirm",
        "等级福利": "My rewards",
        "等级福利详情": "Your level is represented by this distinguish icon. The higher levels have more chance to enjoy tailored benefits.",
        "签名不能出现敏感词": "Introduction includs prohibit word",
        "粉丝": "Fans",
        "系统消息": "System message:",
        "系统消息: 主播回来了，视频即将恢复！": "System message: host is coming back! The show is about is begin!",
        "系统消息: 主播暂时离开了，小伙伴们请稍候。": "System message: host left for a moment, please be patient for a while.",
        "系统消息: 我们提倡绿色直播，只有通过审核并被标记为优质的主播才可能出现在热门，如封面和直播内容含有涉黄、低俗、吸烟、暴露等情况，将会被封禁账号。网警将保持24小时在线审核与审查，请您遵守。": "Content relating to violence, smoking, drugs or pornography is strictly prohibited. Administrators will be patrolling 24/7 and any users found with such content will be banned.",
        "系统错误": "System error",
        "累计经验：<%=code%>": "Epx. accumulated: <%=code%>",
        "经验值<%=num%>": "<%=num%> Exp",
        "花费:": "Contribute",
        "获取个人信息失败": "Fail to get your personal information",
        "获取热门主播失败": "Fail to acquire the hot list",
        "虚位以待": "Waiting for someon...",
        "解除拉黑": "Remove from bloack list",
        "设置国家或地区失败": "Fail to set your country / region",
        "设置国家或地区成功": "Country/Region information updated!",
        "说点什么吧": "Say something",
        "请竖屏获得更佳体验": "Keep your screen vertical to get a better experience",
        "请输入用户昵称或Up号": "Enter nickname or Up ID",
        "贡献U币:<%=code%>": "U coins contributed: <%=code%>",
        "赠送": "Gift",
        "赠送了<%=count%>个<%=giftName%>": "sent <%=count%> <%=giftName%>",
        "赠送了<%=giftName%>": "Sent <%=giftName%>",
        "距离下一级：<%=code%>": "To next level: <%=code%> ",
        "进入房间失败": "Fail to enter this room",
        "进入房间超时": "Timeout",
        "连": "+1",
        "连接失败，请退出直播间重新进入": "Connection failed, try to quit and enter again.",
        "选择国家或地区": "Choose your country/region",
        "重新选择": "Choose again",
        "黑名单": "Blasklist"
    },
    "eses": {
        "AD": "Andorra",
        "AE": "Emiratos Árabes Unidos",
        "AF": "Afganistán",
        "AG": "Antigua y Barbuda",
        "AI": "Anguilla",
        "AL": "Albania",
        "AM": "Armenia",
        "AN": "Antillas holandesas",
        "AO": "Angola",
        "AQ": "Antártida",
        "AR": "Argentina",
        "AS": "Samoa",
        "AT": "Austria",
        "AU": "Australia",
        "AW": "Aruba",
        "AZ": "Azerbaiyán",
        "BA": "Bosnia y Herzegovina",
        "BB": "Barbados",
        "BD": "Bangladesh",
        "BE": "Bélgica",
        "BF": "Burkina Faso",
        "BG": "Bulgaria",
        "BH": "Bahrein",
        "BI": "Burundi",
        "BJ": "Benin",
        "BL": "San Bartolomé",
        "BM": "Bermuda",
        "BN": "Brunei",
        "BO": "Bolivia",
        "BR": "Brasil",
        "BS": "Bahamas",
        "BT": "Bhután",
        "BW": "Botswana",
        "BY": "Belarús",
        "BZ": "Belice",
        "CA": "Canadá",
        "CC": "Islas Cocos",
        "CD": "República Democrática del Congo",
        "CF": "República Centroafricana",
        "CG": "República Democrática del Congo",
        "CH": "Suiza",
        "CI": "Costa de marfil",
        "CK": "Islas Cook",
        "CL": "Chile",
        "CM": "Camerún",
        "CN": "China",
        "CO": "Colombia",
        "CR": "Costa Rica",
        "CU": "Cuba",
        "CV": "Cabo Verde",
        "CW": "Curacao",
        "CX": "Islas de Navidad",
        "CY": "Chipre",
        "CZ": "República Checa",
        "DE": "Alemania",
        "DJ": "Djibouti",
        "DK": "Dinamarca",
        "DM": "dominica",
        "DO": "República Dominicana",
        "DZ": "Argelia",
        "EC": "Ecuador",
        "EE": "Estonia",
        "EG": "Egipto",
        "EH": "Sahara occidental",
        "ER": "Eritrea",
        "ES": "España",
        "ET": "Etiopía",
        "FI": "Finlandia",
        "FJ": "Fiji",
        "FK": "islas Malvinas",
        "FM": "Micronesia",
        "FO": "Islas Feroe",
        "FR": "Francia",
        "GA": "Gabón",
        "GB": "Inglés",
        "GD": "Granada",
        "GE": "Georgia",
        "GG": "Guernesey",
        "GH": "Ghana",
        "GI": "Gibraltar",
        "GL": "Groenlandia",
        "GM": "Gambia",
        "GN": "Guinea",
        "GQ": "Guinea Ecuatorial",
        "GR": "Grecia",
        "GT": "Guatemala",
        "GU": "Guam",
        "GW": "Guinea-Bissau",
        "GY": "Guayana",
        "HK": "Hong Kong",
        "HN": "Honduras",
        "HR": "Croacia",
        "HT": "Haití",
        "HU": "Hungría",
        "ID": "Indonesia",
        "IE": "Irlanda",
        "IL": "Israel",
        "IM": "Isla de Man",
        "IN": "India",
        "IO": "Territorio Británico del Océano Índico",
        "IQ": "Irak",
        "IR": "Irán",
        "IS": "Islandia",
        "IT": "Italia",
        "JE": "New Jersey",
        "JM": "Jamaica",
        "JO": "Jordania",
        "JP": "Japón",
        "KE": "Kenia",
        "KG": "Kirguistán",
        "KH": "Camboya",
        "KI": "Kiribati",
        "KM": "Comoras",
        "KN": "San Cristóbal y Nieves",
        "KP": "Corea del Norte",
        "KR": "Corea",
        "KW": "Kuwait",
        "KY": "Islas Caimán",
        "KZ": "Kazajstán",
        "LA": "Laos",
        "LB": "Líbano",
        "LC": "Santa Lucía",
        "LI": "Liechtenstein",
        "LK": "Sri Lanka",
        "LR": "Liberia",
        "LS": "Lesoto",
        "LT": "Lituania",
        "LU": "Luxemburgo",
        "LV": "Letonia",
        "LY": "Libia",
        "MA": "Marruecos",
        "MC": "Mónaco",
        "MD": "Moldavia",
        "ME": "Montenegro",
        "MF": "San Martín",
        "MG": "Madagascar",
        "MH": "Islas Marshall",
        "MK": "macedonia",
        "ML": "mali",
        "MM": "Myanmar",
        "MN": "Mongolia",
        "MO": "macao",
        "MP": "Islas Marianas del Norte",
        "MR": "Mauritania",
        "MS": "Montserrat",
        "MT": "Malta",
        "MU": "Mauricio",
        "MV": "Maldivas",
        "MW": "Malawi",
        "MX": "México",
        "MY": "Malasia",
        "MZ": "Mozambique",
        "NA": "Namibia",
        "NC": "nueva Caledonia",
        "NE": "Níger",
        "NG": "Nigeria",
        "NI": "Nicaragua",
        "NL": "Países Bajos",
        "NO": "Noruega",
        "NP": "Nepal",
        "NR": "Nauru",
        "NU": "Niue",
        "NZ": "Nueva Zelandia",
        "OM": "Omán",
        "PA": "Panamá",
        "PE": "Perú",
        "PF": "Polinesia francés",
        "PG": "Papua Nueva Guinea",
        "PH": "Filipinas",
        "PK": "Pakistán",
        "PL": "Polonia",
        "PM": "San Pedro y Miquelón",
        "PN": "Pitcairn",
        "PR": "Puerto Rico",
        "PS": "Palestina",
        "PT": "Portugal",
        "PW": "Palau",
        "PY": "Paraguay",
        "QA": "Katar",
        "RE": "reunión",
        "RO": "Rumania",
        "RS": "Serbia",
        "RU": "Rusia",
        "RW": "Ruanda",
        "SA": "Arabia Saudita",
        "SB": "islas Salomón",
        "SC": "Seychelles",
        "SD": "Sudán",
        "SE": "Suecia",
        "SG": "Singapur",
        "SH": "St. Helena",
        "SI": "Eslovenia",
        "SJ": "Svalbard",
        "SK": "Eslovaquia",
        "SL": "Sierra Leona",
        "SM": "San Marino",
        "SN": "Senegal",
        "SO": "Somalia",
        "SR": "Surinam",
        "SS": "Sudán del Sur",
        "ST": "Santo Tomé y Príncipe",
        "SV": "El Salvador",
        "SX": "Sint Maarten",
        "SY": "Siria",
        "SZ": "Swazilandia",
        "TC": "Turks y Caicos",
        "TD": "Chad",
        "TG": "Togo",
        "TH": "Tailandia",
        "TJ": "Tayikistán",
        "TK": "Tokelau",
        "TL": "Timor del Este",
        "TM": "Turkmenistán",
        "TN": "Túnez",
        "TO": "Tonga",
        "TR": "Turquía",
        "TT": "Trinidad y Tobago",
        "TV": "Tuvalu",
        "TW": "Taiwán",
        "TZ": "Tanzania",
        "UA": "Ucrania",
        "UG": "Uganda",
        "US": "Estados Unidos",
        "UY": "Uruguay",
        "UZ": "Uzbekistán",
        "VA": "Santa Sede",
        "VC": "San Vicente y las Granadinas",
        "VE": "Venezuela",
        "VG": "Islas Vírgenes Británicas",
        "VI": "Islas Vírgenes de los Estados",
        "VN": "Vietnam",
        "VU": "Vanuatu",
        "WF": "Wallis y Futuna",
        "WS": "Samoa",
        "XK": "Kosovo",
        "YE": "Yemen",
        "YT": "Mayotte",
        "ZA": "Sudáfrica",
        "ZM": "Zambia",
        "ZW": "Zimbabue"
    },
    "frfr": {
        "AD": "Andorre",
        "AE": "Emirats Arabes Unis",
        "AF": "Afghanistan",
        "AG": "Antigua-et-Barbuda",
        "AI": "Anguilla",
        "AL": "Albanie",
        "AM": "Arménie",
        "AN": "Antilles néerlandaises",
        "AO": "Angola",
        "AQ": "Antarctique",
        "AR": "Argentine",
        "AS": "Samoa Américaines",
        "AT": "Autriche",
        "AU": "Australie",
        "AW": "Aruba",
        "AZ": "Azerbaïdjan",
        "BA": "Bosnie Herzégovine",
        "BB": "Barbade",
        "BD": "Bangladesh",
        "BE": "Belgique",
        "BF": "Burkina Faso",
        "BG": "Bulgarie",
        "BH": "Bahreïn",
        "BI": "Burundi",
        "BJ": "Bénin",
        "BL": "Saint-Barthélemy",
        "BM": "Bermuda",
        "BN": "Brunei",
        "BO": "Bolivie",
        "BR": "Brésil",
        "BS": "Bahamas",
        "BT": "Bhoutan",
        "BW": "Botswana",
        "BY": "Belarus",
        "BZ": "Belize",
        "CA": "Canada",
        "CC": "Îles Cocos",
        "CD": "République Démocratique du Congo",
        "CF": "République centrafricaine",
        "CG": "République du Congo",
        "CH": "Suisse",
        "CI": "Côte d'Ivoire",
        "CK": "les Îles Cook",
        "CL": "Chili",
        "CM": "Cameroun",
        "CN": "Chine",
        "CO": "Colombie",
        "CR": "Costa Rica",
        "CU": "Cuba",
        "CV": "Cap-Vert",
        "CW": "Curacao",
        "CX": "Christmas Islands",
        "CY": "Chypre",
        "CZ": "République Tchèque",
        "DE": "Allemagne",
        "DJ": "Djibouti",
        "DK": "Danemark",
        "DM": "Dominique",
        "DO": "République Dominicaine",
        "DZ": "Algérie",
        "EC": "Equateur",
        "EE": "Estonie",
        "EG": "Egypte",
        "EH": "Sahara occidental",
        "ER": "Érythrée",
        "ES": "l'Espagne",
        "ET": "Ethiopie",
        "FI": "Finlande",
        "FJ": "Fidji",
        "FK": "les îles Falkland",
        "FM": "Micronésie",
        "FO": "Îles Féroé",
        "FR": "France",
        "GA": "Gabon",
        "GB": "Royaume-Uni",
        "GD": "Grenade",
        "GE": "Géorgie",
        "GG": "Guernsey",
        "GH": "Ghana",
        "GI": "Gibraltar",
        "GL": "Groenland",
        "GM": "Gambie",
        "GN": "Guinée",
        "GQ": "Guinée Équatoriale",
        "GR": "Grèce",
        "GT": "Guatemala",
        "GU": "Guam",
        "GW": "Guinée-Bissau",
        "GY": "Guyane",
        "HK": "Hong Kong",
        "HN": "Honduras",
        "HR": "Croatie",
        "HT": "Haïti",
        "HU": "Hongrie",
        "ID": "Indonésie",
        "IE": "Irlande",
        "IL": "Israël",
        "IM": "Isle of Man",
        "IN": "Inde",
        "IO": "Territoire britannique de l'océan Indien",
        "IQ": "Irak",
        "IR": "l'Iran",
        "IS": "Islande",
        "IT": "Italie",
        "JE": "Jersey",
        "JM": "Jamaïque",
        "JO": "Jordanie",
        "JP": "Japon",
        "KE": "Kenya",
        "KG": "Kirghizistan",
        "KH": "Cambodge",
        "KI": "Kiribati",
        "KM": "Comores",
        "KN": "Saint-Christophe-et-Niévès",
        "KP": "Corée du Nord",
        "KR": "Corée du Sud",
        "KW": "Koweit",
        "KY": "Îles Caïmans",
        "KZ": "Kazakhstan",
        "LA": "Laos",
        "LB": "Liban",
        "LC": "Sainte-Lucie",
        "LI": "Liechtenstein",
        "LK": "Sri Lanka",
        "LR": "Libéria",
        "LS": "Lesotho",
        "LT": "Lituanie",
        "LU": "Luxembourg",
        "LV": "Lettonie",
        "LY": "Libye",
        "MA": "Maroc",
        "MC": "Monaco",
        "MD": "Moldova",
        "ME": "Monténégro",
        "MF": "Saint Martin",
        "MG": "Madagascar",
        "MH": "Iles Marshall",
        "MK": "Macédoine",
        "ML": "Mali",
        "MM": "Myanmar",
        "MN": "Mongolie",
        "MO": "Macau",
        "MP": "Îles Mariannes du Nord",
        "MR": "Mauritanie",
        "MS": "Montserrat",
        "MT": "Malte",
        "MU": "Ile Maurice",
        "MV": "Maldives",
        "MW": "Malawi",
        "MX": "Mexique",
        "MY": "Malaisie",
        "MZ": "Mozambique",
        "NA": "Namibie",
        "NC": "Nouvelle Calédonie",
        "NE": "Niger",
        "NG": "Nigeria",
        "NI": "Nicaragua",
        "NL": "Pays-Bas",
        "NO": "Norvège",
        "NP": "Népal",
        "NR": "Nauru",
        "NU": "Niue",
        "NZ": "nouvelle Zélande",
        "OM": "Oman",
        "PA": "Panama",
        "PE": "Pérou",
        "PF": "Polynésie française",
        "PG": "Papouasie Nouvelle Guinée",
        "PH": "Philippines",
        "PK": "Pakistan",
        "PL": "Pologne",
        "PM": "Saint-Pierre-et-Miquelon",
        "PN": "Pitcairn",
        "PR": "Porto Rico",
        "PS": "Palestine",
        "PT": "le Portugal",
        "PW": "Palau",
        "PY": "Paraguay",
        "QA": "Qatar",
        "RE": "Réunion",
        "RO": "Roumanie",
        "RS": "Serbie",
        "RU": "Russie",
        "RW": "Rwanda",
        "SA": "Arabie Saoudite",
        "SB": "Les îles Salomon",
        "SC": "les Seychelles",
        "SD": "Soudan",
        "SE": "Suède",
        "SG": "Singapour",
        "SH": "Saint Helena",
        "SI": "Slovénie",
        "SJ": "Svalbard et Jan Mayen",
        "SK": "Slovaquie",
        "SL": "Sierra Leone",
        "SM": "Saint Marin",
        "SN": "Sénégal",
        "SO": "Somalie",
        "SR": "Suriname",
        "SS": "Soudan du sud",
        "ST": "Sao Tomé-et-Principe",
        "SV": "Le Salvador",
        "SX": "Sint Maarten",
        "SY": "Syrie",
        "SZ": "Swaziland",
        "TC": "îles Turques-et-Caïques",
        "TD": "Tchad",
        "TG": "Aller",
        "TH": "Thaïlande",
        "TJ": "Tadjikistan",
        "TK": "Tokelau",
        "TL": "Timor oriental",
        "TM": "Turkménistan",
        "TN": "Tunisie",
        "TO": "Tonga",
        "TR": "Turquie",
        "TT": "Trinité-et-Tobago",
        "TV": "Tuvalu",
        "TW": "Taïwan",
        "TZ": "Tanzanie",
        "UA": "Ukraine",
        "UG": "Ouganda",
        "US": "États Unis",
        "UY": "Uruguay",
        "UZ": "Ouzbékistan",
        "VA": "Vatican",
        "VC": "Saint-Vincent-et-les-Grenadines",
        "VE": "Venezuela",
        "VG": "Îles Vierges britanniques",
        "VI": "Îles Vierges américaines",
        "VN": "Viêt-Nam",
        "VU": "Vanuatu",
        "WF": "Wallis et Futuna",
        "WS": "Samoa",
        "XK": "Kosovo",
        "YE": "Yémen",
        "YT": "Mayotte",
        "ZA": "Afrique du Sud",
        "ZM": "Zambie",
        "ZW": "Zimbabwe"
    },
    "idid": {
        "AD": "Andorra",
        "AE": "Uni Emirat Arab",
        "AF": "Afganistan",
        "AG": "Antigua dan Barbuda",
        "AI": "anguilla",
        "AL": "Albania",
        "AM": "Armenia",
        "AN": "Antillen Belanda",
        "AO": "Angola",
        "AQ": "Antartika",
        "AR": "Argentina",
        "AS": "Samoa",
        "AT": "Austria",
        "AU": "Australia",
        "AW": "Aruba",
        "AZ": "Azerbaijan",
        "BA": "Bosnia dan Herzegovina",
        "BB": "Barbados",
        "BD": "Bangladesh",
        "BE": "Belgia",
        "BF": "Burkina Faso",
        "BG": "Bulgaria",
        "BH": "Bahrain",
        "BI": "Burundi",
        "BJ": "Benin",
        "BL": "Saint Barthelemy",
        "BM": "Bermuda",
        "BN": "brunei",
        "BO": "Bolivia",
        "BR": "Brazil",
        "BS": "Bahama",
        "BT": "Bhutan",
        "BW": "Botswana",
        "BY": "Belarus",
        "BZ": "Belize",
        "CA": "Kanada",
        "CC": "Kepulauan Cocos",
        "CD": "Republik Demokratik Kongo",
        "CF": "Republik Afrika Tengah",
        "CG": "Republik Demokratik Kongo",
        "CH": "Swiss",
        "CI": "Pantai Gading",
        "CK": "Kepulauan cook",
        "CL": "Chili",
        "CM": "Kamerun",
        "CN": "Cina",
        "CO": "Kolumbia",
        "CR": "Costa Rica",
        "CU": "Kuba",
        "CV": "Cape Verde",
        "CW": "Curacao",
        "CX": "Pulau Natal",
        "CY": "Siprus",
        "CZ": "Republik Ceko",
        "DE": "Jerman",
        "DJ": "Djibouti",
        "DK": "Denmark",
        "DM": "Dominica",
        "DO": "Republik Dominika",
        "DZ": "Aljazair",
        "EC": "Ekuador",
        "EE": "Estonia",
        "EG": "Mesir",
        "EH": "Sahara Barat",
        "ER": "Eritrea",
        "ES": "Spanyol",
        "ET": "Etiopia",
        "FI": "Finlandia",
        "FJ": "Fiji",
        "FK": "Kepulauan Falkland",
        "FM": "Mikronesia",
        "FO": "Kepulauan Faroe",
        "FR": "Prancis",
        "GA": "Gabon",
        "GB": "Inggris",
        "GD": "Grenada",
        "GE": "Georgia",
        "GG": "Guernsey",
        "GH": "Ghana",
        "GI": "Gibraltar",
        "GL": "tanah penggembalaan",
        "GM": "Gambia",
        "GN": "guinea",
        "GQ": "Equatorial Guinea",
        "GR": "Yunani",
        "GT": "Guatemala",
        "GU": "Guam",
        "GW": "Guinea-Bissau",
        "GY": "guyana",
        "HK": "Hong Kong",
        "HN": "honduras",
        "HR": "Kroasia",
        "HT": "Haiti",
        "HU": "Hongaria",
        "ID": "Indonesia",
        "IE": "Irlandia",
        "IL": "Israel",
        "IM": "Isle of Man",
        "IN": "India",
        "IO": "Britania di Samudra Hindia",
        "IQ": "Irak",
        "IR": "Iran",
        "IS": "Islandia",
        "IT": "Italia",
        "JE": "New Jersey",
        "JM": "Jamaika",
        "JO": "Jordan",
        "JP": "Jepang",
        "KE": "Kenya",
        "KG": "Kyrgyzstan",
        "KH": "Kamboja",
        "KI": "Kiribati",
        "KM": "Komoro",
        "KN": "Saint Kitts dan Nevis",
        "KP": "Korea utara",
        "KR": "Korea",
        "KW": "Kuwait",
        "KY": "Kepulauan Cayman",
        "KZ": "Kazakhstan",
        "LA": "Laos",
        "LB": "Libanon",
        "LC": "Saint Lucia",
        "LI": "Liechtenstein",
        "LK": "Sri Lanka",
        "LR": "Liberia",
        "LS": "Lesotho",
        "LT": "Lithuania",
        "LU": "Luksemburg",
        "LV": "Latvia",
        "LY": "Libya",
        "MA": "Maroko",
        "MC": "Monako",
        "MD": "Moldova",
        "ME": "montenegro",
        "MF": "San Martin",
        "MG": "Madagaskar",
        "MH": "Kepulauan Marshall",
        "MK": "Makedonia",
        "ML": "mali",
        "MM": "Myanmar",
        "MN": "Mongolia",
        "MO": "Makao",
        "MP": "Kepulauan Mariana Utara",
        "MR": "Mauritania",
        "MS": "Montserrat",
        "MT": "Malta",
        "MU": "Mauritius",
        "MV": "Maladewa",
        "MW": "Malawi",
        "MX": "Mexico",
        "MY": "Malaysia",
        "MZ": "Mozambik",
        "NA": "Namibia",
        "NC": "Kaledonia baru",
        "NE": "Niger",
        "NG": "Nigeria",
        "NI": "Nikaragua",
        "NL": "Belanda",
        "NO": "Norwegia",
        "NP": "Nepal",
        "NR": "Nauru",
        "NU": "Niue",
        "NZ": "Selandia baru",
        "OM": "Oman",
        "PA": "Panama",
        "PE": "Peru",
        "PF": "Polinesia Prancis",
        "PG": "Papua Nugini",
        "PH": "Pilipina",
        "PK": "Pakistan",
        "PL": "Polandia",
        "PM": "Saint Pierre dan Miquelon",
        "PN": "Pitcairn",
        "PR": "Puerto Rico",
        "PS": "Palestina",
        "PT": "Portugal",
        "PW": "Palau",
        "PY": "Paraguai",
        "QA": "Qatar",
        "RE": "reuni",
        "RO": "Rumania",
        "RS": "Serbia",
        "RU": "Rusia",
        "RW": "Rwanda",
        "SA": "Arab Saudi",
        "SB": "Kepulauan Solomon",
        "SC": "Seychelles",
        "SD": "Sudan",
        "SE": "Swedia",
        "SG": "Singapura",
        "SH": "St. Helena",
        "SI": "Slovenia",
        "SJ": "Svalbard",
        "SK": "Slovakia",
        "SL": "Sierra Leone",
        "SM": "San Marino",
        "SN": "senegal",
        "SO": "Somalia",
        "SR": "Suriname",
        "SS": "Sudan Selatan",
        "ST": "Sao Tome dan Principe",
        "SV": "El Salvador",
        "SX": "Sint Maarten",
        "SY": "Suriah",
        "SZ": "Swaziland",
        "TC": "Kepulauan Turks dan Caicos",
        "TD": "Chad",
        "TG": "Togo",
        "TH": "Thailand",
        "TJ": "Tajikistan",
        "TK": "Tokelau",
        "TL": "Timor timur",
        "TM": "Turkmenistan",
        "TN": "Tunisia",
        "TO": "Tonga",
        "TR": "Turki",
        "TT": "Trinidad dan Tobago",
        "TV": "Tuvalu",
        "TW": "Taiwan",
        "TZ": "Tanzania",
        "UA": "Ukraina",
        "UG": "Uganda",
        "US": "AS",
        "UY": "Uruguay",
        "UZ": "Uzbekistan",
        "VA": "Takhta suci",
        "VC": "Saint Vincent dan Grenadines",
        "VE": "Venezuela",
        "VG": "Kepulauan Virgin Inggris",
        "VI": "Amerika Serikat Kepulauan Virgin",
        "VN": "Vietnam",
        "VU": "Vanuatu",
        "WF": "Wallis dan Futuna",
        "WS": "Samoa",
        "XK": "Kosovo",
        "YE": "Yaman",
        "YT": "Mayotte",
        "ZA": "Afrika Selatan",
        "ZM": "Zambia",
        "ZW": "Zimbabwe"
    },
    "jajp": {
        "<%=userName%>坐着<%=carName%>进入了直播间": "<%=userName%>は<%=carName%>ライブ配信に来ました",
        "AD": "アンドラ",
        "AE": "アラブ首長国連邦",
        "AF": "アフガニスタン",
        "AG": "アンチグアバーブーダ",
        "AI": "アングィラ",
        "AL": "アルバニア",
        "AM": "アルメニア",
        "AN": "オランダ領アンティル",
        "AO": "アンゴラ",
        "AQ": "南極大陸",
        "AR": "アルゼンチン",
        "AS": "アメリカ領サモア",
        "AT": "オーストリア",
        "AU": "オーストラリア",
        "AW": "アルバ",
        "AZ": "アゼルバイジャン",
        "BA": "ボスニア・ヘルツェゴビナ",
        "BB": "バルバドス",
        "BD": "バングラデシュ",
        "BE": "ベルギー",
        "BF": "ブルキナファソ",
        "BG": "ブルガリア",
        "BH": "バーレーン",
        "BI": "ブルンジ",
        "BJ": "ベニン",
        "BL": "セントバーツ",
        "BM": "バミューダ",
        "BN": "ブルネイ",
        "BO": "ボリビア",
        "BR": "ブラジル",
        "BS": "バハマ",
        "BT": "ブータン",
        "BW": "ボツワナ",
        "BY": "ベラルーシ",
        "BZ": "ベリーズ",
        "CA": "カナダ",
        "CC": "ココス諸島",
        "CD": "コンゴ民主共和国",
        "CF": "中央アフリカ共和国",
        "CG": "コンゴ共和国",
        "CH": "スイス",
        "CI": "コー​​トジボワール",
        "CK": "クック諸島",
        "CL": "チリ",
        "CM": "カメルーン",
        "CN": "中国",
        "CO": "コロンビア",
        "CR": "コスタリカ",
        "CU": "キューバ",
        "CV": "カーボベルデ",
        "CW": "キュラソー",
        "CX": "クリスマス島",
        "CY": "キプロス",
        "CZ": "チェコ共和国",
        "DE": "ドイツ",
        "DJ": "ジブチ",
        "DK": "デンマーク",
        "DM": "ドミニカ",
        "DO": "ドミニカ共和国",
        "DZ": "アルジェリア",
        "EC": "エクアドル",
        "EE": "エストニア",
        "EG": "エジプト",
        "EH": "西サハラ",
        "ER": "エリトリア",
        "ES": "スペイン",
        "ET": "エチオピア",
        "FI": "フィンランド",
        "FJ": "フィジー",
        "FK": "フォークランド諸島",
        "FM": "ミクロネシア",
        "FO": "フェロー諸島",
        "FR": "フランス",
        "GA": "ガボン",
        "GB": "イギリス",
        "GD": "グレナダ",
        "GE": "ジョージア",
        "GG": "ガーンジー島",
        "GH": "ガーナ",
        "GI": "ジブラルタル",
        "GL": "グリーンランド",
        "GM": "ガンビア",
        "GN": "ギニア",
        "GQ": "赤道ギニア",
        "GR": "ギリシャ",
        "GT": "グアテマラ",
        "GU": "グアム",
        "GW": "ギニアビサウ",
        "GY": "ガイアナ",
        "HK": "香港",
        "HN": "ホンジュラス",
        "HR": "クロアチア",
        "HT": "ハイチ",
        "HU": "ハンガリー",
        "ID": "インドネシア",
        "IE": "アイルランド",
        "IL": "イスラエル",
        "IM": "マン島",
        "IN": "インド",
        "IO": "イギリス領インド洋地域",
        "IQ": "イラク",
        "IR": "イラン",
        "IS": "アイスランド",
        "IT": "イタリア",
        "JE": "ジャージー",
        "JM": "ジャマイカ",
        "JO": "ヨルダン",
        "JP": "日本",
        "KE": "ケニア",
        "KG": "キルギスタン",
        "KH": "カンボジア",
        "KI": "キリバス",
        "KM": "コモロ",
        "KN": "セントクリストファー・ネイビス",
        "KP": "北朝鮮",
        "KR": "韓国",
        "KW": "クウェート",
        "KY": "ケイマン諸島",
        "KZ": "カザフスタン",
        "LA": "ラオス",
        "LB": "レバノン",
        "LC": "セントルシア",
        "LI": "リヒテンシュタイン",
        "LK": "スリランカ",
        "LR": "リベリア",
        "LS": "レソト",
        "LT": "リトアニア",
        "LU": "ルクセンブルク",
        "LV": "ラトビア",
        "LY": "リビア",
        "MA": "モロッコ",
        "MC": "モナコ",
        "MD": "モルドバ",
        "ME": "モンテネグロ",
        "MF": "サンマルタン島",
        "MG": "マダガスカル",
        "MH": "マーシャル諸島",
        "MK": "マケドニア",
        "ML": "マリ",
        "MM": "ミャンマー",
        "MN": "モンゴル",
        "MO": "マカオ",
        "MP": "北マリアナ諸島",
        "MR": "モーリタニア",
        "MS": "モントセラト",
        "MT": "マルタ",
        "MU": "モーリシャス",
        "MV": "モルディブ",
        "MW": "マラウイ",
        "MX": "メキシコ",
        "MY": "マレーシア",
        "MZ": "モザンビーク",
        "NA": "ナミビア",
        "NC": "ニューカレドニア",
        "NE": "ニジェール",
        "NG": "ナイジェリア",
        "NI": "ニカラグア",
        "NL": "オランダ",
        "NO": "ノルウェー",
        "NP": "ネパール",
        "NR": "ナウル",
        "NU": "ニウエ",
        "NZ": "ニュージーランド",
        "OM": "オマーン",
        "PA": "パナマ",
        "PE": "ペルー",
        "PF": "フランス領ポリネシア",
        "PG": "パプアニューギニア",
        "PH": "フィリピン",
        "PK": "パキスタン",
        "PL": "ポーランド",
        "PM": "サンピエール島・ミクロン島",
        "PN": "ピトケアン",
        "PR": "プエルトリコ",
        "PS": "パレスチナ",
        "PT": "ポルトガル",
        "PW": "パラオ",
        "PY": "パラグアイ",
        "QA": "カタール",
        "RE": "再会",
        "RO": "ルーマニア",
        "RS": "セルビア",
        "RU": "ロシア",
        "RW": "ルワンダ",
        "SA": "サウジアラビア",
        "SB": "ソロモン諸島",
        "SC": "セイシェル",
        "SD": "スーダン",
        "SE": "スウェーデン",
        "SG": "シンガポール",
        "SH": "セントヘレナ",
        "SI": "スロベニア",
        "SJ": "スバールバル諸島ヤンマイエン島",
        "SK": "スロバキア",
        "SL": "シエラレオネ",
        "SM": "サン・マリノ",
        "SN": "セネガル",
        "SO": "ソマリア",
        "SR": "スリナム",
        "SS": "南スーダン",
        "ST": "サントメプリンシペ",
        "SV": "エルサルバドル",
        "SX": "シントマールテン島",
        "SY": "シリア",
        "SZ": "スワジランド",
        "TC": "タークス・カイコス諸島",
        "TD": "チャド",
        "TG": "行く",
        "TH": "タイ",
        "TJ": "タジキスタン",
        "TK": "トケラウ諸島",
        "TL": "東ティモール",
        "TM": "トルクメニスタン",
        "TN": "チュニジア",
        "TO": "トンガ",
        "TR": "トルコ",
        "TT": "トリニダード・トバゴ",
        "TV": "ツバル",
        "TW": "台湾",
        "TZ": "タンザニア",
        "UA": "ウクライナ",
        "UG": "ウガンダ",
        "US": "アメリカ",
        "UY": "ウルグアイ",
        "UZ": "ウズベキスタン",
        "Up号:<%=code%>": "Upアカンウト:<%=code%>",
        "Up直播": "UpLive",
        "U币贡献榜": "貢献ランキング",
        "VA": "バチカン",
        "VC": "セントビンセントおよびグレナディーン諸島",
        "VE": "ベネズエラ",
        "VG": "イギリス領バージン諸島",
        "VI": "米領バージン諸島",
        "VN": "ベトナム",
        "VU": "バヌアツ",
        "WF": "ワリー・エ・フトゥーナ",
        "WS": "サモア",
        "XK": "コソボ",
        "YE": "イエメン",
        "YT": "マヨット島",
        "ZA": "南アフリカ",
        "ZM": "ザンビア",
        "ZW": "ジンバブエ",
        "个人信息设定失败": "プロフィール設定失敗",
        "个人信息设定成功": "プロフィール設定完了",
        "主播可能在休息，稍后再来试试吧": "キャストは休憩中です。後ほどお越しください！",
        "主播已停播，即将返回首页!": "ライブ終了す。ホームページに戻ります！",
        "优秀主播指南": "ハイクォリティキャストマニュアル",
        "余额不足情况下，充值提醒的描述": "ダイヤが不足す、チャージしますか？",
        "你关注的人还没有直播": "フォロー中のキャストは現在ライブ配信をしていません",
        "保存": "保存",
        "充值 >": "チャージ >",
        "关注": "フォロー",
        "关注了主播，从此不再错过。": "このキャストをフォローしました",
        "写个签名吧，让大家了解你。": "自己紹介を書いて、みんなにあなたを知ってもらいましょう！",
        "分享失败": "シェア失敗しました！",
        "分享成功": "シェアしました！",
        "去看看当前热门直播": "現在人気のライブ",
        "参数无效": "パラメータが無効です",
        "参数错误": "パラメータエラー",
        "发现": "新着",
        "发现新主播": "新着キャスト",
        "发送": "送信",
        "取消": "キャンセル",
        "如何升级": "レベルアップ",
        "如何升级详情": "レベルアップの方法",
        "守护身价:<%=code%>": "SPになる:<%=code%>",
        "已停播": "配信停止しました",
        "已关注": "フォローしました",
        "已取消分享": "シェアをキャンセルしました",
        "我的U钻": "ダイヤ",
        "我的守护": "私のSP",
        "我的收益（U币）": "収入（コイン）",
        "我的直播": "ライブ配信確認",
        "我的等级": "レベル",
        "拉黑": "ブロックします",
        "按语言推荐主播": "言語別人気キャスト",
        "搜索": "検索",
        "收到的U币": "受け取ったコイン",
        "昵称不能出现敏感词": "ニックネームにはNGワードを記入することはきません",
        "暂无数据": "データがありません",
        "暂无被拉黑用户": "ブロックされたユーザーがいません",
        "未知星球": "位置情報が取得きません",
        "正在加载": "ローディング中",
        "正在加载更多的数据...": "データ更新中",
        "没发现此人，请重新输入试试": "見つかりませんした、もう一度お試しください",
        "没有更多数据了哦": "これ以上のデータがありません",
        "点亮了": "いいね",
        "热门": "人気",
        "用户登录失效": "ログイン失敗しました",
        "登出": "ログアウト",
        "直播中": "ライブ配信",
        "确认": "確認",
        "等级福利": "レベル特典",
        "等级福利详情": "レベル特典の詳細",
        "签名不能出现敏感词": "自己紹介にはNGワードを記入することはきません",
        "粉丝": "ファン",
        "系统消息": "システムエラー",
        "系统消息: 主播回来了，视频即将恢复！": "お知らせ：キャストが戻ってきました！",
        "系统消息: 主播暂时离开了，小伙伴们请稍候。": "お知らせ：キャストが席をはなれました。戻ってくるまお待ちください！",
        "系统消息: 我们提倡绿色直播，只有通过审核并被标记为优质的主播才可能出现在热门，如封面和直播内容含有涉黄、低俗、吸烟、暴露等情况，将会被封禁账号。网警将保持24小时在线审核与审查，请您遵守。": "お知らせ：利用規約に基づくライブ配信を行いましょう。24時間体制パトロールを行っており、露出、喫煙などの規約違反がある場合、アカウント停止を行う場合があります。協力して魅力的なライブ配信環境を築きましょう!!",
        "系统错误": "システムエラー",
        "累计经验：<%=code%>": "経験値：<%=code%>",
        "经验值<%=num%>": "経験値<%=num%>",
        "花费:": "貢献：",
        "获取个人信息失败": "個人情報の読み取りが失敗",
        "获取成功": "獲得成功",
        "获取热门主播失败": "人気欄キャスト一覧を表示きませんした",
        "虚位以待": "空席",
        "解除拉黑": "ブロック解除",
        "设置国家或地区失败": "国、地域設定失敗",
        "设置国家或地区成功": "国、地域設定完了",
        "说点什么吧": "何かお話しましょう",
        "请竖屏获得更佳体验": "スクリーンを縦にするとより良い体験がきます！",
        "请输入用户昵称或Up号": "ニックネーム、またはUpアカウントを入力してください",
        "贡献U币:<%=code%>": "貢献：<%=code%>",
        "赠送": "贈る",
        "赠送了<%=count%>个<%=giftName%>": "贈りました：<%=count%>個<%=giftName%>",
        "赠送了<%=giftName%>": "贈りました：<%=giftName%>",
        "距离下一级：<%=code%>": "次のレベルま：<%=code%>",
        "进入房间失败": "ライブ配信に参加失敗",
        "进入房间超时": "ライブ配信に参加タイムオーバ",
        "连": "+1",
        "连接失败，请退出直播间重新进入": "接続エラー、再度お試しください",
        "选择国家或地区": "国、地域を選択",
        "重新选择": "再度選択",
        "黑名单": "ブロックリスト"
    },
    "kokr": {
        "AD": "안도라",
        "AE": "아랍 에미리트",
        "AF": "아프가니스탄",
        "AG": "앤티가 바부 다",
        "AI": "앵 귈라",
        "AL": "알바니아",
        "AM": "아르메니아",
        "AN": "네덜란드 령 앤 틸리 스",
        "AO": "앙골라",
        "AQ": "남극 대륙",
        "AR": "아르헨티나",
        "AS": "사모아",
        "AT": "오스트리아",
        "AU": "호주",
        "AW": "아루바",
        "AZ": "아제르바이잔",
        "BA": "보스니아 헤르체고비나",
        "BB": "바베이도스",
        "BD": "방글라데시",
        "BE": "벨기에",
        "BF": "부르 키나 파소",
        "BG": "불가리아",
        "BH": "바레인",
        "BI": "부룬디",
        "BJ": "베냉",
        "BL": "세인트 Barthelemy",
        "BM": "버뮤다",
        "BN": "브루나이",
        "BO": "볼리비아",
        "BR": "브라질",
        "BS": "바하마",
        "BT": "부탄",
        "BW": "보츠와나",
        "BY": "벨라루스",
        "BZ": "벨리즈",
        "CA": "캐나다",
        "CC": "코코스 아일랜드",
        "CD": "콩고 민주 공화국",
        "CF": "중앙 아프리카 공화국",
        "CG": "콩고 민주 공화국",
        "CH": "스위스",
        "CI": "상아 해안",
        "CK": "쿡 제도",
        "CL": "칠레",
        "CM": "카메룬",
        "CN": "중국",
        "CO": "콜롬비아",
        "CR": "코스타리카",
        "CU": "쿠바",
        "CV": "카보 베르데",
        "CW": "쿠라 카오",
        "CX": "크리스마스 제도",
        "CY": "키프로스",
        "CZ": "체코 공화국",
        "DE": "독일",
        "DJ": "지부티",
        "DK": "덴마크",
        "DM": "도미니카",
        "DO": "도미니카 공화국",
        "DZ": "알제리",
        "EC": "에콰도르",
        "EE": "에스토니아",
        "EG": "이집트",
        "EH": "서부 사하라",
        "ER": "에리트레아",
        "ES": "스페인",
        "ET": "에티오피아",
        "FI": "핀란드",
        "FJ": "피지",
        "FK": "포클랜드 제도",
        "FM": "미크로네시아",
        "FO": "파로에 군도",
        "FR": "프랑스",
        "GA": "가봉",
        "GB": "영어",
        "GD": "그레나다",
        "GE": "그루지야",
        "GG": "영국 해협에있는 작은 섬",
        "GH": "가나",
        "GI": "지브롤터",
        "GL": "그린 랜드",
        "GM": "감비아",
        "GN": "기니",
        "GQ": "적도 기니",
        "GR": "그리스",
        "GT": "과테말라",
        "GU": "괌",
        "GW": "기니 비사우",
        "GY": "가이아나",
        "HK": "홍콩",
        "HN": "온두라스",
        "HR": "크로아티아",
        "HT": "아이티",
        "HU": "헝가리",
        "ID": "인도네시아",
        "IE": "아일랜드",
        "IL": "이스라엘",
        "IM": "아일 오브 맨",
        "IN": "인도",
        "IO": "영국령 인도양 지역",
        "IQ": "이라크",
        "IR": "이란",
        "IS": "아이슬란드",
        "IT": "이탈리아",
        "JE": "뉴저지",
        "JM": "자메이카",
        "JO": "요르단",
        "JP": "일본",
        "KE": "케냐",
        "KG": "키르기스스탄",
        "KH": "캄보디아",
        "KI": "키리바시",
        "KM": "코모로",
        "KN": "세인트 키츠 네비스",
        "KP": "북한",
        "KR": "한국",
        "KW": "쿠웨이트",
        "KY": "케이맨 제도",
        "KZ": "카자흐스탄",
        "LA": "라오스",
        "LB": "레바논",
        "LC": "세인트 루시아",
        "LI": "리히텐슈타인",
        "LK": "스리랑카",
        "LR": "라이베리아",
        "LS": "레소토",
        "LT": "리투아니아",
        "LU": "룩셈부르크",
        "LV": "라트비아",
        "LY": "리비아",
        "MA": "모로코",
        "MC": "모나코",
        "MD": "몰르 더바",
        "ME": "몬테네그로",
        "MF": "산 마르틴",
        "MG": "마다가스카르",
        "MH": "마샬 군도",
        "MK": "마케도니아",
        "ML": "말리",
        "MM": "미얀마",
        "MN": "몽골리아",
        "MO": "마카오",
        "MP": "북 마리아나 제도",
        "MR": "모리타니",
        "MS": "몬 세라",
        "MT": "몰타",
        "MU": "모리셔스",
        "MV": "몰디브",
        "MW": "말라위",
        "MX": "멕시코",
        "MY": "말레이시아",
        "MZ": "모잠비크",
        "NA": "나미비아",
        "NC": "뉴 칼레도니아",
        "NE": "니제르",
        "NG": "나이지리아",
        "NI": "니카라과",
        "NL": "네덜란드",
        "NO": "노르웨이",
        "NP": "네팔",
        "NR": "나우루어",
        "NU": "니우에",
        "NZ": "뉴질랜드",
        "OM": "오만",
        "PA": "파나마",
        "PE": "페루",
        "PF": "프랑스 령 폴리네시아의",
        "PG": "파푸아 뉴기니",
        "PH": "필리핀",
        "PK": "파키스탄",
        "PL": "폴란드",
        "PM": "생 피에르 미 클롱",
        "PN": "핏 케언",
        "PR": "푸에르토 리코",
        "PS": "팔레스타인",
        "PT": "포르투갈",
        "PW": "팔라우",
        "PY": "파라과이",
        "QA": "카타르",
        "RE": "재결합",
        "RO": "루마니아",
        "RS": "세르비아",
        "RU": "러시아",
        "RW": "르완다",
        "SA": "사우디 아라비아",
        "SB": "솔로몬 제도",
        "SC": "세이셸",
        "SD": "수단",
        "SE": "스웨덴",
        "SG": "싱가포르",
        "SH": "세인트 헬레나",
        "SI": "슬로베니아",
        "SJ": "스발 바르",
        "SK": "슬로바키아",
        "SL": "시에라 리온",
        "SM": "산 마리노",
        "SN": "세네갈",
        "SO": "소말리아",
        "SR": "수리남",
        "SS": "남 수단",
        "ST": "상투 메 프린시 페",
        "SV": "엘살바도르",
        "SX": "세인트 마틴",
        "SY": "시리아",
        "SZ": "스와질란드",
        "TC": "터크 스 케이 커스 제도",
        "TD": "차드",
        "TG": "토고",
        "TH": "태국",
        "TJ": "타지키스탄",
        "TK": "토켈 라우",
        "TL": "동 티모르",
        "TM": "투르크 메니스탄",
        "TN": "튀니지",
        "TO": "통가",
        "TR": "터키",
        "TT": "트리니다드 토바고",
        "TV": "투발루",
        "TW": "대만",
        "TZ": "탄자니아",
        "UA": "우크라이나",
        "UG": "우간다",
        "US": "미국",
        "UY": "우루과이",
        "UZ": "우즈베키스탄",
        "VA": "교황청",
        "VC": "세인트 빈센트 그레나딘",
        "VE": "베네수엘라",
        "VG": "영국령 버진 아일랜드",
        "VI": "미국 버진 아일랜드",
        "VN": "베트남",
        "VU": "바누아투",
        "WF": "월리스 푸 투나",
        "WS": "사모아",
        "XK": "코소보",
        "YE": "예멘",
        "YT": "마 요트",
        "ZA": "남아프리카 공화국",
        "ZM": "잠비아",
        "ZW": "짐바브웨"
    },
    "msmy": {
        "AD": "Andorra",
        "AE": "United Arab Emirates",
        "AF": "Afghanistan",
        "AG": "Antigua dan Barbuda",
        "AI": "Anguilla",
        "AL": "Albania",
        "AM": "Armenia",
        "AN": "Antillen Belanda",
        "AO": "Angola",
        "AQ": "Antartika",
        "AR": "Argentina",
        "AS": "Samoa",
        "AT": "Austria",
        "AU": "Australia",
        "AW": "Aruba",
        "AZ": "Azerbaijan",
        "BA": "Bosnia dan Herzegovina",
        "BB": "Barbados",
        "BD": "Bangladesh",
        "BE": "Belgium",
        "BF": "Burkina Faso",
        "BG": "Bulgaria",
        "BH": "Bahrain",
        "BI": "Burundi",
        "BJ": "Benin",
        "BL": "Saint Barthelemy",
        "BM": "Bermuda",
        "BN": "Brunei",
        "BO": "Bolivia",
        "BR": "Brazil",
        "BS": "Bahamas",
        "BT": "Bhutan",
        "BW": "Botswana",
        "BY": "Belarus",
        "BZ": "Belize",
        "CA": "Kanada",
        "CC": "Kepulauan Cocos",
        "CD": "Republik Demokratik Congo",
        "CF": "Republik Afrika Tengah",
        "CG": "Republik Demokratik Congo",
        "CH": "Switzerland",
        "CI": "Ivory Coast",
        "CK": "Kepulauan Cook",
        "CL": "Chile",
        "CM": "Cameroon",
        "CN": "China",
        "CO": "Colombia",
        "CR": "Costa Rica",
        "CU": "Cuba",
        "CV": "Cape Verde",
        "CW": "Curacao",
        "CX": "Pulau Krismas",
        "CY": "Cyprus",
        "CZ": "Republik Czech",
        "DE": "Jerman",
        "DJ": "Djibouti",
        "DK": "Denmark",
        "DM": "Dominica",
        "DO": "Republik Dominican",
        "DZ": "Algeria",
        "EC": "Ecuador",
        "EE": "Estonia",
        "EG": "Mesir",
        "EH": "Sahara Barat",
        "ER": "Eritrea",
        "ES": "Sepanyol",
        "ET": "Ethiopia",
        "FI": "Finland",
        "FJ": "Fiji",
        "FK": "Kepulauan Falkland",
        "FM": "Micronesia",
        "FO": "Kepulauan Faroe",
        "FR": "Perancis",
        "GA": "Gabon",
        "GB": "English",
        "GD": "Grenada",
        "GE": "Georgia",
        "GG": "Guernsey",
        "GH": "Ghana",
        "GI": "Gibraltar",
        "GL": "Greenland",
        "GM": "Gambia",
        "GN": "Guinea",
        "GQ": "Guinea Khatulistiwa",
        "GR": "Greece",
        "GT": "Guatemala",
        "GU": "Guam",
        "GW": "Guinea-Bissau",
        "GY": "Guyana",
        "HK": "Hong Kong",
        "HN": "Honduras",
        "HR": "Croatia",
        "HT": "Haiti",
        "HU": "Hungary",
        "ID": "Indonesia",
        "IE": "Ireland",
        "IL": "Israel",
        "IM": "Isle of Man",
        "IN": "India",
        "IO": "British Indian Ocean Territory",
        "IQ": "Iraq",
        "IR": "Iran",
        "IS": "Iceland",
        "IT": "Italy",
        "JE": "New Jersey",
        "JM": "Jamaica",
        "JO": "Jordan",
        "JP": "Jepun",
        "KE": "Kenya",
        "KG": "Kyrgyzstan",
        "KH": "Kemboja",
        "KI": "Kiribati",
        "KM": "Comoros",
        "KN": "Saint Kitts dan Nevis",
        "KP": "Korea Utara",
        "KR": "Korea",
        "KW": "Kuwait",
        "KY": "Pulau Cayman",
        "KZ": "Kazakhstan",
        "LA": "Laos",
        "LB": "Lebanon",
        "LC": "Saint Lucia",
        "LI": "Liechtenstein",
        "LK": "Sri Lanka",
        "LR": "Liberia",
        "LS": "Lesotho",
        "LT": "Lithuania",
        "LU": "Luxembourg",
        "LV": "Latvia",
        "LY": "Libya",
        "MA": "Morocco",
        "MC": "Monaco",
        "MD": "Moldova",
        "ME": "Montenegro",
        "MF": "San Martin",
        "MG": "Madagascar",
        "MH": "Kepulauan Marshall",
        "MK": "Macedonia",
        "ML": "Mali",
        "MM": "Myanmar",
        "MN": "Mongolia",
        "MO": "Macao",
        "MP": "Kepulauan Mariana Utara",
        "MR": "Mauritania",
        "MS": "Montserrat",
        "MT": "Malta",
        "MU": "Mauritius",
        "MV": "Maldives",
        "MW": "Malawi",
        "MX": "Mexico",
        "MY": "Malaysia",
        "MZ": "Mozambique",
        "NA": "Namibia",
        "NC": "New Caledonia",
        "NE": "Niger",
        "NG": "Nigeria",
        "NI": "Nicaragua",
        "NL": "Belanda",
        "NO": "Norway",
        "NP": "Nepal",
        "NR": "Nauru",
        "NU": "Niue",
        "NZ": "New Zealand",
        "OM": "Oman",
        "PA": "Panama",
        "PE": "Peru",
        "PF": "Polynesia Perancis",
        "PG": "Papua New Guinea",
        "PH": "filipina",
        "PK": "pakistan",
        "PL": "Poland",
        "PM": "Saint Pierre dan Miquelon",
        "PN": "Pitcairn",
        "PR": "Puerto Rico",
        "PS": "Palestin",
        "PT": "Portugal",
        "PW": "Palau",
        "PY": "Paraguay",
        "QA": "Qatar",
        "RE": "Reunion",
        "RO": "Romania",
        "RS": "Serbia",
        "RU": "Rusia",
        "RW": "Rwanda",
        "SA": "Arab Saudi",
        "SB": "Kepulauan Solomon",
        "SC": "Seychelles",
        "SD": "Sudan",
        "SE": "Sweden",
        "SG": "Singapura",
        "SH": "St. Helena",
        "SI": "Slovenia",
        "SJ": "Svalbard",
        "SK": "Slovakia",
        "SL": "Sierra Leone",
        "SM": "San Marino",
        "SN": "Senegal",
        "SO": "Somalia",
        "SR": "Surinam",
        "SS": "South Sudan",
        "ST": "Sao Tome dan Principe",
        "SV": "El Salvador",
        "SX": "Sint Maarten",
        "SY": "Syria",
        "SZ": "Swaziland",
        "TC": "Kepulauan Turks dan Caicos",
        "TD": "Chad",
        "TG": "Togo",
        "TH": "Thailand",
        "TJ": "Tajikistan",
        "TK": "Tokelau",
        "TL": "Timor Timur",
        "TM": "Turkmenistan",
        "TN": "Tunisia",
        "TO": "Tonga",
        "TR": "Turki",
        "TT": "Trinidad dan Tobago",
        "TV": "Tuvalu",
        "TW": "Taiwan",
        "TZ": "Tanzania",
        "UA": "Ukraine",
        "UG": "Uganda",
        "US": "Amerika Syarikat",
        "UY": "Uruguay",
        "UZ": "Uzbekistan",
        "VA": "Holy See",
        "VC": "Saint Vincent dan Grenadines",
        "VE": "Venezuela",
        "VG": "Kepulauan British Virgin",
        "VI": "Amerika Syarikat Kepulauan Virgin",
        "VN": "Vietnam",
        "VU": "Vanuatu",
        "WF": "Wallis dan Futuna",
        "WS": "Samoa",
        "XK": "Kosovo",
        "YE": "Yaman",
        "YT": "Mayotte",
        "ZA": "Afrika Selatan",
        "ZM": "Zambia",
        "ZW": "Zimbabwe"
    },
    "ptpt": {
        "AD": "Andorra",
        "AE": "Emirados Árabes Unidos",
        "AF": "Afeganistão",
        "AG": "Antígua e Barbuda",
        "AI": "Anguilla",
        "AL": "Albânia",
        "AM": "Armênia",
        "AN": "Antilhas Holandesas",
        "AO": "Angola",
        "AQ": "Antártica",
        "AR": "Argentina",
        "AS": "Samoa Americana",
        "AT": "Áustria",
        "AU": "Austrália",
        "AW": "Aruba",
        "AZ": "Azerbaijão",
        "BA": "Bósnia e Herzegovina",
        "BB": "Barbados",
        "BD": "Bangladesh",
        "BE": "Bélgica",
        "BF": "Burkina Faso",
        "BG": "Bulgária",
        "BH": "Bahrain",
        "BI": "Burundi",
        "BJ": "Benin",
        "BL": "saint Barthelemy",
        "BM": "Bermudas",
        "BN": "Brunei",
        "BO": "Bolívia",
        "BR": "Brasil",
        "BS": "Bahamas",
        "BT": "Butão",
        "BW": "Botswana",
        "BY": "Belarus",
        "BZ": "Belize",
        "CA": "Canadá",
        "CC": "Ilhas Cocos",
        "CD": "República Democrática do Congo",
        "CF": "Central Africano República",
        "CG": "República do Congo",
        "CH": "Suíça",
        "CI": "Costa do Marfim",
        "CK": "Ilhas Cook",
        "CL": "Chile",
        "CM": "Camarões",
        "CN": "China",
        "CO": "Colômbia",
        "CR": "Costa Rica",
        "CU": "Cuba",
        "CV": "cabo Verde",
        "CW": "Curacao",
        "CX": "Ilhas de Natal",
        "CY": "Chipre",
        "CZ": "República Checa",
        "DE": "Alemanha",
        "DJ": "Djibouti",
        "DK": "Dinamarca",
        "DM": "Dominica",
        "DO": "República Dominicana",
        "DZ": "Argélia",
        "EC": "Equador",
        "EE": "Estônia",
        "EG": "Egito",
        "EH": "Saara Ocidental",
        "ER": "Eritrea",
        "ES": "Espanha",
        "ET": "Etiópia",
        "FI": "Finlândia",
        "FJ": "Fiji",
        "FK": "Ilhas Falkland",
        "FM": "Micronesia",
        "FO": "ilhas Faroe",
        "FR": "França",
        "GA": "Gabão",
        "GB": "Reino Unido",
        "GD": "Grenada",
        "GE": "Georgia",
        "GG": "Guernsey",
        "GH": "Gana",
        "GI": "Gibraltar",
        "GL": "Groenlândia",
        "GM": "Gâmbia",
        "GN": "Guiné",
        "GQ": "Guiné Equatorial",
        "GR": "Grécia",
        "GT": "Guatemala",
        "GU": "Guam",
        "GW": "Guiné-Bissau",
        "GY": "Guiana",
        "HK": "Hong Kong",
        "HN": "Honduras",
        "HR": "Croácia",
        "HT": "Haiti",
        "HU": "Hungria",
        "ID": "Indonésia",
        "IE": "Irlanda",
        "IL": "Israel",
        "IM": "Isle of Man",
        "IN": "Índia",
        "IO": "Território Britânico do Oceano Índico",
        "IQ": "Iraque",
        "IR": "Irã",
        "IS": "Islândia",
        "IT": "Itália",
        "JE": "camisola",
        "JM": "Jamaica",
        "JO": "Jordânia",
        "JP": "Japão",
        "KE": "Quênia",
        "KG": "Quirguistão",
        "KH": "Camboja",
        "KI": "Kiribati",
        "KM": "Comores",
        "KN": "São Cristóvão e Nevis",
        "KP": "Coreia do Norte",
        "KR": "Coreia do Sul",
        "KW": "Kuweit",
        "KY": "Ilhas Cayman",
        "KZ": "Cazaquistão",
        "LA": "Laos",
        "LB": "Líbano",
        "LC": "Santa Lúcia",
        "LI": "Liechtenstein",
        "LK": "Sri Lanka",
        "LR": "Libéria",
        "LS": "Lesoto",
        "LT": "Lituânia",
        "LU": "Luxemburgo",
        "LV": "Letônia",
        "LY": "Líbia",
        "MA": "Marrocos",
        "MC": "Monaco",
        "MD": "Moldova",
        "ME": "Montenegro",
        "MF": "saint Martin",
        "MG": "Madagáscar",
        "MH": "Ilhas Marshall",
        "MK": "Macedónia",
        "ML": "Mali",
        "MM": "Myanmar",
        "MN": "Mongólia",
        "MO": "Macau",
        "MP": "Ilhas Marianas do Norte",
        "MR": "Mauritânia",
        "MS": "Montserrat",
        "MT": "Malta",
        "MU": "Mauritius",
        "MV": "Maldivas",
        "MW": "Malavi",
        "MX": "México",
        "MY": "Malásia",
        "MZ": "Moçambique",
        "NA": "Namíbia",
        "NC": "Nova Caledônia",
        "NE": "Níger",
        "NG": "Nigéria",
        "NI": "Nicarágua",
        "NL": "países Baixos",
        "NO": "Noruega",
        "NP": "Nepal",
        "NR": "Nauru",
        "NU": "Niue",
        "NZ": "Nova Zelândia",
        "OM": "Omã",
        "PA": "Panamá",
        "PE": "Peru",
        "PF": "Polinésia Francesa",
        "PG": "Papua Nova Guiné",
        "PH": "Filipinas",
        "PK": "Paquistão",
        "PL": "Polônia",
        "PM": "Saint Pierre e Miquelon",
        "PN": "Pitcairn",
        "PR": "Porto Rico",
        "PS": "Palestina",
        "PT": "Portugal",
        "PW": "Palau",
        "PY": "Paraguai",
        "QA": "Catar",
        "RE": "Reunião",
        "RO": "Romênia",
        "RS": "Sérvia",
        "RU": "Rússia",
        "RW": "Ruanda",
        "SA": "Arábia Saudita",
        "SB": "Ilhas Salomão",
        "SC": "Seychelles",
        "SD": "Sudão",
        "SE": "Suécia",
        "SG": "Cingapura",
        "SH": "Santa Helena",
        "SI": "Eslovenia",
        "SJ": "Svalbard e Jan Mayen",
        "SK": "Eslováquia",
        "SL": "Serra Leoa",
        "SM": "San Marino",
        "SN": "Senegal",
        "SO": "Somália",
        "SR": "Suriname",
        "SS": "Sudão do Sul",
        "ST": "São Tomé e Príncipe",
        "SV": "El Salvador",
        "SX": "Sint Maarten",
        "SY": "Síria",
        "SZ": "Suazilândia",
        "TC": "Ilhas Turks e Caicos",
        "TD": "Chade",
        "TG": "Ir",
        "TH": "Tailândia",
        "TJ": "Tajiquistão",
        "TK": "Tokelau",
        "TL": "Timor Leste",
        "TM": "Turquemenistão",
        "TN": "Tunísia",
        "TO": "Tonga",
        "TR": "Turquia",
        "TT": "Trinidad e Tobago",
        "TV": "Tuvalu",
        "TW": "Taiwan",
        "TZ": "Tanzânia",
        "UA": "Ucrânia",
        "UG": "Uganda",
        "US": "Estados Unidos",
        "UY": "Uruguai",
        "UZ": "Uzbequistão",
        "VA": "Vaticano",
        "VC": "São Vicente e Granadinas",
        "VE": "Venezuela",
        "VG": "Ilhas Virgens Britânicas",
        "VI": "Ilhas Virgens Americanas",
        "VN": "Vietnã",
        "VU": "Vanuatu",
        "WF": "Wallis e Futuna",
        "WS": "Samoa",
        "XK": "Kosovo",
        "YE": "Iémen",
        "YT": "Mayotte",
        "ZA": "África do Sul",
        "ZM": "Zâmbia",
        "ZW": "Zimbábue"
    },
    "ruru": {
        "AD": "андорра",
        "AE": "Объединенные Арабские Эмираты",
        "AF": "Афганистан",
        "AG": "Антигуа и Барбуда",
        "AI": "Ангилья",
        "AL": "Албания",
        "AM": "Армения",
        "AN": "Нидерландские Антильские острова",
        "AO": "Ангола",
        "AQ": "Антарктида",
        "AR": "Аргентина",
        "AS": "Самоа",
        "AT": "Австрия",
        "AU": "Австралия",
        "AW": "Аруба",
        "AZ": "Азербайджан",
        "BA": "Босния и Герцеговина",
        "BB": "Барбадос",
        "BD": "Бангладеш",
        "BE": "Бельгия",
        "BF": "Буркина-Фасо",
        "BG": "Болгария",
        "BH": "Бахрейн",
        "BI": "Бурунди",
        "BJ": "Бенин",
        "BL": "Сен-Бартельми",
        "BM": "Бермудские острова",
        "BN": "Бруней",
        "BO": "Боливия",
        "BR": "Бразилия",
        "BS": "Багамские о-ва",
        "BT": "Бутан",
        "BW": "Ботсвана",
        "BY": "Беларусь",
        "BZ": "Белиз",
        "CA": "Канада",
        "CC": "Кокосовые острова",
        "CD": "Демократическая Республика Конго",
        "CF": "Центрально-Африканская Республика",
        "CG": "Демократическая Республика Конго",
        "CH": "Швейцария",
        "CI": "Берег Слоновой Кости",
        "CK": "Острова Кука",
        "CL": "Чили",
        "CM": "Камерун",
        "CN": "Китай",
        "CO": "Колумбия",
        "CR": "Коста-Рика",
        "CU": "Куба",
        "CV": "Кабо-Верде",
        "CW": "ликер кюрасо",
        "CX": "Рождественские острова",
        "CY": "Кипр",
        "CZ": "Чехия",
        "DE": "Германия",
        "DJ": "Джибути",
        "DK": "Дания",
        "DM": "Доминика",
        "DO": "Доминиканская Республика",
        "DZ": "Алжир",
        "EC": "Эквадор",
        "EE": "Эстония",
        "EG": "Египет",
        "EH": "Западная Сахара",
        "ER": "Эритрея",
        "ES": "Испания",
        "ET": "Эфиопия",
        "FI": "Финляндия",
        "FJ": "Фиджи",
        "FK": "Фолклендские острова",
        "FM": "Микронезия",
        "FO": "Фарерские острова",
        "FR": "Франция",
        "GA": "Габон",
        "GB": "английский",
        "GD": "Гренада",
        "GE": "Грузия",
        "GG": "шерстяная фуфайка",
        "GH": "Гана",
        "GI": "Гибралтар",
        "GL": "Гренландия",
        "GM": "Гамбия",
        "GN": "Гвинея",
        "GQ": "Экваториальная Гвинея",
        "GR": "Греция",
        "GT": "Гватемала",
        "GU": "Гуам",
        "GW": "Гвинея-Бисау",
        "GY": "Гайана",
        "HK": "Гонконг",
        "HN": "Гондурас",
        "HR": "Хорватия",
        "HT": "Гаити",
        "HU": "Венгрия",
        "ID": "Индонезия",
        "IE": "Ирландия",
        "IL": "Израиль",
        "IM": "Остров Мэн",
        "IN": "Индия",
        "IO": "Британская территория в Индийском океане",
        "IQ": "Ирак",
        "IR": "Иран",
        "IS": "Исландия",
        "IT": "Италия",
        "JE": "Нью-Джерси",
        "JM": "Ямайка",
        "JO": "Иордания",
        "JP": "Япония",
        "KE": "Кения",
        "KG": "Киргизия",
        "KH": "Камбоджа",
        "KI": "Кирибати",
        "KM": "Коморские острова",
        "KN": "Сент-Китс и Невис",
        "KP": "Северная Корея",
        "KR": "Корея",
        "KW": "Кувейт",
        "KY": "Каймановы острова",
        "KZ": "Казахстан",
        "LA": "Лаос",
        "LB": "Ливан",
        "LC": "Сент-Люсия",
        "LI": "Лихтенштейн",
        "LK": "Шри Ланка",
        "LR": "Либерия",
        "LS": "Лесото",
        "LT": "Литва",
        "LU": "Люксембург",
        "LV": "Латвия",
        "LY": "Ливия",
        "MA": "Марокко",
        "MC": "Монако",
        "MD": "Молдова",
        "ME": "Черногория",
        "MF": "Сан - Мартин",
        "MG": "Мадагаскар",
        "MH": "Маршалловы острова",
        "MK": "Македония",
        "ML": "Мали",
        "MM": "Мьянма",
        "MN": "Монголия",
        "MO": "Macao",
        "MP": "Северные Марианские острова",
        "MR": "Мавритания",
        "MS": "Монсеррат",
        "MT": "Мальта",
        "MU": "Маврикий",
        "MV": "Мальдивы",
        "MW": "Малави",
        "MX": "Мексика",
        "MY": "Малайзия",
        "MZ": "Мозамбик",
        "NA": "Намибия",
        "NC": "Новая Каледония",
        "NE": "Нигер",
        "NG": "Нигерия",
        "NI": "Никарагуа",
        "NL": "Нидерланды",
        "NO": "Норвегия",
        "NP": "Непал",
        "NR": "Науру",
        "NU": "Niue",
        "NZ": "Новая Зеландия",
        "OM": "Оман",
        "PA": "Панама",
        "PE": "Перу",
        "PF": "Французская Полинезия",
        "PG": "Папуа-Новая Гвинея",
        "PH": "Филиппины",
        "PK": "Пакистан",
        "PL": "Польша",
        "PM": "Сен-Пьер и Микелон",
        "PN": "Питкэрн",
        "PR": "Пуэрто-Рико",
        "PS": "Палестина",
        "PT": "Португалия",
        "PW": "Palau",
        "PY": "Парагвай",
        "QA": "Катар",
        "RE": "воссоединение",
        "RO": "Румыния",
        "RS": "Сербия",
        "RU": "Россия",
        "RW": "Руанда",
        "SA": "Саудовская Аравия",
        "SB": "Соломоновы острова",
        "SC": "Сейшельские острова",
        "SD": "Судан",
        "SE": "Швеция",
        "SG": "Сингапур",
        "SH": "Святой Елены",
        "SI": "Словения",
        "SJ": "Шпицберген",
        "SK": "Словакия",
        "SL": "Сьерра-Леоне",
        "SM": "Сан - Марино",
        "SN": "Сенегал",
        "SO": "Сомали",
        "SR": "Суринам",
        "SS": "Южный Судан",
        "ST": "Сан-Томе и Принсипи",
        "SV": "Сальвадор",
        "SX": "Синт-Маартен",
        "SY": "Сирия",
        "SZ": "Свазиленд",
        "TC": "Острова Теркс и Кайкос",
        "TD": "Чад",
        "TG": "Того",
        "TH": "Таиланд",
        "TJ": "Таджикистан",
        "TK": "Токелау",
        "TL": "Восточный Тимор",
        "TM": "Туркменистан",
        "TN": "Тунис",
        "TO": "Тонга",
        "TR": "Турция",
        "TT": "Тринидад и Тобаго",
        "TV": "Тувалу",
        "TW": "Тайвань",
        "TZ": "Танзания",
        "UA": "Украина",
        "UG": "Уганда",
        "US": "США",
        "UY": "Уругвай",
        "UZ": "Узбекистан",
        "VA": "папский престол",
        "VC": "Сент-Винсент и Гренадины",
        "VE": "Венесуэла",
        "VG": "Британские Виргинские острова",
        "VI": "Виргинские острова Соединенных Штатов",
        "VN": "Вьетнам",
        "VU": "Вануату",
        "WF": "Уоллис и Футуна",
        "WS": "Самоа",
        "XK": "Косово",
        "YE": "Йемен",
        "YT": "Майотта",
        "ZA": "ЮАР",
        "ZM": "Замбия",
        "ZW": "Зимбабве"
    },
    "thth": {
        "AD": "อันดอร์รา",
        "AE": "สหรัฐอาหรับเอมิ",
        "AF": "อัฟกานิสถาน",
        "AG": "แอนติกาและบาร์บูดา",
        "AI": "แองกวิลลา",
        "AL": "แอลเบเนีย",
        "AM": "อาร์เมเนีย",
        "AN": "เนเธอร์แลนด์",
        "AO": "แองโกลา",
        "AQ": "ทวิปแอนตาร์กติกา",
        "AR": "อาร์เจนตินา",
        "AS": "ซามัว",
        "AT": "ออสเตรีย",
        "AU": "ออสเตรเลีย",
        "AW": "อารูบา",
        "AZ": "อาเซอร์ไบจาน",
        "BA": "บอสเนียและเฮอร์เซ",
        "BB": "บาร์เบโดส",
        "BD": "บังคลาเทศ",
        "BE": "เบลเยียม",
        "BF": "Burkina Faso",
        "BG": "บัลแกเรีย",
        "BH": "บาห์เรน",
        "BI": "บุรุนดี",
        "BJ": "ประเทศเบนิน",
        "BL": "เซนต์บาร์เธเล",
        "BM": "เบอร์มิวดา",
        "BN": "บรูไน",
        "BO": "โบลิเวีย",
        "BR": "บราซิล",
        "BS": "บาฮามาส",
        "BT": "ภูฏาน",
        "BW": "บอตสวานา",
        "BY": "เบลารุส",
        "BZ": "เบลีซ",
        "CA": "แคนาดา",
        "CC": "หมู่เกาะโคโค",
        "CD": "สาธารณรัฐประชาธิปไตยคองโก",
        "CF": "สาธารณรัฐแอฟริกากลาง",
        "CG": "สาธารณรัฐประชาธิปไตยคองโก",
        "CH": "ประเทศสวิสเซอร์แลนด์",
        "CI": "ไอวอรี่โคส",
        "CK": "หมู่เกาะคุก",
        "CL": "ชิลี",
        "CM": "แคเมอรูน",
        "CN": "ประเทศจีน",
        "CO": "โคลอมเบีย",
        "CR": "คอสตาริก้า",
        "CU": "คิวบา",
        "CV": "เคปเวิร์ด",
        "CW": "คูราเซา",
        "CX": "เกาะคริสต์มาส",
        "CY": "ประเทศไซปรัส",
        "CZ": "สาธารณรัฐเช็ก",
        "DE": "ประเทศเยอรมัน",
        "DJ": "จิบูตี",
        "DK": "เดนมาร์ก",
        "DM": "โดมินิกา",
        "DO": "สาธารณรัฐโดมินิกัน",
        "DZ": "แอลจีเรีย",
        "EC": "เอกวาดอร์",
        "EE": "เอสโตเนีย",
        "EG": "อียิปต์",
        "EH": "ซาฮาราตะวันตก",
        "ER": "เอริเทรี",
        "ES": "สเปน",
        "ET": "สาธารณรัฐเอธิโอเปีย",
        "FI": "ฟินแลนด์",
        "FJ": "ฟิจิ",
        "FK": "หมู่เกาะฟอล์คแลนด์",
        "FM": "ไมโครนีเซีย",
        "FO": "หมู่เกาะแฟโร",
        "FR": "ฝรั่งเศส",
        "GA": "ประเทศกาบอง",
        "GB": "อังกฤษ",
        "GD": "เกรเนดา",
        "GE": "จอร์เจีย",
        "GG": "เสื้อไหมพรม",
        "GH": "ประเทศกานา",
        "GI": "ยิบรอลตา",
        "GL": "เกาะกรีนแลนด์",
        "GM": "แกมเบีย",
        "GN": "ประเทศกินี",
        "GQ": "ทอเรียลกินี",
        "GR": "กรีก",
        "GT": "กัวเตมาลา",
        "GU": "กวม",
        "GW": "กินีบิสเซา",
        "GY": "กายอานา",
        "HK": "ฮ่องกง",
        "HN": "ฮอนดูรัส",
        "HR": "โครเอเชีย",
        "HT": "ไฮติ",
        "HU": "ฮังการี",
        "ID": "อินโดนีเซีย",
        "IE": "ไอร์แลนด์",
        "IL": "อิสราเอล",
        "IM": "เกาะ Isle of Man",
        "IN": "อินเดีย",
        "IO": "เขตมหาสมุทรบริติชอินเดีย",
        "IQ": "อิรัก",
        "IR": "อิหร่าน",
        "IS": "ประเทศไอซ์แลนด์",
        "IT": "อิตาลี",
        "JE": "รัฐนิวเจอร์ซีย์",
        "JM": "เกาะจาเมกา",
        "JO": "จอร์แดน",
        "JP": "ประเทศญี่ปุ่น",
        "KE": "ประเทศเคนย่า",
        "KG": "คีร์กีสถาน",
        "KH": "กัมพูชา",
        "KI": "ประเทศคิริบาส",
        "KM": "คอโมโรส",
        "KN": "เซนต์คิตส์และเนวิส",
        "KP": "เกาหลีเหนือ",
        "KR": "เกาหลี",
        "KW": "คูเวต",
        "KY": "หมู่เกาะเคย์เเมน",
        "KZ": "คาซัคสถาน",
        "LA": "ลาว",
        "LB": "เลบานอน",
        "LC": "เซนต์ลูเซีย",
        "LI": "นสไตน์",
        "LK": "ศรีลังกา",
        "LR": "ประเทศไลบีเรีย",
        "LS": "เลโซโท",
        "LT": "ประเทศลิธัวเนีย",
        "LU": "ลักเซมเบิร์ก",
        "LV": "ลัตเวีย",
        "LY": "ประเทศลิบยา",
        "MA": "โมร็อกโก",
        "MC": "โมนาโก",
        "MD": "มอลโดวา",
        "ME": "มอนเตเนโก",
        "MF": "San Martin",
        "MG": "มาดากัสการ์",
        "MH": "หมู่เกาะมาร์แชลล์",
        "MK": "มาซิโดเนีย",
        "ML": "มาลี",
        "MM": "พม่า",
        "MN": "ประเทศมองโกเลีย",
        "MO": "มาเก๊า",
        "MP": "หมู่เกาะมาเรียนาเหนือ",
        "MR": "ประเทศมอริเตเนีย",
        "MS": "มอนต์เซอร์รัต",
        "MT": "เกาะมอลตา",
        "MU": "มอริเชียส",
        "MV": "มัลดีฟส์",
        "MW": "มาลาวี",
        "MX": "เม็กซิโก",
        "MY": "ประเทศมาเลเซีย",
        "MZ": "ประเทศโมซัมบิก",
        "NA": "นามิเบีย",
        "NC": "New Caledonia",
        "NE": "ประเทศไนเธอร์",
        "NG": "ประเทศไนจีเรีย",
        "NI": "นิการากัว",
        "NL": "เนเธอร์แลนด์",
        "NO": "นอร์เวย์",
        "NP": "ประเทศเนปาล",
        "NR": "ประเทศนาอูรู",
        "NU": "นีอูเอ",
        "NZ": "นิวซีแลนด์",
        "OM": "โอมาน",
        "PA": "ปานามา",
        "PE": "เปรู",
        "PF": "french Polynesia",
        "PG": "ปาปัวนิวกินี",
        "PH": "ฟิลิปปินส์",
        "PK": "ประเทศปากีสถาน",
        "PL": "โปแลนด์",
        "PM": "เซนต์ปิแอร์และมีเกอลง",
        "PN": "พิตแคร์น",
        "PR": "เปอร์โตริโก",
        "PS": "ปาเลสไตน์",
        "PT": "โปรตุเกส",
        "PW": "ปาเลา",
        "PY": "ประเทศแพรากเว",
        "QA": "กาตาร์",
        "RE": "การรวมตัวใหม่",
        "RO": "โรมาเนีย",
        "RS": "เซอร์เบีย",
        "RU": "รัสเซีย",
        "RW": "รวันดา",
        "SA": "ประเทศซาอุดีอาระเบีย",
        "SB": "หมู่เกาะโซโลมอน",
        "SC": "เซเชลส์",
        "SD": "ซูดาน",
        "SE": "สวีเดน",
        "SG": "สิงคโปร์",
        "SH": "เซนต์เฮเลนา",
        "SI": "สโลวีเนีย",
        "SJ": "สวาลบาร์ด",
        "SK": "สโลวะเกีย",
        "SL": "เซียร์ราลีโอน",
        "SM": "ซานมารีโน",
        "SN": "ประเทศเซเนกัล",
        "SO": "โซมาเลีย",
        "SR": "ซูรินาเม",
        "SS": "ซูดานใต้",
        "ST": "Sao Tome Principe และ",
        "SV": "เอลซัลวาดอร์",
        "SX": "เซนต์มาติน",
        "SY": "ซีเรีย",
        "SZ": "สวาซิแลนด์",
        "TC": "เติกส์และหมู่เกาะไคคอส",
        "TD": "ชาด",
        "TG": "โตโก",
        "TH": "ประเทศไทย",
        "TJ": "ทาจิกิสถาน",
        "TK": "โตเกเลา",
        "TL": "ประเทศติมอร์ตะวันออก",
        "TM": "เติร์กเมนิสถาน",
        "TN": "ตูนิเซีย",
        "TO": "ตองกา",
        "TR": "ตุรกี",
        "TT": "ตรินิแดดและโตเบโก",
        "TV": "ตูวาลู",
        "TW": "ไต้หวัน",
        "TZ": "ประเทศแทนซาเนีย",
        "UA": "ยูเครน",
        "UG": "ยูกันดา",
        "US": "ประเทศสหรัฐอเมริกา",
        "UY": "อุรุกวัย",
        "UZ": "อุซเบกิ",
        "VA": "พระเห็น",
        "VC": "เซนต์วินเซนต์และเกรนาดีน",
        "VE": "เวเนซุเอลา",
        "VG": "หมู่เกาะบริติชเวอร์จิน",
        "VI": "หมู่เกาะเวอร์จินของสหรัฐอเมริกา",
        "VN": "เวียดนาม",
        "VU": "วานูอาตู",
        "WF": "วาลลิสและฟุตูนา",
        "WS": "ซามัว",
        "XK": "โคโซโว",
        "YE": "เยเมน",
        "YT": "มายอต",
        "ZA": "แอฟริกาใต้",
        "ZM": "ประเทศแซมเบีย",
        "ZW": "ประเทศซิมบับเว"
    },
    "trtr": {
        "AD": "Andorra",
        "AE": "Birleşik Arap Emirlikleri",
        "AF": "Afganistan",
        "AG": "Antigua ve Barbuda",
        "AI": "Anguilla",
        "AL": "Arnavutluk",
        "AM": "Ermenistan",
        "AN": "Hollanda Antilleri",
        "AO": "Angora",
        "AQ": "Antarktika",
        "AR": "Arjantin",
        "AS": "Samoa",
        "AT": "Avusturya",
        "AU": "Avustralya",
        "AW": "Aruba",
        "AZ": "Azerbeycan",
        "BA": "Bosna Hersek",
        "BB": "Barbados",
        "BD": "Bangladeş",
        "BE": "Belçika",
        "BF": "Burkina Faso",
        "BG": "Bulgaristan",
        "BH": "Bahreyn",
        "BI": "Burundi",
        "BJ": "benin",
        "BL": "Aziz Barthelemy",
        "BM": "Bermuda",
        "BN": "Brunei",
        "BO": "Bolivya",
        "BR": "Brezilya",
        "BS": "Bahamalar",
        "BT": "Butan",
        "BW": "Botsvana",
        "BY": "Beyaz rusya",
        "BZ": "Belize",
        "CA": "Kanada",
        "CC": "Cocos Adaları",
        "CD": "Demokratik Kongo Cumhuriyeti",
        "CF": "Orta Afrika Cumhuriyeti",
        "CG": "Demokratik Kongo Cumhuriyeti",
        "CH": "İsviçre",
        "CI": "Fildişi Sahili",
        "CK": "Cook Adaları",
        "CL": "Şili",
        "CM": "Kamerun",
        "CN": "Çin",
        "CO": "Kolombiya",
        "CR": "Kostarika",
        "CU": "Küba",
        "CV": "Cape Verde",
        "CW": "Curacao",
        "CX": "Noel Adaları",
        "CY": "Kıbrıs",
        "CZ": "Çek Cumhuriyeti",
        "DE": "Almanya",
        "DJ": "Cibuti",
        "DK": "Danimarka",
        "DM": "Dominika",
        "DO": "Dominik Cumhuriyeti",
        "DZ": "Cezayir",
        "EC": "Ekvador",
        "EE": "Estonya",
        "EG": "Mısır",
        "EH": "Batı Sahra",
        "ER": "Eritre",
        "ES": "İspanya",
        "ET": "Etiyopya",
        "FI": "Finlandiya",
        "FJ": "Fiji",
        "FK": "Falkland Adaları",
        "FM": "Mikronezya",
        "FO": "Faroe Adaları",
        "FR": "Fransa",
        "GA": "Gabon",
        "GB": "İngilizce",
        "GD": "Grenada",
        "GE": "Georgia",
        "GG": "bir tür inek",
        "GH": "Gana",
        "GI": "Cebelitarık",
        "GL": "Grönland",
        "GM": "Gambiya",
        "GN": "Gine",
        "GQ": "Ekvator Ginesi",
        "GR": "Yunanistan",
        "GT": "Guatemala",
        "GU": "Guam",
        "GW": "Gine-Bissau",
        "GY": "Guyana",
        "HK": "Hong Kong",
        "HN": "Honduras",
        "HR": "Hırvatistan",
        "HT": "Haiti",
        "HU": "Macaristan",
        "ID": "Endonezya",
        "IE": "İrlanda",
        "IL": "İsrail",
        "IM": "Isle of Man",
        "IN": "Hindistan",
        "IO": "İngiliz Hint Okyanusu Toprakları",
        "IQ": "Irak",
        "IR": "İran",
        "IS": "İzlanda",
        "IT": "İtalya",
        "JE": "New Jersey",
        "JM": "Jamaika",
        "JO": "Ürdün",
        "JP": "Japonya",
        "KE": "Kenya",
        "KG": "Kırgızistan",
        "KH": "Kamboçya",
        "KI": "Kiribati",
        "KM": "Komorlar",
        "KN": "Saint Kitts and Nevis",
        "KP": "Kuzey Kore",
        "KR": "Kore",
        "KW": "Kuveyt",
        "KY": "Cayman Adaları",
        "KZ": "kazakistan",
        "LA": "Laos",
        "LB": "Lübnan",
        "LC": "Lucia",
        "LI": "Liechtenstein",
        "LK": "Sri Lanka",
        "LR": "Liberya",
        "LS": "Lesotho",
        "LT": "Litvanya",
        "LU": "Lüksemburg",
        "LV": "Letonya",
        "LY": "Libya",
        "MA": "Fas",
        "MC": "Monako",
        "MD": "Moldova",
        "ME": "Karadağ",
        "MF": "San Martin",
        "MG": "Madagaskar",
        "MH": "Marshall Adaları",
        "MK": "Makedonya",
        "ML": "Mali",
        "MM": "Myanmar",
        "MN": "Moğolistan",
        "MO": "Macao",
        "MP": "Kuzey Mariana Adaları",
        "MR": "Moritanya",
        "MS": "Montserrat",
        "MT": "Malta",
        "MU": "Mauritius",
        "MV": "Maldivler",
        "MW": "Malawi",
        "MX": "Meksika",
        "MY": "Malezya",
        "MZ": "Mozambik",
        "NA": "Namibya",
        "NC": "yeni Kaledonya",
        "NE": "Nijer",
        "NG": "Nijerya",
        "NI": "Nikaragua",
        "NL": "Hollanda",
        "NO": "Norveç",
        "NP": "Nepal",
        "NR": "Nauru",
        "NU": "Niue",
        "NZ": "Yeni Zelanda",
        "OM": "Umman",
        "PA": "Panama",
        "PE": "Peru",
        "PF": "Fransız Polinezyası",
        "PG": "Papua Yeni Gine",
        "PH": "Filipinler",
        "PK": "Pakistan",
        "PL": "Polonya",
        "PM": "Aziz Pierre ve Miquelon",
        "PN": "Pitcairn",
        "PR": "Portoriko",
        "PS": "Filistin",
        "PT": "Portekiz",
        "PW": "Palau",
        "PY": "Paraguay",
        "QA": "Katar",
        "RE": "birleşme",
        "RO": "Romanya",
        "RS": "Sırbistan",
        "RU": "Rusya",
        "RW": "Ruanda",
        "SA": "Suudi Arabistan",
        "SB": "Solomon Adaları",
        "SC": "Seyşeller",
        "SD": "Sudan",
        "SE": "İsveç",
        "SG": "Singapur",
        "SH": "Helena",
        "SI": "Slovenya",
        "SJ": "Svalbard",
        "SK": "Slovakya",
        "SL": "Sierra Leone",
        "SM": "San Marino",
        "SN": "Senegal",
        "SO": "Somali",
        "SR": "Surinam",
        "SS": "Güney Sudan'ın",
        "ST": "Sao Tome ve Principe",
        "SV": "El Salvador",
        "SX": "Sint Maarten",
        "SY": "Suriye",
        "SZ": "Svaziland",
        "TC": "Turks ve Caicos Adaları",
        "TD": "Çad",
        "TG": "Togo",
        "TH": "Tayland",
        "TJ": "Tacikistan",
        "TK": "Tokelau",
        "TL": "Doğu Timor",
        "TM": "Türkmenistan",
        "TN": "Tunus",
        "TO": "Tonga",
        "TR": "Türkiye",
        "TT": "Trinidad ve Tobago",
        "TV": "Tuvalu",
        "TW": "Tayvan",
        "TZ": "Tanzanya",
        "UA": "Ukrayna",
        "UG": "Uganda",
        "US": "Birleşik Devletler",
        "UY": "Uruguay",
        "UZ": "Özbekistan",
        "VA": "Holy See",
        "VC": "Saint Vincent ve Grenadines",
        "VE": "Venezuela",
        "VG": "İngiliz Virgin Adaları",
        "VI": "Amerika Birleşik Devletleri Virgin Adaları",
        "VN": "Vietnam",
        "VU": "Vanuatu",
        "WF": "Wallis ve Futuna",
        "WS": "Samoa",
        "XK": "Kosova",
        "YE": "Yemen",
        "YT": "Mayotte",
        "ZA": "Güney Afrika",
        "ZM": "Zambiya",
        "ZW": "Zimbabve"
    },
    "vivn": {
        "AD": "Andorra",
        "AE": "Các Tiểu Vương Quốc Ả Rập Thống Nhất",
        "AF": "Afghanistan",
        "AG": "Antigua và Barbuda",
        "AI": "Anguilla",
        "AL": "Albania",
        "AM": "Armenia",
        "AN": "Antille thuộc Hà Lan",
        "AO": "Angola",
        "AQ": "Nam Cực",
        "AR": "Argentina",
        "AS": "American Samoa",
        "AT": "Áo",
        "AU": "Châu Úc",
        "AW": "Aruba",
        "AZ": "Azerbaijan",
        "BA": "Bosnia và Herzegovina",
        "BB": "Barbados",
        "BD": "Bangladesh",
        "BE": "Bỉ",
        "BF": "Burkina Faso",
        "BG": "Bulgaria",
        "BH": "Bahrain",
        "BI": "Burundi",
        "BJ": "Benin",
        "BL": "Saint Barthelemy",
        "BM": "Bermuda",
        "BN": "Brunei",
        "BO": "Bolivia",
        "BR": "Brazil",
        "BS": "Bahamas",
        "BT": "Bhutan",
        "BW": "Botswana",
        "BY": "Belarus",
        "BZ": "Belize",
        "CA": "Canada",
        "CC": "Quần đảo Cocos",
        "CD": "Cộng Hòa Dân Chủ Congo",
        "CF": "Cộng Hòa Trung Phi",
        "CG": "Cộng Hòa Congo",
        "CH": "Thụy sĩ",
        "CI": "Bờ Biển Ngà",
        "CK": "Quần đảo Cook",
        "CL": "Chile",
        "CM": "Cameroon",
        "CN": "Trung Quốc",
        "CO": "Colombia",
        "CR": "Costa Rica",
        "CU": "Cuba",
        "CV": "Cape Verde",
        "CW": "Curacao",
        "CX": "Christmas Islands",
        "CY": "Cyprus",
        "CZ": "Cộng Hòa Séc",
        "DE": "Đức",
        "DJ": "Djibouti",
        "DK": "Đan Mạch",
        "DM": "Dominica",
        "DO": "Cộng Hòa Dominica",
        "DZ": "Algeria",
        "EC": "Ecuador",
        "EE": "Estonia",
        "EG": "Ai Cập",
        "EH": "Tây Sahara",
        "ER": "Eritrea",
        "ES": "Tây Ban Nha",
        "ET": "Ethiopia",
        "FI": "Phần Lan",
        "FJ": "Fiji",
        "FK": "Quần đảo Falkland",
        "FM": "Micronesia",
        "FO": "Quần đảo Faroe",
        "FR": "Pháp",
        "GA": "Gabon",
        "GB": "Vương quốc Anh",
        "GD": "Grenada",
        "GE": "Georgia",
        "GG": "Guernsey",
        "GH": "Ghana",
        "GI": "Gibraltar",
        "GL": "Greenland",
        "GM": "Gambia",
        "GN": "Guinea",
        "GQ": "Equatorial Guinea",
        "GR": "Hy Lạp",
        "GT": "Guatemala",
        "GU": "Guam",
        "GW": "Guinea-Bissau",
        "GY": "Guyana",
        "HK": "Hồng Kông",
        "HN": "Honduras",
        "HR": "Croatia",
        "HT": "Haiti",
        "HU": "Hungary",
        "ID": "Indonesia",
        "IE": "Ireland",
        "IL": "Israel",
        "IM": "Isle of Man",
        "IN": "Ấn Độ",
        "IO": "Lãnh thổ Anh tại Ấn Độ Dương",
        "IQ": "Iraq",
        "IR": "Iran",
        "IS": "Iceland",
        "IT": "Ý",
        "JE": "Jersey",
        "JM": "Jamaica",
        "JO": "Jordan",
        "JP": "Nhật Bản",
        "KE": "Kenya",
        "KG": "Kyrgyzstan",
        "KH": "Campuchia",
        "KI": "Kiribati",
        "KM": "Comoros",
        "KN": "Saint Kitts và Nevis",
        "KP": "Bắc Triều Tiên",
        "KR": "Hàn Quốc",
        "KW": "Kuwait",
        "KY": "Quần đảo Cayman",
        "KZ": "Kazakhstan",
        "LA": "Lào",
        "LB": "Lebanon",
        "LC": "Saint Lucia",
        "LI": "Liechtenstein",
        "LK": "Sri Lanka",
        "LR": "Liberia",
        "LS": "Lesotho",
        "LT": "Lithuania",
        "LU": "Luxembourg",
        "LV": "Latvia",
        "LY": "Libya",
        "MA": "Morocco",
        "MC": "Monaco",
        "MD": "Moldova",
        "ME": "Montenegro",
        "MF": "Saint Martin",
        "MG": "Madagascar",
        "MH": "Đảo Marshall",
        "MK": "Macedonia",
        "ML": "Mali",
        "MM": "Myanmar",
        "MN": "Mông Cổ",
        "MO": "Macau",
        "MP": "Quần đảo Bắc Mariana",
        "MR": "Mauritania",
        "MS": "Montserrat",
        "MT": "Malta",
        "MU": "Mauritius",
        "MV": "Maldives",
        "MW": "Malawi",
        "MX": "Mexico",
        "MY": "Malaysia",
        "MZ": "Mozambique",
        "NA": "Namibia",
        "NC": "New Caledonia",
        "NE": "Niger",
        "NG": "Nigeria",
        "NI": "Nicaragua",
        "NL": "Hà Lan",
        "NO": "Na Uy",
        "NP": "Nepal",
        "NR": "Nauru",
        "NU": "Niue",
        "NZ": "New Zealand",
        "OM": "Oman",
        "PA": "Panama",
        "PE": "Peru",
        "PF": "French Polynesia",
        "PG": "Papua New Guinea",
        "PH": "Philippines",
        "PK": "Pakistan",
        "PL": "Ba Lan",
        "PM": "Saint Pierre và Miquelon",
        "PN": "Pitcairn",
        "PR": "Puerto Rico",
        "PS": "Palestine",
        "PT": "Bồ Đào Nha",
        "PW": "Palau",
        "PY": "Paraguay",
        "QA": "Qatar",
        "RE": "Reunion",
        "RO": "Romania",
        "RS": "Serbia",
        "RU": "Nga",
        "RW": "Rwanda",
        "SA": "Ả Rập Saudi",
        "SB": "Quần đảo Solomon",
        "SC": "Seychelles",
        "SD": "Sudan",
        "SE": "Thụy Điển",
        "SG": "Singapore",
        "SH": "Saint Helena",
        "SI": "Slovenia",
        "SJ": "Svalbard và Jan Mayen",
        "SK": "Slovakia",
        "SL": "Sierra Leone",
        "SM": "San Marino",
        "SN": "Senegal",
        "SO": "Somalia",
        "SR": "Suriname",
        "SS": "Nam Sudan",
        "ST": "Sao Tome và Principe",
        "SV": "El Salvador",
        "SX": "Sint Maarten",
        "SY": "Syria",
        "SZ": "Swaziland",
        "TC": "Quần đảo Turks và Caicos",
        "TD": "Chad",
        "TG": "Togo",
        "TH": "Thái Lan",
        "TJ": "Tajikistan",
        "TK": "Tokelau",
        "TL": "Đông Timor",
        "TM": "Turkmenistan",
        "TN": "Tunisia",
        "TO": "Tonga",
        "TR": "Turkey",
        "TT": "Trinidad và Tobago",
        "TV": "Tuvalu",
        "TW": "Đài Loan",
        "TZ": "Tanzania",
        "UA": "Ukraina",
        "UG": "Uganda",
        "US": "Hoa Kỳ",
        "UY": "Uruguay",
        "UZ": "Uzbekistan",
        "Up直播": "Uplive",
        "VA": "Vatican",
        "VC": "Saint Vincent và Grenadines",
        "VE": "Venezuela",
        "VG": "Quần đảo British Virgin",
        "VI": "Quần đảo Virgin Mỹ",
        "VN": "Việt Nam",
        "VU": "Vanuatu",
        "WF": "Wallis và Futuna",
        "WS": "Samoa",
        "XK": "Kosovo",
        "YE": "Yemen",
        "YT": "Mayotte",
        "ZA": "Nam Phi",
        "ZM": "Zambia",
        "ZW": "Zimbabwe",
        "主播可能在休息，稍后再来试试吧": "Host hiện đang nghỉ ngơi, thử lại sau nhé!",
        "余额不足情况下，充值提醒的描述": "Không đủ kim cương, nạp thêm nhé?",
        "你关注的人还没有直播": "Host bạn follow hiện không online",
        "充值 >": "Nạp tiền >",
        "关注": "Theo dõi",
        "分享失败": "Chia sẻ thất bại",
        "分享成功": "Chia sẻ thành công",
        "去看看当前热门直播": "Đến danh sách hot",
        "参数无效": "Thông số không hợp lệ",
        "发现": "Khám phá ",
        "发现新主播": "Khám phá thêm nhiều host mới nào",
        "发送": "Gửi",
        "取消": "Huỷ",
        "已取消分享": "Huỷ bỏ",
        "按语言推荐主播": "Đề nghị theo ngôn ngữ thích hợp",
        "搜索": "Tìm kiếm",
        "暂无数据": "Không có dữ liệu",
        "未知星球": "Không định vị được vị trí",
        "正在加载": "Loading",
        "没有更多数据了哦": "Đã hết",
        "热门": "Hot",
        "用户登录失效": "Đăng nhập thất bại",
        "登出": "Đăng xuất",
        "直播中": "Live",
        "确认": "Xác nhận",
        "系统错误": "Lỗi hệ thống",
        "经验值<%=num%>": "<%=num%> Exp",
        "获取个人信息失败": "Truy cập thông tin cá nhân thất bại",
        "获取成功": "Nhận thành công",
        "获取热门主播失败": "Không load được danh sách hot",
        "设置国家或地区失败": "Thiết lập quốc gia thất bại",
        "设置国家或地区成功": "Quốc gia được cập nhật",
        "说点什么吧": "Hãy nói gì đi nào",
        "请输入用户昵称或Up号": "Nhập nickname hoặc tên Uplive",
        "赠送": "Quà",
        "赠送了<%=giftName%>": "Đã gửi <%=giftName%>",
        "连": "+1",
        "选择国家或地区": "Chọn quốc gia của bạn",
        "重新选择": "Chọn lại"
    },
    "zhcn": {
        "<%=userName%>坐着<%=carName%>进入了直播间": "<%=userName%>坐着<%=carName%>进入了直播间",
        "AD": "安道尔",
        "AE": "阿拉伯联合酋长国",
        "AF": "阿富汗",
        "AG": "安提瓜和巴布达",
        "AI": "安圭拉",
        "AL": "阿尔巴尼亚",
        "AM": "亚美尼亚",
        "AN": "荷属安的列斯",
        "AO": "安哥拉",
        "AQ": "南极洲",
        "AR": "阿根廷",
        "AS": "美属萨摩亚",
        "AT": "奥地利",
        "AU": "澳大利亚",
        "AW": "阿鲁巴",
        "AZ": "阿塞拜疆",
        "BA": "波斯尼亚和黑塞哥维那",
        "BB": "巴巴多斯",
        "BD": "孟加拉国",
        "BE": "比利时",
        "BF": "布基纳法索",
        "BG": "保加利亚",
        "BH": "巴林",
        "BI": "布隆迪",
        "BJ": "贝宁",
        "BL": "圣巴泰勒米",
        "BM": "百慕大",
        "BN": "文莱",
        "BO": "玻利维亚",
        "BR": "巴西",
        "BS": "巴哈马",
        "BT": "不丹",
        "BW": "博茨瓦纳",
        "BY": "白俄罗斯",
        "BZ": "伯利兹",
        "CA": "加拿大",
        "CC": "科科斯群岛",
        "CD": "刚果民主共和国",
        "CF": "中非共和国",
        "CG": "刚果民主共和国",
        "CH": "瑞士",
        "CI": "象牙海岸",
        "CK": "库克群岛",
        "CL": "智利",
        "CM": "喀麦隆",
        "CN": "中国",
        "CO": "哥伦比亚",
        "CR": "哥斯达黎加",
        "CU": "古巴",
        "CV": "佛得角",
        "CW": "库拉索",
        "CX": "圣诞岛",
        "CY": "塞浦路斯",
        "CZ": "捷克共和国",
        "DE": "德国",
        "DJ": "吉布提",
        "DK": "丹麦",
        "DM": "多米尼加",
        "DO": "多明尼加共和国",
        "DZ": "阿尔及利亚",
        "EC": "厄瓜多尔",
        "EE": "爱沙尼亚",
        "EG": "埃及",
        "EH": "西撒哈拉",
        "ER": "厄立特里亚",
        "ES": "西班牙",
        "ET": "埃塞俄比亚",
        "FI": "芬兰",
        "FJ": "斐",
        "FK": "福克兰群岛",
        "FM": "密克罗尼西亚",
        "FO": "法罗群岛",
        "FR": "法国",
        "GA": "加蓬",
        "GB": "英国",
        "GD": "格林纳达",
        "GE": "格鲁吉亚",
        "GG": "根西岛",
        "GH": "加纳",
        "GI": "直布罗陀",
        "GL": "格陵兰",
        "GM": "冈比亚",
        "GN": "几内亚",
        "GQ": "赤道几内亚",
        "GR": "希腊",
        "GT": "危地马拉",
        "GU": "关岛",
        "GW": "几内亚比绍",
        "GY": "圭亚那",
        "HK": "香港",
        "HN": "洪都拉斯",
        "HR": "克罗地亚",
        "HT": "海地",
        "HU": "匈牙利",
        "ID": "印度尼西亚",
        "IE": "爱尔兰",
        "IL": "以色列",
        "IM": "马恩岛",
        "IN": "印度",
        "IO": "英属印度洋领地",
        "IQ": "伊拉克",
        "IR": "伊朗",
        "IS": "冰岛",
        "IT": "意大利",
        "JE": "新泽西",
        "JM": "牙买加",
        "JO": "约旦",
        "JP": "日本",
        "KE": "肯尼亚",
        "KG": "吉尔吉斯斯坦",
        "KH": "柬埔寨",
        "KI": "基里巴斯",
        "KM": "科摩罗",
        "KN": "圣基茨和尼维斯",
        "KP": "北朝鲜",
        "KR": "韩国",
        "KW": "科威特",
        "KY": "开曼群岛",
        "KZ": "哈萨克斯坦",
        "LA": "老挝",
        "LB": "黎巴嫩",
        "LC": "圣卢西亚",
        "LI": "列支敦士登",
        "LK": "斯里兰卡",
        "LR": "利比里亚",
        "LS": "莱索托",
        "LT": "立陶宛",
        "LU": "卢森堡",
        "LV": "拉脱维亚",
        "LY": "利比亚",
        "MA": "摩洛哥",
        "MC": "摩纳哥",
        "MD": "摩尔多瓦",
        "ME": "黑山",
        "MF": "圣马丁",
        "MG": "马达加斯加",
        "MH": "马绍尔群岛",
        "MK": "马其顿",
        "ML": "马里",
        "MM": "缅甸",
        "MN": "蒙古",
        "MO": "澳门",
        "MP": "北马里亚纳群岛",
        "MR": "毛里塔尼亚",
        "MS": "蒙特塞拉特",
        "MT": "马耳他",
        "MU": "毛里求斯",
        "MV": "马尔代夫",
        "MW": "马拉维",
        "MX": "墨西哥",
        "MY": "马来西亚",
        "MZ": "莫桑比克",
        "NA": "纳米比亚",
        "NC": "新喀里多尼亚",
        "NE": "尼日尔",
        "NG": "尼日利亚",
        "NI": "尼加拉瓜",
        "NL": "荷兰",
        "NO": "挪威",
        "NP": "尼泊尔",
        "NR": "瑙鲁",
        "NU": "纽埃",
        "NZ": "新西兰",
        "OM": "阿曼",
        "PA": "巴拿马",
        "PE": "秘鲁",
        "PF": "法属波利尼西亚",
        "PG": "巴布亚新几内亚",
        "PH": "菲律宾",
        "PK": "巴基斯坦",
        "PL": "波兰",
        "PM": "圣皮埃尔和密克隆",
        "PN": "皮特凯恩",
        "PR": "波多黎各",
        "PS": "巴勒斯坦",
        "PT": "葡萄牙",
        "PW": "帕劳",
        "PY": "巴拉圭",
        "QA": "卡塔尔",
        "RE": "团圆",
        "RO": "罗马尼亚",
        "RS": "塞尔维亚",
        "RU": "俄国",
        "RW": "卢旺达",
        "SA": "沙特阿拉伯",
        "SB": "所罗门群岛",
        "SC": "塞舌尔",
        "SD": "苏丹",
        "SE": "瑞典",
        "SG": "新加坡",
        "SH": "圣赫勒拿",
        "SI": "斯洛文尼亚",
        "SJ": "斯瓦尔巴特",
        "SK": "斯洛伐克",
        "SL": "塞拉利昂",
        "SM": "圣马力诺",
        "SN": "塞内加尔",
        "SO": "索马里",
        "SR": "苏里南",
        "SS": "南苏丹",
        "ST": "圣多美和普林西比",
        "SV": "萨尔瓦多",
        "SX": "圣马丁岛",
        "SY": "叙利亚",
        "SZ": "斯威士兰",
        "TC": "特克斯和凯科斯群岛",
        "TD": "乍得",
        "TG": "多哥",
        "TH": "泰国",
        "TJ": "塔吉克斯坦",
        "TK": "托克劳",
        "TL": "东帝汶",
        "TM": "土库曼斯坦",
        "TN": "突尼斯",
        "TO": "汤加",
        "TR": "土耳其",
        "TT": "特立尼达和多巴哥",
        "TV": "图瓦卢",
        "TW": "台湾",
        "TZ": "坦桑尼亚",
        "UA": "乌克兰",
        "UG": "乌干达",
        "US": "美国",
        "UY": "乌拉圭",
        "UZ": "乌兹别克斯坦",
        "Up号:<%=code%>": "Up号:<%=code%>",
        "Up直播": "Up直播",
        "U币贡献榜": "U币贡献榜",
        "VA": "教廷",
        "VC": "圣文森特和格林纳丁斯",
        "VE": "委内瑞拉",
        "VG": "英属维尔京群岛",
        "VI": "美属维尔京群岛",
        "VN": "越南",
        "VU": "瓦努阿图",
        "WF": "瓦利斯和富图纳群岛",
        "WS": "萨摩亚",
        "XK": "科索沃",
        "YE": "也门",
        "YT": "马约特",
        "ZA": "南非",
        "ZM": "赞比亚",
        "ZW": "津巴布韦",
        "个人信息设定失败": "个人信息设定失败",
        "个人信息设定成功": "个人信息设定成功",
        "主播可能在休息，稍后再来试试吧": "主播可能在休息，稍后再来试试吧",
        "主播已停播，即将返回首页!": "主播已停播，即将返回首页!",
        "优秀主播指南": "优秀主播指南",
        "余额不足情况下，充值提醒的描述": "余额不足, 是否前往充值?",
        "你关注的人还没有直播": "你关注的人还没有直播",
        "保存": "保存",
        "充值 >": "充值 >",
        "关注": "关注",
        "关注了主播，从此不再错过。": "关注了主播，从此不再错过。",
        "写个签名吧，让大家了解你。": "写个签名吧，让大家了解你。",
        "分享失败": "分享失败",
        "分享成功": "分享成功",
        "去看看当前热门直播": "去看看当前热门直播",
        "参数无效": "参数无效",
        "参数错误": "参数错误",
        "发现": "发现",
        "发现新主播": "发现新主播",
        "发送": "发送",
        "取消": "取消",
        "如何升级": "如何升级",
        "如何升级详情": "为优秀的主播送礼喝彩，送的越多升级越快。@@@@试试成为主播？优秀的主播升的更快。",
        "守护身价:<%=code%>": "守护身价:<%=code%>",
        "已停播": "已停播",
        "已关注": "已关注",
        "已取消分享": "已取消分享",
        "我的U钻": "我的U钻",
        "我的守护": "我的守护",
        "我的收益（U币）": "我的收益（U币）",
        "我的直播": "我的直播",
        "我的等级": "我的等级",
        "拉黑": "拉黑",
        "按语言推荐主播": "按语言推荐主播",
        "搜索": "搜索",
        "收到的U币": "收到的U币",
        "昵称不能出现敏感词": "昵称不能出现敏感词",
        "暂无数据": "暂无数据",
        "暂无被拉黑用户": "暂无被拉黑用户",
        "未知星球": "未知星球",
        "正在加载": "正在加载",
        "正在加载更多的数据...": "正在加载更多的数据...",
        "没发现此人，请重新输入试试": "没发现此人，请重新输入试试",
        "没有更多数据了哦": "没有更多数据了哦",
        "点亮了": "点亮了",
        "热门": "热门",
        "用户登录失效": "用户登录失效",
        "登出": "登出",
        "直播中": "直播中",
        "确认": "确认",
        "等级福利": "等级福利",
        "等级福利详情": " 高等级用户会有尊贵标识来凸显身份。@@@@ 等级越高，越有机会享受到定制化的产品福利。",
        "签名不能出现敏感词": "签名不能出现敏感词",
        "粉丝": "粉丝",
        "系统消息": "系统消息",
        "系统消息: 主播回来了，视频即将恢复！": "系统消息: 主播回来了，视频即将恢复！",
        "系统消息: 主播暂时离开了，小伙伴们请稍候。": "系统消息: 主播暂时离开了，小伙伴们请稍候。",
        "系统消息: 我们提倡绿色直播，只有通过审核并被标记为优质的主播才可能出现在热门，如封面和直播内容含有涉黄、低俗、吸烟、暴露等情况，将会被封禁账号。网警将保持24小时在线审核与审查，请您遵守。": "系统消息: 我们提倡绿色直播，只有通过审核并被标记为优质的主播才可能出现在热门，如封面和直播内容含有涉黄、低俗、吸烟、暴露等情况，将会被封禁账号。网警将保持24小时在线审核与审查，请您遵守。",
        "系统错误": "系统错误",
        "累计经验：<%=code%>": "累计经验：<%=code%>",
        "经验值<%=num%>": "经验值<%=num%>",
        "花费:": "花费:",
        "获取个人信息失败": "获取个人信息失败",
        "获取成功": "获取成功",
        "获取热门主播失败": "获取热门主播失败",
        "虚位以待": "虚位以待",
        "解除拉黑": "解除拉黑",
        "设置国家或地区失败": "设置国家或地区失败",
        "设置国家或地区成功": "设置国家或地区成功",
        "说点什么吧": "说点什么吧",
        "请竖屏获得更佳体验": "请竖屏获得更佳体验",
        "请输入用户昵称或Up号": "请输入用户昵称或Up号",
        "贡献U币:<%=code%>": "贡献U币:<%=code%>",
        "赠送": "赠送",
        "赠送了<%=count%>个<%=giftName%>": "赠送了<%=count%>个<%=giftName%>",
        "赠送了<%=giftName%>": "赠送了<%=giftName%>",
        "距离下一级：<%=code%>": "距离下一级：<%=code%>",
        "进入房间失败": "进入房间失败",
        "进入房间超时": "进入房间超时",
        "连": "连",
        "连接失败，请退出直播间重新进入": "连接失败，请退出直播间重新进入",
        "选择国家或地区": "选择国家或地区",
        "重新选择": "重新选择",
        "黑名单": "黑名单"
    },
    "zhhk": {
        "AD": "安道​​爾",
        "AE": "阿拉伯聯合酋長國",
        "AF": "阿富汗",
        "AG": "安提瓜和巴布達",
        "AI": "安圭拉",
        "AL": "阿爾巴尼亞",
        "AM": "亞美尼亞",
        "AN": "荷屬安的列斯",
        "AO": "安哥拉",
        "AQ": "南極洲",
        "AR": "阿根廷",
        "AS": "美屬薩摩亞",
        "AT": "奧地利",
        "AU": "澳大利亞",
        "AW": "阿魯巴",
        "AZ": "阿塞拜疆",
        "BA": "波斯尼亞和黑塞哥維那",
        "BB": "巴巴多斯",
        "BD": "孟加拉國",
        "BE": "比利時",
        "BF": "布基納法索",
        "BG": "保加利亞",
        "BH": "巴林",
        "BI": "布隆迪",
        "BJ": "貝寧",
        "BL": "聖巴泰勒米",
        "BM": "百慕大",
        "BN": "文萊",
        "BO": "玻利維亞",
        "BR": "巴西",
        "BS": "巴哈馬",
        "BT": "不丹",
        "BW": "博茨瓦納",
        "BY": "白俄羅斯",
        "BZ": "伯利茲",
        "CA": "加拿大",
        "CC": "科科斯群島",
        "CD": "剛果民主共和國",
        "CF": "中非共和國",
        "CG": "剛果民主共和國",
        "CH": "瑞士",
        "CI": "象牙海岸",
        "CK": "庫克群島",
        "CL": "智利",
        "CM": "喀麥隆",
        "CN": "中國",
        "CO": "哥倫比亞",
        "CR": "哥斯達黎加",
        "CU": "古巴",
        "CV": "佛得角",
        "CW": "庫拉索",
        "CX": "聖誕島",
        "CY": "塞浦路斯",
        "CZ": "捷克共和國",
        "DE": "德國",
        "DJ": "吉布提",
        "DK": "丹麥",
        "DM": "多米尼加",
        "DO": "多明尼加共和國",
        "DZ": "阿爾及利亞",
        "EC": "厄瓜多爾",
        "EE": "愛沙尼亞",
        "EG": "埃及",
        "EH": "西撒哈拉",
        "ER": "厄立特里亞",
        "ES": "西班牙",
        "ET": "埃塞俄比亞",
        "FI": "芬蘭",
        "FJ": "斐",
        "FK": "福克蘭群島",
        "FM": "密克羅尼西亞",
        "FO": "法羅群島",
        "FR": "法國",
        "GA": "加蓬",
        "GB": "英國",
        "GD": "格林納達",
        "GE": "格魯吉亞",
        "GG": "根西島",
        "GH": "加納",
        "GI": "直布羅陀",
        "GL": "格陵蘭",
        "GM": "岡比亞",
        "GN": "幾內亞",
        "GQ": "赤道幾內亞",
        "GR": "希臘",
        "GT": "危地馬拉",
        "GU": "關島",
        "GW": "幾內亞比紹",
        "GY": "圭亞那",
        "HK": "香港",
        "HN": "洪都拉斯",
        "HR": "克羅地亞",
        "HT": "海地",
        "HU": "匈牙利",
        "ID": "印度尼西亞",
        "IE": "愛爾蘭",
        "IL": "以色列",
        "IM": "馬恩島",
        "IN": "印度",
        "IO": "英屬印度洋領地",
        "IQ": "伊拉克",
        "IR": "伊朗",
        "IS": "冰島",
        "IT": "意大利",
        "JE": "新澤西",
        "JM": "牙買加",
        "JO": "約旦",
        "JP": "日本",
        "KE": "肯尼亞",
        "KG": "吉爾吉斯斯坦",
        "KH": "柬埔寨",
        "KI": "基里巴斯",
        "KM": "科摩羅",
        "KN": "聖基茨和尼維斯",
        "KP": "北朝鮮",
        "KR": "韓國",
        "KW": "科威特",
        "KY": "開曼群島",
        "KZ": "哈薩克斯坦",
        "LA": "老撾",
        "LB": "黎巴嫩",
        "LC": "聖盧西亞",
        "LI": "列支敦士登",
        "LK": "斯里蘭卡",
        "LR": "利比里亞",
        "LS": "萊索托",
        "LT": "立陶宛",
        "LU": "盧森堡",
        "LV": "拉脫維亞",
        "LY": "利比亞",
        "MA": "摩洛哥",
        "MC": "摩納哥",
        "MD": "摩爾多瓦",
        "ME": "黑山",
        "MF": "聖馬丁",
        "MG": "馬達加斯加",
        "MH": "馬紹爾群島",
        "MK": "馬其頓",
        "ML": "馬里",
        "MM": "緬甸",
        "MN": "蒙古",
        "MO": "澳門",
        "MP": "北馬里亞納群島",
        "MR": "毛里塔尼亞",
        "MS": "蒙特塞拉特",
        "MT": "馬耳他",
        "MU": "毛里求斯",
        "MV": "馬爾代夫",
        "MW": "馬拉維",
        "MX": "墨西哥",
        "MY": "馬來西亞",
        "MZ": "莫桑比克",
        "NA": "納米比亞",
        "NC": "新喀裡多尼亞",
        "NE": "尼日爾",
        "NG": "尼日利亞",
        "NI": "尼加拉瓜",
        "NL": "荷蘭",
        "NO": "挪威",
        "NP": "尼泊爾",
        "NR": "瑙魯",
        "NU": "紐埃",
        "NZ": "新西蘭",
        "OM": "阿曼",
        "PA": "巴拿馬",
        "PE": "秘魯",
        "PF": "法屬波利尼西亞",
        "PG": "巴布亞新幾內亞",
        "PH": "菲律賓",
        "PK": "巴基斯坦",
        "PL": "波蘭",
        "PM": "聖皮埃爾和密克隆",
        "PN": "皮特凱恩",
        "PR": "波多黎各",
        "PS": "巴勒斯坦",
        "PT": "葡萄牙",
        "PW": "帕勞",
        "PY": "巴拉圭",
        "QA": "卡塔爾",
        "RE": "團圓",
        "RO": "羅馬尼亞",
        "RS": "塞爾維亞",
        "RU": "俄國",
        "RW": "盧旺達",
        "SA": "沙特阿拉伯",
        "SB": "所羅門群島",
        "SC": "塞舌爾",
        "SD": "蘇丹",
        "SE": "瑞典",
        "SG": "新加坡",
        "SH": "聖赫勒拿",
        "SI": "斯洛文尼亞",
        "SJ": "斯瓦爾巴特",
        "SK": "斯洛伐克",
        "SL": "塞拉利昂",
        "SM": "聖馬力諾",
        "SN": "塞內加爾",
        "SO": "索馬里",
        "SR": "蘇里南",
        "SS": "南蘇丹",
        "ST": "聖多美和普林西比",
        "SV": "薩爾瓦多",
        "SX": "聖馬丁島",
        "SY": "敘利亞",
        "SZ": "斯威士蘭",
        "TC": "特克斯和凱科斯群島",
        "TD": "乍得",
        "TG": "多哥",
        "TH": "泰國",
        "TJ": "塔吉克斯坦",
        "TK": "托克勞",
        "TL": "東帝汶",
        "TM": "土庫曼斯坦",
        "TN": "突尼斯",
        "TO": "湯加",
        "TR": "土耳其",
        "TT": "特立尼達和多巴哥",
        "TV": "圖瓦盧",
        "TW": "台灣",
        "TZ": "坦桑尼亞",
        "UA": "烏克蘭",
        "UG": "烏干達",
        "US": "美國",
        "UY": "烏拉圭",
        "UZ": "烏茲別克斯坦",
        "VA": "教廷",
        "VC": "聖文森特和格林納丁斯",
        "VE": "委內瑞拉",
        "VG": "英屬維爾京群島",
        "VI": "美屬維爾京群島",
        "VN": "越南",
        "VU": "瓦努阿圖",
        "WF": "瓦利斯和富圖納群島",
        "WS": "薩摩亞",
        "XK": "科索沃",
        "YE": "也門",
        "YT": "馬約特",
        "ZA": "南非",
        "ZM": "贊比亞",
        "ZW": "津巴布韋"
    },
    "zhtw": {
        "<%=userName%>坐着<%=carName%>进入了直播间": "<%=userName%>坐著<%=carName%>進入了直播間",
        "AD": "安道​​爾",
        "AE": "阿拉伯聯合酋長國",
        "AF": "阿富汗",
        "AG": "安提瓜和巴布達",
        "AI": "安圭拉",
        "AL": "阿爾巴尼亞",
        "AM": "亞美尼亞",
        "AN": "荷屬安的列斯",
        "AO": "安哥拉",
        "AQ": "南極洲",
        "AR": "阿根廷",
        "AS": "美屬薩摩亞",
        "AT": "奧地利",
        "AU": "澳大利亞",
        "AW": "阿魯巴",
        "AZ": "阿塞拜疆",
        "BA": "波斯尼亞和黑塞哥維那",
        "BB": "巴巴多斯",
        "BD": "孟加拉國",
        "BE": "比利時",
        "BF": "布基納法索",
        "BG": "保加利亞",
        "BH": "巴林",
        "BI": "布隆迪",
        "BJ": "貝寧",
        "BL": "聖巴泰勒米",
        "BM": "百慕大",
        "BN": "文萊",
        "BO": "玻利維亞",
        "BR": "巴西",
        "BS": "巴哈馬",
        "BT": "不丹",
        "BW": "博茨瓦納",
        "BY": "白俄羅斯",
        "BZ": "伯利茲",
        "CA": "加拿大",
        "CC": "科科斯群島",
        "CD": "剛果民主共和國",
        "CF": "中非共和國",
        "CG": "剛果民主共和國",
        "CH": "瑞士",
        "CI": "象牙海岸",
        "CK": "庫克群島",
        "CL": "智利",
        "CM": "喀麥隆",
        "CN": "中國",
        "CO": "哥倫比亞",
        "CR": "哥斯達黎加",
        "CU": "古巴",
        "CV": "佛得角",
        "CW": "庫拉索",
        "CX": "聖誕島",
        "CY": "塞浦路斯",
        "CZ": "捷克共和國",
        "DE": "德國",
        "DJ": "吉布提",
        "DK": "丹麥",
        "DM": "多米尼加",
        "DO": "多明尼加共和國",
        "DZ": "阿爾及利亞",
        "EC": "厄瓜多爾",
        "EE": "愛沙尼亞",
        "EG": "埃及",
        "EH": "西撒哈拉",
        "ER": "厄立特里亞",
        "ES": "西班牙",
        "ET": "埃塞俄比亞",
        "FI": "芬蘭",
        "FJ": "斐",
        "FK": "福克蘭群島",
        "FM": "密克羅尼西亞",
        "FO": "法羅群島",
        "FR": "法國",
        "GA": "加蓬",
        "GB": "英國",
        "GD": "格林納達",
        "GE": "格魯吉亞",
        "GG": "根西島",
        "GH": "加納",
        "GI": "直布羅陀",
        "GL": "格陵蘭",
        "GM": "岡比亞",
        "GN": "幾內亞",
        "GQ": "赤道幾內亞",
        "GR": "希臘",
        "GT": "危地馬拉",
        "GU": "關島",
        "GW": "幾內亞比紹",
        "GY": "圭亞那",
        "HK": "香港",
        "HN": "洪都拉斯",
        "HR": "克羅地亞",
        "HT": "海地",
        "HU": "匈牙利",
        "ID": "印度尼西亞",
        "IE": "愛爾蘭",
        "IL": "以色列",
        "IM": "馬恩島",
        "IN": "印度",
        "IO": "英屬印度洋領地",
        "IQ": "伊拉克",
        "IR": "伊朗",
        "IS": "冰島",
        "IT": "意大利",
        "JE": "新澤西",
        "JM": "牙買加",
        "JO": "約旦",
        "JP": "日本",
        "KE": "肯尼亞",
        "KG": "吉爾吉斯斯坦",
        "KH": "柬埔寨",
        "KI": "基里巴斯",
        "KM": "科摩羅",
        "KN": "聖基茨和尼維斯",
        "KP": "北朝鮮",
        "KR": "韓國",
        "KW": "科威特",
        "KY": "開曼群島",
        "KZ": "哈薩克斯坦",
        "LA": "老撾",
        "LB": "黎巴嫩",
        "LC": "聖盧西亞",
        "LI": "列支敦士登",
        "LK": "斯里蘭卡",
        "LR": "利比里亞",
        "LS": "萊索托",
        "LT": "立陶宛",
        "LU": "盧森堡",
        "LV": "拉脫維亞",
        "LY": "利比亞",
        "MA": "摩洛哥",
        "MC": "摩納哥",
        "MD": "摩爾多瓦",
        "ME": "黑山",
        "MF": "聖馬丁",
        "MG": "馬達加斯加",
        "MH": "馬紹爾群島",
        "MK": "馬其頓",
        "ML": "馬里",
        "MM": "緬甸",
        "MN": "蒙古",
        "MO": "澳門",
        "MP": "北馬里亞納群島",
        "MR": "毛里塔尼亞",
        "MS": "蒙特塞拉特",
        "MT": "馬耳他",
        "MU": "毛里求斯",
        "MV": "馬爾代夫",
        "MW": "馬拉維",
        "MX": "墨西哥",
        "MY": "馬來西亞",
        "MZ": "莫桑比克",
        "NA": "納米比亞",
        "NC": "新喀裡多尼亞",
        "NE": "尼日爾",
        "NG": "尼日利亞",
        "NI": "尼加拉瓜",
        "NL": "荷蘭",
        "NO": "挪威",
        "NP": "尼泊爾",
        "NR": "瑙魯",
        "NU": "紐埃",
        "NZ": "新西蘭",
        "OM": "阿曼",
        "PA": "巴拿馬",
        "PE": "秘魯",
        "PF": "法屬波利尼西亞",
        "PG": "巴布亞新幾內亞",
        "PH": "菲律賓",
        "PK": "巴基斯坦",
        "PL": "波蘭",
        "PM": "聖皮埃爾和密克隆",
        "PN": "皮特凱恩",
        "PR": "波多黎各",
        "PS": "巴勒斯坦",
        "PT": "葡萄牙",
        "PW": "帕勞",
        "PY": "巴拉圭",
        "QA": "卡塔爾",
        "RE": "團圓",
        "RO": "羅馬尼亞",
        "RS": "塞爾維亞",
        "RU": "俄國",
        "RW": "盧旺達",
        "SA": "沙特阿拉伯",
        "SB": "所羅門群島",
        "SC": "塞舌爾",
        "SD": "蘇丹",
        "SE": "瑞典",
        "SG": "新加坡",
        "SH": "聖赫勒拿",
        "SI": "斯洛文尼亞",
        "SJ": "斯瓦爾巴特",
        "SK": "斯洛伐克",
        "SL": "塞拉利昂",
        "SM": "聖馬力諾",
        "SN": "塞內加爾",
        "SO": "索馬里",
        "SR": "蘇里南",
        "SS": "南蘇丹",
        "ST": "聖多美和普林西比",
        "SV": "薩爾瓦多",
        "SX": "聖馬丁島",
        "SY": "敘利亞",
        "SZ": "斯威士蘭",
        "TC": "特克斯和凱科斯群島",
        "TD": "乍得",
        "TG": "多哥",
        "TH": "泰國",
        "TJ": "塔吉克斯坦",
        "TK": "托克勞",
        "TL": "東帝汶",
        "TM": "土庫曼斯坦",
        "TN": "突尼斯",
        "TO": "湯加",
        "TR": "土耳其",
        "TT": "特立尼達和多巴哥",
        "TV": "圖瓦盧",
        "TW": "台灣",
        "TZ": "坦桑尼亞",
        "UA": "烏克蘭",
        "UG": "烏干達",
        "US": "美國",
        "UY": "烏拉圭",
        "UZ": "烏茲別克斯坦",
        "Up号:<%=code%>": "Up帳號：<%=code%>",
        "Up直播": "Up直播",
        "U币贡献榜": "U幣貢獻榜",
        "VA": "教廷",
        "VC": "聖文森特和格林納丁斯",
        "VE": "委內瑞拉",
        "VG": "英屬維爾京群島",
        "VI": "美屬維爾京群島",
        "VN": "越南",
        "VU": "瓦努阿圖",
        "WF": "瓦利斯和富圖納群島",
        "WS": "薩摩亞",
        "XK": "科索沃",
        "YE": "也門",
        "YT": "馬約特",
        "ZA": "南非",
        "ZM": "贊比亞",
        "ZW": "津巴布韋",
        "个人信息设定失败": "個人檔案設定失敗",
        "个人信息设定成功": "個人檔案設定成功",
        "主播可能在休息，稍后再来试试吧": "主播可能在休息，等等再來試試吧",
        "主播已停播，即将返回首页!": "主播已關播，即將返回首頁！",
        "优秀主播指南": "優秀主播指南",
        "余额不足情况下，充值提醒的描述": "餘額不足，是否前往儲值？",
        "你关注的人还没有直播": "你追蹤的人還沒直播",
        "保存": "保存",
        "充值 >": "儲值 >",
        "关注": "追蹤",
        "关注了主播，从此不再错过。": "追蹤了主播，從此不再錯過。",
        "写个签名吧，让大家了解你。": "寫個簽名檔，讓大家更了解你！",
        "分享失败": "分享失敗",
        "分享成功": "分享成功",
        "去看看当前热门直播": "去看看現在正夯直播",
        "参数无效": "參數無效",
        "参数错误": "參數錯誤",
        "发现": "發現",
        "发现新主播": "發現新主播",
        "发送": "傳送",
        "取消": "取消",
        "如何升级": "如何升級",
        "如何升级详情": "給主播送送禮物，送的越多升級的越快。@@@@試試成為主播，更有機會升級呦~",
        "守护身价:<%=code%>": "守護身價：<%=code%>",
        "已停播": "已停播",
        "已关注": "已追蹤",
        "已取消分享": "已取消分享",
        "我的U钻": "我的U鑽",
        "我的守护": "我的守護",
        "我的收益（U币）": "我的收益 (U幣)",
        "我的直播": "我的直播",
        "我的等级": "我的等級",
        "拉黑": "加入黑名單",
        "按语言推荐主播": "依照語言推薦主播",
        "搜索": "搜尋",
        "收到的U币": "收到的U幣",
        "昵称不能出现敏感词": "暱稱不能出現敏感詞",
        "暂无数据": "暫無資料",
        "暂无被拉黑用户": "暫無黑名單用戶",
        "未知星球": "未知位置",
        "正在加载": "正在載入",
        "正在加载更多的数据...": "正在載入更多的資料....",
        "没发现此人，请重新输入试试": "未找您想找的人，請重新輸入",
        "没有更多数据了哦": "沒有更多資料了哦",
        "点亮了": "已戀愛",
        "热门": "正夯",
        "用户登录失效": "用戶登入失敗",
        "登出": "登出",
        "直播中": "直播中",
        "确认": "確定",
        "等级福利": "等級福利",
        "等级福利详情": "等級高用戶會有尊貴標示來凸顯身份。@@@@等級越高，越有機會享受福利。",
        "签名不能出现敏感词": "簽名檔不能出現敏感詞",
        "粉丝": "粉絲",
        "系统消息": "系統消息",
        "系统消息: 主播回来了，视频即将恢复！": "系統消息：主播回來了",
        "系统消息: 主播暂时离开了，小伙伴们请稍候。": "系統消息：主播暫時離開，請耐心等待。",
        "系统消息: 我们提倡绿色直播，只有通过审核并被标记为优质的主播才可能出现在热门，如封面和直播内容含有涉黄、低俗、吸烟、暴露等情况，将会被封禁账号。网警将保持24小时在线审核与审查，请您遵守。": "系統消息：我們提倡綠色直播，只有通過審核並被註記為優質主播才有可能出現在熱門列表，如封面和直播內容含有情色、吸菸或其它不雅的情況，將會被封鎖帳號，管理員24小時線上巡邏，請您務必遵守。",
        "系统错误": "系統錯誤",
        "累计经验：<%=code%>": "累計經驗：<%=code%>",
        "经验值<%=num%>": "經驗值<%=num%>",
        "花费:": "花費：",
        "获取个人信息失败": "獲取個人檔案失敗",
        "获取成功": "獲取成功",
        "获取热门主播失败": "獲取正夯主播失敗",
        "虚位以待": "虛位以待",
        "解除拉黑": "解除黑名單",
        "设置国家或地区失败": "設置國家或地區失敗",
        "设置国家或地区成功": "設置國家或地區成功",
        "说点什么吧": "說點話吧",
        "请竖屏获得更佳体验": "請豎屏獲得最好體驗",
        "请输入用户昵称或Up号": "請輸入用戶暱稱或Up帳號",
        "贡献U币:<%=code%>": "貢獻U幣：<%=code%>",
        "赠送": "贈送",
        "赠送了<%=count%>个<%=giftName%>": "贈送了<%=count%>個<%=giftName%>",
        "赠送了<%=giftName%>": "贈送了<%=giftName%>",
        "距离下一级：<%=code%>": "距離下一級：<%=code%>",
        "进入房间失败": "進入直播間失敗",
        "进入房间超时": "進入直播間超時",
        "连": "連",
        "连接失败，请退出直播间重新进入": "連接失敗，請退出直播間重新進入",
        "选择国家或地区": "選擇國家或地區",
        "重新选择": "重新選擇",
        "黑名单": "黑名單"
    }
};

/***/ }),
/* 354 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
var _root = dcodeIO.ProtoBuf.newBuilder({})['import']({
    "package": null,
    "options": {
        "java_package": "com.asiainno.uplive.proto"
    },
    "messages": [{
        "name": "UserBalanceInfo",
        "fields": [{
            "rule": "optional",
            "type": "int64",
            "name": "inBill",
            "id": 1
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "outDiamond",
            "id": 2
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "bill",
            "id": 3
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "diamond",
            "id": 4
        }]
    }, {
        "name": "ProfileInfo",
        "fields": [{
            "rule": "optional",
            "type": "int64",
            "name": "uid",
            "id": 1
        }, {
            "rule": "optional",
            "type": "string",
            "name": "username",
            "id": 2
        }, {
            "rule": "optional",
            "type": "string",
            "name": "upliveCode",
            "id": 3
        }, {
            "rule": "optional",
            "type": "string",
            "name": "avatar",
            "id": 4
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "gender",
            "id": 5
        }, {
            "rule": "optional",
            "type": "string",
            "name": "setting",
            "id": 6
        }, {
            "rule": "optional",
            "type": "string",
            "name": "password",
            "id": 7
        }, {
            "rule": "optional",
            "type": "string",
            "name": "userToken",
            "id": 8
        }, {
            "rule": "optional",
            "type": "string",
            "name": "signature",
            "id": 9
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "grade",
            "id": 10
        }, {
            "rule": "optional",
            "type": "string",
            "name": "location",
            "id": 11
        }, {
            "rule": "optional",
            "type": "string",
            "name": "mobilePhone",
            "id": 12
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "fanTotal",
            "id": 13
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "followTotal",
            "id": 14
        }, {
            "rule": "optional",
            "type": "UserBalanceInfo",
            "name": "balance",
            "id": 15
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "chatroomid",
            "id": 16
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "followType",
            "id": 17
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "exp",
            "id": 18
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "currentExp",
            "id": 19
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "nextExp",
            "id": 20
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "officialAuth",
            "id": 21
        }, {
            "rule": "optional",
            "type": "string",
            "name": "officialAuthContent",
            "id": 22
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "qualityAuth",
            "id": 23
        }, {
            "rule": "optional",
            "type": "string",
            "name": "countryCode",
            "id": 25
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "admin",
            "id": 26
        }]
    }, {
        "name": "Profile",
        "fields": [],
        "messages": [{
            "name": "Get",
            "fields": [],
            "options": {
                "objc_class_prefix": "ProfileGet",
                "java_package": "com.asiainno.uplive.proto"
            },
            "messages": [{
                "name": "Request",
                "fields": [{
                    "rule": "optional",
                    "type": "int64",
                    "name": "vuid",
                    "id": 1
                }]
            }, {
                "name": "Response",
                "fields": [{
                    "rule": "optional",
                    "type": "ProfileInfo",
                    "name": "profile",
                    "id": 1
                }]
            }]
        }]
    }]
}).build();

exports.default = _root;

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _cUpPbajax = __webpack_require__(343);

var _cUpPbajax2 = _interopRequireDefault(_cUpPbajax);

var _cUrl = __webpack_require__(49);

var _cUrl2 = _interopRequireDefault(_cUrl);

var _public = __webpack_require__(344);

var _public2 = _interopRequireDefault(_public);

var _set = __webpack_require__(356);

var _set2 = _interopRequireDefault(_set);

var _cCache = __webpack_require__(91);

var _cCache2 = _interopRequireDefault(_cCache);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var cache = new _cCache2.default({
    prefix: 'uplive'
});
var pbajax = new _cUpPbajax2.default();

var ProfileSet = function () {
    function ProfileSet() {
        var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        _classCallCheck(this, ProfileSet);

        this.promise = this.set(data);
    }

    _createClass(ProfileSet, [{
        key: 'set',
        value: function set(data) {
            var defer = $.Deferred();
            var businessData = new _set2.default.Profile.Set.Request(data);
            var requestData = {
                service: 'service',
                api: '/profile/set',
                header: {
                    userToken: cache.getCache('user').userToken
                }
            };

            pbajax.do(requestData, businessData, function (res) {
                var dataWrap = _public2.default.Result.decode(res);
                var data = void 0;

                if (dataWrap.code == 1) {
                    defer.resolve(true);
                } else {
                    defer.reject();
                }
            }, function () {
                defer.reject();
            }, function () {
                defer.reject();
            });
            return defer.promise();
        }
    }]);

    return ProfileSet;
}();

exports.default = ProfileSet;

/***/ }),
/* 356 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
var _root = dcodeIO.ProtoBuf.newBuilder({})['import']({
    "package": null,
    "options": {
        "java_package": "com.asiainno.uplive.proto"
    },
    "messages": [{
        "name": "Profile",
        "fields": [],
        "messages": [{
            "name": "Set",
            "fields": [],
            "options": {
                "objc_class_prefix": "ProfileSet",
                "java_package": "com.asiainno.uplive.proto"
            },
            "messages": [{
                "name": "Request",
                "fields": [{
                    "rule": "optional",
                    "type": "string",
                    "name": "username",
                    "id": 1
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "setting",
                    "id": 2
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "upliveCode",
                    "id": 3
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "signature",
                    "id": 4
                }, {
                    "rule": "optional",
                    "type": "PushType",
                    "name": "pushType",
                    "id": 5
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "pushToken",
                    "id": 6
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "location",
                    "id": 7
                }, {
                    "rule": "optional",
                    "type": "int32",
                    "name": "gender",
                    "id": 8
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "language",
                    "id": 9
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "countryCode",
                    "id": 11
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "userRealNameAuthInfo",
                    "id": 12
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "acceptAgreement",
                    "id": 13
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "timeZone",
                    "id": 14
                }]
            }]
        }]
    }],
    "enums": [{
        "name": "BindType",
        "values": [{
            "name": "DEFAULT_TYPE",
            "id": 0
        }, {
            "name": "MOBILE_PHONE",
            "id": 1
        }, {
            "name": "QQ",
            "id": 2
        }, {
            "name": "WEIXIN",
            "id": 3
        }, {
            "name": "FACEBOOK",
            "id": 4
        }, {
            "name": "SINA_WEIBO",
            "id": 5
        }, {
            "name": "GOOGLE",
            "id": 15
        }, {
            "name": "TWITTER",
            "id": 16
        }, {
            "name": "EMAIL",
            "id": 17
        }]
    }, {
        "name": "PushType",
        "values": [{
            "name": "DEFAULT_PUSHTYPE",
            "id": 0
        }, {
            "name": "IOS",
            "id": 2
        }, {
            "name": "XIAOMI",
            "id": 4
        }, {
            "name": "GETUI",
            "id": 5
        }, {
            "name": "GOOGLE_PUSH",
            "id": 6
        }, {
            "name": "GOOGLE_FCM",
            "id": 10
        }]
    }]
}).build();
exports.default = _root;

/***/ }),
/* 357 */
/***/ (function(module, exports) {



Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 * loading组件
 * @author zhenn
 * @time 2016-11-16
 */

var template = ['<div>', '<div class="J_Loading">', '<div class="g-app-loading">', '<i class="icon"></i>', '<p class="tip">{{text}}</p>', '</div>', '</div>', '<style type="text/css">', '.J_Loading {', 'position: fixed;', 'background: rgba(0, 0, 0, 0.8);', 'width: 100%;', 'height: 100%;', 'left: 0;', 'top: 0;', 'overflow: hidden;', 'z-index: 99999;', '}', '.J_Loading .g-app-loading {', 'width: 2.5rem;', 'height: 2.5rem;', 'border-radius: 0.3125rem;', 'background: rgba(255,255,255, .9);', 'position: absolute;', 'left: 50%;', 'top: 50%;', 'margin: -1.25rem 0 0 -1.25rem;', '}', '.J_Loading .g-app-loading .icon {', 'display: block;', 'width: 0.9375rem;', 'height: 0.9375rem;', 'margin: 0.46875rem auto 0;', 'background: url(data:image/gif;base64,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) no-repeat center center;', 'background-size: 100% 100%;', '}', '.J_Loading .g-app-loading .tip {', 'text-align: center;', 'margin-top: 0.3125rem;', 'font-size: 0.375rem;', '}', '</style>', '</div>'];

exports.default = {
    show: function show() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref$text = _ref.text,
            text = _ref$text === undefined ? '正在加载' : _ref$text;

        if (this.el) {
            return;
        }
        var el = this.el = $(template.join('').replace('{{text}}', text));
        $(document.body).append(el);
    },
    hide: function hide() {
        if (this.el) {
            this.el.remove();
            this.el = null;
        }
    }
};

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;

/**
 * H5与native协议 js文件
 */
(function (win, $, UpSDK) {
    var apiStatus = {};
    var iframe = null;
    var urlPrefixCallAppInAndroid = 'uplivecn://goWindow'; // android调用外部协议
    var urlPrefixCallAppInIos = void 0;

    if (window.isUpVoice) {
        // 声播协议
        urlPrefixCallAppInIos = 'https://voice.upliveapps.com/goWindow'; // ios调用外部协议
    } else {
        urlPrefixCallAppInIos = 'https://ios.upliveapps.com/goWindow'; // ios调用外部协议
    }

    var native = {
        send: function send(url) {
            if (!iframe) {
                iframe = document.createElement('iframe');
                iframe.id = 'up_callapp_iframe_' + Date.now();
                iframe.frameborder = '0';
                iframe.style.cssText = 'display:none;border:0;width:0;height:0;';
                document.body.appendChild(iframe);
            }
            iframe.src = url;
        },
        sendUriScheme: function sendUriScheme(url) {
            window.location.href = url;
        },
        query: function query(name, scope) {
            var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i"),
                scope = scope || 'search',
                r = location[scope].substr(1).match(reg);
            if (r != null) {
                return unescape(r[2]);
            }
            return null;
        },


        addParam: function addParam(url, data) {
            if (typeof data === 'undefined') {
                return;
            }

            var hashReg = /#.*$/gi,
                hashMatch = url.match(hashReg),
                hash = '';

            if (hashMatch) {
                hash = hashMatch[0];
            }

            // 去除hash值的url
            var preUrl = url.replace(hash, '');

            var searchReg = /\?(.*?)$/gi;
            var result = searchReg.exec(preUrl);
            var query;
            if (result) {
                query = result[1].split('#')[0];
            }

            var id = !query ? '' : '&';

            return preUrl + (query && query.length > 0 ? '' : '?') + (id + $.param(data)) + hash;
        },
        // 获得平台类型
        // weixin, weibo, qq, uplive，海外版本Android在URL Hash中添加标识 #pl=uplive
        getPlatform: function getPlatform() {
            var _ref = [navigator.userAgent, 'other'],
                ua = _ref[0],
                pl = _ref[1];


            if (ua.match(/uplive/i) || this.query('pl', 'hash') == 'uplive' || localStorage.getItem('__inuplive__') || this.query('pl') == 'uplive') {
                pl = 'uplive';
            } else if (ua.match(/micromessenger/i)) {
                pl = 'wechat';
            } else if (ua.match(/qq/i)) {
                pl = 'qq';
            } else if (ua.match(/weibo/i)) {
                pl = 'weibo';
            } else if (ua.match(/renren/i)) {
                pl = 'renren';
            } else if (ua.indexOf("FBAN") > -1 || ua.indexOf("FBAV") > -1) {
                pl = 'fb';
            } else if (ua.match(/Line/i)) {
                pl = 'line';
            }

            return pl;
        },


        // 获得当前系统类型
        getSystem: function getSystem() {
            var ua = navigator.userAgent;
            return (/(iPhone|iPad|iPod|iOS)/i.test(ua) ? 'ios' : /[aA]ndroid/i.test(ua) ? 'android' : 'pc'
            );
        },


        // 系统语言
        getLanguage: function getLanguage() {
            var language = navigator.language || navigator.browserLanguage;

            if (language) {
                var arr = language.split('-');
                arr[1] = arr[1].toUpperCase();
                language = arr.join('-');
            }

            return language;
        },


        // 检查api是否可用
        checkAvail: function checkAvail() {
            var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                apiname = _ref2.apiname,
                errtip = _ref2.errtip;

            setTimeout(function () {
                if (!apiStatus[apiname] && errtip) {
                    if (typeof errtip == 'function') {
                        errtip();
                    } else {
                        alert(errtip);
                    }
                }
            }, 3000);
        },

        /**
         * 获取配置信息
         * @param cfg {
         *      invalid 0: usertoken失效，重新获取；1：第一次获取
         *      complete: function(){}
         * }
         *
         */
        getConfigs: function getConfigs() {
            var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref3$complete = _ref3.complete,
                complete = _ref3$complete === undefined ? function () {} : _ref3$complete,
                _ref3$invalid = _ref3.invalid,
                invalid = _ref3$invalid === undefined ? 0 : _ref3$invalid,
                _ref3$errtip = _ref3.errtip,
                errtip = _ref3$errtip === undefined ? '不支持' : _ref3$errtip;

            var self = this;
            var url = 'uplive://getConfigs?json=';
            var params = {
                invalid: invalid,
                receive: "$['upliveapp_getConfigs']",
                jsCallback: '$.getConfigsComplete'
            };

            $.getConfigsComplete = function (param) {
                // usertoken: "", uid: "", language: ""
                complete.call(self, JSON.parse(param));
            };

            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'getConfigs',
                errtip: errtip
            });
        },


        /**
         * 获取主播信息
         * @param cfg {
         *      complete: function(){}
         * }
         *
         */
        getHostInfo: function getHostInfo() {
            var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref4$complete = _ref4.complete,
                complete = _ref4$complete === undefined ? function () {} : _ref4$complete,
                _ref4$errtip = _ref4.errtip,
                errtip = _ref4$errtip === undefined ? '不支持' : _ref4$errtip;

            var self = this;
            var url = 'uplive://getHostInfo?json=';
            var params = {
                receive: "$['upliveapp_getHostInfo']",
                jsCallback: '$.getHostInfoComplete'
            };

            $.getHostInfoComplete = function (param) {
                complete.call(self, JSON.parse(param));
            };

            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'getHostInfo',
                errtip: errtip
            });
        },


        // 上报提现结果给客户端
        acceptAgreement: function acceptAgreement() {
            var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref5$errtip = _ref5.errtip,
                errtip = _ref5$errtip === undefined ? '不支持' : _ref5$errtip;

            var url = 'uplive://acceptAgreement?json=';
            var params = {
                receive: "$['upliveapp_acceptAgreement']"
            };

            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'acceptAgreement',
                errtip: errtip
            });
        },

        /**
         * 跳转个人主页
         * @param cfg {
         *      uid: 10234, // {Number} 整型
                tab: 0：动态 1：关注 2：粉丝 3：守护
         * }
         */
        profile: function profile() {
            var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref6$uid = _ref6.uid,
                uid = _ref6$uid === undefined ? 0 : _ref6$uid,
                _ref6$tab = _ref6.tab,
                tab = _ref6$tab === undefined ? 0 : _ref6$tab,
                _ref6$errtip = _ref6.errtip,
                errtip = _ref6$errtip === undefined ? '' : _ref6$errtip,
                _ref6$action = _ref6.action,
                action = _ref6$action === undefined ? 'callapp' : _ref6$action;

            var url = 'uplive://goWindow?json=';
            var params = {
                key: 'profile',
                extend: {
                    uid: parseInt(uid, 10),
                    tab: tab
                },
                receive: "$['upliveapp_profile']"
            };

            url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(url);
                this.checkAvail({
                    apiname: 'profile',
                    errtip: errtip
                });
            } else {
                return url;
            }
        },

        /**
         * 跳转到直播间
         * @param cfg {
         *      uid: 10234, // {Number} 整型
         *      roomid: 10234 {Number} 整型
         * }
         */
        goRoom: function goRoom() {
            var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref7$uid = _ref7.uid,
                uid = _ref7$uid === undefined ? 0 : _ref7$uid,
                _ref7$roomid = _ref7.roomid,
                roomid = _ref7$roomid === undefined ? 0 : _ref7$roomid,
                _ref7$errtip = _ref7.errtip,
                errtip = _ref7$errtip === undefined ? '' : _ref7$errtip,
                _ref7$action = _ref7.action,
                action = _ref7$action === undefined ? 'callapp' : _ref7$action;

            var url = 'uplive://goWindow?json=';
            var params = {
                key: 'room',
                extend: {
                    uid: parseInt(uid, 10),
                    roomid: parseInt(roomid, 10)
                },
                receive: "$['upliveapp_goRoom']"
            };

            url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(url);
                this.checkAvail({
                    apiname: 'goRoom',
                    errtip: errtip
                });
            } else {
                return url;
            }
        },
        goRank: function goRank() {
            var _ref8 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref8$name = _ref8.name,
                name = _ref8$name === undefined ? 1 : _ref8$name,
                _ref8$errtip = _ref8.errtip,
                errtip = _ref8$errtip === undefined ? '' : _ref8$errtip,
                _ref8$action = _ref8.action,
                action = _ref8$action === undefined ? 'callapp' : _ref8$action;

            var url = 'uplive://goWindow?json=';
            var key = void 0;

            switch (parseInt(name, 10)) {
                case 1:
                    key = 'starank';
                    break;
                case 2:
                    key = 'hostrank';
                    break;
                case 3:
                    key = 'wealthrank';
                    break;
                default:
                    key = 'starank';
            }

            var params = {
                key: key,
                receive: "$['upliveapp_goRank']"
            };

            url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(url);
                this.checkAvail({
                    apiname: 'goRank',
                    errtip: errtip
                });
            } else {
                return url;
            }
        },


        // 跳转充值界面
        gopay: function gopay() {
            var _ref9 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref9$errtip = _ref9.errtip,
                errtip = _ref9$errtip === undefined ? '' : _ref9$errtip,
                _ref9$complete = _ref9.complete,
                complete = _ref9$complete === undefined ? function () {} : _ref9$complete,
                _ref9$action = _ref9.action,
                action = _ref9$action === undefined ? 'callapp' : _ref9$action;

            var self = this;
            var url = 'uplive://goWindow?json=';
            var params = {
                key: 'pay',
                receive: "$['upliveapp_gopay']",
                jsCallback: "$['getGopayComplete']"
            };

            $.getGopayComplete = function (param) {
                complete.call(self, JSON.parse(param));
            };

            url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(url);
                this.checkAvail({
                    apiname: 'gopay',
                    errtip: errtip
                });
            } else {
                return url;
            }
        },


        // 上报提现结果给客户端
        reportCashResult: function reportCashResult() {
            var _ref10 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref10$success = _ref10.success,
                success = _ref10$success === undefined ? 1 : _ref10$success,
                errtip = _ref10.errtip;

            var url = 'uplive://h5cash?json=';
            var params = {
                success: success,
                receive: "$['upliveapp_reportCashResult']"
            };

            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'reportCashResult',
                errtip: errtip
            });
        },


        // 上报充值结果给客户端
        reportPayResult: function reportPayResult() {
            var _ref11 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref11$success = _ref11.success,
                success = _ref11$success === undefined ? 1 : _ref11$success,
                errtip = _ref11.errtip;

            var url = 'uplive://h5payment?json=';
            var params = {
                success: success,
                receive: "$['upliveapp_reportPayResult']"
            };

            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'reportPayResult',
                errtip: errtip
            });
        },


        // 关闭webview
        closeWindow: function closeWindow() {
            var _ref12 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref12$errtip = _ref12.errtip,
                errtip = _ref12$errtip === undefined ? '' : _ref12$errtip;

            var url = 'uplive://closeWindow?json=';
            var params = {
                receive: "$['upliveapp_closeWindow']"
            };

            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'closeWindow',
                errtip: errtip
            });
        },


        // 浏览器中打开
        openBrowser: function openBrowser() {
            var _ref13 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref13$url = _ref13.url,
                url = _ref13$url === undefined ? '' : _ref13$url,
                _ref13$errtip = _ref13.errtip,
                errtip = _ref13$errtip === undefined ? '' : _ref13$errtip,
                _ref13$action = _ref13.action,
                action = _ref13$action === undefined ? 'callapp' : _ref13$action;

            var _url = 'uplive://openBrowser?json=';
            var params = {
                receive: "$['upliveapp_openBrowser']",
                url: url
            };

            _url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(_url);
                this.checkAvail({
                    apiname: 'openBrowser',
                    errtip: errtip
                });
            } else {
                return _url;
            }
        },

        // 打开新的webview
        openWebView: function openWebView() {
            var _ref14 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref14$url = _ref14.url,
                url = _ref14$url === undefined ? '' : _ref14$url,
                _ref14$errtip = _ref14.errtip,
                errtip = _ref14$errtip === undefined ? '' : _ref14$errtip,
                _ref14$action = _ref14.action,
                action = _ref14$action === undefined ? 'callapp' : _ref14$action;

            var _url = 'uplive://openWebView?json=';
            var params = {
                receive: "$['upliveapp_openWebView']",
                url: url
            };

            _url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(_url);
                this.checkAvail({
                    apiname: 'openWebView',
                    errtip: errtip
                });
            } else {
                return _url;
            }
        },


        // 获取地理位置
        getLocation: function getLocation() {
            var _ref15 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref15$complete = _ref15.complete,
                complete = _ref15$complete === undefined ? function () {} : _ref15$complete,
                _ref15$errtip = _ref15.errtip,
                errtip = _ref15$errtip === undefined ? '不支持' : _ref15$errtip;

            var self = this;
            var url = 'uplive://getLocation?json=';
            var params = {
                receive: "$['upliveapp_getLocation']",
                jsCallback: '$.getLocationComplete'
            };

            $.getLocationComplete = function (param) {
                complete.call(self, JSON.parse(param));
            };

            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'getLocation',
                errtip: errtip
            });
        },

        /**
         * 支付调用
         * @param data {object}
         *      - platform 支付平台
         *      - complete {function}
         *      - params 参数
         * @return this
         */
        pay: function pay() {
            var _ref16 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref16$complete = _ref16.complete,
                complete = _ref16$complete === undefined ? function () {} : _ref16$complete,
                _ref16$platform = _ref16.platform,
                platform = _ref16$platform === undefined ? 'wxpay' : _ref16$platform,
                _ref16$productId = _ref16.productId,
                productId = _ref16$productId === undefined ? '' : _ref16$productId,
                _ref16$errtip = _ref16.errtip,
                errtip = _ref16$errtip === undefined ? '不支持支付' : _ref16$errtip;

            var self = this;
            var _url = 'uplive://payment?json=';
            var _params = {
                receive: "$['upliveapp_pay']",
                platform: platform || 'wxpay',
                params: {
                    productId: productId
                },
                jsCallback: '$.payComplete'
            };

            $.payComplete = function (param) {
                // 支付
                complete.call(self, JSON.parse(param));
            };

            this.send(_url + JSON.stringify(_params));
            this.checkAvail({
                apiname: 'pay',
                errtip: errtip
            });
        },
        ynpay: function ynpay() {
            var _ref17 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref17$complete = _ref17.complete,
                complete = _ref17$complete === undefined ? function () {} : _ref17$complete,
                _ref17$platform = _ref17.platform,
                platform = _ref17$platform === undefined ? 'wxpay' : _ref17$platform,
                _ref17$productId = _ref17.productId,
                productId = _ref17$productId === undefined ? '' : _ref17$productId,
                _ref17$orderStr = _ref17.orderStr,
                orderStr = _ref17$orderStr === undefined ? '' : _ref17$orderStr,
                _ref17$orderId = _ref17.orderId,
                orderId = _ref17$orderId === undefined ? '' : _ref17$orderId,
                _ref17$errtip = _ref17.errtip,
                errtip = _ref17$errtip === undefined ? '不支持支付' : _ref17$errtip;

            var self = this;
            var _url = 'uplive://ynzf?json=';
            var _params = {
                receive: "$['upliveapp_ynpay']",
                platform: platform || 'wxpay',
                params: {
                    orderId: orderId + '',
                    productId: productId + '',
                    orderStr: orderStr
                },
                jsCallback: '$.payComplete'
            };

            $.payComplete = function (param) {
                // 支付
                complete.call(self, JSON.parse(param));
            };

            this.send(_url + JSON.stringify(_params));
            this.checkAvail({
                apiname: 'ynpay',
                errtip: errtip
            });
        },
        checkRepairOrder: function checkRepairOrder() {
            var _ref18 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref18$complete = _ref18.complete,
                complete = _ref18$complete === undefined ? function () {} : _ref18$complete,
                _ref18$errtip = _ref18.errtip,
                errtip = _ref18$errtip === undefined ? '' : _ref18$errtip;

            var self = this;
            var url = 'uplive://checkRepairOrder?json=';
            var params = {
                receive: "$['upliveapp_checkRepairOrder']",
                jsCallback: '$.checkRepairOrderComplete'
            };

            $.checkRepairOrderComplete = function (param) {
                // 支付
                complete.call(self, JSON.parse(param));
            };

            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'checkRepairOrder',
                errtip: errtip
            });
        },
        goRepairOrder: function goRepairOrder() {
            var _ref19 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref19$complete = _ref19.complete,
                complete = _ref19$complete === undefined ? function () {} : _ref19$complete,
                _ref19$errtip = _ref19.errtip,
                errtip = _ref19$errtip === undefined ? '' : _ref19$errtip;

            var url = 'uplive://goRepairOrder?json=';
            var params = {
                receive: "$['upliveapp_goRepairOrder']",
                jsCallback: '$.goRepairOrderComplete'
            };

            $.goRepairOrderComplete = function (param) {
                // 支付
                complete.call(self, JSON.parse(param));
            };

            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'goRepairOrder',
                errtip: errtip
            });
        },

        // 通过相机获取图片
        getPhotoCamera: function getPhotoCamera() {
            var _ref20 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref20$complete = _ref20.complete,
                complete = _ref20$complete === undefined ? function () {} : _ref20$complete,
                _ref20$type = _ref20.type,
                type = _ref20$type === undefined ? "share" : _ref20$type,
                _ref20$crop = _ref20.crop,
                crop = _ref20$crop === undefined ? 0 : _ref20$crop,
                _ref20$width = _ref20.width,
                width = _ref20$width === undefined ? 640 : _ref20$width,
                _ref20$height = _ref20.height,
                height = _ref20$height === undefined ? 640 : _ref20$height,
                _ref20$errtip = _ref20.errtip,
                errtip = _ref20$errtip === undefined ? '不支持' : _ref20$errtip;

            var self = this;
            var url = 'uplive://getPhoto?json=';
            var params = {
                type: type || 'share',
                sourceType: "camera", //图片来源，照相机
                crop: crop,
                width: width,
                height: height,
                receive: "$['upliveapp_getPhotoCamera']",
                jsCallback: '$.getPhotoCameraComplete'
            };

            $.getPhotoCameraComplete = function (param) {
                // "url":"网络链接"
                complete.call(self, JSON.parse(param));
            };

            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'getPhotoCamera',
                errtip: errtip
            });
        },

        // 通过图库获取图片
        getPhotoAlbum: function getPhotoAlbum() {
            var _ref21 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref21$complete = _ref21.complete,
                complete = _ref21$complete === undefined ? function () {} : _ref21$complete,
                _ref21$type = _ref21.type,
                type = _ref21$type === undefined ? "share" : _ref21$type,
                _ref21$crop = _ref21.crop,
                crop = _ref21$crop === undefined ? 0 : _ref21$crop,
                _ref21$width = _ref21.width,
                width = _ref21$width === undefined ? 640 : _ref21$width,
                _ref21$height = _ref21.height,
                height = _ref21$height === undefined ? 640 : _ref21$height,
                _ref21$errtip = _ref21.errtip,
                errtip = _ref21$errtip === undefined ? '不支持' : _ref21$errtip;

            var self = this;
            var url = 'uplive://getPhoto?json=';
            var params = {
                type: type || 'share',
                sourceType: "album", //图片来源，照相机
                crop: crop,
                width: width,
                height: height,
                receive: "$['upliveapp_getPhotoAlbum']",
                jsCallback: '$.getPhotoAlbumComplete'
            };

            $.getPhotoAlbumComplete = function (param) {
                // "url":"网络链接"
                complete.call(self, JSON.parse(param));
            };

            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'getPhotoAlbum',
                errtip: errtip
            });
        },


        // 客户端分享
        share: function share() {
            var _ref22 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref22$complete = _ref22.complete,
                complete = _ref22$complete === undefined ? function () {} : _ref22$complete,
                _ref22$title = _ref22.title,
                title = _ref22$title === undefined ? '分享标题' : _ref22$title,
                _ref22$url = _ref22.url,
                url = _ref22$url === undefined ? 'http://www.baidu.com' : _ref22$url,
                _ref22$imageUrl = _ref22.imageUrl,
                imageUrl = _ref22$imageUrl === undefined ? 'https://m.baidu.com/static/index/plus/plus_logo.png' : _ref22$imageUrl,
                _ref22$desc = _ref22.desc,
                desc = _ref22$desc === undefined ? '分享表述' : _ref22$desc,
                _ref22$platform = _ref22.platform,
                platform = _ref22$platform === undefined ? {} : _ref22$platform,
                _ref22$errtip = _ref22.errtip,
                errtip = _ref22$errtip === undefined ? '客户端不支持分享' : _ref22$errtip;

            var self = this;
            var _url = 'uplive://sharePage?json=';
            var pls = ['qq', 'qzone', 'wechat_friends', 'wechat_circle', 'sina', 'fb', 'tw'];
            var oauthtype = { 'fb': 'fb', 'tw': 'twitter', 'sina': 'weibo' };

            var params = {
                receive: "$['upliveapp_share']",
                platform: {},
                jsCallback: '$.upliveShareComplete'
            };

            pls.forEach(function (item, i) {
                params.platform[item] = {
                    url: url,
                    title: title,
                    imageUrl: imageUrl,
                    desc: desc
                };
            });

            if (JSON.stringify(platform) != '{}') {
                params = $.extend(true, params, {
                    platform: platform
                });
            }

            for (var i in params) {
                if (i == 'platform') {
                    for (var j in params[i]) {
                        for (var k in params[i][j]) {
                            if (k == 'title' || k == 'desc') {
                                params[i][j][k] = encodeURIComponent(params[i][j][k]);
                            }
                            if (k == 'url' && params[i][j][k] && oauthtype[j]) {
                                var _url2 = params[i][j][k];

                                params[i][j][k] = this.addParam(_url2, {
                                    oauthtype: oauthtype[j]
                                });
                            }
                        }
                    }
                }
            }

            $.upliveShareComplete = function (param) {
                complete.call(self, JSON.parse(param));
            };
            this.send(_url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'share',
                errtip: errtip
            });
        },


        // 单渠道分享
        singleShare: function singleShare() {
            var _ref23 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref23$complete = _ref23.complete,
                complete = _ref23$complete === undefined ? function () {} : _ref23$complete,
                _ref23$title = _ref23.title,
                title = _ref23$title === undefined ? '分享标题' : _ref23$title,
                _ref23$url = _ref23.url,
                url = _ref23$url === undefined ? 'http://www.baidu.com' : _ref23$url,
                _ref23$imageUrl = _ref23.imageUrl,
                imageUrl = _ref23$imageUrl === undefined ? 'https://m.baidu.com/static/index/plus/plus_logo.png' : _ref23$imageUrl,
                _ref23$desc = _ref23.desc,
                desc = _ref23$desc === undefined ? '分享表述' : _ref23$desc,
                _ref23$type = _ref23.type,
                type = _ref23$type === undefined ? 'fb' : _ref23$type,
                _ref23$errtip = _ref23.errtip,
                errtip = _ref23$errtip === undefined ? '客户端不支持分享' : _ref23$errtip,
                _ref23$action = _ref23.action,
                action = _ref23$action === undefined ? 'callapp' : _ref23$action;

            var self = this;
            var system = this.getSystem();
            var _url = 'uplive://singleShare?json=';
            var pls = ["qq", "qzone", "wechat_friends", "wechat_circle", "sina", "fb", "tw", "messenger", "whatsapp", "ins", "line", "kakao"];
            var oauthtype = { 'fb': 'fb', 'tw': 'twitter', 'sina': 'weibo' };

            if (url && oauthtype[type]) {
                url = this.addParam(url, {
                    oauthtype: oauthtype[type]
                });
            }
            if (type == 'sina') {
                desc += '>>' + url;
            }
            var params = {
                receive: "$['upliveapp_singleShare']",
                platform: {
                    url: url,
                    title: system == 'ios' ? title : encodeURIComponent(title),
                    imageUrl: imageUrl,
                    desc: system == 'ios' ? desc : encodeURIComponent(desc)
                },
                type: type,
                jsCallback: '$.upliveSingleShareComplete'
            };

            $.upliveSingleShareComplete = function (param) {
                complete.call(self, JSON.parse(param));
            };

            _url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(_url);
                this.checkAvail({
                    apiname: 'singleShare',
                    errtip: errtip
                });
            } else {
                return _url;
            }
        },


        // 1.6.5 根据国家码跳转到国家主播列表
        goHotListByArea: function goHotListByArea() {
            var _ref24 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref24$countryCode = _ref24.countryCode,
                countryCode = _ref24$countryCode === undefined ? '' : _ref24$countryCode,
                _ref24$errtip = _ref24.errtip,
                errtip = _ref24$errtip === undefined ? '' : _ref24$errtip;

            var url = 'uplive://goWindow?json=';
            var params = {
                key: 'hotbyarea',
                extend: {
                    countryCode: countryCode
                },
                receive: "$['upliveapp_goHotListByArea']"
            };

            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'goHotListByArea',
                errtip: errtip
            });
        },

        /*--------------------- V2.0.0 -------------------*/

        // 游客登录
        login: function login() {
            var _ref25 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref25$complete = _ref25.complete,
                complete = _ref25$complete === undefined ? function () {} : _ref25$complete,
                _ref25$errtip = _ref25.errtip,
                errtip = _ref25$errtip === undefined ? '不支持登录' : _ref25$errtip;

            var self = this;
            var url = 'uplive://goLogin?json=';
            var params = {
                receive: "$['upliveapp_login']",
                jsCallback: '$.loginComplete'
            };
            $.loginComplete = function (param) {
                complete.call(self, JSON.parse(param));
            };
            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'login',
                errtip: errtip
            });
        },


        // 刷新用户信息
        refreshProfile: function refreshProfile() {
            var _ref26 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref26$errtip = _ref26.errtip,
                errtip = _ref26$errtip === undefined ? '不支持刷新用户信息' : _ref26$errtip;

            var url = 'uplive://refreshProfile?json=';
            var params = {
                receive: "$['upliveapp_refreshProfile']"
            };

            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'refreshProfile',
                errtip: errtip
            });
        },


        /* -------------------- ios 我的收益 --------------------- */

        goCashRecord: function goCashRecord() {
            var _ref27 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref27$errtip = _ref27.errtip,
                errtip = _ref27$errtip === undefined ? '不支持领取纪录' : _ref27$errtip;

            var url = 'uplive://goCashRecord?json=';
            var params = {
                receive: "$['upliveapp_goCashRecord']"
            };

            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'goCashRecord',
                errtip: errtip
            });
        },
        bindMobilePhone: function bindMobilePhone() {
            var _ref28 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref28$complete = _ref28.complete,
                complete = _ref28$complete === undefined ? function () {} : _ref28$complete,
                _ref28$errtip = _ref28.errtip,
                errtip = _ref28$errtip === undefined ? '不支持手机绑定' : _ref28$errtip;

            var self = this;
            var url = 'uplive://bindMobilePhone?json=';
            var params = {
                receive: "$['upliveapp_bindMobilePhone']",
                jsCallback: '$.bindMobilePhoneComplete'
            };
            $.bindMobilePhoneComplete = function (param) {
                complete.call(self, JSON.parse(param));
            };
            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'bindMobilePhone',
                errtip: errtip
            });
        },
        bindWechat: function bindWechat() {
            var _ref29 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref29$complete = _ref29.complete,
                complete = _ref29$complete === undefined ? function () {} : _ref29$complete,
                _ref29$errtip = _ref29.errtip,
                errtip = _ref29$errtip === undefined ? '不支持微信绑定' : _ref29$errtip;

            var self = this;
            var url = 'uplive://bindWechat?json=';
            var params = {
                receive: "$['upliveapp_bindWechat']",
                jsCallback: '$.bindWechatComplete'
            };
            $.bindWechatComplete = function (param) {
                complete.call(self, JSON.parse(param));
            };
            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'bindWechat',
                errtip: errtip
            });
        },
        setTitle: function setTitle() {
            var _ref30 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref30$title = _ref30.title,
                title = _ref30$title === undefined ? '' : _ref30$title,
                _ref30$errtip = _ref30.errtip,
                errtip = _ref30$errtip === undefined ? function () {} : _ref30$errtip;

            var self = this;
            var system = this.getSystem();
            var _url = 'uplive://setTitle?json=';
            var _params = {
                receive: "$['upliveapp_setTitle']",
                params: {
                    title: title
                }
            };

            if (system == 'android') {
                document.title = title;
            } else {
                this.send(_url + JSON.stringify(_params));
                this.checkAvail({
                    apiname: 'setTitle',
                    errtip: errtip
                });
            }
        },


        /**
         * 设置客户端导航
         */
        setNavBar: function setNavBar() {
            var _ref31 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref31$backgroundColo = _ref31.backgroundColor,
                backgroundColor = _ref31$backgroundColo === undefined ? '#FFFFFF' : _ref31$backgroundColo,
                _ref31$skin = _ref31.skin,
                skin = _ref31$skin === undefined ? 0 : _ref31$skin,
                _ref31$iconPath = _ref31.iconPath,
                iconPath = _ref31$iconPath === undefined ? '' : _ref31$iconPath,
                _ref31$pagePath = _ref31.pagePath,
                pagePath = _ref31$pagePath === undefined ? '' : _ref31$pagePath,
                _ref31$errtip = _ref31.errtip,
                errtip = _ref31$errtip === undefined ? function () {} : _ref31$errtip;

            var self = this;
            var system = this.getSystem();
            var _url = 'uplive://setNavBar?json=';
            var _params = {
                receive: "$['upliveapp_setNavBar']",
                params: {
                    backgroundColor: backgroundColor, // 十六进制
                    skin: skin, // 0: 默认紫色back + 黑色文本；1: 白色back + 白色文本
                    iconPath: iconPath, // 图片路径
                    pagePath: pagePath // 点击icon的页面路径

                }
            };

            this.send(_url + JSON.stringify(_params));
            this.checkAvail({
                apiname: 'setNavBar',
                errtip: errtip
            });
        },

        /* ----------------------V 2.6.0 -------------------*/
        /**
         * 跳转到开播准备页面
         * @param cfg {
         * }
         */
        goReadyToLive: function goReadyToLive() {
            var _ref32 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref32$errtip = _ref32.errtip,
                errtip = _ref32$errtip === undefined ? '' : _ref32$errtip,
                _ref32$action = _ref32.action,
                action = _ref32$action === undefined ? 'callapp' : _ref32$action;

            var url = 'uplive://goWindow?json=';
            var params = {
                key: 'readyToLive',
                receive: "$['upliveapp_goReadyToLive']"
            };

            url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(url);
                this.checkAvail({
                    apiname: 'goReadyToLive',
                    errtip: errtip
                });
            } else {
                return url;
            }
        },


        /**
         * 跳转到我的背包页面
         * @param cfg {
         * }
         */
        goPack: function goPack() {
            var _ref33 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref33$errtip = _ref33.errtip,
                errtip = _ref33$errtip === undefined ? '' : _ref33$errtip,
                _ref33$action = _ref33.action,
                action = _ref33$action === undefined ? 'callapp' : _ref33$action;

            var url = 'uplive://goWindow?json=';
            var params = {
                key: 'pack',
                receive: "$['upliveapp_goPack']"
            };

            url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(url);
                this.checkAvail({
                    apiname: 'goPack',
                    errtip: errtip
                });
            } else {
                return url;
            }
        },


        /**
         * 跳转到发现列表
         * @param cfg {
         * }
         */
        goFindList: function goFindList() {
            var _ref34 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref34$errtip = _ref34.errtip,
                errtip = _ref34$errtip === undefined ? '' : _ref34$errtip,
                _ref34$action = _ref34.action,
                action = _ref34$action === undefined ? 'callapp' : _ref34$action;

            var url = 'uplive://goWindow?json=';
            var params = {
                key: 'findList',
                receive: "$['upliveapp_goFindList']"
            };

            url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(url);
                this.checkAvail({
                    apiname: 'goFindList',
                    errtip: errtip
                });
            } else {
                return url;
            }
        },


        /**
         * 跳转到热门列表
         * @param cfg {
         * }
         */
        goHotList: function goHotList() {
            var _ref35 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref35$errtip = _ref35.errtip,
                errtip = _ref35$errtip === undefined ? '' : _ref35$errtip,
                _ref35$action = _ref35.action,
                action = _ref35$action === undefined ? 'callapp' : _ref35$action;

            var url = 'uplive://goWindow?json=';
            var params = {
                key: 'hotList',
                receive: "$['upliveapp_goHotList']"
            };

            url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(url);
                this.checkAvail({
                    apiname: 'goHotList',
                    errtip: errtip
                });
            } else {
                return url;
            }
        },


        /**
         * 跳转到VIP特权页面
         * @param cfg {
         * }
         */
        goVipPrivileges: function goVipPrivileges() {
            var _ref36 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref36$errtip = _ref36.errtip,
                errtip = _ref36$errtip === undefined ? '' : _ref36$errtip;

            var url = 'uplive://goWindow?json=';
            var params = {
                key: 'vipPrivileges',
                receive: "$['upliveapp_goVipPrivileges']"
            };

            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'goVipPrivileges',
                errtip: errtip
            });
        },


        /**
        * 跳转到VIP特权设置页面
        * @param cfg {
        * }
        */
        goVipPrivilegesSetting: function goVipPrivilegesSetting() {
            var _ref37 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref37$errtip = _ref37.errtip,
                errtip = _ref37$errtip === undefined ? '' : _ref37$errtip,
                _ref37$action = _ref37.action,
                action = _ref37$action === undefined ? 'callapp' : _ref37$action;

            var url = 'uplive://goWindow?json=';
            var params = {
                key: 'vipPrivilegesSetting',
                receive: "$['upliveapp_goVipPrivilegesSetting']"
            };

            url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(url);
                this.checkAvail({
                    apiname: 'goVipPrivilegesSetting',
                    errtip: errtip
                });
            } else {
                return url;
            }
        },


        /**
         * 跳转开通守护
         * uid  主播id
         * roomId 直播间id
         * complete 回调方法
         */
        goOpenGuard: function goOpenGuard() {
            var _ref38 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref38$uid = _ref38.uid,
                uid = _ref38$uid === undefined ? 0 : _ref38$uid,
                _ref38$roomId = _ref38.roomId,
                roomId = _ref38$roomId === undefined ? 0 : _ref38$roomId,
                _ref38$complete = _ref38.complete,
                complete = _ref38$complete === undefined ? function () {} : _ref38$complete,
                _ref38$errtip = _ref38.errtip,
                errtip = _ref38$errtip === undefined ? '' : _ref38$errtip,
                _ref38$action = _ref38.action,
                action = _ref38$action === undefined ? 'callapp' : _ref38$action;

            var url = 'uplive://goWindow?json=';
            var params = {
                key: 'openGuard',
                extend: {
                    uid: uid,
                    roomid: roomId
                },
                receive: "$['upliveapp_goOpenGuard']",
                "jsCallback": "$.buyOpenGuardComplete"
            };

            $.buyOpenGuardComplete = function (param) {
                complete.call(self, JSON.parse(param));
            };

            url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(url);
                this.checkAvail({
                    apiname: 'goOpenGuard',
                    errtip: errtip
                });
            } else {
                return url;
            }
        },


        /**
         *
         * 跳转IM聊天
         * uid  主播id
         *
         */

        openChat: function openChat() {
            var _ref39 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref39$uid = _ref39.uid,
                uid = _ref39$uid === undefined ? 10005 : _ref39$uid,
                _ref39$errtip = _ref39.errtip,
                errtip = _ref39$errtip === undefined ? '' : _ref39$errtip,
                _ref39$action = _ref39.action,
                action = _ref39$action === undefined ? 'callapp' : _ref39$action;

            var url = 'uplive://goWindow?json=';
            var params = {
                key: 'openChat',
                extend: {
                    uid: uid
                },
                receive: "$['upliveapp_openChat']"
            };

            url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(url);
                this.checkAvail({
                    apiname: 'openChat',
                    errtip: errtip
                });
            } else {
                return url;
            }
        },


        /**
         * 跳转到关注列表
         * @param cfg {
         * }
         */
        goFollowList: function goFollowList() {
            var _ref40 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref40$errtip = _ref40.errtip,
                errtip = _ref40$errtip === undefined ? '' : _ref40$errtip,
                _ref40$action = _ref40.action,
                action = _ref40$action === undefined ? 'callapp' : _ref40$action;

            var url = 'uplive://goWindow?json=';
            var params = {
                key: 'followList',
                receive: "$['upliveapp_goFollowList']"
            };

            url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(url);
                this.checkAvail({
                    apiname: 'goFollowList',
                    errtip: errtip
                });
            } else {
                return url;
            }
        },


        /**
         * 跳转到短视频录制准备页面；
         * @param cfg {
                topic: 话题,
                topicId: 话题id {int}
         * }
         */
        goReadyToShortVideo: function goReadyToShortVideo() {
            var _ref41 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref41$topic = _ref41.topic,
                topic = _ref41$topic === undefined ? '' : _ref41$topic,
                _ref41$topicId = _ref41.topicId,
                topicId = _ref41$topicId === undefined ? '' : _ref41$topicId,
                _ref41$errtip = _ref41.errtip,
                errtip = _ref41$errtip === undefined ? '' : _ref41$errtip,
                _ref41$action = _ref41.action,
                action = _ref41$action === undefined ? 'callapp' : _ref41$action;

            var url = 'uplive://goWindow?json=';
            var params = {
                key: 'readyToShortVideo',
                extend: {
                    topic: topic,
                    topicId: parseInt(topicId, 10)
                },
                receive: "$['upliveapp_goReadyToShortVideo']"
            };

            url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(url);
                this.checkAvail({
                    apiname: 'goReadyToShortVideo',
                    errtip: errtip
                });
            } else {
                return url;
            }
        },


        /**
         * 跳转到指定短视频页面&播放视频
         * @param cfg {
                rid: '主帖子ID', ［必须］
                dynamicId: '动态ID',［必须］
                dynamicType: "动态类型",［必须］
                // ［非必须］
                resourceUrls: {}, // 图片或者视频地址
                resourceDesp: "" // 资源描述信息
         * }
         */
        goDynamic: function goDynamic() {
            var _ref42 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref42$rid = _ref42.rid,
                rid = _ref42$rid === undefined ? '' : _ref42$rid,
                _ref42$dynamicId = _ref42.dynamicId,
                dynamicId = _ref42$dynamicId === undefined ? '' : _ref42$dynamicId,
                _ref42$dynamicType = _ref42.dynamicType,
                dynamicType = _ref42$dynamicType === undefined ? '' : _ref42$dynamicType,
                _ref42$resourceUrls = _ref42.resourceUrls,
                resourceUrls = _ref42$resourceUrls === undefined ? null : _ref42$resourceUrls,
                _ref42$resourceDesp = _ref42.resourceDesp,
                resourceDesp = _ref42$resourceDesp === undefined ? '' : _ref42$resourceDesp,
                _ref42$errtip = _ref42.errtip,
                errtip = _ref42$errtip === undefined ? '' : _ref42$errtip;

            var url = 'uplive://goWindow?json=';
            var _params = {
                rid: rid,
                dynamicId: dynamicId,
                dynamicType: dynamicType
            };

            if (resourceUrls) {
                _params.resourceUrls = resourceUrls;
                _params.resourceDesp = resourceDesp;
            }
            var params = {
                key: 'dynamic',
                extend: _params,
                receive: "$['upliveapp_goDynamic']"
            };

            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'goDynamic',
                errtip: errtip
            });
        },


        /* ----------------------V ios 2.5.0 -------------------*/

        /**
         * 跳转到座驾商场
         * @param cfg {
         * }
         */
        goCarMall: function goCarMall() {
            var _ref43 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref43$errtip = _ref43.errtip,
                errtip = _ref43$errtip === undefined ? '' : _ref43$errtip,
                _ref43$action = _ref43.action,
                action = _ref43$action === undefined ? 'callapp' : _ref43$action;

            var url = 'uplive://goWindow?json=';
            var params = {
                key: 'carmall',
                receive: "$['upliveapp_goCarMall']"
            };

            url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(url);
                this.checkAvail({
                    apiname: 'goCarMall',
                    errtip: errtip
                });
            } else {
                return url;
            }
        },


        /**
         * 跳转到我的座驾
         * @param cfg {
         * }
         */
        goMyCar: function goMyCar() {
            var _ref44 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref44$errtip = _ref44.errtip,
                errtip = _ref44$errtip === undefined ? '' : _ref44$errtip,
                _ref44$action = _ref44.action,
                action = _ref44$action === undefined ? 'callapp' : _ref44$action;

            var url = 'uplive://goWindow?json=';
            var params = {
                key: 'mycar',
                receive: "$['upliveapp_goMyCar']"
            };

            url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(url);
                this.checkAvail({
                    apiname: 'goMyCar',
                    errtip: errtip
                });
            } else {
                return url;
            }
        },


        /*--------------------- 外部协议 -------------------*/
        // 打开链接
        openUrlCallApp: function openUrlCallApp() {
            var _ref45 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref45$url = _ref45.url,
                url = _ref45$url === undefined ? '' : _ref45$url;

            var system = this.getSystem();
            var _url = urlPrefixCallAppInIos + '?json=';

            if (system == 'android') {
                _url = urlPrefixCallAppInAndroid + '/webview?json=';;
            }

            var params = {
                key: 'webview',
                url: url
            };
            this.sendUriScheme(_url + encodeURIComponent(JSON.stringify(params)));
        },


        // 进入用户主页
        profileCallApp: function profileCallApp() {
            var _ref46 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref46$uid = _ref46.uid,
                uid = _ref46$uid === undefined ? 0 : _ref46$uid;

            var system = this.getSystem();
            var url = urlPrefixCallAppInIos + '?json=';

            if (system == 'android') {
                url = urlPrefixCallAppInAndroid + '/profile?json=';;
            }
            var params = {
                key: 'profile',
                extend: {
                    uid: parseInt(uid, 10)
                }
            };
            this.sendUriScheme(url + encodeURIComponent(JSON.stringify(params)));
        },


        // 进入充值页
        goPayCallApp: function goPayCallApp() {
            var system = this.getSystem();
            var url = urlPrefixCallAppInIos + '?json=';

            if (system == 'android') {
                url = urlPrefixCallAppInAndroid + '/pay?json=';
            }
            var params = {
                key: 'pay'
            };
            this.sendUriScheme(url + encodeURIComponent(JSON.stringify(params)));
        },


        // 直播间
        goRoomCallApp: function goRoomCallApp() {
            var _ref47 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref47$uid = _ref47.uid,
                uid = _ref47$uid === undefined ? 0 : _ref47$uid,
                _ref47$roomid = _ref47.roomid,
                roomid = _ref47$roomid === undefined ? 0 : _ref47$roomid;

            var system = this.getSystem();
            var url = urlPrefixCallAppInIos + '?json=';

            if (system == 'android') {
                url = urlPrefixCallAppInAndroid + '/room?json=';
            }
            var params = {
                key: 'room',
                extend: {
                    uid: parseInt(uid, 10),
                    roomid: parseInt(roomid, 10)
                }
            };
            this.sendUriScheme(url + encodeURIComponent(JSON.stringify(params)));
        },

        // 榜单页 1 星榜，2主播榜，3财富榜
        goRankCallApp: function goRankCallApp() {
            var _ref48 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref48$name = _ref48.name,
                name = _ref48$name === undefined ? 1 : _ref48$name;

            var system = this.getSystem();
            var url = urlPrefixCallAppInIos + '?json=';

            if (system == 'android') {
                url = urlPrefixCallAppInAndroid + '/rank?json=';
            }
            var key = void 0;

            switch (parseInt(name, 10)) {
                case 1:
                    key = 'starank';
                    break;
                case 2:
                    key = 'hostrank';
                    break;
                case 3:
                    key = 'wealthrank';
                    break;
                default:
                    key = 'starank';
            }
            var params = {
                key: key
            };
            this.sendUriScheme(url + encodeURIComponent(JSON.stringify(params)));
        },

        // 1.6.5 根据国家码跳转到国家主播列表
        goHotListByAreaCallApp: function goHotListByAreaCallApp() {
            var _ref49 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref49$countryCode = _ref49.countryCode,
                countryCode = _ref49$countryCode === undefined ? '' : _ref49$countryCode;

            var system = this.getSystem();
            var url = urlPrefixCallAppInIos + '?json=';

            if (system == 'android') {
                url = urlPrefixCallAppInAndroid + '/hotbyarea?json=';
            }
            var params = {
                key: 'hotbyarea',
                extend: {
                    countryCode: countryCode
                }
            };
            this.sendUriScheme(url + encodeURIComponent(JSON.stringify(params)));
        },

        /**
         * 发送GIFTO礼物
         * @param cfg {
         *      data {}；发送礼物的详细信息
         *      complete: function(){}
         * }
         *      uplive://sendGTOGift?json={
         *              "jsCallback": ""
         *              ,receive:""
         *              ,"data":"{
         *                  //接收礼物用户uid
         *                  "sendtoUid":"",
         *                  // 消息内容
         *                  "content": "1";
         *                  //礼物ID 必填
         *                  "giftId": "2";
         *                  //礼物名称
         *                  "giftName" : "3";
         *                  //连发系数
         *                  "giftAmount": "4";
         *                  //是否连续
         *                  "isContinuous": "5";
         *                  //连续次数 必填
         *                  "numContinuous": "6";
         *                  //礼物大图
         *                  "giftBigPicUrl": "6";
         *              }"}
         *
         */
        sendGTOGift: function sendGTOGift() {
            var _ref50 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref50$complete = _ref50.complete,
                complete = _ref50$complete === undefined ? function () {} : _ref50$complete,
                _ref50$data = _ref50.data,
                data = _ref50$data === undefined ? {} : _ref50$data,
                _ref50$errtip = _ref50.errtip,
                errtip = _ref50$errtip === undefined ? '不支持' : _ref50$errtip;

            var self = this;
            var url = 'uplive://sendGTOGift?json=';
            var params = {
                receive: "$['upliveapp_sendGTOGift']",
                jsCallback: '$.sendGiftoGiftComplete',
                data: data
            };

            $.sendGiftoGiftComplete = function (param) {
                // usertoken: "", uid: "", language: ""
                complete.call(self, JSON.parse(param));
            };

            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'sendGTOGift',
                errtip: errtip
            });
        },

        /**
         * 通过面板的id和礼物的id选中礼物
         * @param data
         * @param errtip
         */
        selectGift: function selectGift(_ref51) {
            var _ref51$data = _ref51.data,
                data = _ref51$data === undefined ? {} : _ref51$data,
                _ref51$errtip = _ref51.errtip,
                errtip = _ref51$errtip === undefined ? '不支持' : _ref51$errtip;

            var url = 'uplive://selectGift?json=';
            var params = {
                receive: "$['upliveapp_selectGift']",
                params: {
                    giftId: data.giftId,
                    labelId: data.labelId
                }
            };
            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'selectGift',
                errtip: errtip
            });
        }
    };

    var _loop = function _loop(i) {
        $['upliveapp_' + i] = function () {
            apiStatus[i] = 1;
        };
    };

    for (var i in native) {
        _loop(i);
    }

    window.UpSDK = native;

    if (typeof module != 'undefined' && module.exports) {
        module.exports = native;
    } else {
        window.UpSDK = native;
    }

    if (window.define && __webpack_require__(359).cmd) {
        !(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
            module.exports = native;
        }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    }
})(window, window.Zepto || window.jQuery || (window['$'] = {}));

/***/ }),
/* 359 */
/***/ (function(module, exports) {

module.exports = function() {
	throw new Error("define cannot be used indirect");
};


/***/ }),
/* 360 */
/***/ (function(module, exports) {



;(function () {
	'use strict';

	/**
  * @preserve FastClick: polyfill to remove click delays on browsers with touch UIs.
  *
  * @codingstandard ftlabs-jsv2
  * @copyright The Financial Times Limited [All Rights Reserved]
  * @license MIT License (see LICENSE.txt)
  */

	/*jslint browser:true, node:true*/
	/*global define, Event, Node*/

	/**
  * Instantiate fast-clicking listeners on the specified layer.
  *
  * @constructor
  * @param {Element} layer The layer to listen on
  * @param {Object} [options={}] The options to override the defaults
  */

	function FastClick(layer, options) {
		var oldOnClick;

		options = options || {};

		/**
   * Whether a click is currently being tracked.
   *
   * @type boolean
   */
		this.trackingClick = false;

		/**
   * Timestamp for when click tracking started.
   *
   * @type number
   */
		this.trackingClickStart = 0;

		/**
   * The element being tracked for a click.
   *
   * @type EventTarget
   */
		this.targetElement = null;

		/**
   * X-coordinate of touch start event.
   *
   * @type number
   */
		this.touchStartX = 0;

		/**
   * Y-coordinate of touch start event.
   *
   * @type number
   */
		this.touchStartY = 0;

		/**
   * ID of the last touch, retrieved from Touch.identifier.
   *
   * @type number
   */
		this.lastTouchIdentifier = 0;

		/**
   * Touchmove boundary, beyond which a click will be cancelled.
   *
   * @type number
   */
		this.touchBoundary = options.touchBoundary || 10;

		/**
   * The FastClick layer.
   *
   * @type Element
   */
		this.layer = layer;

		/**
   * The minimum time between tap(touchstart and touchend) events
   *
   * @type number
   */
		this.tapDelay = options.tapDelay || 200;

		/**
   * The maximum time for a tap
   *
   * @type number
   */
		this.tapTimeout = options.tapTimeout || 700;

		if (FastClick.notNeeded(layer)) {
			return;
		}

		// Some old versions of Android don't have Function.prototype.bind
		function bind(method, context) {
			return function () {
				return method.apply(context, arguments);
			};
		}

		var methods = ['onMouse', 'onClick', 'onTouchStart', 'onTouchMove', 'onTouchEnd', 'onTouchCancel'];
		var context = this;
		for (var i = 0, l = methods.length; i < l; i++) {
			context[methods[i]] = bind(context[methods[i]], context);
		}

		// Set up event handlers as required
		if (deviceIsAndroid) {
			layer.addEventListener('mouseover', this.onMouse, true);
			layer.addEventListener('mousedown', this.onMouse, true);
			layer.addEventListener('mouseup', this.onMouse, true);
		}

		layer.addEventListener('click', this.onClick, true);
		layer.addEventListener('touchstart', this.onTouchStart, false);
		layer.addEventListener('touchmove', this.onTouchMove, false);
		layer.addEventListener('touchend', this.onTouchEnd, false);
		layer.addEventListener('touchcancel', this.onTouchCancel, false);

		// Hack is required for browsers that don't support Event#stopImmediatePropagation (e.g. Android 2)
		// which is how FastClick normally stops click events bubbling to callbacks registered on the FastClick
		// layer when they are cancelled.
		if (!Event.prototype.stopImmediatePropagation) {
			layer.removeEventListener = function (type, callback, capture) {
				var rmv = Node.prototype.removeEventListener;
				if (type === 'click') {
					rmv.call(layer, type, callback.hijacked || callback, capture);
				} else {
					rmv.call(layer, type, callback, capture);
				}
			};

			layer.addEventListener = function (type, callback, capture) {
				var adv = Node.prototype.addEventListener;
				if (type === 'click') {
					adv.call(layer, type, callback.hijacked || (callback.hijacked = function (event) {
						if (!event.propagationStopped) {
							callback(event);
						}
					}), capture);
				} else {
					adv.call(layer, type, callback, capture);
				}
			};
		}

		// If a handler is already declared in the element's onclick attribute, it will be fired before
		// FastClick's onClick handler. Fix this by pulling out the user-defined handler function and
		// adding it as listener.
		if (typeof layer.onclick === 'function') {

			// Android browser on at least 3.2 requires a new reference to the function in layer.onclick
			// - the old one won't work if passed to addEventListener directly.
			oldOnClick = layer.onclick;
			layer.addEventListener('click', function (event) {
				oldOnClick(event);
			}, false);
			layer.onclick = null;
		}
	}

	/**
 * Windows Phone 8.1 fakes user agent string to look like Android and iPhone.
 *
 * @type boolean
 */
	var deviceIsWindowsPhone = navigator.userAgent.indexOf("Windows Phone") >= 0;

	/**
  * Android requires exceptions.
  *
  * @type boolean
  */
	var deviceIsAndroid = navigator.userAgent.indexOf('Android') > 0 && !deviceIsWindowsPhone;

	/**
  * iOS requires exceptions.
  *
  * @type boolean
  */
	var deviceIsIOS = /iP(ad|hone|od)/.test(navigator.userAgent) && !deviceIsWindowsPhone;

	/**
  * iOS 4 requires an exception for select elements.
  *
  * @type boolean
  */
	var deviceIsIOS4 = deviceIsIOS && /OS 4_\d(_\d)?/.test(navigator.userAgent);

	/**
  * iOS 6.0-7.* requires the target element to be manually derived
  *
  * @type boolean
  */
	var deviceIsIOSWithBadTarget = deviceIsIOS && /OS [6-7]_\d/.test(navigator.userAgent);

	/**
  * BlackBerry requires exceptions.
  *
  * @type boolean
  */
	var deviceIsBlackBerry10 = navigator.userAgent.indexOf('BB10') > 0;

	/**
  * Determine whether a given element requires a native click.
  *
  * @param {EventTarget|Element} target Target DOM element
  * @returns {boolean} Returns true if the element needs a native click
  */
	FastClick.prototype.needsClick = function (target) {
		switch (target.nodeName.toLowerCase()) {

			// Don't send a synthetic click to disabled inputs (issue #62)
			case 'button':
			case 'select':
			case 'textarea':
				if (target.disabled) {
					return true;
				}

				break;
			case 'input':

				// File inputs need real clicks on iOS 6 due to a browser bug (issue #68)
				if (deviceIsIOS && target.type === 'file' || target.disabled) {
					return true;
				}

				break;
			case 'label':
			case 'iframe': // iOS8 homescreen apps can prevent events bubbling into frames
			case 'video':
				return true;
		}

		return (/\bneedsclick\b/.test(target.className)
		);
	};

	/**
  * Determine whether a given element requires a call to focus to simulate click into element.
  *
  * @param {EventTarget|Element} target Target DOM element
  * @returns {boolean} Returns true if the element requires a call to focus to simulate native click.
  */
	FastClick.prototype.needsFocus = function (target) {
		switch (target.nodeName.toLowerCase()) {
			case 'textarea':
				return true;
			case 'select':
				return !deviceIsAndroid;
			case 'input':
				switch (target.type) {
					case 'button':
					case 'checkbox':
					case 'file':
					case 'image':
					case 'radio':
					case 'submit':
						return false;
				}

				// No point in attempting to focus disabled inputs
				return !target.disabled && !target.readOnly;
			default:
				return (/\bneedsfocus\b/.test(target.className)
				);
		}
	};

	/**
  * Send a click event to the specified element.
  *
  * @param {EventTarget|Element} targetElement
  * @param {Event} event
  */
	FastClick.prototype.sendClick = function (targetElement, event) {
		var clickEvent, touch;

		// On some Android devices activeElement needs to be blurred otherwise the synthetic click will have no effect (#24)
		if (document.activeElement && document.activeElement !== targetElement) {
			document.activeElement.blur();
		}

		touch = event.changedTouches[0];

		// Synthesise a click event, with an extra attribute so it can be tracked
		clickEvent = document.createEvent('MouseEvents');
		clickEvent.initMouseEvent(this.determineEventType(targetElement), true, true, window, 1, touch.screenX, touch.screenY, touch.clientX, touch.clientY, false, false, false, false, 0, null);
		clickEvent.forwardedTouchEvent = true;
		targetElement.dispatchEvent(clickEvent);
	};

	FastClick.prototype.determineEventType = function (targetElement) {

		//Issue #159: Android Chrome Select Box does not open with a synthetic click event
		if (deviceIsAndroid && targetElement.tagName.toLowerCase() === 'select') {
			return 'mousedown';
		}

		return 'click';
	};

	/**
  * @param {EventTarget|Element} targetElement
  */
	FastClick.prototype.focus = function (targetElement) {
		var length;

		// Issue #160: on iOS 7, some input elements (e.g. date datetime month) throw a vague TypeError on setSelectionRange. These elements don't have an integer value for the selectionStart and selectionEnd properties, but unfortunately that can't be used for detection because accessing the properties also throws a TypeError. Just check the type instead. Filed as Apple bug #15122724.
		if (deviceIsIOS && targetElement.setSelectionRange && targetElement.type.indexOf('date') !== 0 && targetElement.type !== 'time' && targetElement.type !== 'month') {
			length = targetElement.value.length;
			targetElement.setSelectionRange(length, length);
		} else {
			targetElement.focus();
		}
	};

	/**
  * Check whether the given target element is a child of a scrollable layer and if so, set a flag on it.
  *
  * @param {EventTarget|Element} targetElement
  */
	FastClick.prototype.updateScrollParent = function (targetElement) {
		var scrollParent, parentElement;

		scrollParent = targetElement.fastClickScrollParent;

		// Attempt to discover whether the target element is contained within a scrollable layer. Re-check if the
		// target element was moved to another parent.
		if (!scrollParent || !scrollParent.contains(targetElement)) {
			parentElement = targetElement;
			do {
				if (parentElement.scrollHeight > parentElement.offsetHeight) {
					scrollParent = parentElement;
					targetElement.fastClickScrollParent = parentElement;
					break;
				}

				parentElement = parentElement.parentElement;
			} while (parentElement);
		}

		// Always update the scroll top tracker if possible.
		if (scrollParent) {
			scrollParent.fastClickLastScrollTop = scrollParent.scrollTop;
		}
	};

	/**
  * @param {EventTarget} targetElement
  * @returns {Element|EventTarget}
  */
	FastClick.prototype.getTargetElementFromEventTarget = function (eventTarget) {

		// On some older browsers (notably Safari on iOS 4.1 - see issue #56) the event target may be a text node.
		if (eventTarget.nodeType === Node.TEXT_NODE) {
			return eventTarget.parentNode;
		}

		return eventTarget;
	};

	/**
  * On touch start, record the position and scroll offset.
  *
  * @param {Event} event
  * @returns {boolean}
  */
	FastClick.prototype.onTouchStart = function (event) {
		var targetElement, touch, selection;

		// Ignore multiple touches, otherwise pinch-to-zoom is prevented if both fingers are on the FastClick element (issue #111).
		if (event.targetTouches.length > 1) {
			return true;
		}

		targetElement = this.getTargetElementFromEventTarget(event.target);
		touch = event.targetTouches[0];

		if (deviceIsIOS) {

			// Only trusted events will deselect text on iOS (issue #49)
			selection = window.getSelection();
			if (selection.rangeCount && !selection.isCollapsed) {
				return true;
			}

			if (!deviceIsIOS4) {

				// Weird things happen on iOS when an alert or confirm dialog is opened from a click event callback (issue #23):
				// when the user next taps anywhere else on the page, new touchstart and touchend events are dispatched
				// with the same identifier as the touch event that previously triggered the click that triggered the alert.
				// Sadly, there is an issue on iOS 4 that causes some normal touch events to have the same identifier as an
				// immediately preceeding touch event (issue #52), so this fix is unavailable on that platform.
				// Issue 120: touch.identifier is 0 when Chrome dev tools 'Emulate touch events' is set with an iOS device UA string,
				// which causes all touch events to be ignored. As this block only applies to iOS, and iOS identifiers are always long,
				// random integers, it's safe to to continue if the identifier is 0 here.
				if (touch.identifier && touch.identifier === this.lastTouchIdentifier) {
					event.preventDefault();
					return false;
				}

				this.lastTouchIdentifier = touch.identifier;

				// If the target element is a child of a scrollable layer (using -webkit-overflow-scrolling: touch) and:
				// 1) the user does a fling scroll on the scrollable layer
				// 2) the user stops the fling scroll with another tap
				// then the event.target of the last 'touchend' event will be the element that was under the user's finger
				// when the fling scroll was started, causing FastClick to send a click event to that layer - unless a check
				// is made to ensure that a parent layer was not scrolled before sending a synthetic click (issue #42).
				this.updateScrollParent(targetElement);
			}
		}

		this.trackingClick = true;
		this.trackingClickStart = event.timeStamp;
		this.targetElement = targetElement;

		this.touchStartX = touch.pageX;
		this.touchStartY = touch.pageY;

		// Prevent phantom clicks on fast double-tap (issue #36)
		if (event.timeStamp - this.lastClickTime < this.tapDelay) {
			event.preventDefault();
		}

		return true;
	};

	/**
  * Based on a touchmove event object, check whether the touch has moved past a boundary since it started.
  *
  * @param {Event} event
  * @returns {boolean}
  */
	FastClick.prototype.touchHasMoved = function (event) {
		var touch = event.changedTouches[0],
		    boundary = this.touchBoundary;

		if (Math.abs(touch.pageX - this.touchStartX) > boundary || Math.abs(touch.pageY - this.touchStartY) > boundary) {
			return true;
		}

		return false;
	};

	/**
  * Update the last position.
  *
  * @param {Event} event
  * @returns {boolean}
  */
	FastClick.prototype.onTouchMove = function (event) {
		if (!this.trackingClick) {
			return true;
		}

		// If the touch has moved, cancel the click tracking
		if (this.targetElement !== this.getTargetElementFromEventTarget(event.target) || this.touchHasMoved(event)) {
			this.trackingClick = false;
			this.targetElement = null;
		}

		return true;
	};

	/**
  * Attempt to find the labelled control for the given label element.
  *
  * @param {EventTarget|HTMLLabelElement} labelElement
  * @returns {Element|null}
  */
	FastClick.prototype.findControl = function (labelElement) {

		// Fast path for newer browsers supporting the HTML5 control attribute
		if (labelElement.control !== undefined) {
			return labelElement.control;
		}

		// All browsers under test that support touch events also support the HTML5 htmlFor attribute
		if (labelElement.htmlFor) {
			return document.getElementById(labelElement.htmlFor);
		}

		// If no for attribute exists, attempt to retrieve the first labellable descendant element
		// the list of which is defined here: http://www.w3.org/TR/html5/forms.html#category-label
		return labelElement.querySelector('button, input:not([type=hidden]), keygen, meter, output, progress, select, textarea');
	};

	/**
  * On touch end, determine whether to send a click event at once.
  *
  * @param {Event} event
  * @returns {boolean}
  */
	FastClick.prototype.onTouchEnd = function (event) {
		var forElement,
		    trackingClickStart,
		    targetTagName,
		    scrollParent,
		    touch,
		    targetElement = this.targetElement;

		if (!this.trackingClick) {
			return true;
		}

		// Prevent phantom clicks on fast double-tap (issue #36)
		if (event.timeStamp - this.lastClickTime < this.tapDelay) {
			this.cancelNextClick = true;
			return true;
		}

		if (event.timeStamp - this.trackingClickStart > this.tapTimeout) {
			return true;
		}

		// Reset to prevent wrong click cancel on input (issue #156).
		this.cancelNextClick = false;

		this.lastClickTime = event.timeStamp;

		trackingClickStart = this.trackingClickStart;
		this.trackingClick = false;
		this.trackingClickStart = 0;

		// On some iOS devices, the targetElement supplied with the event is invalid if the layer
		// is performing a transition or scroll, and has to be re-detected manually. Note that
		// for this to function correctly, it must be called *after* the event target is checked!
		// See issue #57; also filed as rdar://13048589 .
		if (deviceIsIOSWithBadTarget) {
			touch = event.changedTouches[0];

			// In certain cases arguments of elementFromPoint can be negative, so prevent setting targetElement to null
			targetElement = document.elementFromPoint(touch.pageX - window.pageXOffset, touch.pageY - window.pageYOffset) || targetElement;
			targetElement.fastClickScrollParent = this.targetElement.fastClickScrollParent;
		}

		targetTagName = targetElement.tagName.toLowerCase();
		if (targetTagName === 'label') {
			forElement = this.findControl(targetElement);
			if (forElement) {
				this.focus(targetElement);
				if (deviceIsAndroid) {
					return false;
				}

				targetElement = forElement;
			}
		} else if (this.needsFocus(targetElement)) {

			// Case 1: If the touch started a while ago (best guess is 100ms based on tests for issue #36) then focus will be triggered anyway. Return early and unset the target element reference so that the subsequent click will be allowed through.
			// Case 2: Without this exception for input elements tapped when the document is contained in an iframe, then any inputted text won't be visible even though the value attribute is updated as the user types (issue #37).
			if (event.timeStamp - trackingClickStart > 100 || deviceIsIOS && window.top !== window && targetTagName === 'input') {
				this.targetElement = null;
				return false;
			}

			this.focus(targetElement);
			this.sendClick(targetElement, event);

			// Select elements need the event to go through on iOS 4, otherwise the selector menu won't open.
			// Also this breaks opening selects when VoiceOver is active on iOS6, iOS7 (and possibly others)
			if (!deviceIsIOS || targetTagName !== 'select') {
				this.targetElement = null;
				event.preventDefault();
			}

			return false;
		}

		if (deviceIsIOS && !deviceIsIOS4) {

			// Don't send a synthetic click event if the target element is contained within a parent layer that was scrolled
			// and this tap is being used to stop the scrolling (usually initiated by a fling - issue #42).
			scrollParent = targetElement.fastClickScrollParent;
			if (scrollParent && scrollParent.fastClickLastScrollTop !== scrollParent.scrollTop) {
				return true;
			}
		}

		// Prevent the actual click from going though - unless the target node is marked as requiring
		// real clicks or if it is in the whitelist in which case only non-programmatic clicks are permitted.
		if (!this.needsClick(targetElement)) {
			event.preventDefault();
			this.sendClick(targetElement, event);
		}

		return false;
	};

	/**
  * On touch cancel, stop tracking the click.
  *
  * @returns {void}
  */
	FastClick.prototype.onTouchCancel = function () {
		this.trackingClick = false;
		this.targetElement = null;
	};

	/**
  * Determine mouse events which should be permitted.
  *
  * @param {Event} event
  * @returns {boolean}
  */
	FastClick.prototype.onMouse = function (event) {

		// If a target element was never set (because a touch event was never fired) allow the event
		if (!this.targetElement) {
			return true;
		}

		if (event.forwardedTouchEvent) {
			return true;
		}

		// Programmatically generated events targeting a specific element should be permitted
		if (!event.cancelable) {
			return true;
		}

		// Derive and check the target element to see whether the mouse event needs to be permitted;
		// unless explicitly enabled, prevent non-touch click events from triggering actions,
		// to prevent ghost/doubleclicks.
		if (!this.needsClick(this.targetElement) || this.cancelNextClick) {

			// Prevent any user-added listeners declared on FastClick element from being fired.
			if (event.stopImmediatePropagation) {
				event.stopImmediatePropagation();
			} else {

				// Part of the hack for browsers that don't support Event#stopImmediatePropagation (e.g. Android 2)
				event.propagationStopped = true;
			}

			// Cancel the event
			event.stopPropagation();
			event.preventDefault();

			return false;
		}

		// If the mouse event is permitted, return true for the action to go through.
		return true;
	};

	/**
  * On actual clicks, determine whether this is a touch-generated click, a click action occurring
  * naturally after a delay after a touch (which needs to be cancelled to avoid duplication), or
  * an actual click which should be permitted.
  *
  * @param {Event} event
  * @returns {boolean}
  */
	FastClick.prototype.onClick = function (event) {
		var permitted;

		// It's possible for another FastClick-like library delivered with third-party code to fire a click event before FastClick does (issue #44). In that case, set the click-tracking flag back to false and return early. This will cause onTouchEnd to return early.
		if (this.trackingClick) {
			this.targetElement = null;
			this.trackingClick = false;
			return true;
		}

		// Very odd behaviour on iOS (issue #18): if a submit element is present inside a form and the user hits enter in the iOS simulator or clicks the Go button on the pop-up OS keyboard the a kind of 'fake' click event will be triggered with the submit-type input element as the target.
		if (event.target.type === 'submit' && event.detail === 0) {
			return true;
		}

		permitted = this.onMouse(event);

		// Only unset targetElement if the click is not permitted. This will ensure that the check for !targetElement in onMouse fails and the browser's click doesn't go through.
		if (!permitted) {
			this.targetElement = null;
		}

		// If clicks are permitted, return true for the action to go through.
		return permitted;
	};

	/**
  * Remove all FastClick's event listeners.
  *
  * @returns {void}
  */
	FastClick.prototype.destroy = function () {
		var layer = this.layer;

		if (deviceIsAndroid) {
			layer.removeEventListener('mouseover', this.onMouse, true);
			layer.removeEventListener('mousedown', this.onMouse, true);
			layer.removeEventListener('mouseup', this.onMouse, true);
		}

		layer.removeEventListener('click', this.onClick, true);
		layer.removeEventListener('touchstart', this.onTouchStart, false);
		layer.removeEventListener('touchmove', this.onTouchMove, false);
		layer.removeEventListener('touchend', this.onTouchEnd, false);
		layer.removeEventListener('touchcancel', this.onTouchCancel, false);
	};

	/**
  * Check whether FastClick is needed.
  *
  * @param {Element} layer The layer to listen on
  */
	FastClick.notNeeded = function (layer) {
		var metaViewport;
		var chromeVersion;
		var blackberryVersion;
		var firefoxVersion;

		// Devices that don't support touch don't need FastClick
		if (typeof window.ontouchstart === 'undefined') {
			return true;
		}

		// Chrome version - zero for other browsers
		chromeVersion = +(/Chrome\/([0-9]+)/.exec(navigator.userAgent) || [, 0])[1];

		if (chromeVersion) {

			if (deviceIsAndroid) {
				metaViewport = document.querySelector('meta[name=viewport]');

				if (metaViewport) {
					// Chrome on Android with user-scalable="no" doesn't need FastClick (issue #89)
					if (metaViewport.content.indexOf('user-scalable=no') !== -1) {
						return true;
					}
					// Chrome 32 and above with width=device-width or less don't need FastClick
					if (chromeVersion > 31 && document.documentElement.scrollWidth <= window.outerWidth) {
						return true;
					}
				}

				// Chrome desktop doesn't need FastClick (issue #15)
			} else {
				return true;
			}
		}

		if (deviceIsBlackBerry10) {
			blackberryVersion = navigator.userAgent.match(/Version\/([0-9]*)\.([0-9]*)/);

			// BlackBerry 10.3+ does not require Fastclick library.
			// https://github.com/ftlabs/fastclick/issues/251
			if (blackberryVersion[1] >= 10 && blackberryVersion[2] >= 3) {
				metaViewport = document.querySelector('meta[name=viewport]');

				if (metaViewport) {
					// user-scalable=no eliminates click delay.
					if (metaViewport.content.indexOf('user-scalable=no') !== -1) {
						return true;
					}
					// width=device-width (or less than device-width) eliminates click delay.
					if (document.documentElement.scrollWidth <= window.outerWidth) {
						return true;
					}
				}
			}
		}

		// IE10 with -ms-touch-action: none or manipulation, which disables double-tap-to-zoom (issue #97)
		if (layer.style.msTouchAction === 'none' || layer.style.touchAction === 'manipulation') {
			return true;
		}

		// Firefox version - zero for other browsers
		firefoxVersion = +(/Firefox\/([0-9]+)/.exec(navigator.userAgent) || [, 0])[1];

		if (firefoxVersion >= 27) {
			// Firefox 27+ does not have tap delay if the content is not zoomable - https://bugzilla.mozilla.org/show_bug.cgi?id=922896

			metaViewport = document.querySelector('meta[name=viewport]');
			if (metaViewport && (metaViewport.content.indexOf('user-scalable=no') !== -1 || document.documentElement.scrollWidth <= window.outerWidth)) {
				return true;
			}
		}

		// IE11: prefixed -ms-touch-action is no longer supported and it's recomended to use non-prefixed version
		// http://msdn.microsoft.com/en-us/library/windows/apps/Hh767313.aspx
		if (layer.style.touchAction === 'none' || layer.style.touchAction === 'manipulation') {
			return true;
		}

		return false;
	};

	/**
  * Factory method for creating a FastClick object
  *
  * @param {Element} layer The layer to listen on
  * @param {Object} [options={}] The options to override the defaults
  */
	FastClick.attach = function (layer, options) {
		return new FastClick(layer, options);
	};

	window.FastClick = FastClick;

	module.exports = FastClick;
	// if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) {

	// 	// AMD. Register as an anonymous module.
	// 	define(function() {
	// 		return FastClick;
	// 	});
	// } else if (typeof module !== 'undefined' && module.exports) {
	// 	module.exports = FastClick.attach;
	// 	module.exports.FastClick = FastClick;
	// } else {
	// 	window.FastClick = FastClick;
	// }
})();

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

var _events = __webpack_require__(362);

var _events2 = _interopRequireDefault(_events);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SM = Object.assign({
    init: function init() {
        var hostname = location.hostname;
        var apiHost = 'fp.fengkongcloud.com';

        if (hostname == 'm.upliveapps.com') {
            apiHost = 'fp-xjp.fengkongcloud.com';
        }

        (function () {
            window._smConf = {
                organization: '3kHDvmQMHMyhMkWHki4D', //需要修改为业务 organization
                staticHost: 'static.fengkongcloud.com',
                apiHost: apiHost
            };
            var sm = document.createElement("script");
            sm.src = ('https:' === document.location.protocol ? 'https:' : 'http:') + '//' + _smConf.staticHost + '/fpv2.js';
            var s = document.getElementsByTagName("script")[0];
            sm.onload = function () {
                $.channel.emit('smsdkLoaded');
            };
            sm.onerror = function () {
                $.channel.emit('smsdkLoadedError');
            };
            s.parentNode.insertBefore(sm, s);
        })();
    }
}, _events2.default); // 数美防刷


SM.init();

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Event center
 */
(function (global, factory) {

    // amd mode
    if (true) {
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof require === 'function' && (typeof module === 'undefined' ? 'undefined' : _typeof(module)) === "object" && module && module["exports"]) {
        // commonjs mode
        module.exports = factory();
    } else {
        // global mode
        global.events = factory();
    }
})(window, function () {

    var Callbacks = function Callbacks(options) {
        options = $.extend({}, options);

        var memory,
            // Last fire value (for non-forgettable lists)
        _fired,
            // Flag to know if list was already fired
        firing,
            // Flag to know if list is currently firing
        firingStart,
            // First callback to fire (used internally by add and fireWith)
        firingLength,
            // End of the loop when firing
        firingIndex,
            // Index of currently firing callback (modified by remove if needed)
        list = [],
            // Actual callback list
        stack = !options.once && [],
            // Stack of fire calls for repeatable lists
        fire = function fire(data) {
            memory = options.memory && data;
            _fired = true;
            firingIndex = firingStart || 0;
            firingStart = 0;
            firingLength = list.length;
            firing = true;
            for (; list && firingIndex < firingLength; ++firingIndex) {
                if (list[firingIndex].apply(data[0], data[1]) === false && options.stopOnFalse) {
                    memory = false;
                    break;
                }
            }
            firing = false;
            if (list) {
                if (stack) stack.length && fire(stack.shift());else if (memory) list.length = 0;else Callbacks.disable();
            }
        },
            Callbacks = {
            list: list,
            add: function add() {
                if (list) {
                    var start = list.length,
                        add = function add(args) {
                        args = Array.prototype.slice.call(args);
                        args.forEach(function (arg, _) {
                            if (typeof arg === "function") {
                                if (!options.unique || !Callbacks.has(arg)) list.push(arg);
                            } else if (arg && arg.length && typeof arg !== 'string') add(arg);
                        });
                    };
                    add(arguments);
                    if (firing) firingLength = list.length;else if (memory) {
                        firingStart = start;
                        fire(memory);
                    }
                }
                return this;
            },
            remove: function remove() {
                var args = Array.prototype.slice.call(arguments);
                if (list) {
                    args.forEach(function (arg, _) {
                        var index;
                        while ((index = list.indexOf(arg, index)) > -1) {
                            list.splice(index, 1);
                            // Handle firing indexes
                            if (firing) {
                                if (index <= firingLength) --firingLength;
                                if (index <= firingIndex) --firingIndex;
                            }
                        }
                    });
                }
                return this;
            },
            has: function has(fn) {
                return !!(list && (fn ? list.indexOf(fn) > -1 : list.length));
            },
            empty: function empty() {
                firingLength = list.length = 0;
                return this;
            },
            disable: function disable() {
                list = stack = memory = undefined;
                return this;
            },
            disabled: function disabled() {
                return !list;
            },
            lock: function lock() {
                stack = undefined;
                if (!memory) Callbacks.disable();
                return this;
            },
            locked: function locked() {
                return !stack;
            },
            fireWith: function fireWith(context, args) {
                if (list && (!_fired || stack)) {
                    args = args || [];
                    args = [context, args.slice ? args.slice() : args];
                    if (firing) stack.push(args);else fire(args);
                }
                return this;
            },
            fire: function fire() {
                return Callbacks.fireWith(this, arguments);
            },
            fired: function fired() {
                return !!_fired;
            }
        };

        return Callbacks;
    };
    var channelObj = {};

    // 统一事件机制
    var Events = {
        Event: Callbacks,
        /**
         * 添加事件监听
         * @param  {string}   name - 事件名称
         * @param  {function} callback - 事件回调
         */
        on: function on(name, callback) {
            var obj,
                that = this;

            this.events = this.events || {};

            // 逗号隔开，支持多事件
            if (name && name.indexOf(',') != -1) {
                return (name.split(',') || []).forEach(function (item) {
                    if (item) {
                        that.on(item, callback);
                    }
                });
            }

            if (!this.global && name.indexOf('/') != -1) {
                // 频道监听
                if (name.split('/')[0] == 'channel') {
                    return that.channel.on(name.replace(/^channel\//gi, ''), callback);
                }

                obj = getObjectByNames(name, this);
                this.events[name] = this.events[name] || [];
                this.events[name].push(callback);
                return obj ? obj.on(getEventName(name), callback) : this;
            } else {
                obj = this.events[name] || (this.events[name] = this.Event());
            }

            // 如果设置为一起派发，则再次监听时，直接执行
            if (this._alwayEmitSource && this._alwayEmitSource[name]) {
                return callback.apply(name, this._alwayEmitSource[name]);
            }
            obj.add(callback);

            return this;
        },
        /**
         * 移除事件监听
         * @param  {string}   name     事件名称
         * @param  {function} [callback] - 事件回调，为空时，移除所有回调
         */
        off: function off(name, callback) {
            var obj,
                funs,
                that = this;

            this.events = this.events || {};

            // 逗号隔开，支持多事件
            if (name && name.indexOf(',') != -1) {
                return (name.split(',') || []).forEach(function (item) {
                    if (item) {
                        that.off(item, callback);
                    }
                });
            }

            if (!this.global && name && name.indexOf('/') != -1) {
                if (name.split('/')[0] == 'channel') {
                    return that.channel.off(name.replace(/^channel\//gi, ''), callback);
                }

                if (this.events[name]) {
                    obj = getObjectByNames(name, this);
                    if (callback) {
                        return obj ? obj.off(getEventName(name), callback) : this;
                    } else {
                        funs = this.events[name];
                        for (var i = 0; obj && funs && i < funs.length; i++) {
                            obj.off(getEventName(name), funs[i]);
                        }
                        this.events[name] = null;
                    }
                }

                return this;
            }

            if (name && callback && (obj = this.events[name])) {
                obj.remove(callback);
            } else if (name && (obj = this.events[name])) {
                obj.empty();
            } else {

                for (name in this.events) {
                    if (this.events.hasOwnProperty(name) && this.events[name]) {
                        if (!this.global && name.indexOf('/') != -1) {
                            if (name.split('/')[0] == 'channel') {
                                return this.channel.off(name.replace(/^channel\//gi, ''));
                            }
                            this.off(name);
                        } else {
                            this.events[name].empty();
                        }
                    }
                }
            }

            return this;
        },
        ///**
        // * 只监听一次事件
        // * @param name
        // * @param callback
        // */
        //once: function (name, callback) {
        //    var _callback;
        //
        //    this.on(name, _callback = function () {
        //        callback.apply(this, arguments);
        //        this.off(name, _callback);
        //    });
        //},
        /**
         * 默认派发事件
         * @return {object}
         */
        trigger: function trigger() {
            var name = arguments[0],
                obj,
                param,
                that = this;

            this.events = this.events || {};
            param = Array.prototype.slice.call(arguments, 1);

            // 逗号隔开，支持多事件
            if (name && name.indexOf(',') != -1) {
                return (name.split(',') || []).forEach(function (item) {
                    if (item) {
                        that.trigger.apply(this, [item].concat(param));
                    }
                });
            }

            if (!this.global && name && name.indexOf('/') != -1) {
                if (name.split('/')[0] == 'channel') {
                    return that.channel.trigger.apply(that.channel, [name.replace(/^channel\//gi, '')].concat(param));
                }
                obj = getObjectByNames(name, this);
                name = getEventName(name);
                return obj ? obj.trigger.apply(obj, [name].concat(param)) : this;
            }

            if (name && (obj = this.events[name])) {
                obj.fire.apply(this, [].concat(param));
            }

            return {
                event: obj,
                always: function always() {
                    that._alwayEmitSource = that._alwayEmitSource || {};
                    that._alwayEmitSource[name] = [].concat(param);
                }
            };
        },
        /**
         * 派发事件
         * @example
         *        this.emit('ready',args0,args1...);
         */
        emit: function emit() {
            return this.trigger.apply(this, arguments);
        }
    };

    /**
     * 获取context下的name属性
     * @private
     */
    function getObjectByNames(name, context) {
        var that, names, len;

        context = context || {};
        that = context;
        names = name.split('/');
        len = names.length;

        for (var i = 0; len > 1 && i < len - 1; i++) {
            if (that && that[names[i]]) {
                that = that[names[i]];
            } else {
                that = null;
            }
        }

        return that;
    }

    /**
     * 获取事件名称
     * @param  {String} name [description]
     * @return {String}
     */
    function getEventName(name) {
        var names = name.split('/');
        return names[names.length - 1];
    }

    // global single Event
    Events.channel = $.channel || ($.channel = $.extend(channelObj, Events));
    Events.channel.global = Events.channel;

    return Events;
});

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// app.js